var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[Object.keys(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __reExport = (target, module, desc) => {
  if (module && typeof module === "object" || typeof module === "function") {
    for (let key of __getOwnPropNames(module))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module[key], enumerable: !(desc = __getOwnPropDesc(module, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module) => {
  return __reExport(__markAsModule(__defProp(module != null ? __create(__getProtoOf(module)) : {}, "default", module && module.__esModule && "default" in module ? { get: () => module.default, enumerable: true } : { value: module, enumerable: true })), module);
};

// node_modules/quill/dist/quill.js
var require_quill = __commonJS({
  "node_modules/quill/dist/quill.js"(exports, module) {
    (function webpackUniversalModuleDefinition(root, factory) {
      if (typeof exports === "object" && typeof module === "object")
        module.exports = factory();
      else if (typeof define === "function" && define.amd)
        define([], factory);
      else if (typeof exports === "object")
        exports["Quill"] = factory();
      else
        root["Quill"] = factory();
    })(typeof self !== "undefined" ? self : exports, function() {
      return function(modules) {
        var installedModules = {};
        function __webpack_require__(moduleId) {
          if (installedModules[moduleId]) {
            return installedModules[moduleId].exports;
          }
          var module2 = installedModules[moduleId] = {
            i: moduleId,
            l: false,
            exports: {}
          };
          modules[moduleId].call(module2.exports, module2, module2.exports, __webpack_require__);
          module2.l = true;
          return module2.exports;
        }
        __webpack_require__.m = modules;
        __webpack_require__.c = installedModules;
        __webpack_require__.d = function(exports2, name, getter) {
          if (!__webpack_require__.o(exports2, name)) {
            Object.defineProperty(exports2, name, {
              configurable: false,
              enumerable: true,
              get: getter
            });
          }
        };
        __webpack_require__.n = function(module2) {
          var getter = module2 && module2.__esModule ? function getDefault() {
            return module2["default"];
          } : function getModuleExports() {
            return module2;
          };
          __webpack_require__.d(getter, "a", getter);
          return getter;
        };
        __webpack_require__.o = function(object, property) {
          return Object.prototype.hasOwnProperty.call(object, property);
        };
        __webpack_require__.p = "";
        return __webpack_require__(__webpack_require__.s = 109);
      }([
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", { value: true });
          var container_1 = __webpack_require__(17);
          var format_1 = __webpack_require__(18);
          var leaf_1 = __webpack_require__(19);
          var scroll_1 = __webpack_require__(45);
          var inline_1 = __webpack_require__(46);
          var block_1 = __webpack_require__(47);
          var embed_1 = __webpack_require__(48);
          var text_1 = __webpack_require__(49);
          var attributor_1 = __webpack_require__(12);
          var class_1 = __webpack_require__(32);
          var style_1 = __webpack_require__(33);
          var store_1 = __webpack_require__(31);
          var Registry = __webpack_require__(1);
          var Parchment = {
            Scope: Registry.Scope,
            create: Registry.create,
            find: Registry.find,
            query: Registry.query,
            register: Registry.register,
            Container: container_1.default,
            Format: format_1.default,
            Leaf: leaf_1.default,
            Embed: embed_1.default,
            Scroll: scroll_1.default,
            Block: block_1.default,
            Inline: inline_1.default,
            Text: text_1.default,
            Attributor: {
              Attribute: attributor_1.default,
              Class: class_1.default,
              Style: style_1.default,
              Store: store_1.default
            }
          };
          exports2.default = Parchment;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          var __extends = this && this.__extends || function() {
            var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
              d.__proto__ = b;
            } || function(d, b) {
              for (var p in b)
                if (b.hasOwnProperty(p))
                  d[p] = b[p];
            };
            return function(d, b) {
              extendStatics(d, b);
              function __() {
                this.constructor = d;
              }
              d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            };
          }();
          Object.defineProperty(exports2, "__esModule", { value: true });
          var ParchmentError = function(_super) {
            __extends(ParchmentError2, _super);
            function ParchmentError2(message) {
              var _this = this;
              message = "[Parchment] " + message;
              _this = _super.call(this, message) || this;
              _this.message = message;
              _this.name = _this.constructor.name;
              return _this;
            }
            return ParchmentError2;
          }(Error);
          exports2.ParchmentError = ParchmentError;
          var attributes = {};
          var classes = {};
          var tags = {};
          var types = {};
          exports2.DATA_KEY = "__blot";
          var Scope;
          (function(Scope2) {
            Scope2[Scope2["TYPE"] = 3] = "TYPE";
            Scope2[Scope2["LEVEL"] = 12] = "LEVEL";
            Scope2[Scope2["ATTRIBUTE"] = 13] = "ATTRIBUTE";
            Scope2[Scope2["BLOT"] = 14] = "BLOT";
            Scope2[Scope2["INLINE"] = 7] = "INLINE";
            Scope2[Scope2["BLOCK"] = 11] = "BLOCK";
            Scope2[Scope2["BLOCK_BLOT"] = 10] = "BLOCK_BLOT";
            Scope2[Scope2["INLINE_BLOT"] = 6] = "INLINE_BLOT";
            Scope2[Scope2["BLOCK_ATTRIBUTE"] = 9] = "BLOCK_ATTRIBUTE";
            Scope2[Scope2["INLINE_ATTRIBUTE"] = 5] = "INLINE_ATTRIBUTE";
            Scope2[Scope2["ANY"] = 15] = "ANY";
          })(Scope = exports2.Scope || (exports2.Scope = {}));
          function create(input, value) {
            var match = query(input);
            if (match == null) {
              throw new ParchmentError("Unable to create " + input + " blot");
            }
            var BlotClass = match;
            var node = input instanceof Node || input["nodeType"] === Node.TEXT_NODE ? input : BlotClass.create(value);
            return new BlotClass(node, value);
          }
          exports2.create = create;
          function find(node, bubble) {
            if (bubble === void 0) {
              bubble = false;
            }
            if (node == null)
              return null;
            if (node[exports2.DATA_KEY] != null)
              return node[exports2.DATA_KEY].blot;
            if (bubble)
              return find(node.parentNode, bubble);
            return null;
          }
          exports2.find = find;
          function query(query2, scope) {
            if (scope === void 0) {
              scope = Scope.ANY;
            }
            var match;
            if (typeof query2 === "string") {
              match = types[query2] || attributes[query2];
            } else if (query2 instanceof Text || query2["nodeType"] === Node.TEXT_NODE) {
              match = types["text"];
            } else if (typeof query2 === "number") {
              if (query2 & Scope.LEVEL & Scope.BLOCK) {
                match = types["block"];
              } else if (query2 & Scope.LEVEL & Scope.INLINE) {
                match = types["inline"];
              }
            } else if (query2 instanceof HTMLElement) {
              var names = (query2.getAttribute("class") || "").split(/\s+/);
              for (var i in names) {
                match = classes[names[i]];
                if (match)
                  break;
              }
              match = match || tags[query2.tagName];
            }
            if (match == null)
              return null;
            if (scope & Scope.LEVEL & match.scope && scope & Scope.TYPE & match.scope)
              return match;
            return null;
          }
          exports2.query = query;
          function register() {
            var Definitions = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              Definitions[_i] = arguments[_i];
            }
            if (Definitions.length > 1) {
              return Definitions.map(function(d) {
                return register(d);
              });
            }
            var Definition = Definitions[0];
            if (typeof Definition.blotName !== "string" && typeof Definition.attrName !== "string") {
              throw new ParchmentError("Invalid definition");
            } else if (Definition.blotName === "abstract") {
              throw new ParchmentError("Cannot register abstract class");
            }
            types[Definition.blotName || Definition.attrName] = Definition;
            if (typeof Definition.keyName === "string") {
              attributes[Definition.keyName] = Definition;
            } else {
              if (Definition.className != null) {
                classes[Definition.className] = Definition;
              }
              if (Definition.tagName != null) {
                if (Array.isArray(Definition.tagName)) {
                  Definition.tagName = Definition.tagName.map(function(tagName) {
                    return tagName.toUpperCase();
                  });
                } else {
                  Definition.tagName = Definition.tagName.toUpperCase();
                }
                var tagNames = Array.isArray(Definition.tagName) ? Definition.tagName : [Definition.tagName];
                tagNames.forEach(function(tag) {
                  if (tags[tag] == null || Definition.className == null) {
                    tags[tag] = Definition;
                  }
                });
              }
            }
            return Definition;
          }
          exports2.register = register;
        },
        function(module2, exports2, __webpack_require__) {
          var diff = __webpack_require__(51);
          var equal = __webpack_require__(11);
          var extend = __webpack_require__(3);
          var op = __webpack_require__(20);
          var NULL_CHARACTER = String.fromCharCode(0);
          var Delta = function(ops) {
            if (Array.isArray(ops)) {
              this.ops = ops;
            } else if (ops != null && Array.isArray(ops.ops)) {
              this.ops = ops.ops;
            } else {
              this.ops = [];
            }
          };
          Delta.prototype.insert = function(text, attributes) {
            var newOp = {};
            if (text.length === 0)
              return this;
            newOp.insert = text;
            if (attributes != null && typeof attributes === "object" && Object.keys(attributes).length > 0) {
              newOp.attributes = attributes;
            }
            return this.push(newOp);
          };
          Delta.prototype["delete"] = function(length) {
            if (length <= 0)
              return this;
            return this.push({ "delete": length });
          };
          Delta.prototype.retain = function(length, attributes) {
            if (length <= 0)
              return this;
            var newOp = { retain: length };
            if (attributes != null && typeof attributes === "object" && Object.keys(attributes).length > 0) {
              newOp.attributes = attributes;
            }
            return this.push(newOp);
          };
          Delta.prototype.push = function(newOp) {
            var index = this.ops.length;
            var lastOp = this.ops[index - 1];
            newOp = extend(true, {}, newOp);
            if (typeof lastOp === "object") {
              if (typeof newOp["delete"] === "number" && typeof lastOp["delete"] === "number") {
                this.ops[index - 1] = { "delete": lastOp["delete"] + newOp["delete"] };
                return this;
              }
              if (typeof lastOp["delete"] === "number" && newOp.insert != null) {
                index -= 1;
                lastOp = this.ops[index - 1];
                if (typeof lastOp !== "object") {
                  this.ops.unshift(newOp);
                  return this;
                }
              }
              if (equal(newOp.attributes, lastOp.attributes)) {
                if (typeof newOp.insert === "string" && typeof lastOp.insert === "string") {
                  this.ops[index - 1] = { insert: lastOp.insert + newOp.insert };
                  if (typeof newOp.attributes === "object")
                    this.ops[index - 1].attributes = newOp.attributes;
                  return this;
                } else if (typeof newOp.retain === "number" && typeof lastOp.retain === "number") {
                  this.ops[index - 1] = { retain: lastOp.retain + newOp.retain };
                  if (typeof newOp.attributes === "object")
                    this.ops[index - 1].attributes = newOp.attributes;
                  return this;
                }
              }
            }
            if (index === this.ops.length) {
              this.ops.push(newOp);
            } else {
              this.ops.splice(index, 0, newOp);
            }
            return this;
          };
          Delta.prototype.chop = function() {
            var lastOp = this.ops[this.ops.length - 1];
            if (lastOp && lastOp.retain && !lastOp.attributes) {
              this.ops.pop();
            }
            return this;
          };
          Delta.prototype.filter = function(predicate) {
            return this.ops.filter(predicate);
          };
          Delta.prototype.forEach = function(predicate) {
            this.ops.forEach(predicate);
          };
          Delta.prototype.map = function(predicate) {
            return this.ops.map(predicate);
          };
          Delta.prototype.partition = function(predicate) {
            var passed = [], failed = [];
            this.forEach(function(op2) {
              var target = predicate(op2) ? passed : failed;
              target.push(op2);
            });
            return [passed, failed];
          };
          Delta.prototype.reduce = function(predicate, initial) {
            return this.ops.reduce(predicate, initial);
          };
          Delta.prototype.changeLength = function() {
            return this.reduce(function(length, elem) {
              if (elem.insert) {
                return length + op.length(elem);
              } else if (elem.delete) {
                return length - elem.delete;
              }
              return length;
            }, 0);
          };
          Delta.prototype.length = function() {
            return this.reduce(function(length, elem) {
              return length + op.length(elem);
            }, 0);
          };
          Delta.prototype.slice = function(start, end) {
            start = start || 0;
            if (typeof end !== "number")
              end = Infinity;
            var ops = [];
            var iter = op.iterator(this.ops);
            var index = 0;
            while (index < end && iter.hasNext()) {
              var nextOp;
              if (index < start) {
                nextOp = iter.next(start - index);
              } else {
                nextOp = iter.next(end - index);
                ops.push(nextOp);
              }
              index += op.length(nextOp);
            }
            return new Delta(ops);
          };
          Delta.prototype.compose = function(other) {
            var thisIter = op.iterator(this.ops);
            var otherIter = op.iterator(other.ops);
            var ops = [];
            var firstOther = otherIter.peek();
            if (firstOther != null && typeof firstOther.retain === "number" && firstOther.attributes == null) {
              var firstLeft = firstOther.retain;
              while (thisIter.peekType() === "insert" && thisIter.peekLength() <= firstLeft) {
                firstLeft -= thisIter.peekLength();
                ops.push(thisIter.next());
              }
              if (firstOther.retain - firstLeft > 0) {
                otherIter.next(firstOther.retain - firstLeft);
              }
            }
            var delta = new Delta(ops);
            while (thisIter.hasNext() || otherIter.hasNext()) {
              if (otherIter.peekType() === "insert") {
                delta.push(otherIter.next());
              } else if (thisIter.peekType() === "delete") {
                delta.push(thisIter.next());
              } else {
                var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                var thisOp = thisIter.next(length);
                var otherOp = otherIter.next(length);
                if (typeof otherOp.retain === "number") {
                  var newOp = {};
                  if (typeof thisOp.retain === "number") {
                    newOp.retain = length;
                  } else {
                    newOp.insert = thisOp.insert;
                  }
                  var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === "number");
                  if (attributes)
                    newOp.attributes = attributes;
                  delta.push(newOp);
                  if (!otherIter.hasNext() && equal(delta.ops[delta.ops.length - 1], newOp)) {
                    var rest = new Delta(thisIter.rest());
                    return delta.concat(rest).chop();
                  }
                } else if (typeof otherOp["delete"] === "number" && typeof thisOp.retain === "number") {
                  delta.push(otherOp);
                }
              }
            }
            return delta.chop();
          };
          Delta.prototype.concat = function(other) {
            var delta = new Delta(this.ops.slice());
            if (other.ops.length > 0) {
              delta.push(other.ops[0]);
              delta.ops = delta.ops.concat(other.ops.slice(1));
            }
            return delta;
          };
          Delta.prototype.diff = function(other, index) {
            if (this.ops === other.ops) {
              return new Delta();
            }
            var strings = [this, other].map(function(delta2) {
              return delta2.map(function(op2) {
                if (op2.insert != null) {
                  return typeof op2.insert === "string" ? op2.insert : NULL_CHARACTER;
                }
                var prep = delta2 === other ? "on" : "with";
                throw new Error("diff() called " + prep + " non-document");
              }).join("");
            });
            var delta = new Delta();
            var diffResult = diff(strings[0], strings[1], index);
            var thisIter = op.iterator(this.ops);
            var otherIter = op.iterator(other.ops);
            diffResult.forEach(function(component) {
              var length = component[1].length;
              while (length > 0) {
                var opLength = 0;
                switch (component[0]) {
                  case diff.INSERT:
                    opLength = Math.min(otherIter.peekLength(), length);
                    delta.push(otherIter.next(opLength));
                    break;
                  case diff.DELETE:
                    opLength = Math.min(length, thisIter.peekLength());
                    thisIter.next(opLength);
                    delta["delete"](opLength);
                    break;
                  case diff.EQUAL:
                    opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
                    var thisOp = thisIter.next(opLength);
                    var otherOp = otherIter.next(opLength);
                    if (equal(thisOp.insert, otherOp.insert)) {
                      delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
                    } else {
                      delta.push(otherOp)["delete"](opLength);
                    }
                    break;
                }
                length -= opLength;
              }
            });
            return delta.chop();
          };
          Delta.prototype.eachLine = function(predicate, newline) {
            newline = newline || "\n";
            var iter = op.iterator(this.ops);
            var line = new Delta();
            var i = 0;
            while (iter.hasNext()) {
              if (iter.peekType() !== "insert")
                return;
              var thisOp = iter.peek();
              var start = op.length(thisOp) - iter.peekLength();
              var index = typeof thisOp.insert === "string" ? thisOp.insert.indexOf(newline, start) - start : -1;
              if (index < 0) {
                line.push(iter.next());
              } else if (index > 0) {
                line.push(iter.next(index));
              } else {
                if (predicate(line, iter.next(1).attributes || {}, i) === false) {
                  return;
                }
                i += 1;
                line = new Delta();
              }
            }
            if (line.length() > 0) {
              predicate(line, {}, i);
            }
          };
          Delta.prototype.transform = function(other, priority) {
            priority = !!priority;
            if (typeof other === "number") {
              return this.transformPosition(other, priority);
            }
            var thisIter = op.iterator(this.ops);
            var otherIter = op.iterator(other.ops);
            var delta = new Delta();
            while (thisIter.hasNext() || otherIter.hasNext()) {
              if (thisIter.peekType() === "insert" && (priority || otherIter.peekType() !== "insert")) {
                delta.retain(op.length(thisIter.next()));
              } else if (otherIter.peekType() === "insert") {
                delta.push(otherIter.next());
              } else {
                var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                var thisOp = thisIter.next(length);
                var otherOp = otherIter.next(length);
                if (thisOp["delete"]) {
                  continue;
                } else if (otherOp["delete"]) {
                  delta.push(otherOp);
                } else {
                  delta.retain(length, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
                }
              }
            }
            return delta.chop();
          };
          Delta.prototype.transformPosition = function(index, priority) {
            priority = !!priority;
            var thisIter = op.iterator(this.ops);
            var offset = 0;
            while (thisIter.hasNext() && offset <= index) {
              var length = thisIter.peekLength();
              var nextType = thisIter.peekType();
              thisIter.next();
              if (nextType === "delete") {
                index -= Math.min(length, index - offset);
                continue;
              } else if (nextType === "insert" && (offset < index || !priority)) {
                index += length;
              }
              offset += length;
            }
            return index;
          };
          module2.exports = Delta;
        },
        function(module2, exports2) {
          "use strict";
          var hasOwn = Object.prototype.hasOwnProperty;
          var toStr = Object.prototype.toString;
          var defineProperty = Object.defineProperty;
          var gOPD = Object.getOwnPropertyDescriptor;
          var isArray = function isArray2(arr) {
            if (typeof Array.isArray === "function") {
              return Array.isArray(arr);
            }
            return toStr.call(arr) === "[object Array]";
          };
          var isPlainObject = function isPlainObject2(obj) {
            if (!obj || toStr.call(obj) !== "[object Object]") {
              return false;
            }
            var hasOwnConstructor = hasOwn.call(obj, "constructor");
            var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
            if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
              return false;
            }
            var key;
            for (key in obj) {
            }
            return typeof key === "undefined" || hasOwn.call(obj, key);
          };
          var setProperty = function setProperty2(target, options) {
            if (defineProperty && options.name === "__proto__") {
              defineProperty(target, options.name, {
                enumerable: true,
                configurable: true,
                value: options.newValue,
                writable: true
              });
            } else {
              target[options.name] = options.newValue;
            }
          };
          var getProperty = function getProperty2(obj, name) {
            if (name === "__proto__") {
              if (!hasOwn.call(obj, name)) {
                return void 0;
              } else if (gOPD) {
                return gOPD(obj, name).value;
              }
            }
            return obj[name];
          };
          module2.exports = function extend() {
            var options, name, src, copy, copyIsArray, clone;
            var target = arguments[0];
            var i = 1;
            var length = arguments.length;
            var deep = false;
            if (typeof target === "boolean") {
              deep = target;
              target = arguments[1] || {};
              i = 2;
            }
            if (target == null || typeof target !== "object" && typeof target !== "function") {
              target = {};
            }
            for (; i < length; ++i) {
              options = arguments[i];
              if (options != null) {
                for (name in options) {
                  src = getProperty(target, name);
                  copy = getProperty(options, name);
                  if (target !== copy) {
                    if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
                      if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && isArray(src) ? src : [];
                      } else {
                        clone = src && isPlainObject(src) ? src : {};
                      }
                      setProperty(target, { name, newValue: extend(deep, clone, copy) });
                    } else if (typeof copy !== "undefined") {
                      setProperty(target, { name, newValue: copy });
                    }
                  }
                }
              }
            }
            return target;
          };
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.default = exports2.BlockEmbed = exports2.bubbleFormats = void 0;
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _extend = __webpack_require__(3);
          var _extend2 = _interopRequireDefault(_extend);
          var _quillDelta = __webpack_require__(2);
          var _quillDelta2 = _interopRequireDefault(_quillDelta);
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _break = __webpack_require__(16);
          var _break2 = _interopRequireDefault(_break);
          var _inline = __webpack_require__(6);
          var _inline2 = _interopRequireDefault(_inline);
          var _text = __webpack_require__(7);
          var _text2 = _interopRequireDefault(_text);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var NEWLINE_LENGTH = 1;
          var BlockEmbed = function(_Parchment$Embed) {
            _inherits(BlockEmbed2, _Parchment$Embed);
            function BlockEmbed2() {
              _classCallCheck(this, BlockEmbed2);
              return _possibleConstructorReturn(this, (BlockEmbed2.__proto__ || Object.getPrototypeOf(BlockEmbed2)).apply(this, arguments));
            }
            _createClass(BlockEmbed2, [{
              key: "attach",
              value: function attach() {
                _get(BlockEmbed2.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed2.prototype), "attach", this).call(this);
                this.attributes = new _parchment2.default.Attributor.Store(this.domNode);
              }
            }, {
              key: "delta",
              value: function delta() {
                return new _quillDelta2.default().insert(this.value(), (0, _extend2.default)(this.formats(), this.attributes.values()));
              }
            }, {
              key: "format",
              value: function format(name, value) {
                var attribute = _parchment2.default.query(name, _parchment2.default.Scope.BLOCK_ATTRIBUTE);
                if (attribute != null) {
                  this.attributes.attribute(attribute, value);
                }
              }
            }, {
              key: "formatAt",
              value: function formatAt(index, length, name, value) {
                this.format(name, value);
              }
            }, {
              key: "insertAt",
              value: function insertAt(index, value, def) {
                if (typeof value === "string" && value.endsWith("\n")) {
                  var block = _parchment2.default.create(Block.blotName);
                  this.parent.insertBefore(block, index === 0 ? this : this.next);
                  block.insertAt(0, value.slice(0, -1));
                } else {
                  _get(BlockEmbed2.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed2.prototype), "insertAt", this).call(this, index, value, def);
                }
              }
            }]);
            return BlockEmbed2;
          }(_parchment2.default.Embed);
          BlockEmbed.scope = _parchment2.default.Scope.BLOCK_BLOT;
          var Block = function(_Parchment$Block) {
            _inherits(Block2, _Parchment$Block);
            function Block2(domNode) {
              _classCallCheck(this, Block2);
              var _this2 = _possibleConstructorReturn(this, (Block2.__proto__ || Object.getPrototypeOf(Block2)).call(this, domNode));
              _this2.cache = {};
              return _this2;
            }
            _createClass(Block2, [{
              key: "delta",
              value: function delta() {
                if (this.cache.delta == null) {
                  this.cache.delta = this.descendants(_parchment2.default.Leaf).reduce(function(delta2, leaf) {
                    if (leaf.length() === 0) {
                      return delta2;
                    } else {
                      return delta2.insert(leaf.value(), bubbleFormats(leaf));
                    }
                  }, new _quillDelta2.default()).insert("\n", bubbleFormats(this));
                }
                return this.cache.delta;
              }
            }, {
              key: "deleteAt",
              value: function deleteAt(index, length) {
                _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "deleteAt", this).call(this, index, length);
                this.cache = {};
              }
            }, {
              key: "formatAt",
              value: function formatAt(index, length, name, value) {
                if (length <= 0)
                  return;
                if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
                  if (index + length === this.length()) {
                    this.format(name, value);
                  }
                } else {
                  _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "formatAt", this).call(this, index, Math.min(length, this.length() - index - 1), name, value);
                }
                this.cache = {};
              }
            }, {
              key: "insertAt",
              value: function insertAt(index, value, def) {
                if (def != null)
                  return _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "insertAt", this).call(this, index, value, def);
                if (value.length === 0)
                  return;
                var lines = value.split("\n");
                var text = lines.shift();
                if (text.length > 0) {
                  if (index < this.length() - 1 || this.children.tail == null) {
                    _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "insertAt", this).call(this, Math.min(index, this.length() - 1), text);
                  } else {
                    this.children.tail.insertAt(this.children.tail.length(), text);
                  }
                  this.cache = {};
                }
                var block = this;
                lines.reduce(function(index2, line) {
                  block = block.split(index2, true);
                  block.insertAt(0, line);
                  return line.length;
                }, index + text.length);
              }
            }, {
              key: "insertBefore",
              value: function insertBefore(blot, ref) {
                var head = this.children.head;
                _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "insertBefore", this).call(this, blot, ref);
                if (head instanceof _break2.default) {
                  head.remove();
                }
                this.cache = {};
              }
            }, {
              key: "length",
              value: function length() {
                if (this.cache.length == null) {
                  this.cache.length = _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "length", this).call(this) + NEWLINE_LENGTH;
                }
                return this.cache.length;
              }
            }, {
              key: "moveChildren",
              value: function moveChildren(target, ref) {
                _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "moveChildren", this).call(this, target, ref);
                this.cache = {};
              }
            }, {
              key: "optimize",
              value: function optimize(context) {
                _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "optimize", this).call(this, context);
                this.cache = {};
              }
            }, {
              key: "path",
              value: function path(index) {
                return _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "path", this).call(this, index, true);
              }
            }, {
              key: "removeChild",
              value: function removeChild(child) {
                _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "removeChild", this).call(this, child);
                this.cache = {};
              }
            }, {
              key: "split",
              value: function split(index) {
                var force = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (force && (index === 0 || index >= this.length() - NEWLINE_LENGTH)) {
                  var clone = this.clone();
                  if (index === 0) {
                    this.parent.insertBefore(clone, this);
                    return this;
                  } else {
                    this.parent.insertBefore(clone, this.next);
                    return clone;
                  }
                } else {
                  var next = _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "split", this).call(this, index, force);
                  this.cache = {};
                  return next;
                }
              }
            }]);
            return Block2;
          }(_parchment2.default.Block);
          Block.blotName = "block";
          Block.tagName = "P";
          Block.defaultChild = "break";
          Block.allowedChildren = [_inline2.default, _parchment2.default.Embed, _text2.default];
          function bubbleFormats(blot) {
            var formats = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (blot == null)
              return formats;
            if (typeof blot.formats === "function") {
              formats = (0, _extend2.default)(formats, blot.formats());
            }
            if (blot.parent == null || blot.parent.blotName == "scroll" || blot.parent.statics.scope !== blot.statics.scope) {
              return formats;
            }
            return bubbleFormats(blot.parent, formats);
          }
          exports2.bubbleFormats = bubbleFormats;
          exports2.BlockEmbed = BlockEmbed;
          exports2.default = Block;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.default = exports2.overload = exports2.expandConfig = void 0;
          var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
            return typeof obj;
          } : function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
          var _slicedToArray = function() {
            function sliceIterator(arr, i) {
              var _arr = [];
              var _n = true;
              var _d = false;
              var _e = void 0;
              try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                  _arr.push(_s.value);
                  if (i && _arr.length === i)
                    break;
                }
              } catch (err) {
                _d = true;
                _e = err;
              } finally {
                try {
                  if (!_n && _i["return"])
                    _i["return"]();
                } finally {
                  if (_d)
                    throw _e;
                }
              }
              return _arr;
            }
            return function(arr, i) {
              if (Array.isArray(arr)) {
                return arr;
              } else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
              } else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              }
            };
          }();
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          __webpack_require__(50);
          var _quillDelta = __webpack_require__(2);
          var _quillDelta2 = _interopRequireDefault(_quillDelta);
          var _editor = __webpack_require__(14);
          var _editor2 = _interopRequireDefault(_editor);
          var _emitter3 = __webpack_require__(8);
          var _emitter4 = _interopRequireDefault(_emitter3);
          var _module = __webpack_require__(9);
          var _module2 = _interopRequireDefault(_module);
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _selection = __webpack_require__(15);
          var _selection2 = _interopRequireDefault(_selection);
          var _extend = __webpack_require__(3);
          var _extend2 = _interopRequireDefault(_extend);
          var _logger = __webpack_require__(10);
          var _logger2 = _interopRequireDefault(_logger);
          var _theme = __webpack_require__(34);
          var _theme2 = _interopRequireDefault(_theme);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _defineProperty(obj, key, value) {
            if (key in obj) {
              Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
            } else {
              obj[key] = value;
            }
            return obj;
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          var debug = (0, _logger2.default)("quill");
          var Quill2 = function() {
            _createClass(Quill3, null, [{
              key: "debug",
              value: function debug2(limit) {
                if (limit === true) {
                  limit = "log";
                }
                _logger2.default.level(limit);
              }
            }, {
              key: "find",
              value: function find(node) {
                return node.__quill || _parchment2.default.find(node);
              }
            }, {
              key: "import",
              value: function _import(name) {
                if (this.imports[name] == null) {
                  debug.error("Cannot import " + name + ". Are you sure it was registered?");
                }
                return this.imports[name];
              }
            }, {
              key: "register",
              value: function register(path, target) {
                var _this = this;
                var overwrite = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                if (typeof path !== "string") {
                  var name = path.attrName || path.blotName;
                  if (typeof name === "string") {
                    this.register("formats/" + name, path, target);
                  } else {
                    Object.keys(path).forEach(function(key) {
                      _this.register(key, path[key], target);
                    });
                  }
                } else {
                  if (this.imports[path] != null && !overwrite) {
                    debug.warn("Overwriting " + path + " with", target);
                  }
                  this.imports[path] = target;
                  if ((path.startsWith("blots/") || path.startsWith("formats/")) && target.blotName !== "abstract") {
                    _parchment2.default.register(target);
                  } else if (path.startsWith("modules") && typeof target.register === "function") {
                    target.register();
                  }
                }
              }
            }]);
            function Quill3(container) {
              var _this2 = this;
              var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
              _classCallCheck(this, Quill3);
              this.options = expandConfig(container, options);
              this.container = this.options.container;
              if (this.container == null) {
                return debug.error("Invalid Quill container", container);
              }
              if (this.options.debug) {
                Quill3.debug(this.options.debug);
              }
              var html = this.container.innerHTML.trim();
              this.container.classList.add("ql-container");
              this.container.innerHTML = "";
              this.container.__quill = this;
              this.root = this.addContainer("ql-editor");
              this.root.classList.add("ql-blank");
              this.root.setAttribute("data-gramm", false);
              this.scrollingContainer = this.options.scrollingContainer || this.root;
              this.emitter = new _emitter4.default();
              this.scroll = _parchment2.default.create(this.root, {
                emitter: this.emitter,
                whitelist: this.options.formats
              });
              this.editor = new _editor2.default(this.scroll);
              this.selection = new _selection2.default(this.scroll, this.emitter);
              this.theme = new this.options.theme(this, this.options);
              this.keyboard = this.theme.addModule("keyboard");
              this.clipboard = this.theme.addModule("clipboard");
              this.history = this.theme.addModule("history");
              this.theme.init();
              this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function(type) {
                if (type === _emitter4.default.events.TEXT_CHANGE) {
                  _this2.root.classList.toggle("ql-blank", _this2.editor.isBlank());
                }
              });
              this.emitter.on(_emitter4.default.events.SCROLL_UPDATE, function(source, mutations) {
                var range = _this2.selection.lastRange;
                var index = range && range.length === 0 ? range.index : void 0;
                modify.call(_this2, function() {
                  return _this2.editor.update(null, mutations, index);
                }, source);
              });
              var contents = this.clipboard.convert(`<div class='ql-editor' style="white-space: normal;">` + html + "<p><br></p></div>");
              this.setContents(contents);
              this.history.clear();
              if (this.options.placeholder) {
                this.root.setAttribute("data-placeholder", this.options.placeholder);
              }
              if (this.options.readOnly) {
                this.disable();
              }
            }
            _createClass(Quill3, [{
              key: "addContainer",
              value: function addContainer(container) {
                var refNode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                if (typeof container === "string") {
                  var className = container;
                  container = document.createElement("div");
                  container.classList.add(className);
                }
                this.container.insertBefore(container, refNode);
                return container;
              }
            }, {
              key: "blur",
              value: function blur() {
                this.selection.setRange(null);
              }
            }, {
              key: "deleteText",
              value: function deleteText(index, length, source) {
                var _this3 = this;
                var _overload = overload(index, length, source);
                var _overload2 = _slicedToArray(_overload, 4);
                index = _overload2[0];
                length = _overload2[1];
                source = _overload2[3];
                return modify.call(this, function() {
                  return _this3.editor.deleteText(index, length);
                }, source, index, -1 * length);
              }
            }, {
              key: "disable",
              value: function disable() {
                this.enable(false);
              }
            }, {
              key: "enable",
              value: function enable() {
                var enabled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                this.scroll.enable(enabled);
                this.container.classList.toggle("ql-disabled", !enabled);
              }
            }, {
              key: "focus",
              value: function focus() {
                var scrollTop = this.scrollingContainer.scrollTop;
                this.selection.focus();
                this.scrollingContainer.scrollTop = scrollTop;
                this.scrollIntoView();
              }
            }, {
              key: "format",
              value: function format(name, value) {
                var _this4 = this;
                var source = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _emitter4.default.sources.API;
                return modify.call(this, function() {
                  var range = _this4.getSelection(true);
                  var change = new _quillDelta2.default();
                  if (range == null) {
                    return change;
                  } else if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
                    change = _this4.editor.formatLine(range.index, range.length, _defineProperty({}, name, value));
                  } else if (range.length === 0) {
                    _this4.selection.format(name, value);
                    return change;
                  } else {
                    change = _this4.editor.formatText(range.index, range.length, _defineProperty({}, name, value));
                  }
                  _this4.setSelection(range, _emitter4.default.sources.SILENT);
                  return change;
                }, source);
              }
            }, {
              key: "formatLine",
              value: function formatLine(index, length, name, value, source) {
                var _this5 = this;
                var formats = void 0;
                var _overload3 = overload(index, length, name, value, source);
                var _overload4 = _slicedToArray(_overload3, 4);
                index = _overload4[0];
                length = _overload4[1];
                formats = _overload4[2];
                source = _overload4[3];
                return modify.call(this, function() {
                  return _this5.editor.formatLine(index, length, formats);
                }, source, index, 0);
              }
            }, {
              key: "formatText",
              value: function formatText(index, length, name, value, source) {
                var _this6 = this;
                var formats = void 0;
                var _overload5 = overload(index, length, name, value, source);
                var _overload6 = _slicedToArray(_overload5, 4);
                index = _overload6[0];
                length = _overload6[1];
                formats = _overload6[2];
                source = _overload6[3];
                return modify.call(this, function() {
                  return _this6.editor.formatText(index, length, formats);
                }, source, index, 0);
              }
            }, {
              key: "getBounds",
              value: function getBounds(index) {
                var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var bounds = void 0;
                if (typeof index === "number") {
                  bounds = this.selection.getBounds(index, length);
                } else {
                  bounds = this.selection.getBounds(index.index, index.length);
                }
                var containerBounds = this.container.getBoundingClientRect();
                return {
                  bottom: bounds.bottom - containerBounds.top,
                  height: bounds.height,
                  left: bounds.left - containerBounds.left,
                  right: bounds.right - containerBounds.left,
                  top: bounds.top - containerBounds.top,
                  width: bounds.width
                };
              }
            }, {
              key: "getContents",
              value: function getContents() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.getLength() - index;
                var _overload7 = overload(index, length);
                var _overload8 = _slicedToArray(_overload7, 2);
                index = _overload8[0];
                length = _overload8[1];
                return this.editor.getContents(index, length);
              }
            }, {
              key: "getFormat",
              value: function getFormat() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.getSelection(true);
                var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                if (typeof index === "number") {
                  return this.editor.getFormat(index, length);
                } else {
                  return this.editor.getFormat(index.index, index.length);
                }
              }
            }, {
              key: "getIndex",
              value: function getIndex(blot) {
                return blot.offset(this.scroll);
              }
            }, {
              key: "getLength",
              value: function getLength() {
                return this.scroll.length();
              }
            }, {
              key: "getLeaf",
              value: function getLeaf(index) {
                return this.scroll.leaf(index);
              }
            }, {
              key: "getLine",
              value: function getLine(index) {
                return this.scroll.line(index);
              }
            }, {
              key: "getLines",
              value: function getLines() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Number.MAX_VALUE;
                if (typeof index !== "number") {
                  return this.scroll.lines(index.index, index.length);
                } else {
                  return this.scroll.lines(index, length);
                }
              }
            }, {
              key: "getModule",
              value: function getModule(name) {
                return this.theme.modules[name];
              }
            }, {
              key: "getSelection",
              value: function getSelection() {
                var focus = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                if (focus)
                  this.focus();
                this.update();
                return this.selection.getRange()[0];
              }
            }, {
              key: "getText",
              value: function getText() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.getLength() - index;
                var _overload9 = overload(index, length);
                var _overload10 = _slicedToArray(_overload9, 2);
                index = _overload10[0];
                length = _overload10[1];
                return this.editor.getText(index, length);
              }
            }, {
              key: "hasFocus",
              value: function hasFocus() {
                return this.selection.hasFocus();
              }
            }, {
              key: "insertEmbed",
              value: function insertEmbed(index, embed, value) {
                var _this7 = this;
                var source = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Quill3.sources.API;
                return modify.call(this, function() {
                  return _this7.editor.insertEmbed(index, embed, value);
                }, source, index);
              }
            }, {
              key: "insertText",
              value: function insertText(index, text, name, value, source) {
                var _this8 = this;
                var formats = void 0;
                var _overload11 = overload(index, 0, name, value, source);
                var _overload12 = _slicedToArray(_overload11, 4);
                index = _overload12[0];
                formats = _overload12[2];
                source = _overload12[3];
                return modify.call(this, function() {
                  return _this8.editor.insertText(index, text, formats);
                }, source, index, text.length);
              }
            }, {
              key: "isEnabled",
              value: function isEnabled() {
                return !this.container.classList.contains("ql-disabled");
              }
            }, {
              key: "off",
              value: function off() {
                return this.emitter.off.apply(this.emitter, arguments);
              }
            }, {
              key: "on",
              value: function on() {
                return this.emitter.on.apply(this.emitter, arguments);
              }
            }, {
              key: "once",
              value: function once() {
                return this.emitter.once.apply(this.emitter, arguments);
              }
            }, {
              key: "pasteHTML",
              value: function pasteHTML(index, html, source) {
                this.clipboard.dangerouslyPasteHTML(index, html, source);
              }
            }, {
              key: "removeFormat",
              value: function removeFormat(index, length, source) {
                var _this9 = this;
                var _overload13 = overload(index, length, source);
                var _overload14 = _slicedToArray(_overload13, 4);
                index = _overload14[0];
                length = _overload14[1];
                source = _overload14[3];
                return modify.call(this, function() {
                  return _this9.editor.removeFormat(index, length);
                }, source, index);
              }
            }, {
              key: "scrollIntoView",
              value: function scrollIntoView() {
                this.selection.scrollIntoView(this.scrollingContainer);
              }
            }, {
              key: "setContents",
              value: function setContents(delta) {
                var _this10 = this;
                var source = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _emitter4.default.sources.API;
                return modify.call(this, function() {
                  delta = new _quillDelta2.default(delta);
                  var length = _this10.getLength();
                  var deleted = _this10.editor.deleteText(0, length);
                  var applied = _this10.editor.applyDelta(delta);
                  var lastOp = applied.ops[applied.ops.length - 1];
                  if (lastOp != null && typeof lastOp.insert === "string" && lastOp.insert[lastOp.insert.length - 1] === "\n") {
                    _this10.editor.deleteText(_this10.getLength() - 1, 1);
                    applied.delete(1);
                  }
                  var ret = deleted.compose(applied);
                  return ret;
                }, source);
              }
            }, {
              key: "setSelection",
              value: function setSelection(index, length, source) {
                if (index == null) {
                  this.selection.setRange(null, length || Quill3.sources.API);
                } else {
                  var _overload15 = overload(index, length, source);
                  var _overload16 = _slicedToArray(_overload15, 4);
                  index = _overload16[0];
                  length = _overload16[1];
                  source = _overload16[3];
                  this.selection.setRange(new _selection.Range(index, length), source);
                  if (source !== _emitter4.default.sources.SILENT) {
                    this.selection.scrollIntoView(this.scrollingContainer);
                  }
                }
              }
            }, {
              key: "setText",
              value: function setText(text) {
                var source = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _emitter4.default.sources.API;
                var delta = new _quillDelta2.default().insert(text);
                return this.setContents(delta, source);
              }
            }, {
              key: "update",
              value: function update() {
                var source = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _emitter4.default.sources.USER;
                var change = this.scroll.update(source);
                this.selection.update(source);
                return change;
              }
            }, {
              key: "updateContents",
              value: function updateContents(delta) {
                var _this11 = this;
                var source = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _emitter4.default.sources.API;
                return modify.call(this, function() {
                  delta = new _quillDelta2.default(delta);
                  return _this11.editor.applyDelta(delta, source);
                }, source, true);
              }
            }]);
            return Quill3;
          }();
          Quill2.DEFAULTS = {
            bounds: null,
            formats: null,
            modules: {},
            placeholder: "",
            readOnly: false,
            scrollingContainer: null,
            strict: true,
            theme: "default"
          };
          Quill2.events = _emitter4.default.events;
          Quill2.sources = _emitter4.default.sources;
          Quill2.version = false ? "dev" : "1.3.7";
          Quill2.imports = {
            "delta": _quillDelta2.default,
            "parchment": _parchment2.default,
            "core/module": _module2.default,
            "core/theme": _theme2.default
          };
          function expandConfig(container, userConfig) {
            userConfig = (0, _extend2.default)(true, {
              container,
              modules: {
                clipboard: true,
                keyboard: true,
                history: true
              }
            }, userConfig);
            if (!userConfig.theme || userConfig.theme === Quill2.DEFAULTS.theme) {
              userConfig.theme = _theme2.default;
            } else {
              userConfig.theme = Quill2.import("themes/" + userConfig.theme);
              if (userConfig.theme == null) {
                throw new Error("Invalid theme " + userConfig.theme + ". Did you register it?");
              }
            }
            var themeConfig = (0, _extend2.default)(true, {}, userConfig.theme.DEFAULTS);
            [themeConfig, userConfig].forEach(function(config) {
              config.modules = config.modules || {};
              Object.keys(config.modules).forEach(function(module3) {
                if (config.modules[module3] === true) {
                  config.modules[module3] = {};
                }
              });
            });
            var moduleNames = Object.keys(themeConfig.modules).concat(Object.keys(userConfig.modules));
            var moduleConfig = moduleNames.reduce(function(config, name) {
              var moduleClass = Quill2.import("modules/" + name);
              if (moduleClass == null) {
                debug.error("Cannot load " + name + " module. Are you sure you registered it?");
              } else {
                config[name] = moduleClass.DEFAULTS || {};
              }
              return config;
            }, {});
            if (userConfig.modules != null && userConfig.modules.toolbar && userConfig.modules.toolbar.constructor !== Object) {
              userConfig.modules.toolbar = {
                container: userConfig.modules.toolbar
              };
            }
            userConfig = (0, _extend2.default)(true, {}, Quill2.DEFAULTS, { modules: moduleConfig }, themeConfig, userConfig);
            ["bounds", "container", "scrollingContainer"].forEach(function(key) {
              if (typeof userConfig[key] === "string") {
                userConfig[key] = document.querySelector(userConfig[key]);
              }
            });
            userConfig.modules = Object.keys(userConfig.modules).reduce(function(config, name) {
              if (userConfig.modules[name]) {
                config[name] = userConfig.modules[name];
              }
              return config;
            }, {});
            return userConfig;
          }
          function modify(modifier, source, index, shift) {
            if (this.options.strict && !this.isEnabled() && source === _emitter4.default.sources.USER) {
              return new _quillDelta2.default();
            }
            var range = index == null ? null : this.getSelection();
            var oldDelta = this.editor.delta;
            var change = modifier();
            if (range != null) {
              if (index === true)
                index = range.index;
              if (shift == null) {
                range = shiftRange(range, change, source);
              } else if (shift !== 0) {
                range = shiftRange(range, index, shift, source);
              }
              this.setSelection(range, _emitter4.default.sources.SILENT);
            }
            if (change.length() > 0) {
              var _emitter;
              var args = [_emitter4.default.events.TEXT_CHANGE, change, oldDelta, source];
              (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
              if (source !== _emitter4.default.sources.SILENT) {
                var _emitter2;
                (_emitter2 = this.emitter).emit.apply(_emitter2, args);
              }
            }
            return change;
          }
          function overload(index, length, name, value, source) {
            var formats = {};
            if (typeof index.index === "number" && typeof index.length === "number") {
              if (typeof length !== "number") {
                source = value, value = name, name = length, length = index.length, index = index.index;
              } else {
                length = index.length, index = index.index;
              }
            } else if (typeof length !== "number") {
              source = value, value = name, name = length, length = 0;
            }
            if ((typeof name === "undefined" ? "undefined" : _typeof(name)) === "object") {
              formats = name;
              source = value;
            } else if (typeof name === "string") {
              if (value != null) {
                formats[name] = value;
              } else {
                source = name;
              }
            }
            source = source || _emitter4.default.sources.API;
            return [index, length, formats, source];
          }
          function shiftRange(range, index, length, source) {
            if (range == null)
              return null;
            var start = void 0, end = void 0;
            if (index instanceof _quillDelta2.default) {
              var _map = [range.index, range.index + range.length].map(function(pos) {
                return index.transformPosition(pos, source !== _emitter4.default.sources.USER);
              });
              var _map2 = _slicedToArray(_map, 2);
              start = _map2[0];
              end = _map2[1];
            } else {
              var _map3 = [range.index, range.index + range.length].map(function(pos) {
                if (pos < index || pos === index && source === _emitter4.default.sources.USER)
                  return pos;
                if (length >= 0) {
                  return pos + length;
                } else {
                  return Math.max(index, pos + length);
                }
              });
              var _map4 = _slicedToArray(_map3, 2);
              start = _map4[0];
              end = _map4[1];
            }
            return new _selection.Range(start, end - start);
          }
          exports2.expandConfig = expandConfig;
          exports2.overload = overload;
          exports2.default = Quill2;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _text = __webpack_require__(7);
          var _text2 = _interopRequireDefault(_text);
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var Inline = function(_Parchment$Inline) {
            _inherits(Inline2, _Parchment$Inline);
            function Inline2() {
              _classCallCheck(this, Inline2);
              return _possibleConstructorReturn(this, (Inline2.__proto__ || Object.getPrototypeOf(Inline2)).apply(this, arguments));
            }
            _createClass(Inline2, [{
              key: "formatAt",
              value: function formatAt(index, length, name, value) {
                if (Inline2.compare(this.statics.blotName, name) < 0 && _parchment2.default.query(name, _parchment2.default.Scope.BLOT)) {
                  var blot = this.isolate(index, length);
                  if (value) {
                    blot.wrap(name, value);
                  }
                } else {
                  _get(Inline2.prototype.__proto__ || Object.getPrototypeOf(Inline2.prototype), "formatAt", this).call(this, index, length, name, value);
                }
              }
            }, {
              key: "optimize",
              value: function optimize(context) {
                _get(Inline2.prototype.__proto__ || Object.getPrototypeOf(Inline2.prototype), "optimize", this).call(this, context);
                if (this.parent instanceof Inline2 && Inline2.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
                  var parent = this.parent.isolate(this.offset(), this.length());
                  this.moveChildren(parent);
                  parent.wrap(this);
                }
              }
            }], [{
              key: "compare",
              value: function compare(self2, other) {
                var selfIndex = Inline2.order.indexOf(self2);
                var otherIndex = Inline2.order.indexOf(other);
                if (selfIndex >= 0 || otherIndex >= 0) {
                  return selfIndex - otherIndex;
                } else if (self2 === other) {
                  return 0;
                } else if (self2 < other) {
                  return -1;
                } else {
                  return 1;
                }
              }
            }]);
            return Inline2;
          }(_parchment2.default.Inline);
          Inline.allowedChildren = [Inline, _parchment2.default.Embed, _text2.default];
          Inline.order = [
            "cursor",
            "inline",
            "underline",
            "strike",
            "italic",
            "bold",
            "script",
            "link",
            "code"
          ];
          exports2.default = Inline;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var TextBlot = function(_Parchment$Text) {
            _inherits(TextBlot2, _Parchment$Text);
            function TextBlot2() {
              _classCallCheck(this, TextBlot2);
              return _possibleConstructorReturn(this, (TextBlot2.__proto__ || Object.getPrototypeOf(TextBlot2)).apply(this, arguments));
            }
            return TextBlot2;
          }(_parchment2.default.Text);
          exports2.default = TextBlot;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _eventemitter = __webpack_require__(54);
          var _eventemitter2 = _interopRequireDefault(_eventemitter);
          var _logger = __webpack_require__(10);
          var _logger2 = _interopRequireDefault(_logger);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var debug = (0, _logger2.default)("quill:events");
          var EVENTS = ["selectionchange", "mousedown", "mouseup", "click"];
          EVENTS.forEach(function(eventName) {
            document.addEventListener(eventName, function() {
              for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              [].slice.call(document.querySelectorAll(".ql-container")).forEach(function(node) {
                if (node.__quill && node.__quill.emitter) {
                  var _node$__quill$emitter;
                  (_node$__quill$emitter = node.__quill.emitter).handleDOM.apply(_node$__quill$emitter, args);
                }
              });
            });
          });
          var Emitter = function(_EventEmitter) {
            _inherits(Emitter2, _EventEmitter);
            function Emitter2() {
              _classCallCheck(this, Emitter2);
              var _this = _possibleConstructorReturn(this, (Emitter2.__proto__ || Object.getPrototypeOf(Emitter2)).call(this));
              _this.listeners = {};
              _this.on("error", debug.error);
              return _this;
            }
            _createClass(Emitter2, [{
              key: "emit",
              value: function emit() {
                debug.log.apply(debug, arguments);
                _get(Emitter2.prototype.__proto__ || Object.getPrototypeOf(Emitter2.prototype), "emit", this).apply(this, arguments);
              }
            }, {
              key: "handleDOM",
              value: function handleDOM(event) {
                for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                  args[_key2 - 1] = arguments[_key2];
                }
                (this.listeners[event.type] || []).forEach(function(_ref) {
                  var node = _ref.node, handler = _ref.handler;
                  if (event.target === node || node.contains(event.target)) {
                    handler.apply(void 0, [event].concat(args));
                  }
                });
              }
            }, {
              key: "listenDOM",
              value: function listenDOM(eventName, node, handler) {
                if (!this.listeners[eventName]) {
                  this.listeners[eventName] = [];
                }
                this.listeners[eventName].push({ node, handler });
              }
            }]);
            return Emitter2;
          }(_eventemitter2.default);
          Emitter.events = {
            EDITOR_CHANGE: "editor-change",
            SCROLL_BEFORE_UPDATE: "scroll-before-update",
            SCROLL_OPTIMIZE: "scroll-optimize",
            SCROLL_UPDATE: "scroll-update",
            SELECTION_CHANGE: "selection-change",
            TEXT_CHANGE: "text-change"
          };
          Emitter.sources = {
            API: "api",
            SILENT: "silent",
            USER: "user"
          };
          exports2.default = Emitter;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          var Module = function Module2(quill) {
            var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            _classCallCheck(this, Module2);
            this.quill = quill;
            this.options = options;
          };
          Module.DEFAULTS = {};
          exports2.default = Module;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var levels = ["error", "warn", "log", "info"];
          var level = "warn";
          function debug(method) {
            if (levels.indexOf(method) <= levels.indexOf(level)) {
              var _console;
              for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = arguments[_key];
              }
              (_console = console)[method].apply(_console, args);
            }
          }
          function namespace(ns) {
            return levels.reduce(function(logger, method) {
              logger[method] = debug.bind(console, method, ns);
              return logger;
            }, {});
          }
          debug.level = namespace.level = function(newLevel) {
            level = newLevel;
          };
          exports2.default = namespace;
        },
        function(module2, exports2, __webpack_require__) {
          var pSlice = Array.prototype.slice;
          var objectKeys = __webpack_require__(52);
          var isArguments = __webpack_require__(53);
          var deepEqual = module2.exports = function(actual, expected, opts) {
            if (!opts)
              opts = {};
            if (actual === expected) {
              return true;
            } else if (actual instanceof Date && expected instanceof Date) {
              return actual.getTime() === expected.getTime();
            } else if (!actual || !expected || typeof actual != "object" && typeof expected != "object") {
              return opts.strict ? actual === expected : actual == expected;
            } else {
              return objEquiv(actual, expected, opts);
            }
          };
          function isUndefinedOrNull(value) {
            return value === null || value === void 0;
          }
          function isBuffer(x) {
            if (!x || typeof x !== "object" || typeof x.length !== "number")
              return false;
            if (typeof x.copy !== "function" || typeof x.slice !== "function") {
              return false;
            }
            if (x.length > 0 && typeof x[0] !== "number")
              return false;
            return true;
          }
          function objEquiv(a, b, opts) {
            var i, key;
            if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
              return false;
            if (a.prototype !== b.prototype)
              return false;
            if (isArguments(a)) {
              if (!isArguments(b)) {
                return false;
              }
              a = pSlice.call(a);
              b = pSlice.call(b);
              return deepEqual(a, b, opts);
            }
            if (isBuffer(a)) {
              if (!isBuffer(b)) {
                return false;
              }
              if (a.length !== b.length)
                return false;
              for (i = 0; i < a.length; i++) {
                if (a[i] !== b[i])
                  return false;
              }
              return true;
            }
            try {
              var ka = objectKeys(a), kb = objectKeys(b);
            } catch (e) {
              return false;
            }
            if (ka.length != kb.length)
              return false;
            ka.sort();
            kb.sort();
            for (i = ka.length - 1; i >= 0; i--) {
              if (ka[i] != kb[i])
                return false;
            }
            for (i = ka.length - 1; i >= 0; i--) {
              key = ka[i];
              if (!deepEqual(a[key], b[key], opts))
                return false;
            }
            return typeof a === typeof b;
          }
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", { value: true });
          var Registry = __webpack_require__(1);
          var Attributor = function() {
            function Attributor2(attrName, keyName, options) {
              if (options === void 0) {
                options = {};
              }
              this.attrName = attrName;
              this.keyName = keyName;
              var attributeBit = Registry.Scope.TYPE & Registry.Scope.ATTRIBUTE;
              if (options.scope != null) {
                this.scope = options.scope & Registry.Scope.LEVEL | attributeBit;
              } else {
                this.scope = Registry.Scope.ATTRIBUTE;
              }
              if (options.whitelist != null)
                this.whitelist = options.whitelist;
            }
            Attributor2.keys = function(node) {
              return [].map.call(node.attributes, function(item) {
                return item.name;
              });
            };
            Attributor2.prototype.add = function(node, value) {
              if (!this.canAdd(node, value))
                return false;
              node.setAttribute(this.keyName, value);
              return true;
            };
            Attributor2.prototype.canAdd = function(node, value) {
              var match = Registry.query(node, Registry.Scope.BLOT & (this.scope | Registry.Scope.TYPE));
              if (match == null)
                return false;
              if (this.whitelist == null)
                return true;
              if (typeof value === "string") {
                return this.whitelist.indexOf(value.replace(/["']/g, "")) > -1;
              } else {
                return this.whitelist.indexOf(value) > -1;
              }
            };
            Attributor2.prototype.remove = function(node) {
              node.removeAttribute(this.keyName);
            };
            Attributor2.prototype.value = function(node) {
              var value = node.getAttribute(this.keyName);
              if (this.canAdd(node, value) && value) {
                return value;
              }
              return "";
            };
            return Attributor2;
          }();
          exports2.default = Attributor;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.default = exports2.Code = void 0;
          var _slicedToArray = function() {
            function sliceIterator(arr, i) {
              var _arr = [];
              var _n = true;
              var _d = false;
              var _e = void 0;
              try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                  _arr.push(_s.value);
                  if (i && _arr.length === i)
                    break;
                }
              } catch (err) {
                _d = true;
                _e = err;
              } finally {
                try {
                  if (!_n && _i["return"])
                    _i["return"]();
                } finally {
                  if (_d)
                    throw _e;
                }
              }
              return _arr;
            }
            return function(arr, i) {
              if (Array.isArray(arr)) {
                return arr;
              } else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
              } else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              }
            };
          }();
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _quillDelta = __webpack_require__(2);
          var _quillDelta2 = _interopRequireDefault(_quillDelta);
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _block = __webpack_require__(4);
          var _block2 = _interopRequireDefault(_block);
          var _inline = __webpack_require__(6);
          var _inline2 = _interopRequireDefault(_inline);
          var _text = __webpack_require__(7);
          var _text2 = _interopRequireDefault(_text);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var Code = function(_Inline) {
            _inherits(Code2, _Inline);
            function Code2() {
              _classCallCheck(this, Code2);
              return _possibleConstructorReturn(this, (Code2.__proto__ || Object.getPrototypeOf(Code2)).apply(this, arguments));
            }
            return Code2;
          }(_inline2.default);
          Code.blotName = "code";
          Code.tagName = "CODE";
          var CodeBlock = function(_Block) {
            _inherits(CodeBlock2, _Block);
            function CodeBlock2() {
              _classCallCheck(this, CodeBlock2);
              return _possibleConstructorReturn(this, (CodeBlock2.__proto__ || Object.getPrototypeOf(CodeBlock2)).apply(this, arguments));
            }
            _createClass(CodeBlock2, [{
              key: "delta",
              value: function delta() {
                var _this3 = this;
                var text = this.domNode.textContent;
                if (text.endsWith("\n")) {
                  text = text.slice(0, -1);
                }
                return text.split("\n").reduce(function(delta2, frag) {
                  return delta2.insert(frag).insert("\n", _this3.formats());
                }, new _quillDelta2.default());
              }
            }, {
              key: "format",
              value: function format(name, value) {
                if (name === this.statics.blotName && value)
                  return;
                var _descendant = this.descendant(_text2.default, this.length() - 1), _descendant2 = _slicedToArray(_descendant, 1), text = _descendant2[0];
                if (text != null) {
                  text.deleteAt(text.length() - 1, 1);
                }
                _get(CodeBlock2.prototype.__proto__ || Object.getPrototypeOf(CodeBlock2.prototype), "format", this).call(this, name, value);
              }
            }, {
              key: "formatAt",
              value: function formatAt(index, length, name, value) {
                if (length === 0)
                  return;
                if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK) == null || name === this.statics.blotName && value === this.statics.formats(this.domNode)) {
                  return;
                }
                var nextNewline = this.newlineIndex(index);
                if (nextNewline < 0 || nextNewline >= index + length)
                  return;
                var prevNewline = this.newlineIndex(index, true) + 1;
                var isolateLength = nextNewline - prevNewline + 1;
                var blot = this.isolate(prevNewline, isolateLength);
                var next = blot.next;
                blot.format(name, value);
                if (next instanceof CodeBlock2) {
                  next.formatAt(0, index - prevNewline + length - isolateLength, name, value);
                }
              }
            }, {
              key: "insertAt",
              value: function insertAt(index, value, def) {
                if (def != null)
                  return;
                var _descendant3 = this.descendant(_text2.default, index), _descendant4 = _slicedToArray(_descendant3, 2), text = _descendant4[0], offset = _descendant4[1];
                text.insertAt(offset, value);
              }
            }, {
              key: "length",
              value: function length() {
                var length2 = this.domNode.textContent.length;
                if (!this.domNode.textContent.endsWith("\n")) {
                  return length2 + 1;
                }
                return length2;
              }
            }, {
              key: "newlineIndex",
              value: function newlineIndex(searchIndex) {
                var reverse = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (!reverse) {
                  var offset = this.domNode.textContent.slice(searchIndex).indexOf("\n");
                  return offset > -1 ? searchIndex + offset : -1;
                } else {
                  return this.domNode.textContent.slice(0, searchIndex).lastIndexOf("\n");
                }
              }
            }, {
              key: "optimize",
              value: function optimize(context) {
                if (!this.domNode.textContent.endsWith("\n")) {
                  this.appendChild(_parchment2.default.create("text", "\n"));
                }
                _get(CodeBlock2.prototype.__proto__ || Object.getPrototypeOf(CodeBlock2.prototype), "optimize", this).call(this, context);
                var next = this.next;
                if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === next.statics.formats(next.domNode)) {
                  next.optimize(context);
                  next.moveChildren(this);
                  next.remove();
                }
              }
            }, {
              key: "replace",
              value: function replace(target) {
                _get(CodeBlock2.prototype.__proto__ || Object.getPrototypeOf(CodeBlock2.prototype), "replace", this).call(this, target);
                [].slice.call(this.domNode.querySelectorAll("*")).forEach(function(node) {
                  var blot = _parchment2.default.find(node);
                  if (blot == null) {
                    node.parentNode.removeChild(node);
                  } else if (blot instanceof _parchment2.default.Embed) {
                    blot.remove();
                  } else {
                    blot.unwrap();
                  }
                });
              }
            }], [{
              key: "create",
              value: function create(value) {
                var domNode = _get(CodeBlock2.__proto__ || Object.getPrototypeOf(CodeBlock2), "create", this).call(this, value);
                domNode.setAttribute("spellcheck", false);
                return domNode;
              }
            }, {
              key: "formats",
              value: function formats() {
                return true;
              }
            }]);
            return CodeBlock2;
          }(_block2.default);
          CodeBlock.blotName = "code-block";
          CodeBlock.tagName = "PRE";
          CodeBlock.TAB = "  ";
          exports2.Code = Code;
          exports2.default = CodeBlock;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
            return typeof obj;
          } : function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
          var _slicedToArray = function() {
            function sliceIterator(arr, i) {
              var _arr = [];
              var _n = true;
              var _d = false;
              var _e = void 0;
              try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                  _arr.push(_s.value);
                  if (i && _arr.length === i)
                    break;
                }
              } catch (err) {
                _d = true;
                _e = err;
              } finally {
                try {
                  if (!_n && _i["return"])
                    _i["return"]();
                } finally {
                  if (_d)
                    throw _e;
                }
              }
              return _arr;
            }
            return function(arr, i) {
              if (Array.isArray(arr)) {
                return arr;
              } else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
              } else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              }
            };
          }();
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _quillDelta = __webpack_require__(2);
          var _quillDelta2 = _interopRequireDefault(_quillDelta);
          var _op = __webpack_require__(20);
          var _op2 = _interopRequireDefault(_op);
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _code = __webpack_require__(13);
          var _code2 = _interopRequireDefault(_code);
          var _cursor = __webpack_require__(24);
          var _cursor2 = _interopRequireDefault(_cursor);
          var _block = __webpack_require__(4);
          var _block2 = _interopRequireDefault(_block);
          var _break = __webpack_require__(16);
          var _break2 = _interopRequireDefault(_break);
          var _clone = __webpack_require__(21);
          var _clone2 = _interopRequireDefault(_clone);
          var _deepEqual = __webpack_require__(11);
          var _deepEqual2 = _interopRequireDefault(_deepEqual);
          var _extend = __webpack_require__(3);
          var _extend2 = _interopRequireDefault(_extend);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _defineProperty(obj, key, value) {
            if (key in obj) {
              Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
            } else {
              obj[key] = value;
            }
            return obj;
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          var ASCII = /^[ -~]*$/;
          var Editor = function() {
            function Editor2(scroll) {
              _classCallCheck(this, Editor2);
              this.scroll = scroll;
              this.delta = this.getDelta();
            }
            _createClass(Editor2, [{
              key: "applyDelta",
              value: function applyDelta(delta) {
                var _this = this;
                var consumeNextNewline = false;
                this.scroll.update();
                var scrollLength = this.scroll.length();
                this.scroll.batchStart();
                delta = normalizeDelta(delta);
                delta.reduce(function(index, op) {
                  var length = op.retain || op.delete || op.insert.length || 1;
                  var attributes = op.attributes || {};
                  if (op.insert != null) {
                    if (typeof op.insert === "string") {
                      var text = op.insert;
                      if (text.endsWith("\n") && consumeNextNewline) {
                        consumeNextNewline = false;
                        text = text.slice(0, -1);
                      }
                      if (index >= scrollLength && !text.endsWith("\n")) {
                        consumeNextNewline = true;
                      }
                      _this.scroll.insertAt(index, text);
                      var _scroll$line = _this.scroll.line(index), _scroll$line2 = _slicedToArray(_scroll$line, 2), line = _scroll$line2[0], offset = _scroll$line2[1];
                      var formats = (0, _extend2.default)({}, (0, _block.bubbleFormats)(line));
                      if (line instanceof _block2.default) {
                        var _line$descendant = line.descendant(_parchment2.default.Leaf, offset), _line$descendant2 = _slicedToArray(_line$descendant, 1), leaf = _line$descendant2[0];
                        formats = (0, _extend2.default)(formats, (0, _block.bubbleFormats)(leaf));
                      }
                      attributes = _op2.default.attributes.diff(formats, attributes) || {};
                    } else if (_typeof(op.insert) === "object") {
                      var key = Object.keys(op.insert)[0];
                      if (key == null)
                        return index;
                      _this.scroll.insertAt(index, key, op.insert[key]);
                    }
                    scrollLength += length;
                  }
                  Object.keys(attributes).forEach(function(name) {
                    _this.scroll.formatAt(index, length, name, attributes[name]);
                  });
                  return index + length;
                }, 0);
                delta.reduce(function(index, op) {
                  if (typeof op.delete === "number") {
                    _this.scroll.deleteAt(index, op.delete);
                    return index;
                  }
                  return index + (op.retain || op.insert.length || 1);
                }, 0);
                this.scroll.batchEnd();
                return this.update(delta);
              }
            }, {
              key: "deleteText",
              value: function deleteText(index, length) {
                this.scroll.deleteAt(index, length);
                return this.update(new _quillDelta2.default().retain(index).delete(length));
              }
            }, {
              key: "formatLine",
              value: function formatLine(index, length) {
                var _this2 = this;
                var formats = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                this.scroll.update();
                Object.keys(formats).forEach(function(format) {
                  if (_this2.scroll.whitelist != null && !_this2.scroll.whitelist[format])
                    return;
                  var lines = _this2.scroll.lines(index, Math.max(length, 1));
                  var lengthRemaining = length;
                  lines.forEach(function(line) {
                    var lineLength = line.length();
                    if (!(line instanceof _code2.default)) {
                      line.format(format, formats[format]);
                    } else {
                      var codeIndex = index - line.offset(_this2.scroll);
                      var codeLength = line.newlineIndex(codeIndex + lengthRemaining) - codeIndex + 1;
                      line.formatAt(codeIndex, codeLength, format, formats[format]);
                    }
                    lengthRemaining -= lineLength;
                  });
                });
                this.scroll.optimize();
                return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
              }
            }, {
              key: "formatText",
              value: function formatText(index, length) {
                var _this3 = this;
                var formats = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                Object.keys(formats).forEach(function(format) {
                  _this3.scroll.formatAt(index, length, format, formats[format]);
                });
                return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
              }
            }, {
              key: "getContents",
              value: function getContents(index, length) {
                return this.delta.slice(index, index + length);
              }
            }, {
              key: "getDelta",
              value: function getDelta() {
                return this.scroll.lines().reduce(function(delta, line) {
                  return delta.concat(line.delta());
                }, new _quillDelta2.default());
              }
            }, {
              key: "getFormat",
              value: function getFormat(index) {
                var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var lines = [], leaves = [];
                if (length === 0) {
                  this.scroll.path(index).forEach(function(path) {
                    var _path = _slicedToArray(path, 1), blot = _path[0];
                    if (blot instanceof _block2.default) {
                      lines.push(blot);
                    } else if (blot instanceof _parchment2.default.Leaf) {
                      leaves.push(blot);
                    }
                  });
                } else {
                  lines = this.scroll.lines(index, length);
                  leaves = this.scroll.descendants(_parchment2.default.Leaf, index, length);
                }
                var formatsArr = [lines, leaves].map(function(blots) {
                  if (blots.length === 0)
                    return {};
                  var formats = (0, _block.bubbleFormats)(blots.shift());
                  while (Object.keys(formats).length > 0) {
                    var blot = blots.shift();
                    if (blot == null)
                      return formats;
                    formats = combineFormats((0, _block.bubbleFormats)(blot), formats);
                  }
                  return formats;
                });
                return _extend2.default.apply(_extend2.default, formatsArr);
              }
            }, {
              key: "getText",
              value: function getText(index, length) {
                return this.getContents(index, length).filter(function(op) {
                  return typeof op.insert === "string";
                }).map(function(op) {
                  return op.insert;
                }).join("");
              }
            }, {
              key: "insertEmbed",
              value: function insertEmbed(index, embed, value) {
                this.scroll.insertAt(index, embed, value);
                return this.update(new _quillDelta2.default().retain(index).insert(_defineProperty({}, embed, value)));
              }
            }, {
              key: "insertText",
              value: function insertText(index, text) {
                var _this4 = this;
                var formats = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                text = text.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
                this.scroll.insertAt(index, text);
                Object.keys(formats).forEach(function(format) {
                  _this4.scroll.formatAt(index, text.length, format, formats[format]);
                });
                return this.update(new _quillDelta2.default().retain(index).insert(text, (0, _clone2.default)(formats)));
              }
            }, {
              key: "isBlank",
              value: function isBlank() {
                if (this.scroll.children.length == 0)
                  return true;
                if (this.scroll.children.length > 1)
                  return false;
                var block = this.scroll.children.head;
                if (block.statics.blotName !== _block2.default.blotName)
                  return false;
                if (block.children.length > 1)
                  return false;
                return block.children.head instanceof _break2.default;
              }
            }, {
              key: "removeFormat",
              value: function removeFormat(index, length) {
                var text = this.getText(index, length);
                var _scroll$line3 = this.scroll.line(index + length), _scroll$line4 = _slicedToArray(_scroll$line3, 2), line = _scroll$line4[0], offset = _scroll$line4[1];
                var suffixLength = 0, suffix = new _quillDelta2.default();
                if (line != null) {
                  if (!(line instanceof _code2.default)) {
                    suffixLength = line.length() - offset;
                  } else {
                    suffixLength = line.newlineIndex(offset) - offset + 1;
                  }
                  suffix = line.delta().slice(offset, offset + suffixLength - 1).insert("\n");
                }
                var contents = this.getContents(index, length + suffixLength);
                var diff = contents.diff(new _quillDelta2.default().insert(text).concat(suffix));
                var delta = new _quillDelta2.default().retain(index).concat(diff);
                return this.applyDelta(delta);
              }
            }, {
              key: "update",
              value: function update(change) {
                var mutations = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
                var cursorIndex = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0;
                var oldDelta = this.delta;
                if (mutations.length === 1 && mutations[0].type === "characterData" && mutations[0].target.data.match(ASCII) && _parchment2.default.find(mutations[0].target)) {
                  var textBlot = _parchment2.default.find(mutations[0].target);
                  var formats = (0, _block.bubbleFormats)(textBlot);
                  var index = textBlot.offset(this.scroll);
                  var oldValue = mutations[0].oldValue.replace(_cursor2.default.CONTENTS, "");
                  var oldText = new _quillDelta2.default().insert(oldValue);
                  var newText = new _quillDelta2.default().insert(textBlot.value());
                  var diffDelta = new _quillDelta2.default().retain(index).concat(oldText.diff(newText, cursorIndex));
                  change = diffDelta.reduce(function(delta, op) {
                    if (op.insert) {
                      return delta.insert(op.insert, formats);
                    } else {
                      return delta.push(op);
                    }
                  }, new _quillDelta2.default());
                  this.delta = oldDelta.compose(change);
                } else {
                  this.delta = this.getDelta();
                  if (!change || !(0, _deepEqual2.default)(oldDelta.compose(change), this.delta)) {
                    change = oldDelta.diff(this.delta, cursorIndex);
                  }
                }
                return change;
              }
            }]);
            return Editor2;
          }();
          function combineFormats(formats, combined) {
            return Object.keys(combined).reduce(function(merged, name) {
              if (formats[name] == null)
                return merged;
              if (combined[name] === formats[name]) {
                merged[name] = combined[name];
              } else if (Array.isArray(combined[name])) {
                if (combined[name].indexOf(formats[name]) < 0) {
                  merged[name] = combined[name].concat([formats[name]]);
                }
              } else {
                merged[name] = [combined[name], formats[name]];
              }
              return merged;
            }, {});
          }
          function normalizeDelta(delta) {
            return delta.reduce(function(delta2, op) {
              if (op.insert === 1) {
                var attributes = (0, _clone2.default)(op.attributes);
                delete attributes["image"];
                return delta2.insert({ image: op.attributes.image }, attributes);
              }
              if (op.attributes != null && (op.attributes.list === true || op.attributes.bullet === true)) {
                op = (0, _clone2.default)(op);
                if (op.attributes.list) {
                  op.attributes.list = "ordered";
                } else {
                  op.attributes.list = "bullet";
                  delete op.attributes.bullet;
                }
              }
              if (typeof op.insert === "string") {
                var text = op.insert.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
                return delta2.insert(text, op.attributes);
              }
              return delta2.push(op);
            }, new _quillDelta2.default());
          }
          exports2.default = Editor;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.default = exports2.Range = void 0;
          var _slicedToArray = function() {
            function sliceIterator(arr, i) {
              var _arr = [];
              var _n = true;
              var _d = false;
              var _e = void 0;
              try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                  _arr.push(_s.value);
                  if (i && _arr.length === i)
                    break;
                }
              } catch (err) {
                _d = true;
                _e = err;
              } finally {
                try {
                  if (!_n && _i["return"])
                    _i["return"]();
                } finally {
                  if (_d)
                    throw _e;
                }
              }
              return _arr;
            }
            return function(arr, i) {
              if (Array.isArray(arr)) {
                return arr;
              } else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
              } else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              }
            };
          }();
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _clone = __webpack_require__(21);
          var _clone2 = _interopRequireDefault(_clone);
          var _deepEqual = __webpack_require__(11);
          var _deepEqual2 = _interopRequireDefault(_deepEqual);
          var _emitter3 = __webpack_require__(8);
          var _emitter4 = _interopRequireDefault(_emitter3);
          var _logger = __webpack_require__(10);
          var _logger2 = _interopRequireDefault(_logger);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _toConsumableArray(arr) {
            if (Array.isArray(arr)) {
              for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
                arr2[i] = arr[i];
              }
              return arr2;
            } else {
              return Array.from(arr);
            }
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          var debug = (0, _logger2.default)("quill:selection");
          var Range = function Range2(index) {
            var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            _classCallCheck(this, Range2);
            this.index = index;
            this.length = length;
          };
          var Selection = function() {
            function Selection2(scroll, emitter) {
              var _this = this;
              _classCallCheck(this, Selection2);
              this.emitter = emitter;
              this.scroll = scroll;
              this.composing = false;
              this.mouseDown = false;
              this.root = this.scroll.domNode;
              this.cursor = _parchment2.default.create("cursor", this);
              this.lastRange = this.savedRange = new Range(0, 0);
              this.handleComposition();
              this.handleDragging();
              this.emitter.listenDOM("selectionchange", document, function() {
                if (!_this.mouseDown) {
                  setTimeout(_this.update.bind(_this, _emitter4.default.sources.USER), 1);
                }
              });
              this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function(type, delta) {
                if (type === _emitter4.default.events.TEXT_CHANGE && delta.length() > 0) {
                  _this.update(_emitter4.default.sources.SILENT);
                }
              });
              this.emitter.on(_emitter4.default.events.SCROLL_BEFORE_UPDATE, function() {
                if (!_this.hasFocus())
                  return;
                var native = _this.getNativeRange();
                if (native == null)
                  return;
                if (native.start.node === _this.cursor.textNode)
                  return;
                _this.emitter.once(_emitter4.default.events.SCROLL_UPDATE, function() {
                  try {
                    _this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
                  } catch (ignored) {
                  }
                });
              });
              this.emitter.on(_emitter4.default.events.SCROLL_OPTIMIZE, function(mutations, context) {
                if (context.range) {
                  var _context$range = context.range, startNode = _context$range.startNode, startOffset = _context$range.startOffset, endNode = _context$range.endNode, endOffset = _context$range.endOffset;
                  _this.setNativeRange(startNode, startOffset, endNode, endOffset);
                }
              });
              this.update(_emitter4.default.sources.SILENT);
            }
            _createClass(Selection2, [{
              key: "handleComposition",
              value: function handleComposition() {
                var _this2 = this;
                this.root.addEventListener("compositionstart", function() {
                  _this2.composing = true;
                });
                this.root.addEventListener("compositionend", function() {
                  _this2.composing = false;
                  if (_this2.cursor.parent) {
                    var range = _this2.cursor.restore();
                    if (!range)
                      return;
                    setTimeout(function() {
                      _this2.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
                    }, 1);
                  }
                });
              }
            }, {
              key: "handleDragging",
              value: function handleDragging() {
                var _this3 = this;
                this.emitter.listenDOM("mousedown", document.body, function() {
                  _this3.mouseDown = true;
                });
                this.emitter.listenDOM("mouseup", document.body, function() {
                  _this3.mouseDown = false;
                  _this3.update(_emitter4.default.sources.USER);
                });
              }
            }, {
              key: "focus",
              value: function focus() {
                if (this.hasFocus())
                  return;
                this.root.focus();
                this.setRange(this.savedRange);
              }
            }, {
              key: "format",
              value: function format(_format, value) {
                if (this.scroll.whitelist != null && !this.scroll.whitelist[_format])
                  return;
                this.scroll.update();
                var nativeRange = this.getNativeRange();
                if (nativeRange == null || !nativeRange.native.collapsed || _parchment2.default.query(_format, _parchment2.default.Scope.BLOCK))
                  return;
                if (nativeRange.start.node !== this.cursor.textNode) {
                  var blot = _parchment2.default.find(nativeRange.start.node, false);
                  if (blot == null)
                    return;
                  if (blot instanceof _parchment2.default.Leaf) {
                    var after = blot.split(nativeRange.start.offset);
                    blot.parent.insertBefore(this.cursor, after);
                  } else {
                    blot.insertBefore(this.cursor, nativeRange.start.node);
                  }
                  this.cursor.attach();
                }
                this.cursor.format(_format, value);
                this.scroll.optimize();
                this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
                this.update();
              }
            }, {
              key: "getBounds",
              value: function getBounds(index) {
                var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var scrollLength = this.scroll.length();
                index = Math.min(index, scrollLength - 1);
                length = Math.min(index + length, scrollLength - 1) - index;
                var node = void 0, _scroll$leaf = this.scroll.leaf(index), _scroll$leaf2 = _slicedToArray(_scroll$leaf, 2), leaf = _scroll$leaf2[0], offset = _scroll$leaf2[1];
                if (leaf == null)
                  return null;
                var _leaf$position = leaf.position(offset, true);
                var _leaf$position2 = _slicedToArray(_leaf$position, 2);
                node = _leaf$position2[0];
                offset = _leaf$position2[1];
                var range = document.createRange();
                if (length > 0) {
                  range.setStart(node, offset);
                  var _scroll$leaf3 = this.scroll.leaf(index + length);
                  var _scroll$leaf4 = _slicedToArray(_scroll$leaf3, 2);
                  leaf = _scroll$leaf4[0];
                  offset = _scroll$leaf4[1];
                  if (leaf == null)
                    return null;
                  var _leaf$position3 = leaf.position(offset, true);
                  var _leaf$position4 = _slicedToArray(_leaf$position3, 2);
                  node = _leaf$position4[0];
                  offset = _leaf$position4[1];
                  range.setEnd(node, offset);
                  return range.getBoundingClientRect();
                } else {
                  var side = "left";
                  var rect = void 0;
                  if (node instanceof Text) {
                    if (offset < node.data.length) {
                      range.setStart(node, offset);
                      range.setEnd(node, offset + 1);
                    } else {
                      range.setStart(node, offset - 1);
                      range.setEnd(node, offset);
                      side = "right";
                    }
                    rect = range.getBoundingClientRect();
                  } else {
                    rect = leaf.domNode.getBoundingClientRect();
                    if (offset > 0)
                      side = "right";
                  }
                  return {
                    bottom: rect.top + rect.height,
                    height: rect.height,
                    left: rect[side],
                    right: rect[side],
                    top: rect.top,
                    width: 0
                  };
                }
              }
            }, {
              key: "getNativeRange",
              value: function getNativeRange() {
                var selection = document.getSelection();
                if (selection == null || selection.rangeCount <= 0)
                  return null;
                var nativeRange = selection.getRangeAt(0);
                if (nativeRange == null)
                  return null;
                var range = this.normalizeNative(nativeRange);
                debug.info("getNativeRange", range);
                return range;
              }
            }, {
              key: "getRange",
              value: function getRange() {
                var normalized = this.getNativeRange();
                if (normalized == null)
                  return [null, null];
                var range = this.normalizedToRange(normalized);
                return [range, normalized];
              }
            }, {
              key: "hasFocus",
              value: function hasFocus() {
                return document.activeElement === this.root;
              }
            }, {
              key: "normalizedToRange",
              value: function normalizedToRange(range) {
                var _this4 = this;
                var positions = [[range.start.node, range.start.offset]];
                if (!range.native.collapsed) {
                  positions.push([range.end.node, range.end.offset]);
                }
                var indexes = positions.map(function(position) {
                  var _position = _slicedToArray(position, 2), node = _position[0], offset = _position[1];
                  var blot = _parchment2.default.find(node, true);
                  var index = blot.offset(_this4.scroll);
                  if (offset === 0) {
                    return index;
                  } else if (blot instanceof _parchment2.default.Container) {
                    return index + blot.length();
                  } else {
                    return index + blot.index(node, offset);
                  }
                });
                var end = Math.min(Math.max.apply(Math, _toConsumableArray(indexes)), this.scroll.length() - 1);
                var start = Math.min.apply(Math, [end].concat(_toConsumableArray(indexes)));
                return new Range(start, end - start);
              }
            }, {
              key: "normalizeNative",
              value: function normalizeNative(nativeRange) {
                if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) {
                  return null;
                }
                var range = {
                  start: { node: nativeRange.startContainer, offset: nativeRange.startOffset },
                  end: { node: nativeRange.endContainer, offset: nativeRange.endOffset },
                  native: nativeRange
                };
                [range.start, range.end].forEach(function(position) {
                  var node = position.node, offset = position.offset;
                  while (!(node instanceof Text) && node.childNodes.length > 0) {
                    if (node.childNodes.length > offset) {
                      node = node.childNodes[offset];
                      offset = 0;
                    } else if (node.childNodes.length === offset) {
                      node = node.lastChild;
                      offset = node instanceof Text ? node.data.length : node.childNodes.length + 1;
                    } else {
                      break;
                    }
                  }
                  position.node = node, position.offset = offset;
                });
                return range;
              }
            }, {
              key: "rangeToNative",
              value: function rangeToNative(range) {
                var _this5 = this;
                var indexes = range.collapsed ? [range.index] : [range.index, range.index + range.length];
                var args = [];
                var scrollLength = this.scroll.length();
                indexes.forEach(function(index, i) {
                  index = Math.min(scrollLength - 1, index);
                  var node = void 0, _scroll$leaf5 = _this5.scroll.leaf(index), _scroll$leaf6 = _slicedToArray(_scroll$leaf5, 2), leaf = _scroll$leaf6[0], offset = _scroll$leaf6[1];
                  var _leaf$position5 = leaf.position(offset, i !== 0);
                  var _leaf$position6 = _slicedToArray(_leaf$position5, 2);
                  node = _leaf$position6[0];
                  offset = _leaf$position6[1];
                  args.push(node, offset);
                });
                if (args.length < 2) {
                  args = args.concat(args);
                }
                return args;
              }
            }, {
              key: "scrollIntoView",
              value: function scrollIntoView(scrollingContainer) {
                var range = this.lastRange;
                if (range == null)
                  return;
                var bounds = this.getBounds(range.index, range.length);
                if (bounds == null)
                  return;
                var limit = this.scroll.length() - 1;
                var _scroll$line = this.scroll.line(Math.min(range.index, limit)), _scroll$line2 = _slicedToArray(_scroll$line, 1), first = _scroll$line2[0];
                var last = first;
                if (range.length > 0) {
                  var _scroll$line3 = this.scroll.line(Math.min(range.index + range.length, limit));
                  var _scroll$line4 = _slicedToArray(_scroll$line3, 1);
                  last = _scroll$line4[0];
                }
                if (first == null || last == null)
                  return;
                var scrollBounds = scrollingContainer.getBoundingClientRect();
                if (bounds.top < scrollBounds.top) {
                  scrollingContainer.scrollTop -= scrollBounds.top - bounds.top;
                } else if (bounds.bottom > scrollBounds.bottom) {
                  scrollingContainer.scrollTop += bounds.bottom - scrollBounds.bottom;
                }
              }
            }, {
              key: "setNativeRange",
              value: function setNativeRange(startNode, startOffset) {
                var endNode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : startNode;
                var endOffset = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : startOffset;
                var force = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
                debug.info("setNativeRange", startNode, startOffset, endNode, endOffset);
                if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) {
                  return;
                }
                var selection = document.getSelection();
                if (selection == null)
                  return;
                if (startNode != null) {
                  if (!this.hasFocus())
                    this.root.focus();
                  var native = (this.getNativeRange() || {}).native;
                  if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {
                    if (startNode.tagName == "BR") {
                      startOffset = [].indexOf.call(startNode.parentNode.childNodes, startNode);
                      startNode = startNode.parentNode;
                    }
                    if (endNode.tagName == "BR") {
                      endOffset = [].indexOf.call(endNode.parentNode.childNodes, endNode);
                      endNode = endNode.parentNode;
                    }
                    var range = document.createRange();
                    range.setStart(startNode, startOffset);
                    range.setEnd(endNode, endOffset);
                    selection.removeAllRanges();
                    selection.addRange(range);
                  }
                } else {
                  selection.removeAllRanges();
                  this.root.blur();
                  document.body.focus();
                }
              }
            }, {
              key: "setRange",
              value: function setRange(range) {
                var force = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var source = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _emitter4.default.sources.API;
                if (typeof force === "string") {
                  source = force;
                  force = false;
                }
                debug.info("setRange", range);
                if (range != null) {
                  var args = this.rangeToNative(range);
                  this.setNativeRange.apply(this, _toConsumableArray(args).concat([force]));
                } else {
                  this.setNativeRange(null);
                }
                this.update(source);
              }
            }, {
              key: "update",
              value: function update() {
                var source = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _emitter4.default.sources.USER;
                var oldRange = this.lastRange;
                var _getRange = this.getRange(), _getRange2 = _slicedToArray(_getRange, 2), lastRange = _getRange2[0], nativeRange = _getRange2[1];
                this.lastRange = lastRange;
                if (this.lastRange != null) {
                  this.savedRange = this.lastRange;
                }
                if (!(0, _deepEqual2.default)(oldRange, this.lastRange)) {
                  var _emitter;
                  if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
                    this.cursor.restore();
                  }
                  var args = [_emitter4.default.events.SELECTION_CHANGE, (0, _clone2.default)(this.lastRange), (0, _clone2.default)(oldRange), source];
                  (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
                  if (source !== _emitter4.default.sources.SILENT) {
                    var _emitter2;
                    (_emitter2 = this.emitter).emit.apply(_emitter2, args);
                  }
                }
              }
            }]);
            return Selection2;
          }();
          function contains(parent, descendant) {
            try {
              descendant.parentNode;
            } catch (e) {
              return false;
            }
            if (descendant instanceof Text) {
              descendant = descendant.parentNode;
            }
            return parent.contains(descendant);
          }
          exports2.Range = Range;
          exports2.default = Selection;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var Break = function(_Parchment$Embed) {
            _inherits(Break2, _Parchment$Embed);
            function Break2() {
              _classCallCheck(this, Break2);
              return _possibleConstructorReturn(this, (Break2.__proto__ || Object.getPrototypeOf(Break2)).apply(this, arguments));
            }
            _createClass(Break2, [{
              key: "insertInto",
              value: function insertInto(parent, ref) {
                if (parent.children.length === 0) {
                  _get(Break2.prototype.__proto__ || Object.getPrototypeOf(Break2.prototype), "insertInto", this).call(this, parent, ref);
                } else {
                  this.remove();
                }
              }
            }, {
              key: "length",
              value: function length() {
                return 0;
              }
            }, {
              key: "value",
              value: function value() {
                return "";
              }
            }], [{
              key: "value",
              value: function value() {
                return void 0;
              }
            }]);
            return Break2;
          }(_parchment2.default.Embed);
          Break.blotName = "break";
          Break.tagName = "BR";
          exports2.default = Break;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          var __extends = this && this.__extends || function() {
            var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
              d.__proto__ = b;
            } || function(d, b) {
              for (var p in b)
                if (b.hasOwnProperty(p))
                  d[p] = b[p];
            };
            return function(d, b) {
              extendStatics(d, b);
              function __() {
                this.constructor = d;
              }
              d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            };
          }();
          Object.defineProperty(exports2, "__esModule", { value: true });
          var linked_list_1 = __webpack_require__(44);
          var shadow_1 = __webpack_require__(30);
          var Registry = __webpack_require__(1);
          var ContainerBlot = function(_super) {
            __extends(ContainerBlot2, _super);
            function ContainerBlot2(domNode) {
              var _this = _super.call(this, domNode) || this;
              _this.build();
              return _this;
            }
            ContainerBlot2.prototype.appendChild = function(other) {
              this.insertBefore(other);
            };
            ContainerBlot2.prototype.attach = function() {
              _super.prototype.attach.call(this);
              this.children.forEach(function(child) {
                child.attach();
              });
            };
            ContainerBlot2.prototype.build = function() {
              var _this = this;
              this.children = new linked_list_1.default();
              [].slice.call(this.domNode.childNodes).reverse().forEach(function(node) {
                try {
                  var child = makeBlot(node);
                  _this.insertBefore(child, _this.children.head || void 0);
                } catch (err) {
                  if (err instanceof Registry.ParchmentError)
                    return;
                  else
                    throw err;
                }
              });
            };
            ContainerBlot2.prototype.deleteAt = function(index, length) {
              if (index === 0 && length === this.length()) {
                return this.remove();
              }
              this.children.forEachAt(index, length, function(child, offset, length2) {
                child.deleteAt(offset, length2);
              });
            };
            ContainerBlot2.prototype.descendant = function(criteria, index) {
              var _a2 = this.children.find(index), child = _a2[0], offset = _a2[1];
              if (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) {
                return [child, offset];
              } else if (child instanceof ContainerBlot2) {
                return child.descendant(criteria, offset);
              } else {
                return [null, -1];
              }
            };
            ContainerBlot2.prototype.descendants = function(criteria, index, length) {
              if (index === void 0) {
                index = 0;
              }
              if (length === void 0) {
                length = Number.MAX_VALUE;
              }
              var descendants = [];
              var lengthLeft = length;
              this.children.forEachAt(index, length, function(child, index2, length2) {
                if (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) {
                  descendants.push(child);
                }
                if (child instanceof ContainerBlot2) {
                  descendants = descendants.concat(child.descendants(criteria, index2, lengthLeft));
                }
                lengthLeft -= length2;
              });
              return descendants;
            };
            ContainerBlot2.prototype.detach = function() {
              this.children.forEach(function(child) {
                child.detach();
              });
              _super.prototype.detach.call(this);
            };
            ContainerBlot2.prototype.formatAt = function(index, length, name, value) {
              this.children.forEachAt(index, length, function(child, offset, length2) {
                child.formatAt(offset, length2, name, value);
              });
            };
            ContainerBlot2.prototype.insertAt = function(index, value, def) {
              var _a2 = this.children.find(index), child = _a2[0], offset = _a2[1];
              if (child) {
                child.insertAt(offset, value, def);
              } else {
                var blot = def == null ? Registry.create("text", value) : Registry.create(value, def);
                this.appendChild(blot);
              }
            };
            ContainerBlot2.prototype.insertBefore = function(childBlot, refBlot) {
              if (this.statics.allowedChildren != null && !this.statics.allowedChildren.some(function(child) {
                return childBlot instanceof child;
              })) {
                throw new Registry.ParchmentError("Cannot insert " + childBlot.statics.blotName + " into " + this.statics.blotName);
              }
              childBlot.insertInto(this, refBlot);
            };
            ContainerBlot2.prototype.length = function() {
              return this.children.reduce(function(memo, child) {
                return memo + child.length();
              }, 0);
            };
            ContainerBlot2.prototype.moveChildren = function(targetParent, refNode) {
              this.children.forEach(function(child) {
                targetParent.insertBefore(child, refNode);
              });
            };
            ContainerBlot2.prototype.optimize = function(context) {
              _super.prototype.optimize.call(this, context);
              if (this.children.length === 0) {
                if (this.statics.defaultChild != null) {
                  var child = Registry.create(this.statics.defaultChild);
                  this.appendChild(child);
                  child.optimize(context);
                } else {
                  this.remove();
                }
              }
            };
            ContainerBlot2.prototype.path = function(index, inclusive) {
              if (inclusive === void 0) {
                inclusive = false;
              }
              var _a2 = this.children.find(index, inclusive), child = _a2[0], offset = _a2[1];
              var position = [[this, index]];
              if (child instanceof ContainerBlot2) {
                return position.concat(child.path(offset, inclusive));
              } else if (child != null) {
                position.push([child, offset]);
              }
              return position;
            };
            ContainerBlot2.prototype.removeChild = function(child) {
              this.children.remove(child);
            };
            ContainerBlot2.prototype.replace = function(target) {
              if (target instanceof ContainerBlot2) {
                target.moveChildren(this);
              }
              _super.prototype.replace.call(this, target);
            };
            ContainerBlot2.prototype.split = function(index, force) {
              if (force === void 0) {
                force = false;
              }
              if (!force) {
                if (index === 0)
                  return this;
                if (index === this.length())
                  return this.next;
              }
              var after = this.clone();
              this.parent.insertBefore(after, this.next);
              this.children.forEachAt(index, this.length(), function(child, offset, length) {
                child = child.split(offset, force);
                after.appendChild(child);
              });
              return after;
            };
            ContainerBlot2.prototype.unwrap = function() {
              this.moveChildren(this.parent, this.next);
              this.remove();
            };
            ContainerBlot2.prototype.update = function(mutations, context) {
              var _this = this;
              var addedNodes = [];
              var removedNodes = [];
              mutations.forEach(function(mutation) {
                if (mutation.target === _this.domNode && mutation.type === "childList") {
                  addedNodes.push.apply(addedNodes, mutation.addedNodes);
                  removedNodes.push.apply(removedNodes, mutation.removedNodes);
                }
              });
              removedNodes.forEach(function(node) {
                if (node.parentNode != null && node.tagName !== "IFRAME" && document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
                  return;
                }
                var blot = Registry.find(node);
                if (blot == null)
                  return;
                if (blot.domNode.parentNode == null || blot.domNode.parentNode === _this.domNode) {
                  blot.detach();
                }
              });
              addedNodes.filter(function(node) {
                return node.parentNode == _this.domNode;
              }).sort(function(a, b) {
                if (a === b)
                  return 0;
                if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) {
                  return 1;
                }
                return -1;
              }).forEach(function(node) {
                var refBlot = null;
                if (node.nextSibling != null) {
                  refBlot = Registry.find(node.nextSibling);
                }
                var blot = makeBlot(node);
                if (blot.next != refBlot || blot.next == null) {
                  if (blot.parent != null) {
                    blot.parent.removeChild(_this);
                  }
                  _this.insertBefore(blot, refBlot || void 0);
                }
              });
            };
            return ContainerBlot2;
          }(shadow_1.default);
          function makeBlot(node) {
            var blot = Registry.find(node);
            if (blot == null) {
              try {
                blot = Registry.create(node);
              } catch (e) {
                blot = Registry.create(Registry.Scope.INLINE);
                [].slice.call(node.childNodes).forEach(function(child) {
                  blot.domNode.appendChild(child);
                });
                if (node.parentNode) {
                  node.parentNode.replaceChild(blot.domNode, node);
                }
                blot.attach();
              }
            }
            return blot;
          }
          exports2.default = ContainerBlot;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          var __extends = this && this.__extends || function() {
            var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
              d.__proto__ = b;
            } || function(d, b) {
              for (var p in b)
                if (b.hasOwnProperty(p))
                  d[p] = b[p];
            };
            return function(d, b) {
              extendStatics(d, b);
              function __() {
                this.constructor = d;
              }
              d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            };
          }();
          Object.defineProperty(exports2, "__esModule", { value: true });
          var attributor_1 = __webpack_require__(12);
          var store_1 = __webpack_require__(31);
          var container_1 = __webpack_require__(17);
          var Registry = __webpack_require__(1);
          var FormatBlot = function(_super) {
            __extends(FormatBlot2, _super);
            function FormatBlot2(domNode) {
              var _this = _super.call(this, domNode) || this;
              _this.attributes = new store_1.default(_this.domNode);
              return _this;
            }
            FormatBlot2.formats = function(domNode) {
              if (typeof this.tagName === "string") {
                return true;
              } else if (Array.isArray(this.tagName)) {
                return domNode.tagName.toLowerCase();
              }
              return void 0;
            };
            FormatBlot2.prototype.format = function(name, value) {
              var format = Registry.query(name);
              if (format instanceof attributor_1.default) {
                this.attributes.attribute(format, value);
              } else if (value) {
                if (format != null && (name !== this.statics.blotName || this.formats()[name] !== value)) {
                  this.replaceWith(name, value);
                }
              }
            };
            FormatBlot2.prototype.formats = function() {
              var formats = this.attributes.values();
              var format = this.statics.formats(this.domNode);
              if (format != null) {
                formats[this.statics.blotName] = format;
              }
              return formats;
            };
            FormatBlot2.prototype.replaceWith = function(name, value) {
              var replacement = _super.prototype.replaceWith.call(this, name, value);
              this.attributes.copy(replacement);
              return replacement;
            };
            FormatBlot2.prototype.update = function(mutations, context) {
              var _this = this;
              _super.prototype.update.call(this, mutations, context);
              if (mutations.some(function(mutation) {
                return mutation.target === _this.domNode && mutation.type === "attributes";
              })) {
                this.attributes.build();
              }
            };
            FormatBlot2.prototype.wrap = function(name, value) {
              var wrapper = _super.prototype.wrap.call(this, name, value);
              if (wrapper instanceof FormatBlot2 && wrapper.statics.scope === this.statics.scope) {
                this.attributes.move(wrapper);
              }
              return wrapper;
            };
            return FormatBlot2;
          }(container_1.default);
          exports2.default = FormatBlot;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          var __extends = this && this.__extends || function() {
            var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
              d.__proto__ = b;
            } || function(d, b) {
              for (var p in b)
                if (b.hasOwnProperty(p))
                  d[p] = b[p];
            };
            return function(d, b) {
              extendStatics(d, b);
              function __() {
                this.constructor = d;
              }
              d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            };
          }();
          Object.defineProperty(exports2, "__esModule", { value: true });
          var shadow_1 = __webpack_require__(30);
          var Registry = __webpack_require__(1);
          var LeafBlot = function(_super) {
            __extends(LeafBlot2, _super);
            function LeafBlot2() {
              return _super !== null && _super.apply(this, arguments) || this;
            }
            LeafBlot2.value = function(domNode) {
              return true;
            };
            LeafBlot2.prototype.index = function(node, offset) {
              if (this.domNode === node || this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
                return Math.min(offset, 1);
              }
              return -1;
            };
            LeafBlot2.prototype.position = function(index, inclusive) {
              var offset = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
              if (index > 0)
                offset += 1;
              return [this.parent.domNode, offset];
            };
            LeafBlot2.prototype.value = function() {
              var _a2;
              return _a2 = {}, _a2[this.statics.blotName] = this.statics.value(this.domNode) || true, _a2;
            };
            LeafBlot2.scope = Registry.Scope.INLINE_BLOT;
            return LeafBlot2;
          }(shadow_1.default);
          exports2.default = LeafBlot;
        },
        function(module2, exports2, __webpack_require__) {
          var equal = __webpack_require__(11);
          var extend = __webpack_require__(3);
          var lib = {
            attributes: {
              compose: function(a, b, keepNull) {
                if (typeof a !== "object")
                  a = {};
                if (typeof b !== "object")
                  b = {};
                var attributes = extend(true, {}, b);
                if (!keepNull) {
                  attributes = Object.keys(attributes).reduce(function(copy, key2) {
                    if (attributes[key2] != null) {
                      copy[key2] = attributes[key2];
                    }
                    return copy;
                  }, {});
                }
                for (var key in a) {
                  if (a[key] !== void 0 && b[key] === void 0) {
                    attributes[key] = a[key];
                  }
                }
                return Object.keys(attributes).length > 0 ? attributes : void 0;
              },
              diff: function(a, b) {
                if (typeof a !== "object")
                  a = {};
                if (typeof b !== "object")
                  b = {};
                var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function(attributes2, key) {
                  if (!equal(a[key], b[key])) {
                    attributes2[key] = b[key] === void 0 ? null : b[key];
                  }
                  return attributes2;
                }, {});
                return Object.keys(attributes).length > 0 ? attributes : void 0;
              },
              transform: function(a, b, priority) {
                if (typeof a !== "object")
                  return b;
                if (typeof b !== "object")
                  return void 0;
                if (!priority)
                  return b;
                var attributes = Object.keys(b).reduce(function(attributes2, key) {
                  if (a[key] === void 0)
                    attributes2[key] = b[key];
                  return attributes2;
                }, {});
                return Object.keys(attributes).length > 0 ? attributes : void 0;
              }
            },
            iterator: function(ops) {
              return new Iterator(ops);
            },
            length: function(op) {
              if (typeof op["delete"] === "number") {
                return op["delete"];
              } else if (typeof op.retain === "number") {
                return op.retain;
              } else {
                return typeof op.insert === "string" ? op.insert.length : 1;
              }
            }
          };
          function Iterator(ops) {
            this.ops = ops;
            this.index = 0;
            this.offset = 0;
          }
          ;
          Iterator.prototype.hasNext = function() {
            return this.peekLength() < Infinity;
          };
          Iterator.prototype.next = function(length) {
            if (!length)
              length = Infinity;
            var nextOp = this.ops[this.index];
            if (nextOp) {
              var offset = this.offset;
              var opLength = lib.length(nextOp);
              if (length >= opLength - offset) {
                length = opLength - offset;
                this.index += 1;
                this.offset = 0;
              } else {
                this.offset += length;
              }
              if (typeof nextOp["delete"] === "number") {
                return { "delete": length };
              } else {
                var retOp = {};
                if (nextOp.attributes) {
                  retOp.attributes = nextOp.attributes;
                }
                if (typeof nextOp.retain === "number") {
                  retOp.retain = length;
                } else if (typeof nextOp.insert === "string") {
                  retOp.insert = nextOp.insert.substr(offset, length);
                } else {
                  retOp.insert = nextOp.insert;
                }
                return retOp;
              }
            } else {
              return { retain: Infinity };
            }
          };
          Iterator.prototype.peek = function() {
            return this.ops[this.index];
          };
          Iterator.prototype.peekLength = function() {
            if (this.ops[this.index]) {
              return lib.length(this.ops[this.index]) - this.offset;
            } else {
              return Infinity;
            }
          };
          Iterator.prototype.peekType = function() {
            if (this.ops[this.index]) {
              if (typeof this.ops[this.index]["delete"] === "number") {
                return "delete";
              } else if (typeof this.ops[this.index].retain === "number") {
                return "retain";
              } else {
                return "insert";
              }
            }
            return "retain";
          };
          Iterator.prototype.rest = function() {
            if (!this.hasNext()) {
              return [];
            } else if (this.offset === 0) {
              return this.ops.slice(this.index);
            } else {
              var offset = this.offset;
              var index = this.index;
              var next = this.next();
              var rest = this.ops.slice(this.index);
              this.offset = offset;
              this.index = index;
              return [next].concat(rest);
            }
          };
          module2.exports = lib;
        },
        function(module2, exports2) {
          var clone = function() {
            "use strict";
            function _instanceof(obj, type) {
              return type != null && obj instanceof type;
            }
            var nativeMap;
            try {
              nativeMap = Map;
            } catch (_) {
              nativeMap = function() {
              };
            }
            var nativeSet;
            try {
              nativeSet = Set;
            } catch (_) {
              nativeSet = function() {
              };
            }
            var nativePromise;
            try {
              nativePromise = Promise;
            } catch (_) {
              nativePromise = function() {
              };
            }
            function clone2(parent, circular, depth, prototype, includeNonEnumerable) {
              if (typeof circular === "object") {
                depth = circular.depth;
                prototype = circular.prototype;
                includeNonEnumerable = circular.includeNonEnumerable;
                circular = circular.circular;
              }
              var allParents = [];
              var allChildren = [];
              var useBuffer = typeof Buffer != "undefined";
              if (typeof circular == "undefined")
                circular = true;
              if (typeof depth == "undefined")
                depth = Infinity;
              function _clone(parent2, depth2) {
                if (parent2 === null)
                  return null;
                if (depth2 === 0)
                  return parent2;
                var child;
                var proto;
                if (typeof parent2 != "object") {
                  return parent2;
                }
                if (_instanceof(parent2, nativeMap)) {
                  child = new nativeMap();
                } else if (_instanceof(parent2, nativeSet)) {
                  child = new nativeSet();
                } else if (_instanceof(parent2, nativePromise)) {
                  child = new nativePromise(function(resolve, reject) {
                    parent2.then(function(value) {
                      resolve(_clone(value, depth2 - 1));
                    }, function(err) {
                      reject(_clone(err, depth2 - 1));
                    });
                  });
                } else if (clone2.__isArray(parent2)) {
                  child = [];
                } else if (clone2.__isRegExp(parent2)) {
                  child = new RegExp(parent2.source, __getRegExpFlags(parent2));
                  if (parent2.lastIndex)
                    child.lastIndex = parent2.lastIndex;
                } else if (clone2.__isDate(parent2)) {
                  child = new Date(parent2.getTime());
                } else if (useBuffer && Buffer.isBuffer(parent2)) {
                  if (Buffer.allocUnsafe) {
                    child = Buffer.allocUnsafe(parent2.length);
                  } else {
                    child = new Buffer(parent2.length);
                  }
                  parent2.copy(child);
                  return child;
                } else if (_instanceof(parent2, Error)) {
                  child = Object.create(parent2);
                } else {
                  if (typeof prototype == "undefined") {
                    proto = Object.getPrototypeOf(parent2);
                    child = Object.create(proto);
                  } else {
                    child = Object.create(prototype);
                    proto = prototype;
                  }
                }
                if (circular) {
                  var index = allParents.indexOf(parent2);
                  if (index != -1) {
                    return allChildren[index];
                  }
                  allParents.push(parent2);
                  allChildren.push(child);
                }
                if (_instanceof(parent2, nativeMap)) {
                  parent2.forEach(function(value, key) {
                    var keyChild = _clone(key, depth2 - 1);
                    var valueChild = _clone(value, depth2 - 1);
                    child.set(keyChild, valueChild);
                  });
                }
                if (_instanceof(parent2, nativeSet)) {
                  parent2.forEach(function(value) {
                    var entryChild = _clone(value, depth2 - 1);
                    child.add(entryChild);
                  });
                }
                for (var i in parent2) {
                  var attrs;
                  if (proto) {
                    attrs = Object.getOwnPropertyDescriptor(proto, i);
                  }
                  if (attrs && attrs.set == null) {
                    continue;
                  }
                  child[i] = _clone(parent2[i], depth2 - 1);
                }
                if (Object.getOwnPropertySymbols) {
                  var symbols = Object.getOwnPropertySymbols(parent2);
                  for (var i = 0; i < symbols.length; i++) {
                    var symbol = symbols[i];
                    var descriptor = Object.getOwnPropertyDescriptor(parent2, symbol);
                    if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
                      continue;
                    }
                    child[symbol] = _clone(parent2[symbol], depth2 - 1);
                    if (!descriptor.enumerable) {
                      Object.defineProperty(child, symbol, {
                        enumerable: false
                      });
                    }
                  }
                }
                if (includeNonEnumerable) {
                  var allPropertyNames = Object.getOwnPropertyNames(parent2);
                  for (var i = 0; i < allPropertyNames.length; i++) {
                    var propertyName = allPropertyNames[i];
                    var descriptor = Object.getOwnPropertyDescriptor(parent2, propertyName);
                    if (descriptor && descriptor.enumerable) {
                      continue;
                    }
                    child[propertyName] = _clone(parent2[propertyName], depth2 - 1);
                    Object.defineProperty(child, propertyName, {
                      enumerable: false
                    });
                  }
                }
                return child;
              }
              return _clone(parent, depth);
            }
            clone2.clonePrototype = function clonePrototype(parent) {
              if (parent === null)
                return null;
              var c = function() {
              };
              c.prototype = parent;
              return new c();
            };
            function __objToStr(o) {
              return Object.prototype.toString.call(o);
            }
            clone2.__objToStr = __objToStr;
            function __isDate(o) {
              return typeof o === "object" && __objToStr(o) === "[object Date]";
            }
            clone2.__isDate = __isDate;
            function __isArray(o) {
              return typeof o === "object" && __objToStr(o) === "[object Array]";
            }
            clone2.__isArray = __isArray;
            function __isRegExp(o) {
              return typeof o === "object" && __objToStr(o) === "[object RegExp]";
            }
            clone2.__isRegExp = __isRegExp;
            function __getRegExpFlags(re) {
              var flags = "";
              if (re.global)
                flags += "g";
              if (re.ignoreCase)
                flags += "i";
              if (re.multiline)
                flags += "m";
              return flags;
            }
            clone2.__getRegExpFlags = __getRegExpFlags;
            return clone2;
          }();
          if (typeof module2 === "object" && module2.exports) {
            module2.exports = clone;
          }
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _slicedToArray = function() {
            function sliceIterator(arr, i) {
              var _arr = [];
              var _n = true;
              var _d = false;
              var _e = void 0;
              try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                  _arr.push(_s.value);
                  if (i && _arr.length === i)
                    break;
                }
              } catch (err) {
                _d = true;
                _e = err;
              } finally {
                try {
                  if (!_n && _i["return"])
                    _i["return"]();
                } finally {
                  if (_d)
                    throw _e;
                }
              }
              return _arr;
            }
            return function(arr, i) {
              if (Array.isArray(arr)) {
                return arr;
              } else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
              } else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              }
            };
          }();
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _emitter = __webpack_require__(8);
          var _emitter2 = _interopRequireDefault(_emitter);
          var _block = __webpack_require__(4);
          var _block2 = _interopRequireDefault(_block);
          var _break = __webpack_require__(16);
          var _break2 = _interopRequireDefault(_break);
          var _code = __webpack_require__(13);
          var _code2 = _interopRequireDefault(_code);
          var _container = __webpack_require__(25);
          var _container2 = _interopRequireDefault(_container);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          function isLine(blot) {
            return blot instanceof _block2.default || blot instanceof _block.BlockEmbed;
          }
          var Scroll = function(_Parchment$Scroll) {
            _inherits(Scroll2, _Parchment$Scroll);
            function Scroll2(domNode, config) {
              _classCallCheck(this, Scroll2);
              var _this = _possibleConstructorReturn(this, (Scroll2.__proto__ || Object.getPrototypeOf(Scroll2)).call(this, domNode));
              _this.emitter = config.emitter;
              if (Array.isArray(config.whitelist)) {
                _this.whitelist = config.whitelist.reduce(function(whitelist, format) {
                  whitelist[format] = true;
                  return whitelist;
                }, {});
              }
              _this.domNode.addEventListener("DOMNodeInserted", function() {
              });
              _this.optimize();
              _this.enable();
              return _this;
            }
            _createClass(Scroll2, [{
              key: "batchStart",
              value: function batchStart() {
                this.batch = true;
              }
            }, {
              key: "batchEnd",
              value: function batchEnd() {
                this.batch = false;
                this.optimize();
              }
            }, {
              key: "deleteAt",
              value: function deleteAt(index, length) {
                var _line = this.line(index), _line2 = _slicedToArray(_line, 2), first = _line2[0], offset = _line2[1];
                var _line3 = this.line(index + length), _line4 = _slicedToArray(_line3, 1), last = _line4[0];
                _get(Scroll2.prototype.__proto__ || Object.getPrototypeOf(Scroll2.prototype), "deleteAt", this).call(this, index, length);
                if (last != null && first !== last && offset > 0) {
                  if (first instanceof _block.BlockEmbed || last instanceof _block.BlockEmbed) {
                    this.optimize();
                    return;
                  }
                  if (first instanceof _code2.default) {
                    var newlineIndex = first.newlineIndex(first.length(), true);
                    if (newlineIndex > -1) {
                      first = first.split(newlineIndex + 1);
                      if (first === last) {
                        this.optimize();
                        return;
                      }
                    }
                  } else if (last instanceof _code2.default) {
                    var _newlineIndex = last.newlineIndex(0);
                    if (_newlineIndex > -1) {
                      last.split(_newlineIndex + 1);
                    }
                  }
                  var ref = last.children.head instanceof _break2.default ? null : last.children.head;
                  first.moveChildren(last, ref);
                  first.remove();
                }
                this.optimize();
              }
            }, {
              key: "enable",
              value: function enable() {
                var enabled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                this.domNode.setAttribute("contenteditable", enabled);
              }
            }, {
              key: "formatAt",
              value: function formatAt(index, length, format, value) {
                if (this.whitelist != null && !this.whitelist[format])
                  return;
                _get(Scroll2.prototype.__proto__ || Object.getPrototypeOf(Scroll2.prototype), "formatAt", this).call(this, index, length, format, value);
                this.optimize();
              }
            }, {
              key: "insertAt",
              value: function insertAt(index, value, def) {
                if (def != null && this.whitelist != null && !this.whitelist[value])
                  return;
                if (index >= this.length()) {
                  if (def == null || _parchment2.default.query(value, _parchment2.default.Scope.BLOCK) == null) {
                    var blot = _parchment2.default.create(this.statics.defaultChild);
                    this.appendChild(blot);
                    if (def == null && value.endsWith("\n")) {
                      value = value.slice(0, -1);
                    }
                    blot.insertAt(0, value, def);
                  } else {
                    var embed = _parchment2.default.create(value, def);
                    this.appendChild(embed);
                  }
                } else {
                  _get(Scroll2.prototype.__proto__ || Object.getPrototypeOf(Scroll2.prototype), "insertAt", this).call(this, index, value, def);
                }
                this.optimize();
              }
            }, {
              key: "insertBefore",
              value: function insertBefore(blot, ref) {
                if (blot.statics.scope === _parchment2.default.Scope.INLINE_BLOT) {
                  var wrapper = _parchment2.default.create(this.statics.defaultChild);
                  wrapper.appendChild(blot);
                  blot = wrapper;
                }
                _get(Scroll2.prototype.__proto__ || Object.getPrototypeOf(Scroll2.prototype), "insertBefore", this).call(this, blot, ref);
              }
            }, {
              key: "leaf",
              value: function leaf(index) {
                return this.path(index).pop() || [null, -1];
              }
            }, {
              key: "line",
              value: function line(index) {
                if (index === this.length()) {
                  return this.line(index - 1);
                }
                return this.descendant(isLine, index);
              }
            }, {
              key: "lines",
              value: function lines() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Number.MAX_VALUE;
                var getLines = function getLines2(blot, index2, length2) {
                  var lines2 = [], lengthLeft = length2;
                  blot.children.forEachAt(index2, length2, function(child, index3, length3) {
                    if (isLine(child)) {
                      lines2.push(child);
                    } else if (child instanceof _parchment2.default.Container) {
                      lines2 = lines2.concat(getLines2(child, index3, lengthLeft));
                    }
                    lengthLeft -= length3;
                  });
                  return lines2;
                };
                return getLines(this, index, length);
              }
            }, {
              key: "optimize",
              value: function optimize() {
                var mutations = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (this.batch === true)
                  return;
                _get(Scroll2.prototype.__proto__ || Object.getPrototypeOf(Scroll2.prototype), "optimize", this).call(this, mutations, context);
                if (mutations.length > 0) {
                  this.emitter.emit(_emitter2.default.events.SCROLL_OPTIMIZE, mutations, context);
                }
              }
            }, {
              key: "path",
              value: function path(index) {
                return _get(Scroll2.prototype.__proto__ || Object.getPrototypeOf(Scroll2.prototype), "path", this).call(this, index).slice(1);
              }
            }, {
              key: "update",
              value: function update(mutations) {
                if (this.batch === true)
                  return;
                var source = _emitter2.default.sources.USER;
                if (typeof mutations === "string") {
                  source = mutations;
                }
                if (!Array.isArray(mutations)) {
                  mutations = this.observer.takeRecords();
                }
                if (mutations.length > 0) {
                  this.emitter.emit(_emitter2.default.events.SCROLL_BEFORE_UPDATE, source, mutations);
                }
                _get(Scroll2.prototype.__proto__ || Object.getPrototypeOf(Scroll2.prototype), "update", this).call(this, mutations.concat([]));
                if (mutations.length > 0) {
                  this.emitter.emit(_emitter2.default.events.SCROLL_UPDATE, source, mutations);
                }
              }
            }]);
            return Scroll2;
          }(_parchment2.default.Scroll);
          Scroll.blotName = "scroll";
          Scroll.className = "ql-editor";
          Scroll.tagName = "DIV";
          Scroll.defaultChild = "block";
          Scroll.allowedChildren = [_block2.default, _block.BlockEmbed, _container2.default];
          exports2.default = Scroll;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.SHORTKEY = exports2.default = void 0;
          var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
            return typeof obj;
          } : function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
          var _slicedToArray = function() {
            function sliceIterator(arr, i) {
              var _arr = [];
              var _n = true;
              var _d = false;
              var _e = void 0;
              try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                  _arr.push(_s.value);
                  if (i && _arr.length === i)
                    break;
                }
              } catch (err) {
                _d = true;
                _e = err;
              } finally {
                try {
                  if (!_n && _i["return"])
                    _i["return"]();
                } finally {
                  if (_d)
                    throw _e;
                }
              }
              return _arr;
            }
            return function(arr, i) {
              if (Array.isArray(arr)) {
                return arr;
              } else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
              } else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              }
            };
          }();
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _clone = __webpack_require__(21);
          var _clone2 = _interopRequireDefault(_clone);
          var _deepEqual = __webpack_require__(11);
          var _deepEqual2 = _interopRequireDefault(_deepEqual);
          var _extend = __webpack_require__(3);
          var _extend2 = _interopRequireDefault(_extend);
          var _quillDelta = __webpack_require__(2);
          var _quillDelta2 = _interopRequireDefault(_quillDelta);
          var _op = __webpack_require__(20);
          var _op2 = _interopRequireDefault(_op);
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _quill = __webpack_require__(5);
          var _quill2 = _interopRequireDefault(_quill);
          var _logger = __webpack_require__(10);
          var _logger2 = _interopRequireDefault(_logger);
          var _module = __webpack_require__(9);
          var _module2 = _interopRequireDefault(_module);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _defineProperty(obj, key, value) {
            if (key in obj) {
              Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
            } else {
              obj[key] = value;
            }
            return obj;
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var debug = (0, _logger2.default)("quill:keyboard");
          var SHORTKEY = /Mac/i.test(navigator.platform) ? "metaKey" : "ctrlKey";
          var Keyboard = function(_Module) {
            _inherits(Keyboard2, _Module);
            _createClass(Keyboard2, null, [{
              key: "match",
              value: function match(evt, binding) {
                binding = normalize2(binding);
                if (["altKey", "ctrlKey", "metaKey", "shiftKey"].some(function(key) {
                  return !!binding[key] !== evt[key] && binding[key] !== null;
                })) {
                  return false;
                }
                return binding.key === (evt.which || evt.keyCode);
              }
            }]);
            function Keyboard2(quill, options) {
              _classCallCheck(this, Keyboard2);
              var _this = _possibleConstructorReturn(this, (Keyboard2.__proto__ || Object.getPrototypeOf(Keyboard2)).call(this, quill, options));
              _this.bindings = {};
              Object.keys(_this.options.bindings).forEach(function(name) {
                if (name === "list autofill" && quill.scroll.whitelist != null && !quill.scroll.whitelist["list"]) {
                  return;
                }
                if (_this.options.bindings[name]) {
                  _this.addBinding(_this.options.bindings[name]);
                }
              });
              _this.addBinding({ key: Keyboard2.keys.ENTER, shiftKey: null }, handleEnter);
              _this.addBinding({ key: Keyboard2.keys.ENTER, metaKey: null, ctrlKey: null, altKey: null }, function() {
              });
              if (/Firefox/i.test(navigator.userAgent)) {
                _this.addBinding({ key: Keyboard2.keys.BACKSPACE }, { collapsed: true }, handleBackspace);
                _this.addBinding({ key: Keyboard2.keys.DELETE }, { collapsed: true }, handleDelete);
              } else {
                _this.addBinding({ key: Keyboard2.keys.BACKSPACE }, { collapsed: true, prefix: /^.?$/ }, handleBackspace);
                _this.addBinding({ key: Keyboard2.keys.DELETE }, { collapsed: true, suffix: /^.?$/ }, handleDelete);
              }
              _this.addBinding({ key: Keyboard2.keys.BACKSPACE }, { collapsed: false }, handleDeleteRange);
              _this.addBinding({ key: Keyboard2.keys.DELETE }, { collapsed: false }, handleDeleteRange);
              _this.addBinding({ key: Keyboard2.keys.BACKSPACE, altKey: null, ctrlKey: null, metaKey: null, shiftKey: null }, { collapsed: true, offset: 0 }, handleBackspace);
              _this.listen();
              return _this;
            }
            _createClass(Keyboard2, [{
              key: "addBinding",
              value: function addBinding(key) {
                var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var handler = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var binding = normalize2(key);
                if (binding == null || binding.key == null) {
                  return debug.warn("Attempted to add invalid keyboard binding", binding);
                }
                if (typeof context === "function") {
                  context = { handler: context };
                }
                if (typeof handler === "function") {
                  handler = { handler };
                }
                binding = (0, _extend2.default)(binding, context, handler);
                this.bindings[binding.key] = this.bindings[binding.key] || [];
                this.bindings[binding.key].push(binding);
              }
            }, {
              key: "listen",
              value: function listen() {
                var _this2 = this;
                this.quill.root.addEventListener("keydown", function(evt) {
                  if (evt.defaultPrevented)
                    return;
                  var which = evt.which || evt.keyCode;
                  var bindings = (_this2.bindings[which] || []).filter(function(binding) {
                    return Keyboard2.match(evt, binding);
                  });
                  if (bindings.length === 0)
                    return;
                  var range = _this2.quill.getSelection();
                  if (range == null || !_this2.quill.hasFocus())
                    return;
                  var _quill$getLine = _this2.quill.getLine(range.index), _quill$getLine2 = _slicedToArray(_quill$getLine, 2), line = _quill$getLine2[0], offset = _quill$getLine2[1];
                  var _quill$getLeaf = _this2.quill.getLeaf(range.index), _quill$getLeaf2 = _slicedToArray(_quill$getLeaf, 2), leafStart = _quill$getLeaf2[0], offsetStart = _quill$getLeaf2[1];
                  var _ref = range.length === 0 ? [leafStart, offsetStart] : _this2.quill.getLeaf(range.index + range.length), _ref2 = _slicedToArray(_ref, 2), leafEnd = _ref2[0], offsetEnd = _ref2[1];
                  var prefixText = leafStart instanceof _parchment2.default.Text ? leafStart.value().slice(0, offsetStart) : "";
                  var suffixText = leafEnd instanceof _parchment2.default.Text ? leafEnd.value().slice(offsetEnd) : "";
                  var curContext = {
                    collapsed: range.length === 0,
                    empty: range.length === 0 && line.length() <= 1,
                    format: _this2.quill.getFormat(range),
                    offset,
                    prefix: prefixText,
                    suffix: suffixText
                  };
                  var prevented = bindings.some(function(binding) {
                    if (binding.collapsed != null && binding.collapsed !== curContext.collapsed)
                      return false;
                    if (binding.empty != null && binding.empty !== curContext.empty)
                      return false;
                    if (binding.offset != null && binding.offset !== curContext.offset)
                      return false;
                    if (Array.isArray(binding.format)) {
                      if (binding.format.every(function(name) {
                        return curContext.format[name] == null;
                      })) {
                        return false;
                      }
                    } else if (_typeof(binding.format) === "object") {
                      if (!Object.keys(binding.format).every(function(name) {
                        if (binding.format[name] === true)
                          return curContext.format[name] != null;
                        if (binding.format[name] === false)
                          return curContext.format[name] == null;
                        return (0, _deepEqual2.default)(binding.format[name], curContext.format[name]);
                      })) {
                        return false;
                      }
                    }
                    if (binding.prefix != null && !binding.prefix.test(curContext.prefix))
                      return false;
                    if (binding.suffix != null && !binding.suffix.test(curContext.suffix))
                      return false;
                    return binding.handler.call(_this2, range, curContext) !== true;
                  });
                  if (prevented) {
                    evt.preventDefault();
                  }
                });
              }
            }]);
            return Keyboard2;
          }(_module2.default);
          Keyboard.keys = {
            BACKSPACE: 8,
            TAB: 9,
            ENTER: 13,
            ESCAPE: 27,
            LEFT: 37,
            UP: 38,
            RIGHT: 39,
            DOWN: 40,
            DELETE: 46
          };
          Keyboard.DEFAULTS = {
            bindings: {
              "bold": makeFormatHandler("bold"),
              "italic": makeFormatHandler("italic"),
              "underline": makeFormatHandler("underline"),
              "indent": {
                key: Keyboard.keys.TAB,
                format: ["blockquote", "indent", "list"],
                handler: function handler(range, context) {
                  if (context.collapsed && context.offset !== 0)
                    return true;
                  this.quill.format("indent", "+1", _quill2.default.sources.USER);
                }
              },
              "outdent": {
                key: Keyboard.keys.TAB,
                shiftKey: true,
                format: ["blockquote", "indent", "list"],
                handler: function handler(range, context) {
                  if (context.collapsed && context.offset !== 0)
                    return true;
                  this.quill.format("indent", "-1", _quill2.default.sources.USER);
                }
              },
              "outdent backspace": {
                key: Keyboard.keys.BACKSPACE,
                collapsed: true,
                shiftKey: null,
                metaKey: null,
                ctrlKey: null,
                altKey: null,
                format: ["indent", "list"],
                offset: 0,
                handler: function handler(range, context) {
                  if (context.format.indent != null) {
                    this.quill.format("indent", "-1", _quill2.default.sources.USER);
                  } else if (context.format.list != null) {
                    this.quill.format("list", false, _quill2.default.sources.USER);
                  }
                }
              },
              "indent code-block": makeCodeBlockHandler(true),
              "outdent code-block": makeCodeBlockHandler(false),
              "remove tab": {
                key: Keyboard.keys.TAB,
                shiftKey: true,
                collapsed: true,
                prefix: /\t$/,
                handler: function handler(range) {
                  this.quill.deleteText(range.index - 1, 1, _quill2.default.sources.USER);
                }
              },
              "tab": {
                key: Keyboard.keys.TAB,
                handler: function handler(range) {
                  this.quill.history.cutoff();
                  var delta = new _quillDelta2.default().retain(range.index).delete(range.length).insert("	");
                  this.quill.updateContents(delta, _quill2.default.sources.USER);
                  this.quill.history.cutoff();
                  this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                }
              },
              "list empty enter": {
                key: Keyboard.keys.ENTER,
                collapsed: true,
                format: ["list"],
                empty: true,
                handler: function handler(range, context) {
                  this.quill.format("list", false, _quill2.default.sources.USER);
                  if (context.format.indent) {
                    this.quill.format("indent", false, _quill2.default.sources.USER);
                  }
                }
              },
              "checklist enter": {
                key: Keyboard.keys.ENTER,
                collapsed: true,
                format: { list: "checked" },
                handler: function handler(range) {
                  var _quill$getLine3 = this.quill.getLine(range.index), _quill$getLine4 = _slicedToArray(_quill$getLine3, 2), line = _quill$getLine4[0], offset = _quill$getLine4[1];
                  var formats = (0, _extend2.default)({}, line.formats(), { list: "checked" });
                  var delta = new _quillDelta2.default().retain(range.index).insert("\n", formats).retain(line.length() - offset - 1).retain(1, { list: "unchecked" });
                  this.quill.updateContents(delta, _quill2.default.sources.USER);
                  this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                  this.quill.scrollIntoView();
                }
              },
              "header enter": {
                key: Keyboard.keys.ENTER,
                collapsed: true,
                format: ["header"],
                suffix: /^$/,
                handler: function handler(range, context) {
                  var _quill$getLine5 = this.quill.getLine(range.index), _quill$getLine6 = _slicedToArray(_quill$getLine5, 2), line = _quill$getLine6[0], offset = _quill$getLine6[1];
                  var delta = new _quillDelta2.default().retain(range.index).insert("\n", context.format).retain(line.length() - offset - 1).retain(1, { header: null });
                  this.quill.updateContents(delta, _quill2.default.sources.USER);
                  this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                  this.quill.scrollIntoView();
                }
              },
              "list autofill": {
                key: " ",
                collapsed: true,
                format: { list: false },
                prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
                handler: function handler(range, context) {
                  var length = context.prefix.length;
                  var _quill$getLine7 = this.quill.getLine(range.index), _quill$getLine8 = _slicedToArray(_quill$getLine7, 2), line = _quill$getLine8[0], offset = _quill$getLine8[1];
                  if (offset > length)
                    return true;
                  var value = void 0;
                  switch (context.prefix.trim()) {
                    case "[]":
                    case "[ ]":
                      value = "unchecked";
                      break;
                    case "[x]":
                      value = "checked";
                      break;
                    case "-":
                    case "*":
                      value = "bullet";
                      break;
                    default:
                      value = "ordered";
                  }
                  this.quill.insertText(range.index, " ", _quill2.default.sources.USER);
                  this.quill.history.cutoff();
                  var delta = new _quillDelta2.default().retain(range.index - offset).delete(length + 1).retain(line.length() - 2 - offset).retain(1, { list: value });
                  this.quill.updateContents(delta, _quill2.default.sources.USER);
                  this.quill.history.cutoff();
                  this.quill.setSelection(range.index - length, _quill2.default.sources.SILENT);
                }
              },
              "code exit": {
                key: Keyboard.keys.ENTER,
                collapsed: true,
                format: ["code-block"],
                prefix: /\n\n$/,
                suffix: /^\s+$/,
                handler: function handler(range) {
                  var _quill$getLine9 = this.quill.getLine(range.index), _quill$getLine10 = _slicedToArray(_quill$getLine9, 2), line = _quill$getLine10[0], offset = _quill$getLine10[1];
                  var delta = new _quillDelta2.default().retain(range.index + line.length() - offset - 2).retain(1, { "code-block": null }).delete(1);
                  this.quill.updateContents(delta, _quill2.default.sources.USER);
                }
              },
              "embed left": makeEmbedArrowHandler(Keyboard.keys.LEFT, false),
              "embed left shift": makeEmbedArrowHandler(Keyboard.keys.LEFT, true),
              "embed right": makeEmbedArrowHandler(Keyboard.keys.RIGHT, false),
              "embed right shift": makeEmbedArrowHandler(Keyboard.keys.RIGHT, true)
            }
          };
          function makeEmbedArrowHandler(key, shiftKey) {
            var _ref3;
            var where = key === Keyboard.keys.LEFT ? "prefix" : "suffix";
            return _ref3 = {
              key,
              shiftKey,
              altKey: null
            }, _defineProperty(_ref3, where, /^$/), _defineProperty(_ref3, "handler", function handler(range) {
              var index = range.index;
              if (key === Keyboard.keys.RIGHT) {
                index += range.length + 1;
              }
              var _quill$getLeaf3 = this.quill.getLeaf(index), _quill$getLeaf4 = _slicedToArray(_quill$getLeaf3, 1), leaf = _quill$getLeaf4[0];
              if (!(leaf instanceof _parchment2.default.Embed))
                return true;
              if (key === Keyboard.keys.LEFT) {
                if (shiftKey) {
                  this.quill.setSelection(range.index - 1, range.length + 1, _quill2.default.sources.USER);
                } else {
                  this.quill.setSelection(range.index - 1, _quill2.default.sources.USER);
                }
              } else {
                if (shiftKey) {
                  this.quill.setSelection(range.index, range.length + 1, _quill2.default.sources.USER);
                } else {
                  this.quill.setSelection(range.index + range.length + 1, _quill2.default.sources.USER);
                }
              }
              return false;
            }), _ref3;
          }
          function handleBackspace(range, context) {
            if (range.index === 0 || this.quill.getLength() <= 1)
              return;
            var _quill$getLine11 = this.quill.getLine(range.index), _quill$getLine12 = _slicedToArray(_quill$getLine11, 1), line = _quill$getLine12[0];
            var formats = {};
            if (context.offset === 0) {
              var _quill$getLine13 = this.quill.getLine(range.index - 1), _quill$getLine14 = _slicedToArray(_quill$getLine13, 1), prev = _quill$getLine14[0];
              if (prev != null && prev.length() > 1) {
                var curFormats = line.formats();
                var prevFormats = this.quill.getFormat(range.index - 1, 1);
                formats = _op2.default.attributes.diff(curFormats, prevFormats) || {};
              }
            }
            var length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
            this.quill.deleteText(range.index - length, length, _quill2.default.sources.USER);
            if (Object.keys(formats).length > 0) {
              this.quill.formatLine(range.index - length, length, formats, _quill2.default.sources.USER);
            }
            this.quill.focus();
          }
          function handleDelete(range, context) {
            var length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
            if (range.index >= this.quill.getLength() - length)
              return;
            var formats = {}, nextLength = 0;
            var _quill$getLine15 = this.quill.getLine(range.index), _quill$getLine16 = _slicedToArray(_quill$getLine15, 1), line = _quill$getLine16[0];
            if (context.offset >= line.length() - 1) {
              var _quill$getLine17 = this.quill.getLine(range.index + 1), _quill$getLine18 = _slicedToArray(_quill$getLine17, 1), next = _quill$getLine18[0];
              if (next) {
                var curFormats = line.formats();
                var nextFormats = this.quill.getFormat(range.index, 1);
                formats = _op2.default.attributes.diff(curFormats, nextFormats) || {};
                nextLength = next.length();
              }
            }
            this.quill.deleteText(range.index, length, _quill2.default.sources.USER);
            if (Object.keys(formats).length > 0) {
              this.quill.formatLine(range.index + nextLength - 1, length, formats, _quill2.default.sources.USER);
            }
          }
          function handleDeleteRange(range) {
            var lines = this.quill.getLines(range);
            var formats = {};
            if (lines.length > 1) {
              var firstFormats = lines[0].formats();
              var lastFormats = lines[lines.length - 1].formats();
              formats = _op2.default.attributes.diff(lastFormats, firstFormats) || {};
            }
            this.quill.deleteText(range, _quill2.default.sources.USER);
            if (Object.keys(formats).length > 0) {
              this.quill.formatLine(range.index, 1, formats, _quill2.default.sources.USER);
            }
            this.quill.setSelection(range.index, _quill2.default.sources.SILENT);
            this.quill.focus();
          }
          function handleEnter(range, context) {
            var _this3 = this;
            if (range.length > 0) {
              this.quill.scroll.deleteAt(range.index, range.length);
            }
            var lineFormats = Object.keys(context.format).reduce(function(lineFormats2, format) {
              if (_parchment2.default.query(format, _parchment2.default.Scope.BLOCK) && !Array.isArray(context.format[format])) {
                lineFormats2[format] = context.format[format];
              }
              return lineFormats2;
            }, {});
            this.quill.insertText(range.index, "\n", lineFormats, _quill2.default.sources.USER);
            this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
            this.quill.focus();
            Object.keys(context.format).forEach(function(name) {
              if (lineFormats[name] != null)
                return;
              if (Array.isArray(context.format[name]))
                return;
              if (name === "link")
                return;
              _this3.quill.format(name, context.format[name], _quill2.default.sources.USER);
            });
          }
          function makeCodeBlockHandler(indent) {
            return {
              key: Keyboard.keys.TAB,
              shiftKey: !indent,
              format: { "code-block": true },
              handler: function handler(range) {
                var CodeBlock = _parchment2.default.query("code-block");
                var index = range.index, length = range.length;
                var _quill$scroll$descend = this.quill.scroll.descendant(CodeBlock, index), _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2), block = _quill$scroll$descend2[0], offset = _quill$scroll$descend2[1];
                if (block == null)
                  return;
                var scrollIndex = this.quill.getIndex(block);
                var start = block.newlineIndex(offset, true) + 1;
                var end = block.newlineIndex(scrollIndex + offset + length);
                var lines = block.domNode.textContent.slice(start, end).split("\n");
                offset = 0;
                lines.forEach(function(line, i) {
                  if (indent) {
                    block.insertAt(start + offset, CodeBlock.TAB);
                    offset += CodeBlock.TAB.length;
                    if (i === 0) {
                      index += CodeBlock.TAB.length;
                    } else {
                      length += CodeBlock.TAB.length;
                    }
                  } else if (line.startsWith(CodeBlock.TAB)) {
                    block.deleteAt(start + offset, CodeBlock.TAB.length);
                    offset -= CodeBlock.TAB.length;
                    if (i === 0) {
                      index -= CodeBlock.TAB.length;
                    } else {
                      length -= CodeBlock.TAB.length;
                    }
                  }
                  offset += line.length + 1;
                });
                this.quill.update(_quill2.default.sources.USER);
                this.quill.setSelection(index, length, _quill2.default.sources.SILENT);
              }
            };
          }
          function makeFormatHandler(format) {
            return {
              key: format[0].toUpperCase(),
              shortKey: true,
              handler: function handler(range, context) {
                this.quill.format(format, !context.format[format], _quill2.default.sources.USER);
              }
            };
          }
          function normalize2(binding) {
            if (typeof binding === "string" || typeof binding === "number") {
              return normalize2({ key: binding });
            }
            if ((typeof binding === "undefined" ? "undefined" : _typeof(binding)) === "object") {
              binding = (0, _clone2.default)(binding, false);
            }
            if (typeof binding.key === "string") {
              if (Keyboard.keys[binding.key.toUpperCase()] != null) {
                binding.key = Keyboard.keys[binding.key.toUpperCase()];
              } else if (binding.key.length === 1) {
                binding.key = binding.key.toUpperCase().charCodeAt(0);
              } else {
                return null;
              }
            }
            if (binding.shortKey) {
              binding[SHORTKEY] = binding.shortKey;
              delete binding.shortKey;
            }
            return binding;
          }
          exports2.default = Keyboard;
          exports2.SHORTKEY = SHORTKEY;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _slicedToArray = function() {
            function sliceIterator(arr, i) {
              var _arr = [];
              var _n = true;
              var _d = false;
              var _e = void 0;
              try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                  _arr.push(_s.value);
                  if (i && _arr.length === i)
                    break;
                }
              } catch (err) {
                _d = true;
                _e = err;
              } finally {
                try {
                  if (!_n && _i["return"])
                    _i["return"]();
                } finally {
                  if (_d)
                    throw _e;
                }
              }
              return _arr;
            }
            return function(arr, i) {
              if (Array.isArray(arr)) {
                return arr;
              } else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
              } else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              }
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _text = __webpack_require__(7);
          var _text2 = _interopRequireDefault(_text);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var Cursor = function(_Parchment$Embed) {
            _inherits(Cursor2, _Parchment$Embed);
            _createClass(Cursor2, null, [{
              key: "value",
              value: function value() {
                return void 0;
              }
            }]);
            function Cursor2(domNode, selection) {
              _classCallCheck(this, Cursor2);
              var _this = _possibleConstructorReturn(this, (Cursor2.__proto__ || Object.getPrototypeOf(Cursor2)).call(this, domNode));
              _this.selection = selection;
              _this.textNode = document.createTextNode(Cursor2.CONTENTS);
              _this.domNode.appendChild(_this.textNode);
              _this._length = 0;
              return _this;
            }
            _createClass(Cursor2, [{
              key: "detach",
              value: function detach() {
                if (this.parent != null)
                  this.parent.removeChild(this);
              }
            }, {
              key: "format",
              value: function format(name, value) {
                if (this._length !== 0) {
                  return _get(Cursor2.prototype.__proto__ || Object.getPrototypeOf(Cursor2.prototype), "format", this).call(this, name, value);
                }
                var target = this, index = 0;
                while (target != null && target.statics.scope !== _parchment2.default.Scope.BLOCK_BLOT) {
                  index += target.offset(target.parent);
                  target = target.parent;
                }
                if (target != null) {
                  this._length = Cursor2.CONTENTS.length;
                  target.optimize();
                  target.formatAt(index, Cursor2.CONTENTS.length, name, value);
                  this._length = 0;
                }
              }
            }, {
              key: "index",
              value: function index(node, offset) {
                if (node === this.textNode)
                  return 0;
                return _get(Cursor2.prototype.__proto__ || Object.getPrototypeOf(Cursor2.prototype), "index", this).call(this, node, offset);
              }
            }, {
              key: "length",
              value: function length() {
                return this._length;
              }
            }, {
              key: "position",
              value: function position() {
                return [this.textNode, this.textNode.data.length];
              }
            }, {
              key: "remove",
              value: function remove() {
                _get(Cursor2.prototype.__proto__ || Object.getPrototypeOf(Cursor2.prototype), "remove", this).call(this);
                this.parent = null;
              }
            }, {
              key: "restore",
              value: function restore() {
                if (this.selection.composing || this.parent == null)
                  return;
                var textNode = this.textNode;
                var range = this.selection.getNativeRange();
                var restoreText = void 0, start = void 0, end = void 0;
                if (range != null && range.start.node === textNode && range.end.node === textNode) {
                  var _ref = [textNode, range.start.offset, range.end.offset];
                  restoreText = _ref[0];
                  start = _ref[1];
                  end = _ref[2];
                }
                while (this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode) {
                  this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
                }
                if (this.textNode.data !== Cursor2.CONTENTS) {
                  var text = this.textNode.data.split(Cursor2.CONTENTS).join("");
                  if (this.next instanceof _text2.default) {
                    restoreText = this.next.domNode;
                    this.next.insertAt(0, text);
                    this.textNode.data = Cursor2.CONTENTS;
                  } else {
                    this.textNode.data = text;
                    this.parent.insertBefore(_parchment2.default.create(this.textNode), this);
                    this.textNode = document.createTextNode(Cursor2.CONTENTS);
                    this.domNode.appendChild(this.textNode);
                  }
                }
                this.remove();
                if (start != null) {
                  var _map = [start, end].map(function(offset) {
                    return Math.max(0, Math.min(restoreText.data.length, offset - 1));
                  });
                  var _map2 = _slicedToArray(_map, 2);
                  start = _map2[0];
                  end = _map2[1];
                  return {
                    startNode: restoreText,
                    startOffset: start,
                    endNode: restoreText,
                    endOffset: end
                  };
                }
              }
            }, {
              key: "update",
              value: function update(mutations, context) {
                var _this2 = this;
                if (mutations.some(function(mutation) {
                  return mutation.type === "characterData" && mutation.target === _this2.textNode;
                })) {
                  var range = this.restore();
                  if (range)
                    context.range = range;
                }
              }
            }, {
              key: "value",
              value: function value() {
                return "";
              }
            }]);
            return Cursor2;
          }(_parchment2.default.Embed);
          Cursor.blotName = "cursor";
          Cursor.className = "ql-cursor";
          Cursor.tagName = "span";
          Cursor.CONTENTS = "\uFEFF";
          exports2.default = Cursor;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _block = __webpack_require__(4);
          var _block2 = _interopRequireDefault(_block);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var Container2 = function(_Parchment$Container) {
            _inherits(Container3, _Parchment$Container);
            function Container3() {
              _classCallCheck(this, Container3);
              return _possibleConstructorReturn(this, (Container3.__proto__ || Object.getPrototypeOf(Container3)).apply(this, arguments));
            }
            return Container3;
          }(_parchment2.default.Container);
          Container2.allowedChildren = [_block2.default, _block.BlockEmbed, Container2];
          exports2.default = Container2;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.ColorStyle = exports2.ColorClass = exports2.ColorAttributor = void 0;
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var ColorAttributor = function(_Parchment$Attributor) {
            _inherits(ColorAttributor2, _Parchment$Attributor);
            function ColorAttributor2() {
              _classCallCheck(this, ColorAttributor2);
              return _possibleConstructorReturn(this, (ColorAttributor2.__proto__ || Object.getPrototypeOf(ColorAttributor2)).apply(this, arguments));
            }
            _createClass(ColorAttributor2, [{
              key: "value",
              value: function value(domNode) {
                var value2 = _get(ColorAttributor2.prototype.__proto__ || Object.getPrototypeOf(ColorAttributor2.prototype), "value", this).call(this, domNode);
                if (!value2.startsWith("rgb("))
                  return value2;
                value2 = value2.replace(/^[^\d]+/, "").replace(/[^\d]+$/, "");
                return "#" + value2.split(",").map(function(component) {
                  return ("00" + parseInt(component).toString(16)).slice(-2);
                }).join("");
              }
            }]);
            return ColorAttributor2;
          }(_parchment2.default.Attributor.Style);
          var ColorClass = new _parchment2.default.Attributor.Class("color", "ql-color", {
            scope: _parchment2.default.Scope.INLINE
          });
          var ColorStyle = new ColorAttributor("color", "color", {
            scope: _parchment2.default.Scope.INLINE
          });
          exports2.ColorAttributor = ColorAttributor;
          exports2.ColorClass = ColorClass;
          exports2.ColorStyle = ColorStyle;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.sanitize = exports2.default = void 0;
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _inline = __webpack_require__(6);
          var _inline2 = _interopRequireDefault(_inline);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var Link = function(_Inline) {
            _inherits(Link2, _Inline);
            function Link2() {
              _classCallCheck(this, Link2);
              return _possibleConstructorReturn(this, (Link2.__proto__ || Object.getPrototypeOf(Link2)).apply(this, arguments));
            }
            _createClass(Link2, [{
              key: "format",
              value: function format(name, value) {
                if (name !== this.statics.blotName || !value)
                  return _get(Link2.prototype.__proto__ || Object.getPrototypeOf(Link2.prototype), "format", this).call(this, name, value);
                value = this.constructor.sanitize(value);
                this.domNode.setAttribute("href", value);
              }
            }], [{
              key: "create",
              value: function create(value) {
                var node = _get(Link2.__proto__ || Object.getPrototypeOf(Link2), "create", this).call(this, value);
                value = this.sanitize(value);
                node.setAttribute("href", value);
                node.setAttribute("rel", "noopener noreferrer");
                node.setAttribute("target", "_blank");
                return node;
              }
            }, {
              key: "formats",
              value: function formats(domNode) {
                return domNode.getAttribute("href");
              }
            }, {
              key: "sanitize",
              value: function sanitize(url) {
                return _sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
              }
            }]);
            return Link2;
          }(_inline2.default);
          Link.blotName = "link";
          Link.tagName = "A";
          Link.SANITIZED_URL = "about:blank";
          Link.PROTOCOL_WHITELIST = ["http", "https", "mailto", "tel"];
          function _sanitize(url, protocols) {
            var anchor = document.createElement("a");
            anchor.href = url;
            var protocol = anchor.href.slice(0, anchor.href.indexOf(":"));
            return protocols.indexOf(protocol) > -1;
          }
          exports2.default = Link;
          exports2.sanitize = _sanitize;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
            return typeof obj;
          } : function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _keyboard = __webpack_require__(23);
          var _keyboard2 = _interopRequireDefault(_keyboard);
          var _dropdown = __webpack_require__(107);
          var _dropdown2 = _interopRequireDefault(_dropdown);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          var optionsCounter = 0;
          function toggleAriaAttribute(element, attribute) {
            element.setAttribute(attribute, !(element.getAttribute(attribute) === "true"));
          }
          var Picker = function() {
            function Picker2(select) {
              var _this = this;
              _classCallCheck(this, Picker2);
              this.select = select;
              this.container = document.createElement("span");
              this.buildPicker();
              this.select.style.display = "none";
              this.select.parentNode.insertBefore(this.container, this.select);
              this.label.addEventListener("mousedown", function() {
                _this.togglePicker();
              });
              this.label.addEventListener("keydown", function(event) {
                switch (event.keyCode) {
                  case _keyboard2.default.keys.ENTER:
                    _this.togglePicker();
                    break;
                  case _keyboard2.default.keys.ESCAPE:
                    _this.escape();
                    event.preventDefault();
                    break;
                  default:
                }
              });
              this.select.addEventListener("change", this.update.bind(this));
            }
            _createClass(Picker2, [{
              key: "togglePicker",
              value: function togglePicker() {
                this.container.classList.toggle("ql-expanded");
                toggleAriaAttribute(this.label, "aria-expanded");
                toggleAriaAttribute(this.options, "aria-hidden");
              }
            }, {
              key: "buildItem",
              value: function buildItem(option) {
                var _this2 = this;
                var item = document.createElement("span");
                item.tabIndex = "0";
                item.setAttribute("role", "button");
                item.classList.add("ql-picker-item");
                if (option.hasAttribute("value")) {
                  item.setAttribute("data-value", option.getAttribute("value"));
                }
                if (option.textContent) {
                  item.setAttribute("data-label", option.textContent);
                }
                item.addEventListener("click", function() {
                  _this2.selectItem(item, true);
                });
                item.addEventListener("keydown", function(event) {
                  switch (event.keyCode) {
                    case _keyboard2.default.keys.ENTER:
                      _this2.selectItem(item, true);
                      event.preventDefault();
                      break;
                    case _keyboard2.default.keys.ESCAPE:
                      _this2.escape();
                      event.preventDefault();
                      break;
                    default:
                  }
                });
                return item;
              }
            }, {
              key: "buildLabel",
              value: function buildLabel() {
                var label = document.createElement("span");
                label.classList.add("ql-picker-label");
                label.innerHTML = _dropdown2.default;
                label.tabIndex = "0";
                label.setAttribute("role", "button");
                label.setAttribute("aria-expanded", "false");
                this.container.appendChild(label);
                return label;
              }
            }, {
              key: "buildOptions",
              value: function buildOptions() {
                var _this3 = this;
                var options = document.createElement("span");
                options.classList.add("ql-picker-options");
                options.setAttribute("aria-hidden", "true");
                options.tabIndex = "-1";
                options.id = "ql-picker-options-" + optionsCounter;
                optionsCounter += 1;
                this.label.setAttribute("aria-controls", options.id);
                this.options = options;
                [].slice.call(this.select.options).forEach(function(option) {
                  var item = _this3.buildItem(option);
                  options.appendChild(item);
                  if (option.selected === true) {
                    _this3.selectItem(item);
                  }
                });
                this.container.appendChild(options);
              }
            }, {
              key: "buildPicker",
              value: function buildPicker() {
                var _this4 = this;
                [].slice.call(this.select.attributes).forEach(function(item) {
                  _this4.container.setAttribute(item.name, item.value);
                });
                this.container.classList.add("ql-picker");
                this.label = this.buildLabel();
                this.buildOptions();
              }
            }, {
              key: "escape",
              value: function escape() {
                var _this5 = this;
                this.close();
                setTimeout(function() {
                  return _this5.label.focus();
                }, 1);
              }
            }, {
              key: "close",
              value: function close() {
                this.container.classList.remove("ql-expanded");
                this.label.setAttribute("aria-expanded", "false");
                this.options.setAttribute("aria-hidden", "true");
              }
            }, {
              key: "selectItem",
              value: function selectItem(item) {
                var trigger = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var selected = this.container.querySelector(".ql-selected");
                if (item === selected)
                  return;
                if (selected != null) {
                  selected.classList.remove("ql-selected");
                }
                if (item == null)
                  return;
                item.classList.add("ql-selected");
                this.select.selectedIndex = [].indexOf.call(item.parentNode.children, item);
                if (item.hasAttribute("data-value")) {
                  this.label.setAttribute("data-value", item.getAttribute("data-value"));
                } else {
                  this.label.removeAttribute("data-value");
                }
                if (item.hasAttribute("data-label")) {
                  this.label.setAttribute("data-label", item.getAttribute("data-label"));
                } else {
                  this.label.removeAttribute("data-label");
                }
                if (trigger) {
                  if (typeof Event === "function") {
                    this.select.dispatchEvent(new Event("change"));
                  } else if ((typeof Event === "undefined" ? "undefined" : _typeof(Event)) === "object") {
                    var event = document.createEvent("Event");
                    event.initEvent("change", true, true);
                    this.select.dispatchEvent(event);
                  }
                  this.close();
                }
              }
            }, {
              key: "update",
              value: function update() {
                var option = void 0;
                if (this.select.selectedIndex > -1) {
                  var item = this.container.querySelector(".ql-picker-options").children[this.select.selectedIndex];
                  option = this.select.options[this.select.selectedIndex];
                  this.selectItem(item);
                } else {
                  this.selectItem(null);
                }
                var isActive = option != null && option !== this.select.querySelector("option[selected]");
                this.label.classList.toggle("ql-active", isActive);
              }
            }]);
            return Picker2;
          }();
          exports2.default = Picker;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _quill = __webpack_require__(5);
          var _quill2 = _interopRequireDefault(_quill);
          var _block = __webpack_require__(4);
          var _block2 = _interopRequireDefault(_block);
          var _break = __webpack_require__(16);
          var _break2 = _interopRequireDefault(_break);
          var _container = __webpack_require__(25);
          var _container2 = _interopRequireDefault(_container);
          var _cursor = __webpack_require__(24);
          var _cursor2 = _interopRequireDefault(_cursor);
          var _embed = __webpack_require__(35);
          var _embed2 = _interopRequireDefault(_embed);
          var _inline = __webpack_require__(6);
          var _inline2 = _interopRequireDefault(_inline);
          var _scroll = __webpack_require__(22);
          var _scroll2 = _interopRequireDefault(_scroll);
          var _text = __webpack_require__(7);
          var _text2 = _interopRequireDefault(_text);
          var _clipboard = __webpack_require__(55);
          var _clipboard2 = _interopRequireDefault(_clipboard);
          var _history = __webpack_require__(42);
          var _history2 = _interopRequireDefault(_history);
          var _keyboard = __webpack_require__(23);
          var _keyboard2 = _interopRequireDefault(_keyboard);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          _quill2.default.register({
            "blots/block": _block2.default,
            "blots/block/embed": _block.BlockEmbed,
            "blots/break": _break2.default,
            "blots/container": _container2.default,
            "blots/cursor": _cursor2.default,
            "blots/embed": _embed2.default,
            "blots/inline": _inline2.default,
            "blots/scroll": _scroll2.default,
            "blots/text": _text2.default,
            "modules/clipboard": _clipboard2.default,
            "modules/history": _history2.default,
            "modules/keyboard": _keyboard2.default
          });
          _parchment2.default.register(_block2.default, _break2.default, _cursor2.default, _inline2.default, _scroll2.default, _text2.default);
          exports2.default = _quill2.default;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", { value: true });
          var Registry = __webpack_require__(1);
          var ShadowBlot = function() {
            function ShadowBlot2(domNode) {
              this.domNode = domNode;
              this.domNode[Registry.DATA_KEY] = { blot: this };
            }
            Object.defineProperty(ShadowBlot2.prototype, "statics", {
              get: function() {
                return this.constructor;
              },
              enumerable: true,
              configurable: true
            });
            ShadowBlot2.create = function(value) {
              if (this.tagName == null) {
                throw new Registry.ParchmentError("Blot definition missing tagName");
              }
              var node;
              if (Array.isArray(this.tagName)) {
                if (typeof value === "string") {
                  value = value.toUpperCase();
                  if (parseInt(value).toString() === value) {
                    value = parseInt(value);
                  }
                }
                if (typeof value === "number") {
                  node = document.createElement(this.tagName[value - 1]);
                } else if (this.tagName.indexOf(value) > -1) {
                  node = document.createElement(value);
                } else {
                  node = document.createElement(this.tagName[0]);
                }
              } else {
                node = document.createElement(this.tagName);
              }
              if (this.className) {
                node.classList.add(this.className);
              }
              return node;
            };
            ShadowBlot2.prototype.attach = function() {
              if (this.parent != null) {
                this.scroll = this.parent.scroll;
              }
            };
            ShadowBlot2.prototype.clone = function() {
              var domNode = this.domNode.cloneNode(false);
              return Registry.create(domNode);
            };
            ShadowBlot2.prototype.detach = function() {
              if (this.parent != null)
                this.parent.removeChild(this);
              delete this.domNode[Registry.DATA_KEY];
            };
            ShadowBlot2.prototype.deleteAt = function(index, length) {
              var blot = this.isolate(index, length);
              blot.remove();
            };
            ShadowBlot2.prototype.formatAt = function(index, length, name, value) {
              var blot = this.isolate(index, length);
              if (Registry.query(name, Registry.Scope.BLOT) != null && value) {
                blot.wrap(name, value);
              } else if (Registry.query(name, Registry.Scope.ATTRIBUTE) != null) {
                var parent = Registry.create(this.statics.scope);
                blot.wrap(parent);
                parent.format(name, value);
              }
            };
            ShadowBlot2.prototype.insertAt = function(index, value, def) {
              var blot = def == null ? Registry.create("text", value) : Registry.create(value, def);
              var ref = this.split(index);
              this.parent.insertBefore(blot, ref);
            };
            ShadowBlot2.prototype.insertInto = function(parentBlot, refBlot) {
              if (refBlot === void 0) {
                refBlot = null;
              }
              if (this.parent != null) {
                this.parent.children.remove(this);
              }
              var refDomNode = null;
              parentBlot.children.insertBefore(this, refBlot);
              if (refBlot != null) {
                refDomNode = refBlot.domNode;
              }
              if (this.domNode.parentNode != parentBlot.domNode || this.domNode.nextSibling != refDomNode) {
                parentBlot.domNode.insertBefore(this.domNode, refDomNode);
              }
              this.parent = parentBlot;
              this.attach();
            };
            ShadowBlot2.prototype.isolate = function(index, length) {
              var target = this.split(index);
              target.split(length);
              return target;
            };
            ShadowBlot2.prototype.length = function() {
              return 1;
            };
            ShadowBlot2.prototype.offset = function(root) {
              if (root === void 0) {
                root = this.parent;
              }
              if (this.parent == null || this == root)
                return 0;
              return this.parent.children.offset(this) + this.parent.offset(root);
            };
            ShadowBlot2.prototype.optimize = function(context) {
              if (this.domNode[Registry.DATA_KEY] != null) {
                delete this.domNode[Registry.DATA_KEY].mutations;
              }
            };
            ShadowBlot2.prototype.remove = function() {
              if (this.domNode.parentNode != null) {
                this.domNode.parentNode.removeChild(this.domNode);
              }
              this.detach();
            };
            ShadowBlot2.prototype.replace = function(target) {
              if (target.parent == null)
                return;
              target.parent.insertBefore(this, target.next);
              target.remove();
            };
            ShadowBlot2.prototype.replaceWith = function(name, value) {
              var replacement = typeof name === "string" ? Registry.create(name, value) : name;
              replacement.replace(this);
              return replacement;
            };
            ShadowBlot2.prototype.split = function(index, force) {
              return index === 0 ? this : this.next;
            };
            ShadowBlot2.prototype.update = function(mutations, context) {
            };
            ShadowBlot2.prototype.wrap = function(name, value) {
              var wrapper = typeof name === "string" ? Registry.create(name, value) : name;
              if (this.parent != null) {
                this.parent.insertBefore(wrapper, this.next);
              }
              wrapper.appendChild(this);
              return wrapper;
            };
            ShadowBlot2.blotName = "abstract";
            return ShadowBlot2;
          }();
          exports2.default = ShadowBlot;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", { value: true });
          var attributor_1 = __webpack_require__(12);
          var class_1 = __webpack_require__(32);
          var style_1 = __webpack_require__(33);
          var Registry = __webpack_require__(1);
          var AttributorStore = function() {
            function AttributorStore2(domNode) {
              this.attributes = {};
              this.domNode = domNode;
              this.build();
            }
            AttributorStore2.prototype.attribute = function(attribute, value) {
              if (value) {
                if (attribute.add(this.domNode, value)) {
                  if (attribute.value(this.domNode) != null) {
                    this.attributes[attribute.attrName] = attribute;
                  } else {
                    delete this.attributes[attribute.attrName];
                  }
                }
              } else {
                attribute.remove(this.domNode);
                delete this.attributes[attribute.attrName];
              }
            };
            AttributorStore2.prototype.build = function() {
              var _this = this;
              this.attributes = {};
              var attributes = attributor_1.default.keys(this.domNode);
              var classes = class_1.default.keys(this.domNode);
              var styles = style_1.default.keys(this.domNode);
              attributes.concat(classes).concat(styles).forEach(function(name) {
                var attr = Registry.query(name, Registry.Scope.ATTRIBUTE);
                if (attr instanceof attributor_1.default) {
                  _this.attributes[attr.attrName] = attr;
                }
              });
            };
            AttributorStore2.prototype.copy = function(target) {
              var _this = this;
              Object.keys(this.attributes).forEach(function(key) {
                var value = _this.attributes[key].value(_this.domNode);
                target.format(key, value);
              });
            };
            AttributorStore2.prototype.move = function(target) {
              var _this = this;
              this.copy(target);
              Object.keys(this.attributes).forEach(function(key) {
                _this.attributes[key].remove(_this.domNode);
              });
              this.attributes = {};
            };
            AttributorStore2.prototype.values = function() {
              var _this = this;
              return Object.keys(this.attributes).reduce(function(attributes, name) {
                attributes[name] = _this.attributes[name].value(_this.domNode);
                return attributes;
              }, {});
            };
            return AttributorStore2;
          }();
          exports2.default = AttributorStore;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          var __extends = this && this.__extends || function() {
            var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
              d.__proto__ = b;
            } || function(d, b) {
              for (var p in b)
                if (b.hasOwnProperty(p))
                  d[p] = b[p];
            };
            return function(d, b) {
              extendStatics(d, b);
              function __() {
                this.constructor = d;
              }
              d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            };
          }();
          Object.defineProperty(exports2, "__esModule", { value: true });
          var attributor_1 = __webpack_require__(12);
          function match(node, prefix) {
            var className = node.getAttribute("class") || "";
            return className.split(/\s+/).filter(function(name) {
              return name.indexOf(prefix + "-") === 0;
            });
          }
          var ClassAttributor = function(_super) {
            __extends(ClassAttributor2, _super);
            function ClassAttributor2() {
              return _super !== null && _super.apply(this, arguments) || this;
            }
            ClassAttributor2.keys = function(node) {
              return (node.getAttribute("class") || "").split(/\s+/).map(function(name) {
                return name.split("-").slice(0, -1).join("-");
              });
            };
            ClassAttributor2.prototype.add = function(node, value) {
              if (!this.canAdd(node, value))
                return false;
              this.remove(node);
              node.classList.add(this.keyName + "-" + value);
              return true;
            };
            ClassAttributor2.prototype.remove = function(node) {
              var matches = match(node, this.keyName);
              matches.forEach(function(name) {
                node.classList.remove(name);
              });
              if (node.classList.length === 0) {
                node.removeAttribute("class");
              }
            };
            ClassAttributor2.prototype.value = function(node) {
              var result = match(node, this.keyName)[0] || "";
              var value = result.slice(this.keyName.length + 1);
              return this.canAdd(node, value) ? value : "";
            };
            return ClassAttributor2;
          }(attributor_1.default);
          exports2.default = ClassAttributor;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          var __extends = this && this.__extends || function() {
            var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
              d.__proto__ = b;
            } || function(d, b) {
              for (var p in b)
                if (b.hasOwnProperty(p))
                  d[p] = b[p];
            };
            return function(d, b) {
              extendStatics(d, b);
              function __() {
                this.constructor = d;
              }
              d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            };
          }();
          Object.defineProperty(exports2, "__esModule", { value: true });
          var attributor_1 = __webpack_require__(12);
          function camelize(name) {
            var parts = name.split("-");
            var rest = parts.slice(1).map(function(part) {
              return part[0].toUpperCase() + part.slice(1);
            }).join("");
            return parts[0] + rest;
          }
          var StyleAttributor = function(_super) {
            __extends(StyleAttributor2, _super);
            function StyleAttributor2() {
              return _super !== null && _super.apply(this, arguments) || this;
            }
            StyleAttributor2.keys = function(node) {
              return (node.getAttribute("style") || "").split(";").map(function(value) {
                var arr = value.split(":");
                return arr[0].trim();
              });
            };
            StyleAttributor2.prototype.add = function(node, value) {
              if (!this.canAdd(node, value))
                return false;
              node.style[camelize(this.keyName)] = value;
              return true;
            };
            StyleAttributor2.prototype.remove = function(node) {
              node.style[camelize(this.keyName)] = "";
              if (!node.getAttribute("style")) {
                node.removeAttribute("style");
              }
            };
            StyleAttributor2.prototype.value = function(node) {
              var value = node.style[camelize(this.keyName)];
              return this.canAdd(node, value) ? value : "";
            };
            return StyleAttributor2;
          }(attributor_1.default);
          exports2.default = StyleAttributor;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          var Theme = function() {
            function Theme2(quill, options) {
              _classCallCheck(this, Theme2);
              this.quill = quill;
              this.options = options;
              this.modules = {};
            }
            _createClass(Theme2, [{
              key: "init",
              value: function init() {
                var _this = this;
                Object.keys(this.options.modules).forEach(function(name) {
                  if (_this.modules[name] == null) {
                    _this.addModule(name);
                  }
                });
              }
            }, {
              key: "addModule",
              value: function addModule(name) {
                var moduleClass = this.quill.constructor.import("modules/" + name);
                this.modules[name] = new moduleClass(this.quill, this.options.modules[name] || {});
                return this.modules[name];
              }
            }]);
            return Theme2;
          }();
          Theme.DEFAULTS = {
            modules: {}
          };
          Theme.themes = {
            "default": Theme
          };
          exports2.default = Theme;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _text = __webpack_require__(7);
          var _text2 = _interopRequireDefault(_text);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var GUARD_TEXT = "\uFEFF";
          var Embed = function(_Parchment$Embed) {
            _inherits(Embed2, _Parchment$Embed);
            function Embed2(node) {
              _classCallCheck(this, Embed2);
              var _this = _possibleConstructorReturn(this, (Embed2.__proto__ || Object.getPrototypeOf(Embed2)).call(this, node));
              _this.contentNode = document.createElement("span");
              _this.contentNode.setAttribute("contenteditable", false);
              [].slice.call(_this.domNode.childNodes).forEach(function(childNode) {
                _this.contentNode.appendChild(childNode);
              });
              _this.leftGuard = document.createTextNode(GUARD_TEXT);
              _this.rightGuard = document.createTextNode(GUARD_TEXT);
              _this.domNode.appendChild(_this.leftGuard);
              _this.domNode.appendChild(_this.contentNode);
              _this.domNode.appendChild(_this.rightGuard);
              return _this;
            }
            _createClass(Embed2, [{
              key: "index",
              value: function index(node, offset) {
                if (node === this.leftGuard)
                  return 0;
                if (node === this.rightGuard)
                  return 1;
                return _get(Embed2.prototype.__proto__ || Object.getPrototypeOf(Embed2.prototype), "index", this).call(this, node, offset);
              }
            }, {
              key: "restore",
              value: function restore(node) {
                var range = void 0, textNode = void 0;
                var text = node.data.split(GUARD_TEXT).join("");
                if (node === this.leftGuard) {
                  if (this.prev instanceof _text2.default) {
                    var prevLength = this.prev.length();
                    this.prev.insertAt(prevLength, text);
                    range = {
                      startNode: this.prev.domNode,
                      startOffset: prevLength + text.length
                    };
                  } else {
                    textNode = document.createTextNode(text);
                    this.parent.insertBefore(_parchment2.default.create(textNode), this);
                    range = {
                      startNode: textNode,
                      startOffset: text.length
                    };
                  }
                } else if (node === this.rightGuard) {
                  if (this.next instanceof _text2.default) {
                    this.next.insertAt(0, text);
                    range = {
                      startNode: this.next.domNode,
                      startOffset: text.length
                    };
                  } else {
                    textNode = document.createTextNode(text);
                    this.parent.insertBefore(_parchment2.default.create(textNode), this.next);
                    range = {
                      startNode: textNode,
                      startOffset: text.length
                    };
                  }
                }
                node.data = GUARD_TEXT;
                return range;
              }
            }, {
              key: "update",
              value: function update(mutations, context) {
                var _this2 = this;
                mutations.forEach(function(mutation) {
                  if (mutation.type === "characterData" && (mutation.target === _this2.leftGuard || mutation.target === _this2.rightGuard)) {
                    var range = _this2.restore(mutation.target);
                    if (range)
                      context.range = range;
                  }
                });
              }
            }]);
            return Embed2;
          }(_parchment2.default.Embed);
          exports2.default = Embed;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.AlignStyle = exports2.AlignClass = exports2.AlignAttribute = void 0;
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          var config = {
            scope: _parchment2.default.Scope.BLOCK,
            whitelist: ["right", "center", "justify"]
          };
          var AlignAttribute = new _parchment2.default.Attributor.Attribute("align", "align", config);
          var AlignClass = new _parchment2.default.Attributor.Class("align", "ql-align", config);
          var AlignStyle = new _parchment2.default.Attributor.Style("align", "text-align", config);
          exports2.AlignAttribute = AlignAttribute;
          exports2.AlignClass = AlignClass;
          exports2.AlignStyle = AlignStyle;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.BackgroundStyle = exports2.BackgroundClass = void 0;
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _color = __webpack_require__(26);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          var BackgroundClass = new _parchment2.default.Attributor.Class("background", "ql-bg", {
            scope: _parchment2.default.Scope.INLINE
          });
          var BackgroundStyle = new _color.ColorAttributor("background", "background-color", {
            scope: _parchment2.default.Scope.INLINE
          });
          exports2.BackgroundClass = BackgroundClass;
          exports2.BackgroundStyle = BackgroundStyle;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.DirectionStyle = exports2.DirectionClass = exports2.DirectionAttribute = void 0;
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          var config = {
            scope: _parchment2.default.Scope.BLOCK,
            whitelist: ["rtl"]
          };
          var DirectionAttribute = new _parchment2.default.Attributor.Attribute("direction", "dir", config);
          var DirectionClass = new _parchment2.default.Attributor.Class("direction", "ql-direction", config);
          var DirectionStyle = new _parchment2.default.Attributor.Style("direction", "direction", config);
          exports2.DirectionAttribute = DirectionAttribute;
          exports2.DirectionClass = DirectionClass;
          exports2.DirectionStyle = DirectionStyle;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.FontClass = exports2.FontStyle = void 0;
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var config = {
            scope: _parchment2.default.Scope.INLINE,
            whitelist: ["serif", "monospace"]
          };
          var FontClass = new _parchment2.default.Attributor.Class("font", "ql-font", config);
          var FontStyleAttributor = function(_Parchment$Attributor) {
            _inherits(FontStyleAttributor2, _Parchment$Attributor);
            function FontStyleAttributor2() {
              _classCallCheck(this, FontStyleAttributor2);
              return _possibleConstructorReturn(this, (FontStyleAttributor2.__proto__ || Object.getPrototypeOf(FontStyleAttributor2)).apply(this, arguments));
            }
            _createClass(FontStyleAttributor2, [{
              key: "value",
              value: function value(node) {
                return _get(FontStyleAttributor2.prototype.__proto__ || Object.getPrototypeOf(FontStyleAttributor2.prototype), "value", this).call(this, node).replace(/["']/g, "");
              }
            }]);
            return FontStyleAttributor2;
          }(_parchment2.default.Attributor.Style);
          var FontStyle = new FontStyleAttributor("font", "font-family", config);
          exports2.FontStyle = FontStyle;
          exports2.FontClass = FontClass;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.SizeStyle = exports2.SizeClass = void 0;
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          var SizeClass = new _parchment2.default.Attributor.Class("size", "ql-size", {
            scope: _parchment2.default.Scope.INLINE,
            whitelist: ["small", "large", "huge"]
          });
          var SizeStyle = new _parchment2.default.Attributor.Style("size", "font-size", {
            scope: _parchment2.default.Scope.INLINE,
            whitelist: ["10px", "18px", "32px"]
          });
          exports2.SizeClass = SizeClass;
          exports2.SizeStyle = SizeStyle;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          module2.exports = {
            "align": {
              "": __webpack_require__(76),
              "center": __webpack_require__(77),
              "right": __webpack_require__(78),
              "justify": __webpack_require__(79)
            },
            "background": __webpack_require__(80),
            "blockquote": __webpack_require__(81),
            "bold": __webpack_require__(82),
            "clean": __webpack_require__(83),
            "code": __webpack_require__(58),
            "code-block": __webpack_require__(58),
            "color": __webpack_require__(84),
            "direction": {
              "": __webpack_require__(85),
              "rtl": __webpack_require__(86)
            },
            "float": {
              "center": __webpack_require__(87),
              "full": __webpack_require__(88),
              "left": __webpack_require__(89),
              "right": __webpack_require__(90)
            },
            "formula": __webpack_require__(91),
            "header": {
              "1": __webpack_require__(92),
              "2": __webpack_require__(93)
            },
            "italic": __webpack_require__(94),
            "image": __webpack_require__(95),
            "indent": {
              "+1": __webpack_require__(96),
              "-1": __webpack_require__(97)
            },
            "link": __webpack_require__(98),
            "list": {
              "ordered": __webpack_require__(99),
              "bullet": __webpack_require__(100),
              "check": __webpack_require__(101)
            },
            "script": {
              "sub": __webpack_require__(102),
              "super": __webpack_require__(103)
            },
            "strike": __webpack_require__(104),
            "underline": __webpack_require__(105),
            "video": __webpack_require__(106)
          };
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.getLastChangeIndex = exports2.default = void 0;
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _quill = __webpack_require__(5);
          var _quill2 = _interopRequireDefault(_quill);
          var _module = __webpack_require__(9);
          var _module2 = _interopRequireDefault(_module);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var History = function(_Module) {
            _inherits(History2, _Module);
            function History2(quill, options) {
              _classCallCheck(this, History2);
              var _this = _possibleConstructorReturn(this, (History2.__proto__ || Object.getPrototypeOf(History2)).call(this, quill, options));
              _this.lastRecorded = 0;
              _this.ignoreChange = false;
              _this.clear();
              _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function(eventName, delta, oldDelta, source) {
                if (eventName !== _quill2.default.events.TEXT_CHANGE || _this.ignoreChange)
                  return;
                if (!_this.options.userOnly || source === _quill2.default.sources.USER) {
                  _this.record(delta, oldDelta);
                } else {
                  _this.transform(delta);
                }
              });
              _this.quill.keyboard.addBinding({ key: "Z", shortKey: true }, _this.undo.bind(_this));
              _this.quill.keyboard.addBinding({ key: "Z", shortKey: true, shiftKey: true }, _this.redo.bind(_this));
              if (/Win/i.test(navigator.platform)) {
                _this.quill.keyboard.addBinding({ key: "Y", shortKey: true }, _this.redo.bind(_this));
              }
              return _this;
            }
            _createClass(History2, [{
              key: "change",
              value: function change(source, dest) {
                if (this.stack[source].length === 0)
                  return;
                var delta = this.stack[source].pop();
                this.stack[dest].push(delta);
                this.lastRecorded = 0;
                this.ignoreChange = true;
                this.quill.updateContents(delta[source], _quill2.default.sources.USER);
                this.ignoreChange = false;
                var index = getLastChangeIndex(delta[source]);
                this.quill.setSelection(index);
              }
            }, {
              key: "clear",
              value: function clear() {
                this.stack = { undo: [], redo: [] };
              }
            }, {
              key: "cutoff",
              value: function cutoff() {
                this.lastRecorded = 0;
              }
            }, {
              key: "record",
              value: function record(changeDelta, oldDelta) {
                if (changeDelta.ops.length === 0)
                  return;
                this.stack.redo = [];
                var undoDelta = this.quill.getContents().diff(oldDelta);
                var timestamp = Date.now();
                if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
                  var delta = this.stack.undo.pop();
                  undoDelta = undoDelta.compose(delta.undo);
                  changeDelta = delta.redo.compose(changeDelta);
                } else {
                  this.lastRecorded = timestamp;
                }
                this.stack.undo.push({
                  redo: changeDelta,
                  undo: undoDelta
                });
                if (this.stack.undo.length > this.options.maxStack) {
                  this.stack.undo.shift();
                }
              }
            }, {
              key: "redo",
              value: function redo() {
                this.change("redo", "undo");
              }
            }, {
              key: "transform",
              value: function transform(delta) {
                this.stack.undo.forEach(function(change) {
                  change.undo = delta.transform(change.undo, true);
                  change.redo = delta.transform(change.redo, true);
                });
                this.stack.redo.forEach(function(change) {
                  change.undo = delta.transform(change.undo, true);
                  change.redo = delta.transform(change.redo, true);
                });
              }
            }, {
              key: "undo",
              value: function undo() {
                this.change("undo", "redo");
              }
            }]);
            return History2;
          }(_module2.default);
          History.DEFAULTS = {
            delay: 1e3,
            maxStack: 100,
            userOnly: false
          };
          function endsWithNewlineChange(delta) {
            var lastOp = delta.ops[delta.ops.length - 1];
            if (lastOp == null)
              return false;
            if (lastOp.insert != null) {
              return typeof lastOp.insert === "string" && lastOp.insert.endsWith("\n");
            }
            if (lastOp.attributes != null) {
              return Object.keys(lastOp.attributes).some(function(attr) {
                return _parchment2.default.query(attr, _parchment2.default.Scope.BLOCK) != null;
              });
            }
            return false;
          }
          function getLastChangeIndex(delta) {
            var deleteLength = delta.reduce(function(length, op) {
              length += op.delete || 0;
              return length;
            }, 0);
            var changeIndex = delta.length() - deleteLength;
            if (endsWithNewlineChange(delta)) {
              changeIndex -= 1;
            }
            return changeIndex;
          }
          exports2.default = History;
          exports2.getLastChangeIndex = getLastChangeIndex;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.default = exports2.BaseTooltip = void 0;
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _extend = __webpack_require__(3);
          var _extend2 = _interopRequireDefault(_extend);
          var _quillDelta = __webpack_require__(2);
          var _quillDelta2 = _interopRequireDefault(_quillDelta);
          var _emitter = __webpack_require__(8);
          var _emitter2 = _interopRequireDefault(_emitter);
          var _keyboard = __webpack_require__(23);
          var _keyboard2 = _interopRequireDefault(_keyboard);
          var _theme = __webpack_require__(34);
          var _theme2 = _interopRequireDefault(_theme);
          var _colorPicker = __webpack_require__(59);
          var _colorPicker2 = _interopRequireDefault(_colorPicker);
          var _iconPicker = __webpack_require__(60);
          var _iconPicker2 = _interopRequireDefault(_iconPicker);
          var _picker = __webpack_require__(28);
          var _picker2 = _interopRequireDefault(_picker);
          var _tooltip = __webpack_require__(61);
          var _tooltip2 = _interopRequireDefault(_tooltip);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var ALIGNS = [false, "center", "right", "justify"];
          var COLORS = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"];
          var FONTS = [false, "serif", "monospace"];
          var HEADERS = ["1", "2", "3", false];
          var SIZES = ["small", false, "large", "huge"];
          var BaseTheme = function(_Theme) {
            _inherits(BaseTheme2, _Theme);
            function BaseTheme2(quill, options) {
              _classCallCheck(this, BaseTheme2);
              var _this = _possibleConstructorReturn(this, (BaseTheme2.__proto__ || Object.getPrototypeOf(BaseTheme2)).call(this, quill, options));
              var listener = function listener2(e) {
                if (!document.body.contains(quill.root)) {
                  return document.body.removeEventListener("click", listener2);
                }
                if (_this.tooltip != null && !_this.tooltip.root.contains(e.target) && document.activeElement !== _this.tooltip.textbox && !_this.quill.hasFocus()) {
                  _this.tooltip.hide();
                }
                if (_this.pickers != null) {
                  _this.pickers.forEach(function(picker) {
                    if (!picker.container.contains(e.target)) {
                      picker.close();
                    }
                  });
                }
              };
              quill.emitter.listenDOM("click", document.body, listener);
              return _this;
            }
            _createClass(BaseTheme2, [{
              key: "addModule",
              value: function addModule(name) {
                var module3 = _get(BaseTheme2.prototype.__proto__ || Object.getPrototypeOf(BaseTheme2.prototype), "addModule", this).call(this, name);
                if (name === "toolbar") {
                  this.extendToolbar(module3);
                }
                return module3;
              }
            }, {
              key: "buildButtons",
              value: function buildButtons(buttons, icons) {
                buttons.forEach(function(button) {
                  var className = button.getAttribute("class") || "";
                  className.split(/\s+/).forEach(function(name) {
                    if (!name.startsWith("ql-"))
                      return;
                    name = name.slice("ql-".length);
                    if (icons[name] == null)
                      return;
                    if (name === "direction") {
                      button.innerHTML = icons[name][""] + icons[name]["rtl"];
                    } else if (typeof icons[name] === "string") {
                      button.innerHTML = icons[name];
                    } else {
                      var value = button.value || "";
                      if (value != null && icons[name][value]) {
                        button.innerHTML = icons[name][value];
                      }
                    }
                  });
                });
              }
            }, {
              key: "buildPickers",
              value: function buildPickers(selects, icons) {
                var _this2 = this;
                this.pickers = selects.map(function(select) {
                  if (select.classList.contains("ql-align")) {
                    if (select.querySelector("option") == null) {
                      fillSelect(select, ALIGNS);
                    }
                    return new _iconPicker2.default(select, icons.align);
                  } else if (select.classList.contains("ql-background") || select.classList.contains("ql-color")) {
                    var format = select.classList.contains("ql-background") ? "background" : "color";
                    if (select.querySelector("option") == null) {
                      fillSelect(select, COLORS, format === "background" ? "#ffffff" : "#000000");
                    }
                    return new _colorPicker2.default(select, icons[format]);
                  } else {
                    if (select.querySelector("option") == null) {
                      if (select.classList.contains("ql-font")) {
                        fillSelect(select, FONTS);
                      } else if (select.classList.contains("ql-header")) {
                        fillSelect(select, HEADERS);
                      } else if (select.classList.contains("ql-size")) {
                        fillSelect(select, SIZES);
                      }
                    }
                    return new _picker2.default(select);
                  }
                });
                var update = function update2() {
                  _this2.pickers.forEach(function(picker) {
                    picker.update();
                  });
                };
                this.quill.on(_emitter2.default.events.EDITOR_CHANGE, update);
              }
            }]);
            return BaseTheme2;
          }(_theme2.default);
          BaseTheme.DEFAULTS = (0, _extend2.default)(true, {}, _theme2.default.DEFAULTS, {
            modules: {
              toolbar: {
                handlers: {
                  formula: function formula() {
                    this.quill.theme.tooltip.edit("formula");
                  },
                  image: function image() {
                    var _this3 = this;
                    var fileInput = this.container.querySelector("input.ql-image[type=file]");
                    if (fileInput == null) {
                      fileInput = document.createElement("input");
                      fileInput.setAttribute("type", "file");
                      fileInput.setAttribute("accept", "image/png, image/gif, image/jpeg, image/bmp, image/x-icon");
                      fileInput.classList.add("ql-image");
                      fileInput.addEventListener("change", function() {
                        if (fileInput.files != null && fileInput.files[0] != null) {
                          var reader = new FileReader();
                          reader.onload = function(e) {
                            var range = _this3.quill.getSelection(true);
                            _this3.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert({ image: e.target.result }), _emitter2.default.sources.USER);
                            _this3.quill.setSelection(range.index + 1, _emitter2.default.sources.SILENT);
                            fileInput.value = "";
                          };
                          reader.readAsDataURL(fileInput.files[0]);
                        }
                      });
                      this.container.appendChild(fileInput);
                    }
                    fileInput.click();
                  },
                  video: function video() {
                    this.quill.theme.tooltip.edit("video");
                  }
                }
              }
            }
          });
          var BaseTooltip = function(_Tooltip) {
            _inherits(BaseTooltip2, _Tooltip);
            function BaseTooltip2(quill, boundsContainer) {
              _classCallCheck(this, BaseTooltip2);
              var _this4 = _possibleConstructorReturn(this, (BaseTooltip2.__proto__ || Object.getPrototypeOf(BaseTooltip2)).call(this, quill, boundsContainer));
              _this4.textbox = _this4.root.querySelector('input[type="text"]');
              _this4.listen();
              return _this4;
            }
            _createClass(BaseTooltip2, [{
              key: "listen",
              value: function listen() {
                var _this5 = this;
                this.textbox.addEventListener("keydown", function(event) {
                  if (_keyboard2.default.match(event, "enter")) {
                    _this5.save();
                    event.preventDefault();
                  } else if (_keyboard2.default.match(event, "escape")) {
                    _this5.cancel();
                    event.preventDefault();
                  }
                });
              }
            }, {
              key: "cancel",
              value: function cancel() {
                this.hide();
              }
            }, {
              key: "edit",
              value: function edit() {
                var mode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "link";
                var preview = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                this.root.classList.remove("ql-hidden");
                this.root.classList.add("ql-editing");
                if (preview != null) {
                  this.textbox.value = preview;
                } else if (mode !== this.root.getAttribute("data-mode")) {
                  this.textbox.value = "";
                }
                this.position(this.quill.getBounds(this.quill.selection.savedRange));
                this.textbox.select();
                this.textbox.setAttribute("placeholder", this.textbox.getAttribute("data-" + mode) || "");
                this.root.setAttribute("data-mode", mode);
              }
            }, {
              key: "restoreFocus",
              value: function restoreFocus() {
                var scrollTop = this.quill.scrollingContainer.scrollTop;
                this.quill.focus();
                this.quill.scrollingContainer.scrollTop = scrollTop;
              }
            }, {
              key: "save",
              value: function save() {
                var value = this.textbox.value;
                switch (this.root.getAttribute("data-mode")) {
                  case "link": {
                    var scrollTop = this.quill.root.scrollTop;
                    if (this.linkRange) {
                      this.quill.formatText(this.linkRange, "link", value, _emitter2.default.sources.USER);
                      delete this.linkRange;
                    } else {
                      this.restoreFocus();
                      this.quill.format("link", value, _emitter2.default.sources.USER);
                    }
                    this.quill.root.scrollTop = scrollTop;
                    break;
                  }
                  case "video": {
                    value = extractVideoUrl(value);
                  }
                  case "formula": {
                    if (!value)
                      break;
                    var range = this.quill.getSelection(true);
                    if (range != null) {
                      var index = range.index + range.length;
                      this.quill.insertEmbed(index, this.root.getAttribute("data-mode"), value, _emitter2.default.sources.USER);
                      if (this.root.getAttribute("data-mode") === "formula") {
                        this.quill.insertText(index + 1, " ", _emitter2.default.sources.USER);
                      }
                      this.quill.setSelection(index + 2, _emitter2.default.sources.USER);
                    }
                    break;
                  }
                  default:
                }
                this.textbox.value = "";
                this.hide();
              }
            }]);
            return BaseTooltip2;
          }(_tooltip2.default);
          function extractVideoUrl(url) {
            var match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
            if (match) {
              return (match[1] || "https") + "://www.youtube.com/embed/" + match[2] + "?showinfo=0";
            }
            if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) {
              return (match[1] || "https") + "://player.vimeo.com/video/" + match[2] + "/";
            }
            return url;
          }
          function fillSelect(select, values) {
            var defaultValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            values.forEach(function(value) {
              var option = document.createElement("option");
              if (value === defaultValue) {
                option.setAttribute("selected", "selected");
              } else {
                option.setAttribute("value", value);
              }
              select.appendChild(option);
            });
          }
          exports2.BaseTooltip = BaseTooltip;
          exports2.default = BaseTheme;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", { value: true });
          var LinkedList = function() {
            function LinkedList2() {
              this.head = this.tail = null;
              this.length = 0;
            }
            LinkedList2.prototype.append = function() {
              var nodes = [];
              for (var _i = 0; _i < arguments.length; _i++) {
                nodes[_i] = arguments[_i];
              }
              this.insertBefore(nodes[0], null);
              if (nodes.length > 1) {
                this.append.apply(this, nodes.slice(1));
              }
            };
            LinkedList2.prototype.contains = function(node) {
              var cur, next = this.iterator();
              while (cur = next()) {
                if (cur === node)
                  return true;
              }
              return false;
            };
            LinkedList2.prototype.insertBefore = function(node, refNode) {
              if (!node)
                return;
              node.next = refNode;
              if (refNode != null) {
                node.prev = refNode.prev;
                if (refNode.prev != null) {
                  refNode.prev.next = node;
                }
                refNode.prev = node;
                if (refNode === this.head) {
                  this.head = node;
                }
              } else if (this.tail != null) {
                this.tail.next = node;
                node.prev = this.tail;
                this.tail = node;
              } else {
                node.prev = null;
                this.head = this.tail = node;
              }
              this.length += 1;
            };
            LinkedList2.prototype.offset = function(target) {
              var index = 0, cur = this.head;
              while (cur != null) {
                if (cur === target)
                  return index;
                index += cur.length();
                cur = cur.next;
              }
              return -1;
            };
            LinkedList2.prototype.remove = function(node) {
              if (!this.contains(node))
                return;
              if (node.prev != null)
                node.prev.next = node.next;
              if (node.next != null)
                node.next.prev = node.prev;
              if (node === this.head)
                this.head = node.next;
              if (node === this.tail)
                this.tail = node.prev;
              this.length -= 1;
            };
            LinkedList2.prototype.iterator = function(curNode) {
              if (curNode === void 0) {
                curNode = this.head;
              }
              return function() {
                var ret = curNode;
                if (curNode != null)
                  curNode = curNode.next;
                return ret;
              };
            };
            LinkedList2.prototype.find = function(index, inclusive) {
              if (inclusive === void 0) {
                inclusive = false;
              }
              var cur, next = this.iterator();
              while (cur = next()) {
                var length = cur.length();
                if (index < length || inclusive && index === length && (cur.next == null || cur.next.length() !== 0)) {
                  return [cur, index];
                }
                index -= length;
              }
              return [null, 0];
            };
            LinkedList2.prototype.forEach = function(callback) {
              var cur, next = this.iterator();
              while (cur = next()) {
                callback(cur);
              }
            };
            LinkedList2.prototype.forEachAt = function(index, length, callback) {
              if (length <= 0)
                return;
              var _a2 = this.find(index), startNode = _a2[0], offset = _a2[1];
              var cur, curIndex = index - offset, next = this.iterator(startNode);
              while ((cur = next()) && curIndex < index + length) {
                var curLength = cur.length();
                if (index > curIndex) {
                  callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index));
                } else {
                  callback(cur, 0, Math.min(curLength, index + length - curIndex));
                }
                curIndex += curLength;
              }
            };
            LinkedList2.prototype.map = function(callback) {
              return this.reduce(function(memo, cur) {
                memo.push(callback(cur));
                return memo;
              }, []);
            };
            LinkedList2.prototype.reduce = function(callback, memo) {
              var cur, next = this.iterator();
              while (cur = next()) {
                memo = callback(memo, cur);
              }
              return memo;
            };
            return LinkedList2;
          }();
          exports2.default = LinkedList;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          var __extends = this && this.__extends || function() {
            var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
              d.__proto__ = b;
            } || function(d, b) {
              for (var p in b)
                if (b.hasOwnProperty(p))
                  d[p] = b[p];
            };
            return function(d, b) {
              extendStatics(d, b);
              function __() {
                this.constructor = d;
              }
              d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            };
          }();
          Object.defineProperty(exports2, "__esModule", { value: true });
          var container_1 = __webpack_require__(17);
          var Registry = __webpack_require__(1);
          var OBSERVER_CONFIG = {
            attributes: true,
            characterData: true,
            characterDataOldValue: true,
            childList: true,
            subtree: true
          };
          var MAX_OPTIMIZE_ITERATIONS = 100;
          var ScrollBlot = function(_super) {
            __extends(ScrollBlot2, _super);
            function ScrollBlot2(node) {
              var _this = _super.call(this, node) || this;
              _this.scroll = _this;
              _this.observer = new MutationObserver(function(mutations) {
                _this.update(mutations);
              });
              _this.observer.observe(_this.domNode, OBSERVER_CONFIG);
              _this.attach();
              return _this;
            }
            ScrollBlot2.prototype.detach = function() {
              _super.prototype.detach.call(this);
              this.observer.disconnect();
            };
            ScrollBlot2.prototype.deleteAt = function(index, length) {
              this.update();
              if (index === 0 && length === this.length()) {
                this.children.forEach(function(child) {
                  child.remove();
                });
              } else {
                _super.prototype.deleteAt.call(this, index, length);
              }
            };
            ScrollBlot2.prototype.formatAt = function(index, length, name, value) {
              this.update();
              _super.prototype.formatAt.call(this, index, length, name, value);
            };
            ScrollBlot2.prototype.insertAt = function(index, value, def) {
              this.update();
              _super.prototype.insertAt.call(this, index, value, def);
            };
            ScrollBlot2.prototype.optimize = function(mutations, context) {
              var _this = this;
              if (mutations === void 0) {
                mutations = [];
              }
              if (context === void 0) {
                context = {};
              }
              _super.prototype.optimize.call(this, context);
              var records = [].slice.call(this.observer.takeRecords());
              while (records.length > 0)
                mutations.push(records.pop());
              var mark = function(blot, markParent) {
                if (markParent === void 0) {
                  markParent = true;
                }
                if (blot == null || blot === _this)
                  return;
                if (blot.domNode.parentNode == null)
                  return;
                if (blot.domNode[Registry.DATA_KEY].mutations == null) {
                  blot.domNode[Registry.DATA_KEY].mutations = [];
                }
                if (markParent)
                  mark(blot.parent);
              };
              var optimize = function(blot) {
                if (blot.domNode[Registry.DATA_KEY] == null || blot.domNode[Registry.DATA_KEY].mutations == null) {
                  return;
                }
                if (blot instanceof container_1.default) {
                  blot.children.forEach(optimize);
                }
                blot.optimize(context);
              };
              var remaining = mutations;
              for (var i = 0; remaining.length > 0; i += 1) {
                if (i >= MAX_OPTIMIZE_ITERATIONS) {
                  throw new Error("[Parchment] Maximum optimize iterations reached");
                }
                remaining.forEach(function(mutation) {
                  var blot = Registry.find(mutation.target, true);
                  if (blot == null)
                    return;
                  if (blot.domNode === mutation.target) {
                    if (mutation.type === "childList") {
                      mark(Registry.find(mutation.previousSibling, false));
                      [].forEach.call(mutation.addedNodes, function(node) {
                        var child = Registry.find(node, false);
                        mark(child, false);
                        if (child instanceof container_1.default) {
                          child.children.forEach(function(grandChild) {
                            mark(grandChild, false);
                          });
                        }
                      });
                    } else if (mutation.type === "attributes") {
                      mark(blot.prev);
                    }
                  }
                  mark(blot);
                });
                this.children.forEach(optimize);
                remaining = [].slice.call(this.observer.takeRecords());
                records = remaining.slice();
                while (records.length > 0)
                  mutations.push(records.pop());
              }
            };
            ScrollBlot2.prototype.update = function(mutations, context) {
              var _this = this;
              if (context === void 0) {
                context = {};
              }
              mutations = mutations || this.observer.takeRecords();
              mutations.map(function(mutation) {
                var blot = Registry.find(mutation.target, true);
                if (blot == null)
                  return null;
                if (blot.domNode[Registry.DATA_KEY].mutations == null) {
                  blot.domNode[Registry.DATA_KEY].mutations = [mutation];
                  return blot;
                } else {
                  blot.domNode[Registry.DATA_KEY].mutations.push(mutation);
                  return null;
                }
              }).forEach(function(blot) {
                if (blot == null || blot === _this || blot.domNode[Registry.DATA_KEY] == null)
                  return;
                blot.update(blot.domNode[Registry.DATA_KEY].mutations || [], context);
              });
              if (this.domNode[Registry.DATA_KEY].mutations != null) {
                _super.prototype.update.call(this, this.domNode[Registry.DATA_KEY].mutations, context);
              }
              this.optimize(mutations, context);
            };
            ScrollBlot2.blotName = "scroll";
            ScrollBlot2.defaultChild = "block";
            ScrollBlot2.scope = Registry.Scope.BLOCK_BLOT;
            ScrollBlot2.tagName = "DIV";
            return ScrollBlot2;
          }(container_1.default);
          exports2.default = ScrollBlot;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          var __extends = this && this.__extends || function() {
            var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
              d.__proto__ = b;
            } || function(d, b) {
              for (var p in b)
                if (b.hasOwnProperty(p))
                  d[p] = b[p];
            };
            return function(d, b) {
              extendStatics(d, b);
              function __() {
                this.constructor = d;
              }
              d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            };
          }();
          Object.defineProperty(exports2, "__esModule", { value: true });
          var format_1 = __webpack_require__(18);
          var Registry = __webpack_require__(1);
          function isEqual(obj1, obj2) {
            if (Object.keys(obj1).length !== Object.keys(obj2).length)
              return false;
            for (var prop in obj1) {
              if (obj1[prop] !== obj2[prop])
                return false;
            }
            return true;
          }
          var InlineBlot = function(_super) {
            __extends(InlineBlot2, _super);
            function InlineBlot2() {
              return _super !== null && _super.apply(this, arguments) || this;
            }
            InlineBlot2.formats = function(domNode) {
              if (domNode.tagName === InlineBlot2.tagName)
                return void 0;
              return _super.formats.call(this, domNode);
            };
            InlineBlot2.prototype.format = function(name, value) {
              var _this = this;
              if (name === this.statics.blotName && !value) {
                this.children.forEach(function(child) {
                  if (!(child instanceof format_1.default)) {
                    child = child.wrap(InlineBlot2.blotName, true);
                  }
                  _this.attributes.copy(child);
                });
                this.unwrap();
              } else {
                _super.prototype.format.call(this, name, value);
              }
            };
            InlineBlot2.prototype.formatAt = function(index, length, name, value) {
              if (this.formats()[name] != null || Registry.query(name, Registry.Scope.ATTRIBUTE)) {
                var blot = this.isolate(index, length);
                blot.format(name, value);
              } else {
                _super.prototype.formatAt.call(this, index, length, name, value);
              }
            };
            InlineBlot2.prototype.optimize = function(context) {
              _super.prototype.optimize.call(this, context);
              var formats = this.formats();
              if (Object.keys(formats).length === 0) {
                return this.unwrap();
              }
              var next = this.next;
              if (next instanceof InlineBlot2 && next.prev === this && isEqual(formats, next.formats())) {
                next.moveChildren(this);
                next.remove();
              }
            };
            InlineBlot2.blotName = "inline";
            InlineBlot2.scope = Registry.Scope.INLINE_BLOT;
            InlineBlot2.tagName = "SPAN";
            return InlineBlot2;
          }(format_1.default);
          exports2.default = InlineBlot;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          var __extends = this && this.__extends || function() {
            var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
              d.__proto__ = b;
            } || function(d, b) {
              for (var p in b)
                if (b.hasOwnProperty(p))
                  d[p] = b[p];
            };
            return function(d, b) {
              extendStatics(d, b);
              function __() {
                this.constructor = d;
              }
              d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            };
          }();
          Object.defineProperty(exports2, "__esModule", { value: true });
          var format_1 = __webpack_require__(18);
          var Registry = __webpack_require__(1);
          var BlockBlot = function(_super) {
            __extends(BlockBlot2, _super);
            function BlockBlot2() {
              return _super !== null && _super.apply(this, arguments) || this;
            }
            BlockBlot2.formats = function(domNode) {
              var tagName = Registry.query(BlockBlot2.blotName).tagName;
              if (domNode.tagName === tagName)
                return void 0;
              return _super.formats.call(this, domNode);
            };
            BlockBlot2.prototype.format = function(name, value) {
              if (Registry.query(name, Registry.Scope.BLOCK) == null) {
                return;
              } else if (name === this.statics.blotName && !value) {
                this.replaceWith(BlockBlot2.blotName);
              } else {
                _super.prototype.format.call(this, name, value);
              }
            };
            BlockBlot2.prototype.formatAt = function(index, length, name, value) {
              if (Registry.query(name, Registry.Scope.BLOCK) != null) {
                this.format(name, value);
              } else {
                _super.prototype.formatAt.call(this, index, length, name, value);
              }
            };
            BlockBlot2.prototype.insertAt = function(index, value, def) {
              if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) {
                _super.prototype.insertAt.call(this, index, value, def);
              } else {
                var after = this.split(index);
                var blot = Registry.create(value, def);
                after.parent.insertBefore(blot, after);
              }
            };
            BlockBlot2.prototype.update = function(mutations, context) {
              if (navigator.userAgent.match(/Trident/)) {
                this.build();
              } else {
                _super.prototype.update.call(this, mutations, context);
              }
            };
            BlockBlot2.blotName = "block";
            BlockBlot2.scope = Registry.Scope.BLOCK_BLOT;
            BlockBlot2.tagName = "P";
            return BlockBlot2;
          }(format_1.default);
          exports2.default = BlockBlot;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          var __extends = this && this.__extends || function() {
            var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
              d.__proto__ = b;
            } || function(d, b) {
              for (var p in b)
                if (b.hasOwnProperty(p))
                  d[p] = b[p];
            };
            return function(d, b) {
              extendStatics(d, b);
              function __() {
                this.constructor = d;
              }
              d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            };
          }();
          Object.defineProperty(exports2, "__esModule", { value: true });
          var leaf_1 = __webpack_require__(19);
          var EmbedBlot = function(_super) {
            __extends(EmbedBlot2, _super);
            function EmbedBlot2() {
              return _super !== null && _super.apply(this, arguments) || this;
            }
            EmbedBlot2.formats = function(domNode) {
              return void 0;
            };
            EmbedBlot2.prototype.format = function(name, value) {
              _super.prototype.formatAt.call(this, 0, this.length(), name, value);
            };
            EmbedBlot2.prototype.formatAt = function(index, length, name, value) {
              if (index === 0 && length === this.length()) {
                this.format(name, value);
              } else {
                _super.prototype.formatAt.call(this, index, length, name, value);
              }
            };
            EmbedBlot2.prototype.formats = function() {
              return this.statics.formats(this.domNode);
            };
            return EmbedBlot2;
          }(leaf_1.default);
          exports2.default = EmbedBlot;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          var __extends = this && this.__extends || function() {
            var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
              d.__proto__ = b;
            } || function(d, b) {
              for (var p in b)
                if (b.hasOwnProperty(p))
                  d[p] = b[p];
            };
            return function(d, b) {
              extendStatics(d, b);
              function __() {
                this.constructor = d;
              }
              d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            };
          }();
          Object.defineProperty(exports2, "__esModule", { value: true });
          var leaf_1 = __webpack_require__(19);
          var Registry = __webpack_require__(1);
          var TextBlot = function(_super) {
            __extends(TextBlot2, _super);
            function TextBlot2(node) {
              var _this = _super.call(this, node) || this;
              _this.text = _this.statics.value(_this.domNode);
              return _this;
            }
            TextBlot2.create = function(value) {
              return document.createTextNode(value);
            };
            TextBlot2.value = function(domNode) {
              var text = domNode.data;
              if (text["normalize"])
                text = text["normalize"]();
              return text;
            };
            TextBlot2.prototype.deleteAt = function(index, length) {
              this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
            };
            TextBlot2.prototype.index = function(node, offset) {
              if (this.domNode === node) {
                return offset;
              }
              return -1;
            };
            TextBlot2.prototype.insertAt = function(index, value, def) {
              if (def == null) {
                this.text = this.text.slice(0, index) + value + this.text.slice(index);
                this.domNode.data = this.text;
              } else {
                _super.prototype.insertAt.call(this, index, value, def);
              }
            };
            TextBlot2.prototype.length = function() {
              return this.text.length;
            };
            TextBlot2.prototype.optimize = function(context) {
              _super.prototype.optimize.call(this, context);
              this.text = this.statics.value(this.domNode);
              if (this.text.length === 0) {
                this.remove();
              } else if (this.next instanceof TextBlot2 && this.next.prev === this) {
                this.insertAt(this.length(), this.next.value());
                this.next.remove();
              }
            };
            TextBlot2.prototype.position = function(index, inclusive) {
              if (inclusive === void 0) {
                inclusive = false;
              }
              return [this.domNode, index];
            };
            TextBlot2.prototype.split = function(index, force) {
              if (force === void 0) {
                force = false;
              }
              if (!force) {
                if (index === 0)
                  return this;
                if (index === this.length())
                  return this.next;
              }
              var after = Registry.create(this.domNode.splitText(index));
              this.parent.insertBefore(after, this.next);
              this.text = this.statics.value(this.domNode);
              return after;
            };
            TextBlot2.prototype.update = function(mutations, context) {
              var _this = this;
              if (mutations.some(function(mutation) {
                return mutation.type === "characterData" && mutation.target === _this.domNode;
              })) {
                this.text = this.statics.value(this.domNode);
              }
            };
            TextBlot2.prototype.value = function() {
              return this.text;
            };
            TextBlot2.blotName = "text";
            TextBlot2.scope = Registry.Scope.INLINE_BLOT;
            return TextBlot2;
          }(leaf_1.default);
          exports2.default = TextBlot;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          var elem = document.createElement("div");
          elem.classList.toggle("test-class", false);
          if (elem.classList.contains("test-class")) {
            var _toggle = DOMTokenList.prototype.toggle;
            DOMTokenList.prototype.toggle = function(token, force) {
              if (arguments.length > 1 && !this.contains(token) === !force) {
                return force;
              } else {
                return _toggle.call(this, token);
              }
            };
          }
          if (!String.prototype.startsWith) {
            String.prototype.startsWith = function(searchString, position) {
              position = position || 0;
              return this.substr(position, searchString.length) === searchString;
            };
          }
          if (!String.prototype.endsWith) {
            String.prototype.endsWith = function(searchString, position) {
              var subjectString = this.toString();
              if (typeof position !== "number" || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
                position = subjectString.length;
              }
              position -= searchString.length;
              var lastIndex = subjectString.indexOf(searchString, position);
              return lastIndex !== -1 && lastIndex === position;
            };
          }
          if (!Array.prototype.find) {
            Object.defineProperty(Array.prototype, "find", {
              value: function value(predicate) {
                if (this === null) {
                  throw new TypeError("Array.prototype.find called on null or undefined");
                }
                if (typeof predicate !== "function") {
                  throw new TypeError("predicate must be a function");
                }
                var list = Object(this);
                var length = list.length >>> 0;
                var thisArg = arguments[1];
                var value2;
                for (var i = 0; i < length; i++) {
                  value2 = list[i];
                  if (predicate.call(thisArg, value2, i, list)) {
                    return value2;
                  }
                }
                return void 0;
              }
            });
          }
          document.addEventListener("DOMContentLoaded", function() {
            document.execCommand("enableObjectResizing", false, false);
            document.execCommand("autoUrlDetect", false, false);
          });
        },
        function(module2, exports2) {
          var DIFF_DELETE = -1;
          var DIFF_INSERT = 1;
          var DIFF_EQUAL = 0;
          function diff_main(text1, text2, cursor_pos) {
            if (text1 == text2) {
              if (text1) {
                return [[DIFF_EQUAL, text1]];
              }
              return [];
            }
            if (cursor_pos < 0 || text1.length < cursor_pos) {
              cursor_pos = null;
            }
            var commonlength = diff_commonPrefix(text1, text2);
            var commonprefix = text1.substring(0, commonlength);
            text1 = text1.substring(commonlength);
            text2 = text2.substring(commonlength);
            commonlength = diff_commonSuffix(text1, text2);
            var commonsuffix = text1.substring(text1.length - commonlength);
            text1 = text1.substring(0, text1.length - commonlength);
            text2 = text2.substring(0, text2.length - commonlength);
            var diffs = diff_compute_(text1, text2);
            if (commonprefix) {
              diffs.unshift([DIFF_EQUAL, commonprefix]);
            }
            if (commonsuffix) {
              diffs.push([DIFF_EQUAL, commonsuffix]);
            }
            diff_cleanupMerge(diffs);
            if (cursor_pos != null) {
              diffs = fix_cursor(diffs, cursor_pos);
            }
            diffs = fix_emoji(diffs);
            return diffs;
          }
          ;
          function diff_compute_(text1, text2) {
            var diffs;
            if (!text1) {
              return [[DIFF_INSERT, text2]];
            }
            if (!text2) {
              return [[DIFF_DELETE, text1]];
            }
            var longtext = text1.length > text2.length ? text1 : text2;
            var shorttext = text1.length > text2.length ? text2 : text1;
            var i = longtext.indexOf(shorttext);
            if (i != -1) {
              diffs = [
                [DIFF_INSERT, longtext.substring(0, i)],
                [DIFF_EQUAL, shorttext],
                [DIFF_INSERT, longtext.substring(i + shorttext.length)]
              ];
              if (text1.length > text2.length) {
                diffs[0][0] = diffs[2][0] = DIFF_DELETE;
              }
              return diffs;
            }
            if (shorttext.length == 1) {
              return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
            }
            var hm = diff_halfMatch_(text1, text2);
            if (hm) {
              var text1_a = hm[0];
              var text1_b = hm[1];
              var text2_a = hm[2];
              var text2_b = hm[3];
              var mid_common = hm[4];
              var diffs_a = diff_main(text1_a, text2_a);
              var diffs_b = diff_main(text1_b, text2_b);
              return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
            }
            return diff_bisect_(text1, text2);
          }
          ;
          function diff_bisect_(text1, text2) {
            var text1_length = text1.length;
            var text2_length = text2.length;
            var max_d = Math.ceil((text1_length + text2_length) / 2);
            var v_offset = max_d;
            var v_length = 2 * max_d;
            var v1 = new Array(v_length);
            var v2 = new Array(v_length);
            for (var x = 0; x < v_length; x++) {
              v1[x] = -1;
              v2[x] = -1;
            }
            v1[v_offset + 1] = 0;
            v2[v_offset + 1] = 0;
            var delta = text1_length - text2_length;
            var front = delta % 2 != 0;
            var k1start = 0;
            var k1end = 0;
            var k2start = 0;
            var k2end = 0;
            for (var d = 0; d < max_d; d++) {
              for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
                var k1_offset = v_offset + k1;
                var x1;
                if (k1 == -d || k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1]) {
                  x1 = v1[k1_offset + 1];
                } else {
                  x1 = v1[k1_offset - 1] + 1;
                }
                var y1 = x1 - k1;
                while (x1 < text1_length && y1 < text2_length && text1.charAt(x1) == text2.charAt(y1)) {
                  x1++;
                  y1++;
                }
                v1[k1_offset] = x1;
                if (x1 > text1_length) {
                  k1end += 2;
                } else if (y1 > text2_length) {
                  k1start += 2;
                } else if (front) {
                  var k2_offset = v_offset + delta - k1;
                  if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
                    var x2 = text1_length - v2[k2_offset];
                    if (x1 >= x2) {
                      return diff_bisectSplit_(text1, text2, x1, y1);
                    }
                  }
                }
              }
              for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
                var k2_offset = v_offset + k2;
                var x2;
                if (k2 == -d || k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1]) {
                  x2 = v2[k2_offset + 1];
                } else {
                  x2 = v2[k2_offset - 1] + 1;
                }
                var y2 = x2 - k2;
                while (x2 < text1_length && y2 < text2_length && text1.charAt(text1_length - x2 - 1) == text2.charAt(text2_length - y2 - 1)) {
                  x2++;
                  y2++;
                }
                v2[k2_offset] = x2;
                if (x2 > text1_length) {
                  k2end += 2;
                } else if (y2 > text2_length) {
                  k2start += 2;
                } else if (!front) {
                  var k1_offset = v_offset + delta - k2;
                  if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
                    var x1 = v1[k1_offset];
                    var y1 = v_offset + x1 - k1_offset;
                    x2 = text1_length - x2;
                    if (x1 >= x2) {
                      return diff_bisectSplit_(text1, text2, x1, y1);
                    }
                  }
                }
              }
            }
            return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
          }
          ;
          function diff_bisectSplit_(text1, text2, x, y) {
            var text1a = text1.substring(0, x);
            var text2a = text2.substring(0, y);
            var text1b = text1.substring(x);
            var text2b = text2.substring(y);
            var diffs = diff_main(text1a, text2a);
            var diffsb = diff_main(text1b, text2b);
            return diffs.concat(diffsb);
          }
          ;
          function diff_commonPrefix(text1, text2) {
            if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
              return 0;
            }
            var pointermin = 0;
            var pointermax = Math.min(text1.length, text2.length);
            var pointermid = pointermax;
            var pointerstart = 0;
            while (pointermin < pointermid) {
              if (text1.substring(pointerstart, pointermid) == text2.substring(pointerstart, pointermid)) {
                pointermin = pointermid;
                pointerstart = pointermin;
              } else {
                pointermax = pointermid;
              }
              pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
            }
            return pointermid;
          }
          ;
          function diff_commonSuffix(text1, text2) {
            if (!text1 || !text2 || text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
              return 0;
            }
            var pointermin = 0;
            var pointermax = Math.min(text1.length, text2.length);
            var pointermid = pointermax;
            var pointerend = 0;
            while (pointermin < pointermid) {
              if (text1.substring(text1.length - pointermid, text1.length - pointerend) == text2.substring(text2.length - pointermid, text2.length - pointerend)) {
                pointermin = pointermid;
                pointerend = pointermin;
              } else {
                pointermax = pointermid;
              }
              pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
            }
            return pointermid;
          }
          ;
          function diff_halfMatch_(text1, text2) {
            var longtext = text1.length > text2.length ? text1 : text2;
            var shorttext = text1.length > text2.length ? text2 : text1;
            if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
              return null;
            }
            function diff_halfMatchI_(longtext2, shorttext2, i) {
              var seed = longtext2.substring(i, i + Math.floor(longtext2.length / 4));
              var j = -1;
              var best_common = "";
              var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
              while ((j = shorttext2.indexOf(seed, j + 1)) != -1) {
                var prefixLength = diff_commonPrefix(longtext2.substring(i), shorttext2.substring(j));
                var suffixLength = diff_commonSuffix(longtext2.substring(0, i), shorttext2.substring(0, j));
                if (best_common.length < suffixLength + prefixLength) {
                  best_common = shorttext2.substring(j - suffixLength, j) + shorttext2.substring(j, j + prefixLength);
                  best_longtext_a = longtext2.substring(0, i - suffixLength);
                  best_longtext_b = longtext2.substring(i + prefixLength);
                  best_shorttext_a = shorttext2.substring(0, j - suffixLength);
                  best_shorttext_b = shorttext2.substring(j + prefixLength);
                }
              }
              if (best_common.length * 2 >= longtext2.length) {
                return [
                  best_longtext_a,
                  best_longtext_b,
                  best_shorttext_a,
                  best_shorttext_b,
                  best_common
                ];
              } else {
                return null;
              }
            }
            var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
            var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
            var hm;
            if (!hm1 && !hm2) {
              return null;
            } else if (!hm2) {
              hm = hm1;
            } else if (!hm1) {
              hm = hm2;
            } else {
              hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
            }
            var text1_a, text1_b, text2_a, text2_b;
            if (text1.length > text2.length) {
              text1_a = hm[0];
              text1_b = hm[1];
              text2_a = hm[2];
              text2_b = hm[3];
            } else {
              text2_a = hm[0];
              text2_b = hm[1];
              text1_a = hm[2];
              text1_b = hm[3];
            }
            var mid_common = hm[4];
            return [text1_a, text1_b, text2_a, text2_b, mid_common];
          }
          ;
          function diff_cleanupMerge(diffs) {
            diffs.push([DIFF_EQUAL, ""]);
            var pointer = 0;
            var count_delete = 0;
            var count_insert = 0;
            var text_delete = "";
            var text_insert = "";
            var commonlength;
            while (pointer < diffs.length) {
              switch (diffs[pointer][0]) {
                case DIFF_INSERT:
                  count_insert++;
                  text_insert += diffs[pointer][1];
                  pointer++;
                  break;
                case DIFF_DELETE:
                  count_delete++;
                  text_delete += diffs[pointer][1];
                  pointer++;
                  break;
                case DIFF_EQUAL:
                  if (count_delete + count_insert > 1) {
                    if (count_delete !== 0 && count_insert !== 0) {
                      commonlength = diff_commonPrefix(text_insert, text_delete);
                      if (commonlength !== 0) {
                        if (pointer - count_delete - count_insert > 0 && diffs[pointer - count_delete - count_insert - 1][0] == DIFF_EQUAL) {
                          diffs[pointer - count_delete - count_insert - 1][1] += text_insert.substring(0, commonlength);
                        } else {
                          diffs.splice(0, 0, [
                            DIFF_EQUAL,
                            text_insert.substring(0, commonlength)
                          ]);
                          pointer++;
                        }
                        text_insert = text_insert.substring(commonlength);
                        text_delete = text_delete.substring(commonlength);
                      }
                      commonlength = diff_commonSuffix(text_insert, text_delete);
                      if (commonlength !== 0) {
                        diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
                        text_insert = text_insert.substring(0, text_insert.length - commonlength);
                        text_delete = text_delete.substring(0, text_delete.length - commonlength);
                      }
                    }
                    if (count_delete === 0) {
                      diffs.splice(pointer - count_insert, count_delete + count_insert, [DIFF_INSERT, text_insert]);
                    } else if (count_insert === 0) {
                      diffs.splice(pointer - count_delete, count_delete + count_insert, [DIFF_DELETE, text_delete]);
                    } else {
                      diffs.splice(pointer - count_delete - count_insert, count_delete + count_insert, [DIFF_DELETE, text_delete], [DIFF_INSERT, text_insert]);
                    }
                    pointer = pointer - count_delete - count_insert + (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
                  } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
                    diffs[pointer - 1][1] += diffs[pointer][1];
                    diffs.splice(pointer, 1);
                  } else {
                    pointer++;
                  }
                  count_insert = 0;
                  count_delete = 0;
                  text_delete = "";
                  text_insert = "";
                  break;
              }
            }
            if (diffs[diffs.length - 1][1] === "") {
              diffs.pop();
            }
            var changes = false;
            pointer = 1;
            while (pointer < diffs.length - 1) {
              if (diffs[pointer - 1][0] == DIFF_EQUAL && diffs[pointer + 1][0] == DIFF_EQUAL) {
                if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
                  diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
                  diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
                  diffs.splice(pointer - 1, 1);
                  changes = true;
                } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) == diffs[pointer + 1][1]) {
                  diffs[pointer - 1][1] += diffs[pointer + 1][1];
                  diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
                  diffs.splice(pointer + 1, 1);
                  changes = true;
                }
              }
              pointer++;
            }
            if (changes) {
              diff_cleanupMerge(diffs);
            }
          }
          ;
          var diff = diff_main;
          diff.INSERT = DIFF_INSERT;
          diff.DELETE = DIFF_DELETE;
          diff.EQUAL = DIFF_EQUAL;
          module2.exports = diff;
          function cursor_normalize_diff(diffs, cursor_pos) {
            if (cursor_pos === 0) {
              return [DIFF_EQUAL, diffs];
            }
            for (var current_pos = 0, i = 0; i < diffs.length; i++) {
              var d = diffs[i];
              if (d[0] === DIFF_DELETE || d[0] === DIFF_EQUAL) {
                var next_pos = current_pos + d[1].length;
                if (cursor_pos === next_pos) {
                  return [i + 1, diffs];
                } else if (cursor_pos < next_pos) {
                  diffs = diffs.slice();
                  var split_pos = cursor_pos - current_pos;
                  var d_left = [d[0], d[1].slice(0, split_pos)];
                  var d_right = [d[0], d[1].slice(split_pos)];
                  diffs.splice(i, 1, d_left, d_right);
                  return [i + 1, diffs];
                } else {
                  current_pos = next_pos;
                }
              }
            }
            throw new Error("cursor_pos is out of bounds!");
          }
          function fix_cursor(diffs, cursor_pos) {
            var norm = cursor_normalize_diff(diffs, cursor_pos);
            var ndiffs = norm[1];
            var cursor_pointer = norm[0];
            var d = ndiffs[cursor_pointer];
            var d_next = ndiffs[cursor_pointer + 1];
            if (d == null) {
              return diffs;
            } else if (d[0] !== DIFF_EQUAL) {
              return diffs;
            } else {
              if (d_next != null && d[1] + d_next[1] === d_next[1] + d[1]) {
                ndiffs.splice(cursor_pointer, 2, d_next, d);
                return merge_tuples(ndiffs, cursor_pointer, 2);
              } else if (d_next != null && d_next[1].indexOf(d[1]) === 0) {
                ndiffs.splice(cursor_pointer, 2, [d_next[0], d[1]], [0, d[1]]);
                var suffix = d_next[1].slice(d[1].length);
                if (suffix.length > 0) {
                  ndiffs.splice(cursor_pointer + 2, 0, [d_next[0], suffix]);
                }
                return merge_tuples(ndiffs, cursor_pointer, 3);
              } else {
                return diffs;
              }
            }
          }
          function fix_emoji(diffs) {
            var compact = false;
            var starts_with_pair_end = function(str) {
              return str.charCodeAt(0) >= 56320 && str.charCodeAt(0) <= 57343;
            };
            var ends_with_pair_start = function(str) {
              return str.charCodeAt(str.length - 1) >= 55296 && str.charCodeAt(str.length - 1) <= 56319;
            };
            for (var i = 2; i < diffs.length; i += 1) {
              if (diffs[i - 2][0] === DIFF_EQUAL && ends_with_pair_start(diffs[i - 2][1]) && diffs[i - 1][0] === DIFF_DELETE && starts_with_pair_end(diffs[i - 1][1]) && diffs[i][0] === DIFF_INSERT && starts_with_pair_end(diffs[i][1])) {
                compact = true;
                diffs[i - 1][1] = diffs[i - 2][1].slice(-1) + diffs[i - 1][1];
                diffs[i][1] = diffs[i - 2][1].slice(-1) + diffs[i][1];
                diffs[i - 2][1] = diffs[i - 2][1].slice(0, -1);
              }
            }
            if (!compact) {
              return diffs;
            }
            var fixed_diffs = [];
            for (var i = 0; i < diffs.length; i += 1) {
              if (diffs[i][1].length > 0) {
                fixed_diffs.push(diffs[i]);
              }
            }
            return fixed_diffs;
          }
          function merge_tuples(diffs, start, length) {
            for (var i = start + length - 1; i >= 0 && i >= start - 1; i--) {
              if (i + 1 < diffs.length) {
                var left_d = diffs[i];
                var right_d = diffs[i + 1];
                if (left_d[0] === right_d[1]) {
                  diffs.splice(i, 2, [left_d[0], left_d[1] + right_d[1]]);
                }
              }
            }
            return diffs;
          }
        },
        function(module2, exports2) {
          exports2 = module2.exports = typeof Object.keys === "function" ? Object.keys : shim;
          exports2.shim = shim;
          function shim(obj) {
            var keys = [];
            for (var key in obj)
              keys.push(key);
            return keys;
          }
        },
        function(module2, exports2) {
          var supportsArgumentsClass = function() {
            return Object.prototype.toString.call(arguments);
          }() == "[object Arguments]";
          exports2 = module2.exports = supportsArgumentsClass ? supported : unsupported;
          exports2.supported = supported;
          function supported(object) {
            return Object.prototype.toString.call(object) == "[object Arguments]";
          }
          ;
          exports2.unsupported = unsupported;
          function unsupported(object) {
            return object && typeof object == "object" && typeof object.length == "number" && Object.prototype.hasOwnProperty.call(object, "callee") && !Object.prototype.propertyIsEnumerable.call(object, "callee") || false;
          }
          ;
        },
        function(module2, exports2) {
          "use strict";
          var has = Object.prototype.hasOwnProperty, prefix = "~";
          function Events() {
          }
          if (Object.create) {
            Events.prototype = Object.create(null);
            if (!new Events().__proto__)
              prefix = false;
          }
          function EE(fn, context, once) {
            this.fn = fn;
            this.context = context;
            this.once = once || false;
          }
          function EventEmitter() {
            this._events = new Events();
            this._eventsCount = 0;
          }
          EventEmitter.prototype.eventNames = function eventNames() {
            var names = [], events, name;
            if (this._eventsCount === 0)
              return names;
            for (name in events = this._events) {
              if (has.call(events, name))
                names.push(prefix ? name.slice(1) : name);
            }
            if (Object.getOwnPropertySymbols) {
              return names.concat(Object.getOwnPropertySymbols(events));
            }
            return names;
          };
          EventEmitter.prototype.listeners = function listeners(event, exists) {
            var evt = prefix ? prefix + event : event, available = this._events[evt];
            if (exists)
              return !!available;
            if (!available)
              return [];
            if (available.fn)
              return [available.fn];
            for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
              ee[i] = available[i].fn;
            }
            return ee;
          };
          EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
            var evt = prefix ? prefix + event : event;
            if (!this._events[evt])
              return false;
            var listeners = this._events[evt], len = arguments.length, args, i;
            if (listeners.fn) {
              if (listeners.once)
                this.removeListener(event, listeners.fn, void 0, true);
              switch (len) {
                case 1:
                  return listeners.fn.call(listeners.context), true;
                case 2:
                  return listeners.fn.call(listeners.context, a1), true;
                case 3:
                  return listeners.fn.call(listeners.context, a1, a2), true;
                case 4:
                  return listeners.fn.call(listeners.context, a1, a2, a3), true;
                case 5:
                  return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
                case 6:
                  return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
              }
              for (i = 1, args = new Array(len - 1); i < len; i++) {
                args[i - 1] = arguments[i];
              }
              listeners.fn.apply(listeners.context, args);
            } else {
              var length = listeners.length, j;
              for (i = 0; i < length; i++) {
                if (listeners[i].once)
                  this.removeListener(event, listeners[i].fn, void 0, true);
                switch (len) {
                  case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                  case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                  case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                  case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                  default:
                    if (!args)
                      for (j = 1, args = new Array(len - 1); j < len; j++) {
                        args[j - 1] = arguments[j];
                      }
                    listeners[i].fn.apply(listeners[i].context, args);
                }
              }
            }
            return true;
          };
          EventEmitter.prototype.on = function on(event, fn, context) {
            var listener = new EE(fn, context || this), evt = prefix ? prefix + event : event;
            if (!this._events[evt])
              this._events[evt] = listener, this._eventsCount++;
            else if (!this._events[evt].fn)
              this._events[evt].push(listener);
            else
              this._events[evt] = [this._events[evt], listener];
            return this;
          };
          EventEmitter.prototype.once = function once(event, fn, context) {
            var listener = new EE(fn, context || this, true), evt = prefix ? prefix + event : event;
            if (!this._events[evt])
              this._events[evt] = listener, this._eventsCount++;
            else if (!this._events[evt].fn)
              this._events[evt].push(listener);
            else
              this._events[evt] = [this._events[evt], listener];
            return this;
          };
          EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
            var evt = prefix ? prefix + event : event;
            if (!this._events[evt])
              return this;
            if (!fn) {
              if (--this._eventsCount === 0)
                this._events = new Events();
              else
                delete this._events[evt];
              return this;
            }
            var listeners = this._events[evt];
            if (listeners.fn) {
              if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
                if (--this._eventsCount === 0)
                  this._events = new Events();
                else
                  delete this._events[evt];
              }
            } else {
              for (var i = 0, events = [], length = listeners.length; i < length; i++) {
                if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) {
                  events.push(listeners[i]);
                }
              }
              if (events.length)
                this._events[evt] = events.length === 1 ? events[0] : events;
              else if (--this._eventsCount === 0)
                this._events = new Events();
              else
                delete this._events[evt];
            }
            return this;
          };
          EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
            var evt;
            if (event) {
              evt = prefix ? prefix + event : event;
              if (this._events[evt]) {
                if (--this._eventsCount === 0)
                  this._events = new Events();
                else
                  delete this._events[evt];
              }
            } else {
              this._events = new Events();
              this._eventsCount = 0;
            }
            return this;
          };
          EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
          EventEmitter.prototype.addListener = EventEmitter.prototype.on;
          EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
            return this;
          };
          EventEmitter.prefixed = prefix;
          EventEmitter.EventEmitter = EventEmitter;
          if (typeof module2 !== "undefined") {
            module2.exports = EventEmitter;
          }
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.matchText = exports2.matchSpacing = exports2.matchNewline = exports2.matchBlot = exports2.matchAttributor = exports2.default = void 0;
          var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
            return typeof obj;
          } : function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
          var _slicedToArray = function() {
            function sliceIterator(arr, i) {
              var _arr = [];
              var _n = true;
              var _d = false;
              var _e = void 0;
              try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                  _arr.push(_s.value);
                  if (i && _arr.length === i)
                    break;
                }
              } catch (err) {
                _d = true;
                _e = err;
              } finally {
                try {
                  if (!_n && _i["return"])
                    _i["return"]();
                } finally {
                  if (_d)
                    throw _e;
                }
              }
              return _arr;
            }
            return function(arr, i) {
              if (Array.isArray(arr)) {
                return arr;
              } else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
              } else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              }
            };
          }();
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _extend2 = __webpack_require__(3);
          var _extend3 = _interopRequireDefault(_extend2);
          var _quillDelta = __webpack_require__(2);
          var _quillDelta2 = _interopRequireDefault(_quillDelta);
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _quill = __webpack_require__(5);
          var _quill2 = _interopRequireDefault(_quill);
          var _logger = __webpack_require__(10);
          var _logger2 = _interopRequireDefault(_logger);
          var _module = __webpack_require__(9);
          var _module2 = _interopRequireDefault(_module);
          var _align = __webpack_require__(36);
          var _background = __webpack_require__(37);
          var _code = __webpack_require__(13);
          var _code2 = _interopRequireDefault(_code);
          var _color = __webpack_require__(26);
          var _direction = __webpack_require__(38);
          var _font = __webpack_require__(39);
          var _size = __webpack_require__(40);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _defineProperty(obj, key, value) {
            if (key in obj) {
              Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
            } else {
              obj[key] = value;
            }
            return obj;
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var debug = (0, _logger2.default)("quill:clipboard");
          var DOM_KEY = "__ql-matcher";
          var CLIPBOARD_CONFIG = [[Node.TEXT_NODE, matchText], [Node.TEXT_NODE, matchNewline], ["br", matchBreak], [Node.ELEMENT_NODE, matchNewline], [Node.ELEMENT_NODE, matchBlot], [Node.ELEMENT_NODE, matchSpacing], [Node.ELEMENT_NODE, matchAttributor], [Node.ELEMENT_NODE, matchStyles], ["li", matchIndent], ["b", matchAlias.bind(matchAlias, "bold")], ["i", matchAlias.bind(matchAlias, "italic")], ["style", matchIgnore]];
          var ATTRIBUTE_ATTRIBUTORS = [_align.AlignAttribute, _direction.DirectionAttribute].reduce(function(memo, attr) {
            memo[attr.keyName] = attr;
            return memo;
          }, {});
          var STYLE_ATTRIBUTORS = [_align.AlignStyle, _background.BackgroundStyle, _color.ColorStyle, _direction.DirectionStyle, _font.FontStyle, _size.SizeStyle].reduce(function(memo, attr) {
            memo[attr.keyName] = attr;
            return memo;
          }, {});
          var Clipboard = function(_Module) {
            _inherits(Clipboard2, _Module);
            function Clipboard2(quill, options) {
              _classCallCheck(this, Clipboard2);
              var _this = _possibleConstructorReturn(this, (Clipboard2.__proto__ || Object.getPrototypeOf(Clipboard2)).call(this, quill, options));
              _this.quill.root.addEventListener("paste", _this.onPaste.bind(_this));
              _this.container = _this.quill.addContainer("ql-clipboard");
              _this.container.setAttribute("contenteditable", true);
              _this.container.setAttribute("tabindex", -1);
              _this.matchers = [];
              CLIPBOARD_CONFIG.concat(_this.options.matchers).forEach(function(_ref) {
                var _ref2 = _slicedToArray(_ref, 2), selector = _ref2[0], matcher = _ref2[1];
                if (!options.matchVisual && matcher === matchSpacing)
                  return;
                _this.addMatcher(selector, matcher);
              });
              return _this;
            }
            _createClass(Clipboard2, [{
              key: "addMatcher",
              value: function addMatcher(selector, matcher) {
                this.matchers.push([selector, matcher]);
              }
            }, {
              key: "convert",
              value: function convert(html) {
                if (typeof html === "string") {
                  this.container.innerHTML = html.replace(/\>\r?\n +\</g, "><");
                  return this.convert();
                }
                var formats = this.quill.getFormat(this.quill.selection.savedRange.index);
                if (formats[_code2.default.blotName]) {
                  var text = this.container.innerText;
                  this.container.innerHTML = "";
                  return new _quillDelta2.default().insert(text, _defineProperty({}, _code2.default.blotName, formats[_code2.default.blotName]));
                }
                var _prepareMatching = this.prepareMatching(), _prepareMatching2 = _slicedToArray(_prepareMatching, 2), elementMatchers = _prepareMatching2[0], textMatchers = _prepareMatching2[1];
                var delta = traverse(this.container, elementMatchers, textMatchers);
                if (deltaEndsWith(delta, "\n") && delta.ops[delta.ops.length - 1].attributes == null) {
                  delta = delta.compose(new _quillDelta2.default().retain(delta.length() - 1).delete(1));
                }
                debug.log("convert", this.container.innerHTML, delta);
                this.container.innerHTML = "";
                return delta;
              }
            }, {
              key: "dangerouslyPasteHTML",
              value: function dangerouslyPasteHTML(index, html) {
                var source = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _quill2.default.sources.API;
                if (typeof index === "string") {
                  this.quill.setContents(this.convert(index), html);
                  this.quill.setSelection(0, _quill2.default.sources.SILENT);
                } else {
                  var paste = this.convert(html);
                  this.quill.updateContents(new _quillDelta2.default().retain(index).concat(paste), source);
                  this.quill.setSelection(index + paste.length(), _quill2.default.sources.SILENT);
                }
              }
            }, {
              key: "onPaste",
              value: function onPaste(e) {
                var _this2 = this;
                if (e.defaultPrevented || !this.quill.isEnabled())
                  return;
                var range = this.quill.getSelection();
                var delta = new _quillDelta2.default().retain(range.index);
                var scrollTop = this.quill.scrollingContainer.scrollTop;
                this.container.focus();
                this.quill.selection.update(_quill2.default.sources.SILENT);
                setTimeout(function() {
                  delta = delta.concat(_this2.convert()).delete(range.length);
                  _this2.quill.updateContents(delta, _quill2.default.sources.USER);
                  _this2.quill.setSelection(delta.length() - range.length, _quill2.default.sources.SILENT);
                  _this2.quill.scrollingContainer.scrollTop = scrollTop;
                  _this2.quill.focus();
                }, 1);
              }
            }, {
              key: "prepareMatching",
              value: function prepareMatching() {
                var _this3 = this;
                var elementMatchers = [], textMatchers = [];
                this.matchers.forEach(function(pair) {
                  var _pair = _slicedToArray(pair, 2), selector = _pair[0], matcher = _pair[1];
                  switch (selector) {
                    case Node.TEXT_NODE:
                      textMatchers.push(matcher);
                      break;
                    case Node.ELEMENT_NODE:
                      elementMatchers.push(matcher);
                      break;
                    default:
                      [].forEach.call(_this3.container.querySelectorAll(selector), function(node) {
                        node[DOM_KEY] = node[DOM_KEY] || [];
                        node[DOM_KEY].push(matcher);
                      });
                      break;
                  }
                });
                return [elementMatchers, textMatchers];
              }
            }]);
            return Clipboard2;
          }(_module2.default);
          Clipboard.DEFAULTS = {
            matchers: [],
            matchVisual: true
          };
          function applyFormat(delta, format, value) {
            if ((typeof format === "undefined" ? "undefined" : _typeof(format)) === "object") {
              return Object.keys(format).reduce(function(delta2, key) {
                return applyFormat(delta2, key, format[key]);
              }, delta);
            } else {
              return delta.reduce(function(delta2, op) {
                if (op.attributes && op.attributes[format]) {
                  return delta2.push(op);
                } else {
                  return delta2.insert(op.insert, (0, _extend3.default)({}, _defineProperty({}, format, value), op.attributes));
                }
              }, new _quillDelta2.default());
            }
          }
          function computeStyle(node) {
            if (node.nodeType !== Node.ELEMENT_NODE)
              return {};
            var DOM_KEY2 = "__ql-computed-style";
            return node[DOM_KEY2] || (node[DOM_KEY2] = window.getComputedStyle(node));
          }
          function deltaEndsWith(delta, text) {
            var endText = "";
            for (var i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i) {
              var op = delta.ops[i];
              if (typeof op.insert !== "string")
                break;
              endText = op.insert + endText;
            }
            return endText.slice(-1 * text.length) === text;
          }
          function isLine(node) {
            if (node.childNodes.length === 0)
              return false;
            var style = computeStyle(node);
            return ["block", "list-item"].indexOf(style.display) > -1;
          }
          function traverse(node, elementMatchers, textMatchers) {
            if (node.nodeType === node.TEXT_NODE) {
              return textMatchers.reduce(function(delta, matcher) {
                return matcher(node, delta);
              }, new _quillDelta2.default());
            } else if (node.nodeType === node.ELEMENT_NODE) {
              return [].reduce.call(node.childNodes || [], function(delta, childNode) {
                var childrenDelta = traverse(childNode, elementMatchers, textMatchers);
                if (childNode.nodeType === node.ELEMENT_NODE) {
                  childrenDelta = elementMatchers.reduce(function(childrenDelta2, matcher) {
                    return matcher(childNode, childrenDelta2);
                  }, childrenDelta);
                  childrenDelta = (childNode[DOM_KEY] || []).reduce(function(childrenDelta2, matcher) {
                    return matcher(childNode, childrenDelta2);
                  }, childrenDelta);
                }
                return delta.concat(childrenDelta);
              }, new _quillDelta2.default());
            } else {
              return new _quillDelta2.default();
            }
          }
          function matchAlias(format, node, delta) {
            return applyFormat(delta, format, true);
          }
          function matchAttributor(node, delta) {
            var attributes = _parchment2.default.Attributor.Attribute.keys(node);
            var classes = _parchment2.default.Attributor.Class.keys(node);
            var styles = _parchment2.default.Attributor.Style.keys(node);
            var formats = {};
            attributes.concat(classes).concat(styles).forEach(function(name) {
              var attr = _parchment2.default.query(name, _parchment2.default.Scope.ATTRIBUTE);
              if (attr != null) {
                formats[attr.attrName] = attr.value(node);
                if (formats[attr.attrName])
                  return;
              }
              attr = ATTRIBUTE_ATTRIBUTORS[name];
              if (attr != null && (attr.attrName === name || attr.keyName === name)) {
                formats[attr.attrName] = attr.value(node) || void 0;
              }
              attr = STYLE_ATTRIBUTORS[name];
              if (attr != null && (attr.attrName === name || attr.keyName === name)) {
                attr = STYLE_ATTRIBUTORS[name];
                formats[attr.attrName] = attr.value(node) || void 0;
              }
            });
            if (Object.keys(formats).length > 0) {
              delta = applyFormat(delta, formats);
            }
            return delta;
          }
          function matchBlot(node, delta) {
            var match = _parchment2.default.query(node);
            if (match == null)
              return delta;
            if (match.prototype instanceof _parchment2.default.Embed) {
              var embed = {};
              var value = match.value(node);
              if (value != null) {
                embed[match.blotName] = value;
                delta = new _quillDelta2.default().insert(embed, match.formats(node));
              }
            } else if (typeof match.formats === "function") {
              delta = applyFormat(delta, match.blotName, match.formats(node));
            }
            return delta;
          }
          function matchBreak(node, delta) {
            if (!deltaEndsWith(delta, "\n")) {
              delta.insert("\n");
            }
            return delta;
          }
          function matchIgnore() {
            return new _quillDelta2.default();
          }
          function matchIndent(node, delta) {
            var match = _parchment2.default.query(node);
            if (match == null || match.blotName !== "list-item" || !deltaEndsWith(delta, "\n")) {
              return delta;
            }
            var indent = -1, parent = node.parentNode;
            while (!parent.classList.contains("ql-clipboard")) {
              if ((_parchment2.default.query(parent) || {}).blotName === "list") {
                indent += 1;
              }
              parent = parent.parentNode;
            }
            if (indent <= 0)
              return delta;
            return delta.compose(new _quillDelta2.default().retain(delta.length() - 1).retain(1, { indent }));
          }
          function matchNewline(node, delta) {
            if (!deltaEndsWith(delta, "\n")) {
              if (isLine(node) || delta.length() > 0 && node.nextSibling && isLine(node.nextSibling)) {
                delta.insert("\n");
              }
            }
            return delta;
          }
          function matchSpacing(node, delta) {
            if (isLine(node) && node.nextElementSibling != null && !deltaEndsWith(delta, "\n\n")) {
              var nodeHeight = node.offsetHeight + parseFloat(computeStyle(node).marginTop) + parseFloat(computeStyle(node).marginBottom);
              if (node.nextElementSibling.offsetTop > node.offsetTop + nodeHeight * 1.5) {
                delta.insert("\n");
              }
            }
            return delta;
          }
          function matchStyles(node, delta) {
            var formats = {};
            var style = node.style || {};
            if (style.fontStyle && computeStyle(node).fontStyle === "italic") {
              formats.italic = true;
            }
            if (style.fontWeight && (computeStyle(node).fontWeight.startsWith("bold") || parseInt(computeStyle(node).fontWeight) >= 700)) {
              formats.bold = true;
            }
            if (Object.keys(formats).length > 0) {
              delta = applyFormat(delta, formats);
            }
            if (parseFloat(style.textIndent || 0) > 0) {
              delta = new _quillDelta2.default().insert("	").concat(delta);
            }
            return delta;
          }
          function matchText(node, delta) {
            var text = node.data;
            if (node.parentNode.tagName === "O:P") {
              return delta.insert(text.trim());
            }
            if (text.trim().length === 0 && node.parentNode.classList.contains("ql-clipboard")) {
              return delta;
            }
            if (!computeStyle(node.parentNode).whiteSpace.startsWith("pre")) {
              var replacer = function replacer2(collapse, match) {
                match = match.replace(/[^\u00a0]/g, "");
                return match.length < 1 && collapse ? " " : match;
              };
              text = text.replace(/\r\n/g, " ").replace(/\n/g, " ");
              text = text.replace(/\s\s+/g, replacer.bind(replacer, true));
              if (node.previousSibling == null && isLine(node.parentNode) || node.previousSibling != null && isLine(node.previousSibling)) {
                text = text.replace(/^\s+/, replacer.bind(replacer, false));
              }
              if (node.nextSibling == null && isLine(node.parentNode) || node.nextSibling != null && isLine(node.nextSibling)) {
                text = text.replace(/\s+$/, replacer.bind(replacer, false));
              }
            }
            return delta.insert(text);
          }
          exports2.default = Clipboard;
          exports2.matchAttributor = matchAttributor;
          exports2.matchBlot = matchBlot;
          exports2.matchNewline = matchNewline;
          exports2.matchSpacing = matchSpacing;
          exports2.matchText = matchText;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _inline = __webpack_require__(6);
          var _inline2 = _interopRequireDefault(_inline);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var Bold = function(_Inline) {
            _inherits(Bold2, _Inline);
            function Bold2() {
              _classCallCheck(this, Bold2);
              return _possibleConstructorReturn(this, (Bold2.__proto__ || Object.getPrototypeOf(Bold2)).apply(this, arguments));
            }
            _createClass(Bold2, [{
              key: "optimize",
              value: function optimize(context) {
                _get(Bold2.prototype.__proto__ || Object.getPrototypeOf(Bold2.prototype), "optimize", this).call(this, context);
                if (this.domNode.tagName !== this.statics.tagName[0]) {
                  this.replaceWith(this.statics.blotName);
                }
              }
            }], [{
              key: "create",
              value: function create() {
                return _get(Bold2.__proto__ || Object.getPrototypeOf(Bold2), "create", this).call(this);
              }
            }, {
              key: "formats",
              value: function formats() {
                return true;
              }
            }]);
            return Bold2;
          }(_inline2.default);
          Bold.blotName = "bold";
          Bold.tagName = ["STRONG", "B"];
          exports2.default = Bold;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.addControls = exports2.default = void 0;
          var _slicedToArray = function() {
            function sliceIterator(arr, i) {
              var _arr = [];
              var _n = true;
              var _d = false;
              var _e = void 0;
              try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                  _arr.push(_s.value);
                  if (i && _arr.length === i)
                    break;
                }
              } catch (err) {
                _d = true;
                _e = err;
              } finally {
                try {
                  if (!_n && _i["return"])
                    _i["return"]();
                } finally {
                  if (_d)
                    throw _e;
                }
              }
              return _arr;
            }
            return function(arr, i) {
              if (Array.isArray(arr)) {
                return arr;
              } else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
              } else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              }
            };
          }();
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _quillDelta = __webpack_require__(2);
          var _quillDelta2 = _interopRequireDefault(_quillDelta);
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _quill = __webpack_require__(5);
          var _quill2 = _interopRequireDefault(_quill);
          var _logger = __webpack_require__(10);
          var _logger2 = _interopRequireDefault(_logger);
          var _module = __webpack_require__(9);
          var _module2 = _interopRequireDefault(_module);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _defineProperty(obj, key, value) {
            if (key in obj) {
              Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
            } else {
              obj[key] = value;
            }
            return obj;
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var debug = (0, _logger2.default)("quill:toolbar");
          var Toolbar = function(_Module) {
            _inherits(Toolbar2, _Module);
            function Toolbar2(quill, options) {
              _classCallCheck(this, Toolbar2);
              var _this = _possibleConstructorReturn(this, (Toolbar2.__proto__ || Object.getPrototypeOf(Toolbar2)).call(this, quill, options));
              if (Array.isArray(_this.options.container)) {
                var container = document.createElement("div");
                addControls(container, _this.options.container);
                quill.container.parentNode.insertBefore(container, quill.container);
                _this.container = container;
              } else if (typeof _this.options.container === "string") {
                _this.container = document.querySelector(_this.options.container);
              } else {
                _this.container = _this.options.container;
              }
              if (!(_this.container instanceof HTMLElement)) {
                var _ret;
                return _ret = debug.error("Container required for toolbar", _this.options), _possibleConstructorReturn(_this, _ret);
              }
              _this.container.classList.add("ql-toolbar");
              _this.controls = [];
              _this.handlers = {};
              Object.keys(_this.options.handlers).forEach(function(format) {
                _this.addHandler(format, _this.options.handlers[format]);
              });
              [].forEach.call(_this.container.querySelectorAll("button, select"), function(input) {
                _this.attach(input);
              });
              _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function(type, range) {
                if (type === _quill2.default.events.SELECTION_CHANGE) {
                  _this.update(range);
                }
              });
              _this.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function() {
                var _this$quill$selection = _this.quill.selection.getRange(), _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1), range = _this$quill$selection2[0];
                _this.update(range);
              });
              return _this;
            }
            _createClass(Toolbar2, [{
              key: "addHandler",
              value: function addHandler(format, handler) {
                this.handlers[format] = handler;
              }
            }, {
              key: "attach",
              value: function attach(input) {
                var _this2 = this;
                var format = [].find.call(input.classList, function(className) {
                  return className.indexOf("ql-") === 0;
                });
                if (!format)
                  return;
                format = format.slice("ql-".length);
                if (input.tagName === "BUTTON") {
                  input.setAttribute("type", "button");
                }
                if (this.handlers[format] == null) {
                  if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[format] == null) {
                    debug.warn("ignoring attaching to disabled format", format, input);
                    return;
                  }
                  if (_parchment2.default.query(format) == null) {
                    debug.warn("ignoring attaching to nonexistent format", format, input);
                    return;
                  }
                }
                var eventName = input.tagName === "SELECT" ? "change" : "click";
                input.addEventListener(eventName, function(e) {
                  var value = void 0;
                  if (input.tagName === "SELECT") {
                    if (input.selectedIndex < 0)
                      return;
                    var selected = input.options[input.selectedIndex];
                    if (selected.hasAttribute("selected")) {
                      value = false;
                    } else {
                      value = selected.value || false;
                    }
                  } else {
                    if (input.classList.contains("ql-active")) {
                      value = false;
                    } else {
                      value = input.value || !input.hasAttribute("value");
                    }
                    e.preventDefault();
                  }
                  _this2.quill.focus();
                  var _quill$selection$getR = _this2.quill.selection.getRange(), _quill$selection$getR2 = _slicedToArray(_quill$selection$getR, 1), range = _quill$selection$getR2[0];
                  if (_this2.handlers[format] != null) {
                    _this2.handlers[format].call(_this2, value);
                  } else if (_parchment2.default.query(format).prototype instanceof _parchment2.default.Embed) {
                    value = prompt("Enter " + format);
                    if (!value)
                      return;
                    _this2.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert(_defineProperty({}, format, value)), _quill2.default.sources.USER);
                  } else {
                    _this2.quill.format(format, value, _quill2.default.sources.USER);
                  }
                  _this2.update(range);
                });
                this.controls.push([format, input]);
              }
            }, {
              key: "update",
              value: function update(range) {
                var formats = range == null ? {} : this.quill.getFormat(range);
                this.controls.forEach(function(pair) {
                  var _pair = _slicedToArray(pair, 2), format = _pair[0], input = _pair[1];
                  if (input.tagName === "SELECT") {
                    var option = void 0;
                    if (range == null) {
                      option = null;
                    } else if (formats[format] == null) {
                      option = input.querySelector("option[selected]");
                    } else if (!Array.isArray(formats[format])) {
                      var value = formats[format];
                      if (typeof value === "string") {
                        value = value.replace(/\"/g, '\\"');
                      }
                      option = input.querySelector('option[value="' + value + '"]');
                    }
                    if (option == null) {
                      input.value = "";
                      input.selectedIndex = -1;
                    } else {
                      option.selected = true;
                    }
                  } else {
                    if (range == null) {
                      input.classList.remove("ql-active");
                    } else if (input.hasAttribute("value")) {
                      var isActive = formats[format] === input.getAttribute("value") || formats[format] != null && formats[format].toString() === input.getAttribute("value") || formats[format] == null && !input.getAttribute("value");
                      input.classList.toggle("ql-active", isActive);
                    } else {
                      input.classList.toggle("ql-active", formats[format] != null);
                    }
                  }
                });
              }
            }]);
            return Toolbar2;
          }(_module2.default);
          Toolbar.DEFAULTS = {};
          function addButton(container, format, value) {
            var input = document.createElement("button");
            input.setAttribute("type", "button");
            input.classList.add("ql-" + format);
            if (value != null) {
              input.value = value;
            }
            container.appendChild(input);
          }
          function addControls(container, groups) {
            if (!Array.isArray(groups[0])) {
              groups = [groups];
            }
            groups.forEach(function(controls) {
              var group = document.createElement("span");
              group.classList.add("ql-formats");
              controls.forEach(function(control) {
                if (typeof control === "string") {
                  addButton(group, control);
                } else {
                  var format = Object.keys(control)[0];
                  var value = control[format];
                  if (Array.isArray(value)) {
                    addSelect(group, format, value);
                  } else {
                    addButton(group, format, value);
                  }
                }
              });
              container.appendChild(group);
            });
          }
          function addSelect(container, format, values) {
            var input = document.createElement("select");
            input.classList.add("ql-" + format);
            values.forEach(function(value) {
              var option = document.createElement("option");
              if (value !== false) {
                option.setAttribute("value", value);
              } else {
                option.setAttribute("selected", "selected");
              }
              input.appendChild(option);
            });
            container.appendChild(input);
          }
          Toolbar.DEFAULTS = {
            container: null,
            handlers: {
              clean: function clean() {
                var _this3 = this;
                var range = this.quill.getSelection();
                if (range == null)
                  return;
                if (range.length == 0) {
                  var formats = this.quill.getFormat();
                  Object.keys(formats).forEach(function(name) {
                    if (_parchment2.default.query(name, _parchment2.default.Scope.INLINE) != null) {
                      _this3.quill.format(name, false);
                    }
                  });
                } else {
                  this.quill.removeFormat(range, _quill2.default.sources.USER);
                }
              },
              direction: function direction(value) {
                var align = this.quill.getFormat()["align"];
                if (value === "rtl" && align == null) {
                  this.quill.format("align", "right", _quill2.default.sources.USER);
                } else if (!value && align === "right") {
                  this.quill.format("align", false, _quill2.default.sources.USER);
                }
                this.quill.format("direction", value, _quill2.default.sources.USER);
              },
              indent: function indent(value) {
                var range = this.quill.getSelection();
                var formats = this.quill.getFormat(range);
                var indent2 = parseInt(formats.indent || 0);
                if (value === "+1" || value === "-1") {
                  var modifier = value === "+1" ? 1 : -1;
                  if (formats.direction === "rtl")
                    modifier *= -1;
                  this.quill.format("indent", indent2 + modifier, _quill2.default.sources.USER);
                }
              },
              link: function link(value) {
                if (value === true) {
                  value = prompt("Enter link URL:");
                }
                this.quill.format("link", value, _quill2.default.sources.USER);
              },
              list: function list(value) {
                var range = this.quill.getSelection();
                var formats = this.quill.getFormat(range);
                if (value === "check") {
                  if (formats["list"] === "checked" || formats["list"] === "unchecked") {
                    this.quill.format("list", false, _quill2.default.sources.USER);
                  } else {
                    this.quill.format("list", "unchecked", _quill2.default.sources.USER);
                  }
                } else {
                  this.quill.format("list", value, _quill2.default.sources.USER);
                }
              }
            }
          };
          exports2.default = Toolbar;
          exports2.addControls = addControls;
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <polyline class="ql-even ql-stroke" points="5 7 3 9 5 11"></polyline> <polyline class="ql-even ql-stroke" points="13 7 15 9 13 11"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>';
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _picker = __webpack_require__(28);
          var _picker2 = _interopRequireDefault(_picker);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var ColorPicker = function(_Picker) {
            _inherits(ColorPicker2, _Picker);
            function ColorPicker2(select, label) {
              _classCallCheck(this, ColorPicker2);
              var _this = _possibleConstructorReturn(this, (ColorPicker2.__proto__ || Object.getPrototypeOf(ColorPicker2)).call(this, select));
              _this.label.innerHTML = label;
              _this.container.classList.add("ql-color-picker");
              [].slice.call(_this.container.querySelectorAll(".ql-picker-item"), 0, 7).forEach(function(item) {
                item.classList.add("ql-primary");
              });
              return _this;
            }
            _createClass(ColorPicker2, [{
              key: "buildItem",
              value: function buildItem(option) {
                var item = _get(ColorPicker2.prototype.__proto__ || Object.getPrototypeOf(ColorPicker2.prototype), "buildItem", this).call(this, option);
                item.style.backgroundColor = option.getAttribute("value") || "";
                return item;
              }
            }, {
              key: "selectItem",
              value: function selectItem(item, trigger) {
                _get(ColorPicker2.prototype.__proto__ || Object.getPrototypeOf(ColorPicker2.prototype), "selectItem", this).call(this, item, trigger);
                var colorLabel = this.label.querySelector(".ql-color-label");
                var value = item ? item.getAttribute("data-value") || "" : "";
                if (colorLabel) {
                  if (colorLabel.tagName === "line") {
                    colorLabel.style.stroke = value;
                  } else {
                    colorLabel.style.fill = value;
                  }
                }
              }
            }]);
            return ColorPicker2;
          }(_picker2.default);
          exports2.default = ColorPicker;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _picker = __webpack_require__(28);
          var _picker2 = _interopRequireDefault(_picker);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var IconPicker = function(_Picker) {
            _inherits(IconPicker2, _Picker);
            function IconPicker2(select, icons) {
              _classCallCheck(this, IconPicker2);
              var _this = _possibleConstructorReturn(this, (IconPicker2.__proto__ || Object.getPrototypeOf(IconPicker2)).call(this, select));
              _this.container.classList.add("ql-icon-picker");
              [].forEach.call(_this.container.querySelectorAll(".ql-picker-item"), function(item) {
                item.innerHTML = icons[item.getAttribute("data-value") || ""];
              });
              _this.defaultItem = _this.container.querySelector(".ql-selected");
              _this.selectItem(_this.defaultItem);
              return _this;
            }
            _createClass(IconPicker2, [{
              key: "selectItem",
              value: function selectItem(item, trigger) {
                _get(IconPicker2.prototype.__proto__ || Object.getPrototypeOf(IconPicker2.prototype), "selectItem", this).call(this, item, trigger);
                item = item || this.defaultItem;
                this.label.innerHTML = item.innerHTML;
              }
            }]);
            return IconPicker2;
          }(_picker2.default);
          exports2.default = IconPicker;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          var Tooltip = function() {
            function Tooltip2(quill, boundsContainer) {
              var _this = this;
              _classCallCheck(this, Tooltip2);
              this.quill = quill;
              this.boundsContainer = boundsContainer || document.body;
              this.root = quill.addContainer("ql-tooltip");
              this.root.innerHTML = this.constructor.TEMPLATE;
              if (this.quill.root === this.quill.scrollingContainer) {
                this.quill.root.addEventListener("scroll", function() {
                  _this.root.style.marginTop = -1 * _this.quill.root.scrollTop + "px";
                });
              }
              this.hide();
            }
            _createClass(Tooltip2, [{
              key: "hide",
              value: function hide() {
                this.root.classList.add("ql-hidden");
              }
            }, {
              key: "position",
              value: function position(reference) {
                var left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
                var top = reference.bottom + this.quill.root.scrollTop;
                this.root.style.left = left + "px";
                this.root.style.top = top + "px";
                this.root.classList.remove("ql-flip");
                var containerBounds = this.boundsContainer.getBoundingClientRect();
                var rootBounds = this.root.getBoundingClientRect();
                var shift = 0;
                if (rootBounds.right > containerBounds.right) {
                  shift = containerBounds.right - rootBounds.right;
                  this.root.style.left = left + shift + "px";
                }
                if (rootBounds.left < containerBounds.left) {
                  shift = containerBounds.left - rootBounds.left;
                  this.root.style.left = left + shift + "px";
                }
                if (rootBounds.bottom > containerBounds.bottom) {
                  var height = rootBounds.bottom - rootBounds.top;
                  var verticalShift = reference.bottom - reference.top + height;
                  this.root.style.top = top - verticalShift + "px";
                  this.root.classList.add("ql-flip");
                }
                return shift;
              }
            }, {
              key: "show",
              value: function show() {
                this.root.classList.remove("ql-editing");
                this.root.classList.remove("ql-hidden");
              }
            }]);
            return Tooltip2;
          }();
          exports2.default = Tooltip;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _slicedToArray = function() {
            function sliceIterator(arr, i) {
              var _arr = [];
              var _n = true;
              var _d = false;
              var _e = void 0;
              try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                  _arr.push(_s.value);
                  if (i && _arr.length === i)
                    break;
                }
              } catch (err) {
                _d = true;
                _e = err;
              } finally {
                try {
                  if (!_n && _i["return"])
                    _i["return"]();
                } finally {
                  if (_d)
                    throw _e;
                }
              }
              return _arr;
            }
            return function(arr, i) {
              if (Array.isArray(arr)) {
                return arr;
              } else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
              } else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              }
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _extend = __webpack_require__(3);
          var _extend2 = _interopRequireDefault(_extend);
          var _emitter = __webpack_require__(8);
          var _emitter2 = _interopRequireDefault(_emitter);
          var _base = __webpack_require__(43);
          var _base2 = _interopRequireDefault(_base);
          var _link = __webpack_require__(27);
          var _link2 = _interopRequireDefault(_link);
          var _selection = __webpack_require__(15);
          var _icons = __webpack_require__(41);
          var _icons2 = _interopRequireDefault(_icons);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var TOOLBAR_CONFIG = [[{ header: ["1", "2", "3", false] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], ["clean"]];
          var SnowTheme = function(_BaseTheme) {
            _inherits(SnowTheme2, _BaseTheme);
            function SnowTheme2(quill, options) {
              _classCallCheck(this, SnowTheme2);
              if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
                options.modules.toolbar.container = TOOLBAR_CONFIG;
              }
              var _this = _possibleConstructorReturn(this, (SnowTheme2.__proto__ || Object.getPrototypeOf(SnowTheme2)).call(this, quill, options));
              _this.quill.container.classList.add("ql-snow");
              return _this;
            }
            _createClass(SnowTheme2, [{
              key: "extendToolbar",
              value: function extendToolbar(toolbar) {
                toolbar.container.classList.add("ql-snow");
                this.buildButtons([].slice.call(toolbar.container.querySelectorAll("button")), _icons2.default);
                this.buildPickers([].slice.call(toolbar.container.querySelectorAll("select")), _icons2.default);
                this.tooltip = new SnowTooltip(this.quill, this.options.bounds);
                if (toolbar.container.querySelector(".ql-link")) {
                  this.quill.keyboard.addBinding({ key: "K", shortKey: true }, function(range, context) {
                    toolbar.handlers["link"].call(toolbar, !context.format.link);
                  });
                }
              }
            }]);
            return SnowTheme2;
          }(_base2.default);
          SnowTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
            modules: {
              toolbar: {
                handlers: {
                  link: function link(value) {
                    if (value) {
                      var range = this.quill.getSelection();
                      if (range == null || range.length == 0)
                        return;
                      var preview = this.quill.getText(range);
                      if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf("mailto:") !== 0) {
                        preview = "mailto:" + preview;
                      }
                      var tooltip = this.quill.theme.tooltip;
                      tooltip.edit("link", preview);
                    } else {
                      this.quill.format("link", false);
                    }
                  }
                }
              }
            }
          });
          var SnowTooltip = function(_BaseTooltip) {
            _inherits(SnowTooltip2, _BaseTooltip);
            function SnowTooltip2(quill, bounds) {
              _classCallCheck(this, SnowTooltip2);
              var _this2 = _possibleConstructorReturn(this, (SnowTooltip2.__proto__ || Object.getPrototypeOf(SnowTooltip2)).call(this, quill, bounds));
              _this2.preview = _this2.root.querySelector("a.ql-preview");
              return _this2;
            }
            _createClass(SnowTooltip2, [{
              key: "listen",
              value: function listen() {
                var _this3 = this;
                _get(SnowTooltip2.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip2.prototype), "listen", this).call(this);
                this.root.querySelector("a.ql-action").addEventListener("click", function(event) {
                  if (_this3.root.classList.contains("ql-editing")) {
                    _this3.save();
                  } else {
                    _this3.edit("link", _this3.preview.textContent);
                  }
                  event.preventDefault();
                });
                this.root.querySelector("a.ql-remove").addEventListener("click", function(event) {
                  if (_this3.linkRange != null) {
                    var range = _this3.linkRange;
                    _this3.restoreFocus();
                    _this3.quill.formatText(range, "link", false, _emitter2.default.sources.USER);
                    delete _this3.linkRange;
                  }
                  event.preventDefault();
                  _this3.hide();
                });
                this.quill.on(_emitter2.default.events.SELECTION_CHANGE, function(range, oldRange, source) {
                  if (range == null)
                    return;
                  if (range.length === 0 && source === _emitter2.default.sources.USER) {
                    var _quill$scroll$descend = _this3.quill.scroll.descendant(_link2.default, range.index), _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2), link = _quill$scroll$descend2[0], offset = _quill$scroll$descend2[1];
                    if (link != null) {
                      _this3.linkRange = new _selection.Range(range.index - offset, link.length());
                      var preview = _link2.default.formats(link.domNode);
                      _this3.preview.textContent = preview;
                      _this3.preview.setAttribute("href", preview);
                      _this3.show();
                      _this3.position(_this3.quill.getBounds(_this3.linkRange));
                      return;
                    }
                  } else {
                    delete _this3.linkRange;
                  }
                  _this3.hide();
                });
              }
            }, {
              key: "show",
              value: function show() {
                _get(SnowTooltip2.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip2.prototype), "show", this).call(this);
                this.root.removeAttribute("data-mode");
              }
            }]);
            return SnowTooltip2;
          }(_base.BaseTooltip);
          SnowTooltip.TEMPLATE = ['<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join("");
          exports2.default = SnowTheme;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _core = __webpack_require__(29);
          var _core2 = _interopRequireDefault(_core);
          var _align = __webpack_require__(36);
          var _direction = __webpack_require__(38);
          var _indent = __webpack_require__(64);
          var _blockquote = __webpack_require__(65);
          var _blockquote2 = _interopRequireDefault(_blockquote);
          var _header = __webpack_require__(66);
          var _header2 = _interopRequireDefault(_header);
          var _list = __webpack_require__(67);
          var _list2 = _interopRequireDefault(_list);
          var _background = __webpack_require__(37);
          var _color = __webpack_require__(26);
          var _font = __webpack_require__(39);
          var _size = __webpack_require__(40);
          var _bold = __webpack_require__(56);
          var _bold2 = _interopRequireDefault(_bold);
          var _italic = __webpack_require__(68);
          var _italic2 = _interopRequireDefault(_italic);
          var _link = __webpack_require__(27);
          var _link2 = _interopRequireDefault(_link);
          var _script = __webpack_require__(69);
          var _script2 = _interopRequireDefault(_script);
          var _strike = __webpack_require__(70);
          var _strike2 = _interopRequireDefault(_strike);
          var _underline = __webpack_require__(71);
          var _underline2 = _interopRequireDefault(_underline);
          var _image = __webpack_require__(72);
          var _image2 = _interopRequireDefault(_image);
          var _video = __webpack_require__(73);
          var _video2 = _interopRequireDefault(_video);
          var _code = __webpack_require__(13);
          var _code2 = _interopRequireDefault(_code);
          var _formula = __webpack_require__(74);
          var _formula2 = _interopRequireDefault(_formula);
          var _syntax = __webpack_require__(75);
          var _syntax2 = _interopRequireDefault(_syntax);
          var _toolbar = __webpack_require__(57);
          var _toolbar2 = _interopRequireDefault(_toolbar);
          var _icons = __webpack_require__(41);
          var _icons2 = _interopRequireDefault(_icons);
          var _picker = __webpack_require__(28);
          var _picker2 = _interopRequireDefault(_picker);
          var _colorPicker = __webpack_require__(59);
          var _colorPicker2 = _interopRequireDefault(_colorPicker);
          var _iconPicker = __webpack_require__(60);
          var _iconPicker2 = _interopRequireDefault(_iconPicker);
          var _tooltip = __webpack_require__(61);
          var _tooltip2 = _interopRequireDefault(_tooltip);
          var _bubble = __webpack_require__(108);
          var _bubble2 = _interopRequireDefault(_bubble);
          var _snow = __webpack_require__(62);
          var _snow2 = _interopRequireDefault(_snow);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          _core2.default.register({
            "attributors/attribute/direction": _direction.DirectionAttribute,
            "attributors/class/align": _align.AlignClass,
            "attributors/class/background": _background.BackgroundClass,
            "attributors/class/color": _color.ColorClass,
            "attributors/class/direction": _direction.DirectionClass,
            "attributors/class/font": _font.FontClass,
            "attributors/class/size": _size.SizeClass,
            "attributors/style/align": _align.AlignStyle,
            "attributors/style/background": _background.BackgroundStyle,
            "attributors/style/color": _color.ColorStyle,
            "attributors/style/direction": _direction.DirectionStyle,
            "attributors/style/font": _font.FontStyle,
            "attributors/style/size": _size.SizeStyle
          }, true);
          _core2.default.register({
            "formats/align": _align.AlignClass,
            "formats/direction": _direction.DirectionClass,
            "formats/indent": _indent.IndentClass,
            "formats/background": _background.BackgroundStyle,
            "formats/color": _color.ColorStyle,
            "formats/font": _font.FontClass,
            "formats/size": _size.SizeClass,
            "formats/blockquote": _blockquote2.default,
            "formats/code-block": _code2.default,
            "formats/header": _header2.default,
            "formats/list": _list2.default,
            "formats/bold": _bold2.default,
            "formats/code": _code.Code,
            "formats/italic": _italic2.default,
            "formats/link": _link2.default,
            "formats/script": _script2.default,
            "formats/strike": _strike2.default,
            "formats/underline": _underline2.default,
            "formats/image": _image2.default,
            "formats/video": _video2.default,
            "formats/list/item": _list.ListItem,
            "modules/formula": _formula2.default,
            "modules/syntax": _syntax2.default,
            "modules/toolbar": _toolbar2.default,
            "themes/bubble": _bubble2.default,
            "themes/snow": _snow2.default,
            "ui/icons": _icons2.default,
            "ui/picker": _picker2.default,
            "ui/icon-picker": _iconPicker2.default,
            "ui/color-picker": _colorPicker2.default,
            "ui/tooltip": _tooltip2.default
          }, true);
          exports2.default = _core2.default;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.IndentClass = void 0;
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var IdentAttributor = function(_Parchment$Attributor) {
            _inherits(IdentAttributor2, _Parchment$Attributor);
            function IdentAttributor2() {
              _classCallCheck(this, IdentAttributor2);
              return _possibleConstructorReturn(this, (IdentAttributor2.__proto__ || Object.getPrototypeOf(IdentAttributor2)).apply(this, arguments));
            }
            _createClass(IdentAttributor2, [{
              key: "add",
              value: function add(node, value) {
                if (value === "+1" || value === "-1") {
                  var indent = this.value(node) || 0;
                  value = value === "+1" ? indent + 1 : indent - 1;
                }
                if (value === 0) {
                  this.remove(node);
                  return true;
                } else {
                  return _get(IdentAttributor2.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor2.prototype), "add", this).call(this, node, value);
                }
              }
            }, {
              key: "canAdd",
              value: function canAdd(node, value) {
                return _get(IdentAttributor2.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor2.prototype), "canAdd", this).call(this, node, value) || _get(IdentAttributor2.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor2.prototype), "canAdd", this).call(this, node, parseInt(value));
              }
            }, {
              key: "value",
              value: function value(node) {
                return parseInt(_get(IdentAttributor2.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor2.prototype), "value", this).call(this, node)) || void 0;
              }
            }]);
            return IdentAttributor2;
          }(_parchment2.default.Attributor.Class);
          var IndentClass = new IdentAttributor("indent", "ql-indent", {
            scope: _parchment2.default.Scope.BLOCK,
            whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
          });
          exports2.IndentClass = IndentClass;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _block = __webpack_require__(4);
          var _block2 = _interopRequireDefault(_block);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var Blockquote = function(_Block) {
            _inherits(Blockquote2, _Block);
            function Blockquote2() {
              _classCallCheck(this, Blockquote2);
              return _possibleConstructorReturn(this, (Blockquote2.__proto__ || Object.getPrototypeOf(Blockquote2)).apply(this, arguments));
            }
            return Blockquote2;
          }(_block2.default);
          Blockquote.blotName = "blockquote";
          Blockquote.tagName = "blockquote";
          exports2.default = Blockquote;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _block = __webpack_require__(4);
          var _block2 = _interopRequireDefault(_block);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var Header = function(_Block) {
            _inherits(Header2, _Block);
            function Header2() {
              _classCallCheck(this, Header2);
              return _possibleConstructorReturn(this, (Header2.__proto__ || Object.getPrototypeOf(Header2)).apply(this, arguments));
            }
            _createClass(Header2, null, [{
              key: "formats",
              value: function formats(domNode) {
                return this.tagName.indexOf(domNode.tagName) + 1;
              }
            }]);
            return Header2;
          }(_block2.default);
          Header.blotName = "header";
          Header.tagName = ["H1", "H2", "H3", "H4", "H5", "H6"];
          exports2.default = Header;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.default = exports2.ListItem = void 0;
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _block = __webpack_require__(4);
          var _block2 = _interopRequireDefault(_block);
          var _container = __webpack_require__(25);
          var _container2 = _interopRequireDefault(_container);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _defineProperty(obj, key, value) {
            if (key in obj) {
              Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
            } else {
              obj[key] = value;
            }
            return obj;
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var ListItem = function(_Block) {
            _inherits(ListItem2, _Block);
            function ListItem2() {
              _classCallCheck(this, ListItem2);
              return _possibleConstructorReturn(this, (ListItem2.__proto__ || Object.getPrototypeOf(ListItem2)).apply(this, arguments));
            }
            _createClass(ListItem2, [{
              key: "format",
              value: function format(name, value) {
                if (name === List.blotName && !value) {
                  this.replaceWith(_parchment2.default.create(this.statics.scope));
                } else {
                  _get(ListItem2.prototype.__proto__ || Object.getPrototypeOf(ListItem2.prototype), "format", this).call(this, name, value);
                }
              }
            }, {
              key: "remove",
              value: function remove() {
                if (this.prev == null && this.next == null) {
                  this.parent.remove();
                } else {
                  _get(ListItem2.prototype.__proto__ || Object.getPrototypeOf(ListItem2.prototype), "remove", this).call(this);
                }
              }
            }, {
              key: "replaceWith",
              value: function replaceWith(name, value) {
                this.parent.isolate(this.offset(this.parent), this.length());
                if (name === this.parent.statics.blotName) {
                  this.parent.replaceWith(name, value);
                  return this;
                } else {
                  this.parent.unwrap();
                  return _get(ListItem2.prototype.__proto__ || Object.getPrototypeOf(ListItem2.prototype), "replaceWith", this).call(this, name, value);
                }
              }
            }], [{
              key: "formats",
              value: function formats(domNode) {
                return domNode.tagName === this.tagName ? void 0 : _get(ListItem2.__proto__ || Object.getPrototypeOf(ListItem2), "formats", this).call(this, domNode);
              }
            }]);
            return ListItem2;
          }(_block2.default);
          ListItem.blotName = "list-item";
          ListItem.tagName = "LI";
          var List = function(_Container) {
            _inherits(List2, _Container);
            _createClass(List2, null, [{
              key: "create",
              value: function create(value) {
                var tagName = value === "ordered" ? "OL" : "UL";
                var node = _get(List2.__proto__ || Object.getPrototypeOf(List2), "create", this).call(this, tagName);
                if (value === "checked" || value === "unchecked") {
                  node.setAttribute("data-checked", value === "checked");
                }
                return node;
              }
            }, {
              key: "formats",
              value: function formats(domNode) {
                if (domNode.tagName === "OL")
                  return "ordered";
                if (domNode.tagName === "UL") {
                  if (domNode.hasAttribute("data-checked")) {
                    return domNode.getAttribute("data-checked") === "true" ? "checked" : "unchecked";
                  } else {
                    return "bullet";
                  }
                }
                return void 0;
              }
            }]);
            function List2(domNode) {
              _classCallCheck(this, List2);
              var _this2 = _possibleConstructorReturn(this, (List2.__proto__ || Object.getPrototypeOf(List2)).call(this, domNode));
              var listEventHandler = function listEventHandler2(e) {
                if (e.target.parentNode !== domNode)
                  return;
                var format = _this2.statics.formats(domNode);
                var blot = _parchment2.default.find(e.target);
                if (format === "checked") {
                  blot.format("list", "unchecked");
                } else if (format === "unchecked") {
                  blot.format("list", "checked");
                }
              };
              domNode.addEventListener("touchstart", listEventHandler);
              domNode.addEventListener("mousedown", listEventHandler);
              return _this2;
            }
            _createClass(List2, [{
              key: "format",
              value: function format(name, value) {
                if (this.children.length > 0) {
                  this.children.tail.format(name, value);
                }
              }
            }, {
              key: "formats",
              value: function formats() {
                return _defineProperty({}, this.statics.blotName, this.statics.formats(this.domNode));
              }
            }, {
              key: "insertBefore",
              value: function insertBefore(blot, ref) {
                if (blot instanceof ListItem) {
                  _get(List2.prototype.__proto__ || Object.getPrototypeOf(List2.prototype), "insertBefore", this).call(this, blot, ref);
                } else {
                  var index = ref == null ? this.length() : ref.offset(this);
                  var after = this.split(index);
                  after.parent.insertBefore(blot, after);
                }
              }
            }, {
              key: "optimize",
              value: function optimize(context) {
                _get(List2.prototype.__proto__ || Object.getPrototypeOf(List2.prototype), "optimize", this).call(this, context);
                var next = this.next;
                if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName && next.domNode.getAttribute("data-checked") === this.domNode.getAttribute("data-checked")) {
                  next.moveChildren(this);
                  next.remove();
                }
              }
            }, {
              key: "replace",
              value: function replace(target) {
                if (target.statics.blotName !== this.statics.blotName) {
                  var item = _parchment2.default.create(this.statics.defaultChild);
                  target.moveChildren(item);
                  this.appendChild(item);
                }
                _get(List2.prototype.__proto__ || Object.getPrototypeOf(List2.prototype), "replace", this).call(this, target);
              }
            }]);
            return List2;
          }(_container2.default);
          List.blotName = "list";
          List.scope = _parchment2.default.Scope.BLOCK_BLOT;
          List.tagName = ["OL", "UL"];
          List.defaultChild = "list-item";
          List.allowedChildren = [ListItem];
          exports2.ListItem = ListItem;
          exports2.default = List;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _bold = __webpack_require__(56);
          var _bold2 = _interopRequireDefault(_bold);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var Italic = function(_Bold) {
            _inherits(Italic2, _Bold);
            function Italic2() {
              _classCallCheck(this, Italic2);
              return _possibleConstructorReturn(this, (Italic2.__proto__ || Object.getPrototypeOf(Italic2)).apply(this, arguments));
            }
            return Italic2;
          }(_bold2.default);
          Italic.blotName = "italic";
          Italic.tagName = ["EM", "I"];
          exports2.default = Italic;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _inline = __webpack_require__(6);
          var _inline2 = _interopRequireDefault(_inline);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var Script = function(_Inline) {
            _inherits(Script2, _Inline);
            function Script2() {
              _classCallCheck(this, Script2);
              return _possibleConstructorReturn(this, (Script2.__proto__ || Object.getPrototypeOf(Script2)).apply(this, arguments));
            }
            _createClass(Script2, null, [{
              key: "create",
              value: function create(value) {
                if (value === "super") {
                  return document.createElement("sup");
                } else if (value === "sub") {
                  return document.createElement("sub");
                } else {
                  return _get(Script2.__proto__ || Object.getPrototypeOf(Script2), "create", this).call(this, value);
                }
              }
            }, {
              key: "formats",
              value: function formats(domNode) {
                if (domNode.tagName === "SUB")
                  return "sub";
                if (domNode.tagName === "SUP")
                  return "super";
                return void 0;
              }
            }]);
            return Script2;
          }(_inline2.default);
          Script.blotName = "script";
          Script.tagName = ["SUB", "SUP"];
          exports2.default = Script;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _inline = __webpack_require__(6);
          var _inline2 = _interopRequireDefault(_inline);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var Strike = function(_Inline) {
            _inherits(Strike2, _Inline);
            function Strike2() {
              _classCallCheck(this, Strike2);
              return _possibleConstructorReturn(this, (Strike2.__proto__ || Object.getPrototypeOf(Strike2)).apply(this, arguments));
            }
            return Strike2;
          }(_inline2.default);
          Strike.blotName = "strike";
          Strike.tagName = "S";
          exports2.default = Strike;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _inline = __webpack_require__(6);
          var _inline2 = _interopRequireDefault(_inline);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var Underline = function(_Inline) {
            _inherits(Underline2, _Inline);
            function Underline2() {
              _classCallCheck(this, Underline2);
              return _possibleConstructorReturn(this, (Underline2.__proto__ || Object.getPrototypeOf(Underline2)).apply(this, arguments));
            }
            return Underline2;
          }(_inline2.default);
          Underline.blotName = "underline";
          Underline.tagName = "U";
          exports2.default = Underline;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _link = __webpack_require__(27);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var ATTRIBUTES = ["alt", "height", "width"];
          var Image = function(_Parchment$Embed) {
            _inherits(Image2, _Parchment$Embed);
            function Image2() {
              _classCallCheck(this, Image2);
              return _possibleConstructorReturn(this, (Image2.__proto__ || Object.getPrototypeOf(Image2)).apply(this, arguments));
            }
            _createClass(Image2, [{
              key: "format",
              value: function format(name, value) {
                if (ATTRIBUTES.indexOf(name) > -1) {
                  if (value) {
                    this.domNode.setAttribute(name, value);
                  } else {
                    this.domNode.removeAttribute(name);
                  }
                } else {
                  _get(Image2.prototype.__proto__ || Object.getPrototypeOf(Image2.prototype), "format", this).call(this, name, value);
                }
              }
            }], [{
              key: "create",
              value: function create(value) {
                var node = _get(Image2.__proto__ || Object.getPrototypeOf(Image2), "create", this).call(this, value);
                if (typeof value === "string") {
                  node.setAttribute("src", this.sanitize(value));
                }
                return node;
              }
            }, {
              key: "formats",
              value: function formats(domNode) {
                return ATTRIBUTES.reduce(function(formats2, attribute) {
                  if (domNode.hasAttribute(attribute)) {
                    formats2[attribute] = domNode.getAttribute(attribute);
                  }
                  return formats2;
                }, {});
              }
            }, {
              key: "match",
              value: function match(url) {
                return /\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url);
              }
            }, {
              key: "sanitize",
              value: function sanitize(url) {
                return (0, _link.sanitize)(url, ["http", "https", "data"]) ? url : "//:0";
              }
            }, {
              key: "value",
              value: function value(domNode) {
                return domNode.getAttribute("src");
              }
            }]);
            return Image2;
          }(_parchment2.default.Embed);
          Image.blotName = "image";
          Image.tagName = "IMG";
          exports2.default = Image;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _block = __webpack_require__(4);
          var _link = __webpack_require__(27);
          var _link2 = _interopRequireDefault(_link);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var ATTRIBUTES = ["height", "width"];
          var Video = function(_BlockEmbed) {
            _inherits(Video2, _BlockEmbed);
            function Video2() {
              _classCallCheck(this, Video2);
              return _possibleConstructorReturn(this, (Video2.__proto__ || Object.getPrototypeOf(Video2)).apply(this, arguments));
            }
            _createClass(Video2, [{
              key: "format",
              value: function format(name, value) {
                if (ATTRIBUTES.indexOf(name) > -1) {
                  if (value) {
                    this.domNode.setAttribute(name, value);
                  } else {
                    this.domNode.removeAttribute(name);
                  }
                } else {
                  _get(Video2.prototype.__proto__ || Object.getPrototypeOf(Video2.prototype), "format", this).call(this, name, value);
                }
              }
            }], [{
              key: "create",
              value: function create(value) {
                var node = _get(Video2.__proto__ || Object.getPrototypeOf(Video2), "create", this).call(this, value);
                node.setAttribute("frameborder", "0");
                node.setAttribute("allowfullscreen", true);
                node.setAttribute("src", this.sanitize(value));
                return node;
              }
            }, {
              key: "formats",
              value: function formats(domNode) {
                return ATTRIBUTES.reduce(function(formats2, attribute) {
                  if (domNode.hasAttribute(attribute)) {
                    formats2[attribute] = domNode.getAttribute(attribute);
                  }
                  return formats2;
                }, {});
              }
            }, {
              key: "sanitize",
              value: function sanitize(url) {
                return _link2.default.sanitize(url);
              }
            }, {
              key: "value",
              value: function value(domNode) {
                return domNode.getAttribute("src");
              }
            }]);
            return Video2;
          }(_block.BlockEmbed);
          Video.blotName = "video";
          Video.className = "ql-video";
          Video.tagName = "IFRAME";
          exports2.default = Video;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.default = exports2.FormulaBlot = void 0;
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _embed = __webpack_require__(35);
          var _embed2 = _interopRequireDefault(_embed);
          var _quill = __webpack_require__(5);
          var _quill2 = _interopRequireDefault(_quill);
          var _module = __webpack_require__(9);
          var _module2 = _interopRequireDefault(_module);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var FormulaBlot = function(_Embed) {
            _inherits(FormulaBlot2, _Embed);
            function FormulaBlot2() {
              _classCallCheck(this, FormulaBlot2);
              return _possibleConstructorReturn(this, (FormulaBlot2.__proto__ || Object.getPrototypeOf(FormulaBlot2)).apply(this, arguments));
            }
            _createClass(FormulaBlot2, null, [{
              key: "create",
              value: function create(value) {
                var node = _get(FormulaBlot2.__proto__ || Object.getPrototypeOf(FormulaBlot2), "create", this).call(this, value);
                if (typeof value === "string") {
                  window.katex.render(value, node, {
                    throwOnError: false,
                    errorColor: "#f00"
                  });
                  node.setAttribute("data-value", value);
                }
                return node;
              }
            }, {
              key: "value",
              value: function value(domNode) {
                return domNode.getAttribute("data-value");
              }
            }]);
            return FormulaBlot2;
          }(_embed2.default);
          FormulaBlot.blotName = "formula";
          FormulaBlot.className = "ql-formula";
          FormulaBlot.tagName = "SPAN";
          var Formula = function(_Module) {
            _inherits(Formula2, _Module);
            _createClass(Formula2, null, [{
              key: "register",
              value: function register() {
                _quill2.default.register(FormulaBlot, true);
              }
            }]);
            function Formula2() {
              _classCallCheck(this, Formula2);
              var _this2 = _possibleConstructorReturn(this, (Formula2.__proto__ || Object.getPrototypeOf(Formula2)).call(this));
              if (window.katex == null) {
                throw new Error("Formula module requires KaTeX.");
              }
              return _this2;
            }
            return Formula2;
          }(_module2.default);
          exports2.FormulaBlot = FormulaBlot;
          exports2.default = Formula;
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.default = exports2.CodeToken = exports2.CodeBlock = void 0;
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _quill = __webpack_require__(5);
          var _quill2 = _interopRequireDefault(_quill);
          var _module = __webpack_require__(9);
          var _module2 = _interopRequireDefault(_module);
          var _code = __webpack_require__(13);
          var _code2 = _interopRequireDefault(_code);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var SyntaxCodeBlock = function(_CodeBlock) {
            _inherits(SyntaxCodeBlock2, _CodeBlock);
            function SyntaxCodeBlock2() {
              _classCallCheck(this, SyntaxCodeBlock2);
              return _possibleConstructorReturn(this, (SyntaxCodeBlock2.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock2)).apply(this, arguments));
            }
            _createClass(SyntaxCodeBlock2, [{
              key: "replaceWith",
              value: function replaceWith(block) {
                this.domNode.textContent = this.domNode.textContent;
                this.attach();
                _get(SyntaxCodeBlock2.prototype.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock2.prototype), "replaceWith", this).call(this, block);
              }
            }, {
              key: "highlight",
              value: function highlight(_highlight) {
                var text = this.domNode.textContent;
                if (this.cachedText !== text) {
                  if (text.trim().length > 0 || this.cachedText == null) {
                    this.domNode.innerHTML = _highlight(text);
                    this.domNode.normalize();
                    this.attach();
                  }
                  this.cachedText = text;
                }
              }
            }]);
            return SyntaxCodeBlock2;
          }(_code2.default);
          SyntaxCodeBlock.className = "ql-syntax";
          var CodeToken = new _parchment2.default.Attributor.Class("token", "hljs", {
            scope: _parchment2.default.Scope.INLINE
          });
          var Syntax = function(_Module) {
            _inherits(Syntax2, _Module);
            _createClass(Syntax2, null, [{
              key: "register",
              value: function register() {
                _quill2.default.register(CodeToken, true);
                _quill2.default.register(SyntaxCodeBlock, true);
              }
            }]);
            function Syntax2(quill, options) {
              _classCallCheck(this, Syntax2);
              var _this2 = _possibleConstructorReturn(this, (Syntax2.__proto__ || Object.getPrototypeOf(Syntax2)).call(this, quill, options));
              if (typeof _this2.options.highlight !== "function") {
                throw new Error("Syntax module requires highlight.js. Please include the library on the page before Quill.");
              }
              var timer = null;
              _this2.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function() {
                clearTimeout(timer);
                timer = setTimeout(function() {
                  _this2.highlight();
                  timer = null;
                }, _this2.options.interval);
              });
              _this2.highlight();
              return _this2;
            }
            _createClass(Syntax2, [{
              key: "highlight",
              value: function highlight() {
                var _this3 = this;
                if (this.quill.selection.composing)
                  return;
                this.quill.update(_quill2.default.sources.USER);
                var range = this.quill.getSelection();
                this.quill.scroll.descendants(SyntaxCodeBlock).forEach(function(code) {
                  code.highlight(_this3.options.highlight);
                });
                this.quill.update(_quill2.default.sources.SILENT);
                if (range != null) {
                  this.quill.setSelection(range, _quill2.default.sources.SILENT);
                }
              }
            }]);
            return Syntax2;
          }(_module2.default);
          Syntax.DEFAULTS = {
            highlight: function() {
              if (window.hljs == null)
                return null;
              return function(text) {
                var result = window.hljs.highlightAuto(text);
                return result.value;
              };
            }(),
            interval: 1e3
          };
          exports2.CodeBlock = SyntaxCodeBlock;
          exports2.CodeToken = CodeToken;
          exports2.default = Syntax;
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <g class="ql-fill ql-color-label"> <polygon points="6 6.868 6 6 5 6 5 7 5.942 7 6 6.868"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points="6.817 5 6 5 6 6 6.38 6 6.817 5"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points="4 11.439 4 11 3 11 3 12 3.755 12 4 11.439"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points="4.63 10 4 10 4 11 4.192 11 4.63 10"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points="13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points="12 6.868 12 6 11.62 6 12 6.868"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points="12.933 9 13 9 13 8 12.495 8 12.933 9"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points="5.5 13 9 5 12.5 13"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <rect class="ql-fill ql-stroke" height=3 width=3 x=4 y=5></rect> <rect class="ql-fill ql-stroke" height=3 width=3 x=11 y=5></rect> <path class="ql-even ql-fill ql-stroke" d=M7,8c0,4.031-3,5-3,5></path> <path class="ql-even ql-fill ql-stroke" d=M14,8c0,4.031-3,5-3,5></path> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg class="" viewbox="0 0 18 18"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <line class="ql-color-label ql-stroke ql-transparent" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points="5.5 11 9 3 12.5 11"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <polygon class="ql-stroke ql-fill" points="3 11 5 9 3 7 3 11"></polygon> <line class="ql-stroke ql-fill" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <polygon class="ql-stroke ql-fill" points="15 12 13 10 15 8 15 12"></polygon> <line class="ql-stroke ql-fill" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform="translate(24 18) rotate(-180)"/> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewBox="0 0 18 18"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewBox="0 0 18 18"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class="ql-even ql-fill" points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"></polyline> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class="ql-fill ql-stroke" points="3 7 3 11 5 9 3 7"></polyline> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points="5 7 5 11 3 9 5 7"></polyline> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class="ql-even ql-stroke" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class="ql-even ql-stroke" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class="ql-stroke ql-thin" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class="ql-stroke ql-thin" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class="ql-stroke ql-thin" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg class="" viewbox="0 0 18 18"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points="3 4 4 5 6 3"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points="3 14 4 15 6 13"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points="3 9 4 10 6 8"></polyline> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <line class="ql-stroke ql-thin" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>';
        },
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <polygon class=ql-stroke points="7 11 9 13 11 11 7 11"></polygon> <polygon class=ql-stroke points="7 7 9 5 11 7 7 7"></polygon> </svg>';
        },
        function(module2, exports2, __webpack_require__) {
          "use strict";
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.default = exports2.BubbleTooltip = void 0;
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _createClass = function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _extend = __webpack_require__(3);
          var _extend2 = _interopRequireDefault(_extend);
          var _emitter = __webpack_require__(8);
          var _emitter2 = _interopRequireDefault(_emitter);
          var _base = __webpack_require__(43);
          var _base2 = _interopRequireDefault(_base);
          var _selection = __webpack_require__(15);
          var _icons = __webpack_require__(41);
          var _icons2 = _interopRequireDefault(_icons);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var TOOLBAR_CONFIG = [["bold", "italic", "link"], [{ header: 1 }, { header: 2 }, "blockquote"]];
          var BubbleTheme = function(_BaseTheme) {
            _inherits(BubbleTheme2, _BaseTheme);
            function BubbleTheme2(quill, options) {
              _classCallCheck(this, BubbleTheme2);
              if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
                options.modules.toolbar.container = TOOLBAR_CONFIG;
              }
              var _this = _possibleConstructorReturn(this, (BubbleTheme2.__proto__ || Object.getPrototypeOf(BubbleTheme2)).call(this, quill, options));
              _this.quill.container.classList.add("ql-bubble");
              return _this;
            }
            _createClass(BubbleTheme2, [{
              key: "extendToolbar",
              value: function extendToolbar(toolbar) {
                this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
                this.tooltip.root.appendChild(toolbar.container);
                this.buildButtons([].slice.call(toolbar.container.querySelectorAll("button")), _icons2.default);
                this.buildPickers([].slice.call(toolbar.container.querySelectorAll("select")), _icons2.default);
              }
            }]);
            return BubbleTheme2;
          }(_base2.default);
          BubbleTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
            modules: {
              toolbar: {
                handlers: {
                  link: function link(value) {
                    if (!value) {
                      this.quill.format("link", false);
                    } else {
                      this.quill.theme.tooltip.edit();
                    }
                  }
                }
              }
            }
          });
          var BubbleTooltip = function(_BaseTooltip) {
            _inherits(BubbleTooltip2, _BaseTooltip);
            function BubbleTooltip2(quill, bounds) {
              _classCallCheck(this, BubbleTooltip2);
              var _this2 = _possibleConstructorReturn(this, (BubbleTooltip2.__proto__ || Object.getPrototypeOf(BubbleTooltip2)).call(this, quill, bounds));
              _this2.quill.on(_emitter2.default.events.EDITOR_CHANGE, function(type, range, oldRange, source) {
                if (type !== _emitter2.default.events.SELECTION_CHANGE)
                  return;
                if (range != null && range.length > 0 && source === _emitter2.default.sources.USER) {
                  _this2.show();
                  _this2.root.style.left = "0px";
                  _this2.root.style.width = "";
                  _this2.root.style.width = _this2.root.offsetWidth + "px";
                  var lines = _this2.quill.getLines(range.index, range.length);
                  if (lines.length === 1) {
                    _this2.position(_this2.quill.getBounds(range));
                  } else {
                    var lastLine = lines[lines.length - 1];
                    var index = _this2.quill.getIndex(lastLine);
                    var length = Math.min(lastLine.length() - 1, range.index + range.length - index);
                    var _bounds = _this2.quill.getBounds(new _selection.Range(index, length));
                    _this2.position(_bounds);
                  }
                } else if (document.activeElement !== _this2.textbox && _this2.quill.hasFocus()) {
                  _this2.hide();
                }
              });
              return _this2;
            }
            _createClass(BubbleTooltip2, [{
              key: "listen",
              value: function listen() {
                var _this3 = this;
                _get(BubbleTooltip2.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip2.prototype), "listen", this).call(this);
                this.root.querySelector(".ql-close").addEventListener("click", function() {
                  _this3.root.classList.remove("ql-editing");
                });
                this.quill.on(_emitter2.default.events.SCROLL_OPTIMIZE, function() {
                  setTimeout(function() {
                    if (_this3.root.classList.contains("ql-hidden"))
                      return;
                    var range = _this3.quill.getSelection();
                    if (range != null) {
                      _this3.position(_this3.quill.getBounds(range));
                    }
                  }, 1);
                });
              }
            }, {
              key: "cancel",
              value: function cancel() {
                this.show();
              }
            }, {
              key: "position",
              value: function position(reference) {
                var shift = _get(BubbleTooltip2.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip2.prototype), "position", this).call(this, reference);
                var arrow = this.root.querySelector(".ql-tooltip-arrow");
                arrow.style.marginLeft = "";
                if (shift === 0)
                  return shift;
                arrow.style.marginLeft = -1 * shift - arrow.offsetWidth / 2 + "px";
              }
            }]);
            return BubbleTooltip2;
          }(_base.BaseTooltip);
          BubbleTooltip.TEMPLATE = ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', "</div>"].join("");
          exports2.BubbleTooltip = BubbleTooltip;
          exports2.default = BubbleTheme;
        },
        function(module2, exports2, __webpack_require__) {
          module2.exports = __webpack_require__(63);
        }
      ])["default"];
    });
  }
});

// src/close-selection-process.js
import React15, { useState as useState8, useReducer, useEffect as useEffect7 } from "react";
import { Modal, Toaster, useToaster } from "@vagastec/ensemble-core";
import "@vagastec/ensemble-core/dist/index.css";

// src/locales/en_US.json
var btn_cancelar = {
  string: "Cancel"
};
var btn_confirmar_aprovados = {
  string: "Confirm approved candidates"
};
var btn_enviar_feedback = {
  string: "Send feedback"
};
var btn_enviar_feedback_e_fechar = {
  string: "Send and close job"
};
var btn_fechar = {
  string: "Close"
};
var btn_fechar_vaga = {
  string: "Close job"
};
var btn_fechar_vaga_cancelar = {
  string: "Cancel"
};
var btn_informar_aprovados = {
  string: "Close job"
};
var btn_marcar_aprovados = {
  string: "Mark approved candidates"
};
var btn_nao_informar_aprovados = {
  string: "Send feedback"
};
var btn_voltar = {
  string: "Back"
};
var editor_texto_normal = {
  string: "Normal"
};
var editor_titulo1 = {
  string: "Title 1"
};
var editor_titulo2 = {
  string: "Title 2"
};
var step1_aprovados_candidatos_aprovados = {
  string: "approved candidates"
};
var step1_aprovados_de = {
  string: "from"
};
var step1_aprovados_placeholder = {
  string: "Type the name"
};
var step1_aviso_feedback = {
  string: "This message will be sent to <b>{candidatesCounter} candidates not selected.</b>"
};
var step1_aviso_posicoes = {
  string: "You still have open positions!"
};
var step1_confirmar_fechamento = {
  string: "Do you really wish to close this job?"
};
var step1_confirmar_fechar_vaga = {
  string: "Do you really wish to close the job?"
};
var step1_envie_mensagem = {
  string: "Elimination feedback"
};
var step1_feedback = {
  string: "<p>Hello <strong>{candidato_nome}</strong></p> <p>Thank you for participating in the selection process.<br />After careful consideration, in this process, <strong>your profile was not selected</strong>, but don't be discouraged!</p><p>You are now part of our talent pool and we may consider your experience for future opportunities.<br />Keep your CV up to date to increase your chances!</p><p><strong>We wish you success in your career!</strong></p><br /><p>Sincerely,</p>"
};
var step1_info_fechar_vaga = {
  string: "This selection process will not receive further applications.{br}You can still access candidate information on the job board at any time.{br}{br}To view the approved candidates, access the Reports section of this selection process."
};
var step1_lista_aprovados = {
  string: "List of approved candidates"
};
var step1_lista_aprovados_erro = {
  string: "<b> Error in the application! </b>"
};
var step1_lista_aprovados_erro_infos = {
  string: "We were not able to load the information. Please try again. If the error persists, please contact our support team."
};
var step1_lista_aprovados_fechado = {
  string: "You have closed all positions"
};
var step1_mensagem_reprovados = {
  string: "Send a message to the<b>candidates not selected</b>"
};
var step1_mensagem_reprovados_fechar = {
  string: "Send a message to the<b>candidates not selected</b> to notify them that the selection process has been closed"
};
var step1_mensagens_padrao = {
  string: "Default messages"
};
var step1_mensagens_padrao_aviso = {
  string: "You do not have permission to view default messages"
};
var step1_mensagens_padrao_erro = {
  string: "Default messages could not be loaded"
};
var step1_mensagens_padrao_sem_mensagem = {
  string: "There are no default messages in your company"
};
var step1_mensagens_padrao_sem_mensagem_divisao = {
  string: "There are no default messages in your division"
};
var step1_selecione_mensagem = {
  string: "Choose a message"
};
var step1_variaveis = {
  string: "Variables"
};
var step2_aprovados_info = {
  string: "This information helps us recommend candidates who are increasingly adhering to your selection processes."
};
var step2_candidato_aprovado = {
  string: "Tell us who {openPositions, plural, one {is the approved candidate} other {are the {openPositions} approved candidates}}"
};
var step2_candidatos_aprovados = {
  string: "Candidates approved successfully"
};
var step2_candidatos_aprovados_info = {
  string: "You will still be able to access candidate information on the job dashboard {link} at any time.{br} To view those approved, access the Reports section of this selection process."
};
var step2_nenhum_candidato = {
  string: " No candidates found"
};
var step2_procurar = {
  string: "Search among candidates in the job opening"
};
var step2_redirect_relatorio_link = {
  string: "click here"
};
var step2_vaga_fechada_candidatos_aprovados = {
  string: "Candidates approved successfully, {br} do you wish to close the job?"
};
var toast_texto_erro = {
  string: "We were unable to complete your request"
};
var toast_texto_escreva_mensagem = {
  string: "The message field cannot be empty"
};
var toast_texto_feedback = {
  string: "Feedback is not allowed for jobs created more than 6 months ago."
};
var toast_titulo_erro = {
  string: "There was an unexpected error"
};
var toast_titulo_escreva_mensagem = {
  string: "Write a message"
};
var toast_titulo_feedback = {
  string: "Error!"
};
var en_US_default = {
  "btn.cancelar": btn_cancelar,
  "btn.confirmar-aprovados": btn_confirmar_aprovados,
  "btn.enviar-feedback": btn_enviar_feedback,
  "btn.enviar-feedback-e-fechar": btn_enviar_feedback_e_fechar,
  "btn.fechar": btn_fechar,
  "btn.fechar-vaga": btn_fechar_vaga,
  "btn.fechar-vaga-cancelar": btn_fechar_vaga_cancelar,
  "btn.informar-aprovados": btn_informar_aprovados,
  "btn.marcar-aprovados": btn_marcar_aprovados,
  "btn.nao-informar-aprovados": btn_nao_informar_aprovados,
  "btn.voltar": btn_voltar,
  "editor.texto-normal": editor_texto_normal,
  "editor.titulo1": editor_titulo1,
  "editor.titulo2": editor_titulo2,
  "step1.aprovados-candidatos-aprovados": step1_aprovados_candidatos_aprovados,
  "step1.aprovados-de": step1_aprovados_de,
  "step1.aprovados-placeholder": step1_aprovados_placeholder,
  "step1.aviso-feedback": step1_aviso_feedback,
  "step1.aviso-posicoes": step1_aviso_posicoes,
  "step1.confirmar-fechamento": step1_confirmar_fechamento,
  "step1.confirmar-fechar-vaga": step1_confirmar_fechar_vaga,
  "step1.envie-mensagem": step1_envie_mensagem,
  "step1.feedback": step1_feedback,
  "step1.info-fechar-vaga": step1_info_fechar_vaga,
  "step1.lista-aprovados": step1_lista_aprovados,
  "step1.lista-aprovados-erro": step1_lista_aprovados_erro,
  "step1.lista-aprovados-erro-infos": step1_lista_aprovados_erro_infos,
  "step1.lista-aprovados-fechado": step1_lista_aprovados_fechado,
  "step1.mensagem-reprovados": step1_mensagem_reprovados,
  "step1.mensagem-reprovados-fechar": step1_mensagem_reprovados_fechar,
  "step1.mensagens-padrao": step1_mensagens_padrao,
  "step1.mensagens-padrao-aviso": step1_mensagens_padrao_aviso,
  "step1.mensagens-padrao-erro": step1_mensagens_padrao_erro,
  "step1.mensagens-padrao-sem-mensagem": step1_mensagens_padrao_sem_mensagem,
  "step1.mensagens-padrao-sem-mensagem-divisao": step1_mensagens_padrao_sem_mensagem_divisao,
  "step1.selecione-mensagem": step1_selecione_mensagem,
  "step1.variaveis": step1_variaveis,
  "step2.aprovados-info": step2_aprovados_info,
  "step2.candidato-aprovado": step2_candidato_aprovado,
  "step2.candidatos-aprovados": step2_candidatos_aprovados,
  "step2.candidatos-aprovados-info": step2_candidatos_aprovados_info,
  "step2.nenhum-candidato": step2_nenhum_candidato,
  "step2.procurar": step2_procurar,
  "step2.redirect-relatorio-link": step2_redirect_relatorio_link,
  "step2.vaga-fechada-candidatos-aprovados": step2_vaga_fechada_candidatos_aprovados,
  "toast.texto-erro": toast_texto_erro,
  "toast.texto-escreva-mensagem": toast_texto_escreva_mensagem,
  "toast.texto-feedback": toast_texto_feedback,
  "toast.titulo-erro": toast_titulo_erro,
  "toast.titulo-escreva-mensagem": toast_titulo_escreva_mensagem,
  "toast.titulo-feedback": toast_titulo_feedback
};

// src/locales/es_ES.json
var btn_cancelar2 = {
  string: "Cancelar"
};
var btn_confirmar_aprovados2 = {
  string: "Confirmar aprobados"
};
var btn_enviar_feedback2 = {
  string: "Enviar feedback"
};
var btn_enviar_feedback_e_fechar2 = {
  string: "Enviar y cerrar la vacante"
};
var btn_fechar2 = {
  string: "Cerrar"
};
var btn_fechar_vaga2 = {
  string: "Cerrar vacante"
};
var btn_fechar_vaga_cancelar2 = {
  string: "Cancelar"
};
var btn_informar_aprovados2 = {
  string: "Cerrar vacante"
};
var btn_marcar_aprovados2 = {
  string: "Indicar aprobados"
};
var btn_nao_informar_aprovados2 = {
  string: "Enviar feedback"
};
var btn_voltar2 = {
  string: "Volver"
};
var editor_texto_normal2 = {
  string: "Normal"
};
var editor_titulo12 = {
  string: "T\xEDtulo 1"
};
var editor_titulo22 = {
  string: "T\xEDtulo 2"
};
var step1_aprovados_candidatos_aprovados2 = {
  string: "candidatos aprobados"
};
var step1_aprovados_de2 = {
  string: "de"
};
var step1_aprovados_placeholder2 = {
  string: "Digita el nombre"
};
var step1_aviso_feedback2 = {
  string: "Este mensaje ser\xE1 enviado para <b>{candidatesCounter} candidatos no seleccionados.</b>"
};
var step1_aviso_posicoes2 = {
  string: "\xA1A\xFAn tienes vacantes abiertas!"
};
var step1_confirmar_fechamento2 = {
  string: "\xBFRealmente deseas cerrar esta vacante?"
};
var step1_confirmar_fechar_vaga2 = {
  string: "\xBFRealmente deseas cerrar la vacante?"
};
var step1_envie_mensagem2 = {
  string: "Feedback de eliminaci\xF3n"
};
var step1_feedback2 = {
  string: "<p>Hola, <strong>{candidato_nome}</strong></p> <p>Te agradecemos por participar en el proceso de selecci\xF3n.<br /> Tras un an\xE1lisis cuidadoso en este proceso, <strong>no hemos podido aprovechar tu perfil</strong>, \xA1pero no te desanimes!</p><p>Ahora formas parte de nuestro banco de talentos y podremos considerar tu experiencia en futuras oportunidades.<br />\xA1Mant\xE9n tu curr\xEDculum actualizado para aumentar tus chances!</p><p><strong>\xA1Te deseamos \xE9xitos en tu carrera!</strong></p><br /><p>Atentamente,</p>"
};
var step1_info_fechar_vaga2 = {
  string: "Este proceso de selecci\xF3n ya no aceptar\xE1 nuevos candidatos.{br}Podr\xE1s continuar accediendo a las informaciones de los candidatos en cualquier momento en el panel de la vacante.{br}{br}Para ver la lista de los aprobados,  accede a la secci\xF3n de Informes del proceso de selecci\xF3n."
};
var step1_lista_aprovados2 = {
  string: "Lista de aprobados"
};
var step1_lista_aprovados_erro2 = {
  string: "<b> \xA1Error en la aplicaci\xF3n! </b>"
};
var step1_lista_aprovados_erro_infos2 = {
  string: "No ha sido posible cargar la informaci\xF3n. Por favor, int\xE9ntalo nuevamente. Si el error contin\xFAa, entra en contacto con nuestro equipo de soporte."
};
var step1_lista_aprovados_fechado2 = {
  string: "Has cerrado todas las vacantes"
};
var step1_mensagem_reprovados2 = {
  string: "Env\xEDales un mensaje a los <b>candidatos no seleccionados</b>"
};
var step1_mensagem_reprovados_fechar2 = {
  string: "Env\xEDales un mensaje a los <b>candidatos no seleccionados</b> para informarles el cierre del proceso de selecci\xF3n"
};
var step1_mensagens_padrao2 = {
  string: "Mensajes est\xE1ndar"
};
var step1_mensagens_padrao_aviso2 = {
  string: "No tienes permiso para ver los mensajes est\xE1ndar"
};
var step1_mensagens_padrao_erro2 = {
  string: "No ha sido posible cargar los mensajes est\xE1ndar"
};
var step1_mensagens_padrao_sem_mensagem2 = {
  string: "No hay mensajes est\xE1ndar en tu empresa"
};
var step1_mensagens_padrao_sem_mensagem_divisao2 = {
  string: "No hay mensajes est\xE1ndar en tu divisi\xF3n"
};
var step1_selecione_mensagem2 = {
  string: "Selecciona un mensaje"
};
var step1_variaveis2 = {
  string: "Variables"
};
var step2_aprovados_info2 = {
  string: "Busca a los candidatos que han sido aprovados en el proceso de selecci\xF3n"
};
var step2_candidato_aprovado2 = {
  string: "{openPositions, plural, =0 {Qui\xE9nes son los aprobados} one {Qui\xE9nes son los aprobados} other {Qui\xE9n es el aprobado}}?"
};
var step2_candidatos_aprovados2 = {
  string: "Candidatos aprobados con \xE9xito"
};
var step2_candidatos_aprovados_info2 = {
  string: "Todav\xEDa podr\xE1s aceder a las informaciones de los candidatos en el panel de la vacante {link} en cualquier momento.{br} Para ver los aprobados, accede a la secci\xF3n de Informes del proceso de selecci\xF3n."
};
var step2_nenhum_candidato2 = {
  string: "Ning\xFAn candidato encontrado"
};
var step2_procurar2 = {
  string: "Busca por el nombre del candidato"
};
var step2_redirect_relatorio_link2 = {
  string: "haz click aqu\xED"
};
var step2_vaga_fechada_candidatos_aprovados2 = {
  string: "Candidatos aprobados con \xE9xito, {br} \xBFquieres cerrar la vacante?"
};
var toast_texto_erro2 = {
  string: "No ha sido posible completar tu solicitud"
};
var toast_texto_escreva_mensagem2 = {
  string: "El campo de mensaje no puede estar vac\xEDo"
};
var toast_texto_feedback2 = {
  string: "No es posible enviar feedbacks para vacantes creadas hace m\xE1s de 6 meses."
};
var toast_titulo_erro2 = {
  string: "Ha habido un error inesperado"
};
var toast_titulo_escreva_mensagem2 = {
  string: "Escribe un mensaje"
};
var toast_titulo_feedback2 = {
  string: "\xA1Error!"
};
var es_ES_default = {
  "btn.cancelar": btn_cancelar2,
  "btn.confirmar-aprovados": btn_confirmar_aprovados2,
  "btn.enviar-feedback": btn_enviar_feedback2,
  "btn.enviar-feedback-e-fechar": btn_enviar_feedback_e_fechar2,
  "btn.fechar": btn_fechar2,
  "btn.fechar-vaga": btn_fechar_vaga2,
  "btn.fechar-vaga-cancelar": btn_fechar_vaga_cancelar2,
  "btn.informar-aprovados": btn_informar_aprovados2,
  "btn.marcar-aprovados": btn_marcar_aprovados2,
  "btn.nao-informar-aprovados": btn_nao_informar_aprovados2,
  "btn.voltar": btn_voltar2,
  "editor.texto-normal": editor_texto_normal2,
  "editor.titulo1": editor_titulo12,
  "editor.titulo2": editor_titulo22,
  "step1.aprovados-candidatos-aprovados": step1_aprovados_candidatos_aprovados2,
  "step1.aprovados-de": step1_aprovados_de2,
  "step1.aprovados-placeholder": step1_aprovados_placeholder2,
  "step1.aviso-feedback": step1_aviso_feedback2,
  "step1.aviso-posicoes": step1_aviso_posicoes2,
  "step1.confirmar-fechamento": step1_confirmar_fechamento2,
  "step1.confirmar-fechar-vaga": step1_confirmar_fechar_vaga2,
  "step1.envie-mensagem": step1_envie_mensagem2,
  "step1.feedback": step1_feedback2,
  "step1.info-fechar-vaga": step1_info_fechar_vaga2,
  "step1.lista-aprovados": step1_lista_aprovados2,
  "step1.lista-aprovados-erro": step1_lista_aprovados_erro2,
  "step1.lista-aprovados-erro-infos": step1_lista_aprovados_erro_infos2,
  "step1.lista-aprovados-fechado": step1_lista_aprovados_fechado2,
  "step1.mensagem-reprovados": step1_mensagem_reprovados2,
  "step1.mensagem-reprovados-fechar": step1_mensagem_reprovados_fechar2,
  "step1.mensagens-padrao": step1_mensagens_padrao2,
  "step1.mensagens-padrao-aviso": step1_mensagens_padrao_aviso2,
  "step1.mensagens-padrao-erro": step1_mensagens_padrao_erro2,
  "step1.mensagens-padrao-sem-mensagem": step1_mensagens_padrao_sem_mensagem2,
  "step1.mensagens-padrao-sem-mensagem-divisao": step1_mensagens_padrao_sem_mensagem_divisao2,
  "step1.selecione-mensagem": step1_selecione_mensagem2,
  "step1.variaveis": step1_variaveis2,
  "step2.aprovados-info": step2_aprovados_info2,
  "step2.candidato-aprovado": step2_candidato_aprovado2,
  "step2.candidatos-aprovados": step2_candidatos_aprovados2,
  "step2.candidatos-aprovados-info": step2_candidatos_aprovados_info2,
  "step2.nenhum-candidato": step2_nenhum_candidato2,
  "step2.procurar": step2_procurar2,
  "step2.redirect-relatorio-link": step2_redirect_relatorio_link2,
  "step2.vaga-fechada-candidatos-aprovados": step2_vaga_fechada_candidatos_aprovados2,
  "toast.texto-erro": toast_texto_erro2,
  "toast.texto-escreva-mensagem": toast_texto_escreva_mensagem2,
  "toast.texto-feedback": toast_texto_feedback2,
  "toast.titulo-erro": toast_titulo_erro2,
  "toast.titulo-escreva-mensagem": toast_titulo_escreva_mensagem2,
  "toast.titulo-feedback": toast_titulo_feedback2
};

// src/close-selection-process.js
import { IntlProvider } from "react-intl";
import styled11 from "@emotion/styled";

// src/context/steps.context.js
import React, { createContext, useContext } from "react";
var Context = createContext();
function StepsProvider({ children, ...props }) {
  return /* @__PURE__ */ React.createElement(Context.Provider, {
    value: { ...props }
  }, children);
}
function useStepsContext() {
  const context = useContext(Context);
  return context;
}

// src/fluxos/fechar-vaga/steps/step1/step1.component.js
import React6, { useEffect as useEffect2, useState as useState2 } from "react";
import { FormattedMessage as FormattedMessage3, useIntl } from "react-intl";
import { Text as Text2 } from "@vagastec/ensemble-core";
import "@vagastec/ensemble-core/dist/index.css";

// src/styles/global.style.js
import styled from "@emotion/styled";
var Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  width: 790px;
  padding: 0 24px 24px 24px;

  &:before {
    background-color: #e8e8e8;
    content: "";
    display: inline-block;
    height: 1px;
    margin-bottom: 24px;
    width: 944px;
  }
`;
var btnAux = {
  background: "#fff",
  border: "1px solid",
  borderColor: "#ededed",
  color: "#373737"
};
var btnSuccess = {
  background: "#2dac3a",
  border: "1px solid",
  borderColor: "#2dac3a",
  color: "#fff"
};
var Button = styled.button`
  ${(props) => props.kind === "aux" ? btnAux : btnSuccess};
  border-radius: 6px;
  cursor: pointer;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-weight: 600;
  padding: 8px 24px;
  transition: box-shadow 0.3s ease;
  &:focus {
    box-shadow: 0px 0px 4px #ededed;
  }
`;

// src/footer/footer.component.js
import React2 from "react";

// src/footer/footer.style.js
import styled2 from "@emotion/styled";
var FooterWrapper = styled2.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 32px;
  button {
    margin-bottom: 16px;
  }
  button:disabled {
    background: #c8c8c8;
    border-color: #c8c8c8;
    cursor: not-allowed;
  }

  div {
    display: flex;
    flex-direction: column;
    button:first-of-type {
      margin-bottom: 16px;
    }
  }

  @media screen and (min-width: 426px) {
    align-items: center;
    flex-direction: row;
    justify-content: ${(props) => props.center ? "center" : "right"};
    max-width: 100%;

    button {
      margin-bottom: 0;
      margin-right: 8px;
    }

    div {
      flex-direction: row;
      button:first-of-type {
        margin-bottom: 0;
      }
      button:last-of-type {
        margin-right: 0;
      }
    }
  }
`;

// src/footer/footer.component.js
import { FormattedMessage } from "react-intl";
var Footer = ({
  labelAux,
  labelFeedback,
  labelSuccess,
  stepToback,
  nextStep,
  functionSuccess,
  disabledSuccess,
  functionAux,
  idAux,
  idFeedback,
  idSuccess,
  hasBackButton,
  center,
  permiteFeedback,
  exibirMsgErroFeedback = () => {
  }
}) => {
  const { setModalContent } = useStepsContext();
  return /* @__PURE__ */ React2.createElement(FooterWrapper, {
    center
  }, hasBackButton && /* @__PURE__ */ React2.createElement(Button, {
    id: "btn_voltar",
    "data-testid": "btn_voltar",
    type: "button",
    onClick: () => setModalContent({
      fluxo: stepToback.fluxo,
      step: stepToback.step,
      origin: stepToback.origin
    }),
    kind: "aux"
  }, /* @__PURE__ */ React2.createElement(FormattedMessage, {
    id: "btn.voltar",
    defaultMessage: "Voltar"
  })), /* @__PURE__ */ React2.createElement("div", null, labelAux && /* @__PURE__ */ React2.createElement(Button, {
    id: idAux,
    "data-testid": idAux,
    type: "button",
    onClick: () => functionAux(),
    kind: "aux"
  }, labelAux), labelFeedback && /* @__PURE__ */ React2.createElement(Button, {
    id: idFeedback,
    "data-testid": idFeedback,
    type: "button",
    onClick: () => {
      if (permiteFeedback) {
        setModalContent({
          fluxo: nextStep.fluxo,
          step: nextStep.step,
          origin: nextStep.origin
        });
      } else {
        exibirMsgErroFeedback();
      }
    },
    kind: "aux"
  }, labelFeedback), labelSuccess && /* @__PURE__ */ React2.createElement(Button, {
    disabled: disabledSuccess,
    id: idSuccess,
    "data-testid": idSuccess,
    type: "button",
    onClick: () => functionSuccess()
  }, labelSuccess)));
};

// src/hooks/useFetch/fetcher.js
var fetcher = (url, token, method = "GET", body) => fetch(url, {
  method,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`
  },
  body: JSON.stringify(body)
}).then((res) => res.json());

// src/hooks/useFetch/urls.js
function useUrls(vagaId, env) {
  const VACANCY = vagaId;
  const ENV = env;
  const BASE_URL = ENV !== "production" ? "https://apigateway.ad.vagastec.com.br/v1" : "https://apigateway.vagas.com.br/v1";
  const PERMISSIONS = `${BASE_URL}/athena/painel`;
  const EMAIL_TEMPLATE = `${BASE_URL}/athena/mensagens-padrao`;
  const VACANCY_DATA = `${BASE_URL}/athena/processos-seletivos/${VACANCY}`;
  const FEEDBACK = `${BASE_URL}/athena/processos-seletivos/${VACANCY}/feedback`;
  const PROFESSIONALS = `${BASE_URL}/athena/processos-seletivos/${VACANCY}/candidatos?nome`;
  const INFORM_APPROVED = `${BASE_URL}/athena/processos-seletivos/${VACANCY}/contratados/bulk`;
  const CLOSE_PROCESS = `${BASE_URL}/athena/processos-seletivos/${VACANCY}/fechar`;
  const APPROVED_LIST = `${BASE_URL}/painel-vaga/processos-seletivos/${VACANCY}/aprovados`;
  return {
    PERMISSIONS,
    EMAIL_TEMPLATE,
    PROFESSIONALS,
    INFORM_APPROVED,
    VACANCY_DATA,
    FEEDBACK,
    CLOSE_PROCESS,
    APPROVED_LIST
  };
}

// src/loading/loading.component.js
import React5 from "react";

// src/loading/loading.style.js
import styled3 from "@emotion/styled";
var LoadingWrapper = styled3.div`
  background-color: ${(props) => props.opaque ? "white" : "rgba(200,200,200,0.7)"};
  text-align: center;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .loader {
    animation: rotate 1.5s cubic-bezier(0.08, 0.485, 0.98, 0.58) infinite;
  }

  .logo {
    height: 32px;
    width: 116px;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0);
    }

    100% {
      transform: rotate(360deg);
    }
  }
`;
var WaitMessage = styled3.p`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  bottom: 0;
  color: #797979;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-weight: 400;
  position: absolute;
  width: 100%;
  z-index: 4;
`;

// src/images/loading.svg.js
import React3 from "react";
function Loading(props) {
  return /* @__PURE__ */ React3.createElement("svg", {
    className: "vg-loader-svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: "95",
    height: "95",
    ...props
  }, /* @__PURE__ */ React3.createElement("defs", null, /* @__PURE__ */ React3.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    y1: "50%",
    y2: "50%"
  }, /* @__PURE__ */ React3.createElement("stop", {
    offset: "0%",
    stopColor: "#F7902A"
  }), /* @__PURE__ */ React3.createElement("stop", {
    offset: "100%",
    stopColor: "#F9564B"
  }))), /* @__PURE__ */ React3.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: "9",
    transform: "translate(5 5)"
  }, /* @__PURE__ */ React3.createElement("circle", {
    cx: "42.5",
    cy: "42.5",
    r: "42.5",
    stroke: "#E6E6E6"
  }), /* @__PURE__ */ React3.createElement("path", {
    stroke: "url(#a)",
    strokeLinecap: "round",
    d: "M42.5 85C65.972 85 85 65.972 85 42.5"
  })));
}

// src/images/logo-vagas.svg.js
import React4 from "react";
function Logo(props) {
  return /* @__PURE__ */ React4.createElement("svg", {
    className: "vg-logo-footer",
    xmlns: "http://www.w3.org/2000/svg",
    width: "75",
    height: "31",
    viewBox: "0 0 75 31",
    ...props
  }, /* @__PURE__ */ React4.createElement("g", {
    fill: "none"
  }, /* @__PURE__ */ React4.createElement("path", {
    d: "M12.3788 7.86542L7.58522 19.552L2.62504 7.86542H0L6.45988 22.1822H8.4686L14.8395 7.86542H12.3788Z",
    fill: "#797979"
  }), /* @__PURE__ */ React4.createElement("path", {
    d: "M69.2692 13.7386C66.6829 13.1281 65.9205 12.6691 65.9205 11.5973C65.9205 10.4038 67.0778 9.78872 68.9952 9.78872C70.5755 9.74959 72.1279 10.2113 73.4327 11.1084L73.1291 8.56773C72.0631 7.98707 70.6022 7.68182 69.082 7.68182C65.8269 7.68182 63.6356 9.27232 63.6356 11.751C63.6356 14.014 65.0052 15.1776 68.2602 15.912C71.1501 16.5225 71.9125 17.1353 71.9125 18.3586C71.9125 19.5819 70.7255 20.1947 68.6255 20.1947C66.7312 20.2345 64.8891 19.5691 63.453 18.3265L63.7566 21.1104C65.1878 21.9366 66.708 22.3039 68.6551 22.3039C71.9718 22.3039 74.1928 20.6812 74.1928 18.1727C74.1928 15.6642 72.9214 14.5946 69.2692 13.7386Z",
    fill: "#797979"
  }), /* @__PURE__ */ React4.createElement("path", {
    d: "M31.7059 14.1242C31.7059 17.8446 34.5821 20.4931 38.1749 20.4931C39.0181 20.5121 39.8565 20.3613 40.6408 20.0496C41.4251 19.7379 42.1394 19.2716 42.7418 18.6781C43.3441 18.0846 43.8223 17.376 44.1482 16.594C44.4741 15.8119 44.6411 14.9722 44.6394 14.1242C44.6449 13.322 44.4651 12.5294 44.1141 11.809C43.7632 11.0885 43.2507 10.4598 42.617 9.97238L44.6713 9.37566V7.72778H38.4283C34.8697 7.72778 31.7059 10.4567 31.7059 14.1242ZM42.2906 14.1242C42.2906 16.4721 40.4644 18.4252 38.1818 18.4252C35.8991 18.4252 34.1187 16.4721 34.1187 14.1242C34.1187 11.7763 35.922 9.91501 38.1818 9.91501C38.7278 9.91491 39.2683 10.0242 39.7717 10.2366C40.2752 10.4489 40.7315 10.76 41.1141 11.1517C41.4966 11.5433 41.7977 12.0077 41.9997 12.5177C42.2017 13.0277 42.3006 13.5731 42.2906 14.1219V14.1242Z",
    fill: "#797979"
  }), /* @__PURE__ */ React4.createElement("path", {
    d: "M59.0087 10.25C57.7304 8.62965 55.7536 7.71161 53.471 7.71161C49.5768 7.71161 46.4108 10.8329 46.4108 15.0238C46.4108 19.2766 49.5448 22.3061 53.471 22.3061C54.482 22.3227 55.4846 22.1177 56.4089 21.7056C57.3333 21.2934 58.1573 20.6838 58.8238 19.9192L59.1411 22.1822H61.2114V7.86538H59.1342L59.0087 10.25ZM53.802 20.1326C51.0012 20.1326 48.8418 17.9294 48.8418 15.0238C48.8418 12.1182 51.0057 9.88047 53.802 9.88047C56.6621 9.88047 58.8535 12.0815 58.8535 15.0192C58.8689 15.692 58.7491 16.3611 58.5011 16.9862C58.2532 17.6114 57.8822 18.1798 57.4105 18.6573C56.9388 19.1348 56.376 19.5116 55.7559 19.7651C55.1359 20.0186 54.4713 20.1436 53.802 20.1326Z",
    fill: "#797979"
  }), /* @__PURE__ */ React4.createElement("path", {
    d: "M39.5833 22.0078H34.3994V24.0733H39.5924C40.1125 24.0733 40.6112 24.281 40.9789 24.6508C41.3466 25.0205 41.5532 25.5219 41.5532 26.0448C41.5532 26.5677 41.3466 27.0691 40.9789 27.4389C40.6112 27.8086 40.1125 28.0163 39.5924 28.0163H39.4212V30.2609H39.5901C41.9207 30.2609 43.9797 28.4248 43.9797 26.1022C43.9797 23.7796 42.0075 22.0078 39.5833 22.0078Z",
    fill: "#797979"
  }), /* @__PURE__ */ React4.createElement("path", {
    d: "M27.2729 10.2684C25.9947 8.64802 24.0179 7.72998 21.7353 7.72998C17.8411 7.72998 14.675 10.8513 14.675 15.0421C14.675 19.2949 17.8091 22.3245 21.7353 22.3245C22.7474 22.3419 23.7512 22.1374 24.6768 21.7252C25.6024 21.313 26.4276 20.703 27.0949 19.9376L27.4122 22.2005H29.4803V7.88145H27.4053L27.2729 10.2684ZM22.0731 20.151C19.2723 20.151 17.1129 17.9477 17.1129 15.0421C17.1129 12.1366 19.2723 9.90113 22.0731 9.90113C24.9332 9.90113 27.1223 12.1044 27.1223 15.0421C27.1374 15.7145 27.0174 16.383 26.7694 17.0076C26.5215 17.6322 26.1506 18.2001 25.6792 18.6771C25.2077 19.1542 24.6453 19.5306 24.0256 19.7839C23.406 20.0371 22.7419 20.162 22.0731 20.151Z",
    fill: "#797979"
  })));
}

// src/loading/loading.component.js
import { FormattedMessage as FormattedMessage2 } from "react-intl";
function Loader({
  id = "loader.mensagem-loading",
  defaultMessage = "Aguarde, estamos enviando sua mensagem.",
  opaque = false
}) {
  return /* @__PURE__ */ React5.createElement(LoadingWrapper, {
    opaque
  }, /* @__PURE__ */ React5.createElement(Loading, {
    className: "loader"
  }), /* @__PURE__ */ React5.createElement(WaitMessage, null, /* @__PURE__ */ React5.createElement(Logo, {
    className: "logo"
  }), /* @__PURE__ */ React5.createElement(FormattedMessage2, {
    id,
    defaultMessage
  })));
}

// node_modules/swr/dist/index.mjs
import { useEffect, useLayoutEffect, createContext as createContext2, useContext as useContext2, useState, createElement, useRef, useCallback, useDebugValue } from "react";
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1)
      throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (_)
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
          return t;
        if (y = 0, t)
          op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
var noop = function() {
};
var UNDEFINED = noop();
var OBJECT = Object;
var isUndefined = function(v) {
  return v === UNDEFINED;
};
var isFunction = function(v) {
  return typeof v == "function";
};
var mergeObjects = function(a, b) {
  return OBJECT.assign({}, a, b);
};
var STR_UNDEFINED = "undefined";
var hasWindow = function() {
  return typeof window != STR_UNDEFINED;
};
var hasDocument = function() {
  return typeof document != STR_UNDEFINED;
};
var hasRequestAnimationFrame = function() {
  return hasWindow() && typeof window["requestAnimationFrame"] != STR_UNDEFINED;
};
var table = new WeakMap();
var counter = 0;
var stableHash = function(arg) {
  var type = typeof arg;
  var constructor = arg && arg.constructor;
  var isDate = constructor == Date;
  var result;
  var index;
  if (OBJECT(arg) === arg && !isDate && constructor != RegExp) {
    result = table.get(arg);
    if (result)
      return result;
    result = ++counter + "~";
    table.set(arg, result);
    if (constructor == Array) {
      result = "@";
      for (index = 0; index < arg.length; index++) {
        result += stableHash(arg[index]) + ",";
      }
      table.set(arg, result);
    }
    if (constructor == OBJECT) {
      result = "#";
      var keys = OBJECT.keys(arg).sort();
      while (!isUndefined(index = keys.pop())) {
        if (!isUndefined(arg[index])) {
          result += index + ":" + stableHash(arg[index]) + ",";
        }
      }
      table.set(arg, result);
    }
  } else {
    result = isDate ? arg.toJSON() : type == "symbol" ? arg.toString() : type == "string" ? JSON.stringify(arg) : "" + arg;
  }
  return result;
};
var online = true;
var isOnline = function() {
  return online;
};
var hasWin = hasWindow();
var hasDoc = hasDocument();
var onWindowEvent = hasWin && window.addEventListener ? window.addEventListener.bind(window) : noop;
var onDocumentEvent = hasDoc ? document.addEventListener.bind(document) : noop;
var offWindowEvent = hasWin && window.removeEventListener ? window.removeEventListener.bind(window) : noop;
var offDocumentEvent = hasDoc ? document.removeEventListener.bind(document) : noop;
var isVisible = function() {
  var visibilityState = hasDoc && document.visibilityState;
  return isUndefined(visibilityState) || visibilityState !== "hidden";
};
var initFocus = function(callback) {
  onDocumentEvent("visibilitychange", callback);
  onWindowEvent("focus", callback);
  return function() {
    offDocumentEvent("visibilitychange", callback);
    offWindowEvent("focus", callback);
  };
};
var initReconnect = function(callback) {
  var onOnline = function() {
    online = true;
    callback();
  };
  var onOffline = function() {
    online = false;
  };
  onWindowEvent("online", onOnline);
  onWindowEvent("offline", onOffline);
  return function() {
    offWindowEvent("online", onOnline);
    offWindowEvent("offline", onOffline);
  };
};
var preset = {
  isOnline,
  isVisible
};
var defaultConfigOptions = {
  initFocus,
  initReconnect
};
var IS_SERVER = !hasWindow() || "Deno" in window;
var rAF = function(f) {
  return hasRequestAnimationFrame() ? window["requestAnimationFrame"](f) : setTimeout(f, 1);
};
var useIsomorphicLayoutEffect = IS_SERVER ? useEffect : useLayoutEffect;
var navigatorConnection = typeof navigator !== "undefined" && navigator.connection;
var slowConnection = !IS_SERVER && navigatorConnection && (["slow-2g", "2g"].includes(navigatorConnection.effectiveType) || navigatorConnection.saveData);
var serialize = function(key) {
  if (isFunction(key)) {
    try {
      key = key();
    } catch (err) {
      key = "";
    }
  }
  var args = [].concat(key);
  key = typeof key == "string" ? key : (Array.isArray(key) ? key.length : key) ? stableHash(key) : "";
  var infoKey = key ? "$swr$" + key : "";
  return [key, args, infoKey];
};
var SWRGlobalState = new WeakMap();
var FOCUS_EVENT = 0;
var RECONNECT_EVENT = 1;
var MUTATE_EVENT = 2;
var broadcastState = function(cache2, key, data, error, isValidating, revalidate, broadcast) {
  if (broadcast === void 0) {
    broadcast = true;
  }
  var _a2 = SWRGlobalState.get(cache2), EVENT_REVALIDATORS = _a2[0], STATE_UPDATERS = _a2[1], FETCH = _a2[3];
  var revalidators = EVENT_REVALIDATORS[key];
  var updaters = STATE_UPDATERS[key];
  if (broadcast && updaters) {
    for (var i = 0; i < updaters.length; ++i) {
      updaters[i](data, error, isValidating);
    }
  }
  if (revalidate) {
    delete FETCH[key];
    if (revalidators && revalidators[0]) {
      return revalidators[0](MUTATE_EVENT).then(function() {
        return cache2.get(key);
      });
    }
  }
  return cache2.get(key);
};
var __timestamp = 0;
var getTimestamp = function() {
  return ++__timestamp;
};
var internalMutate = function() {
  var args = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
  return __awaiter(void 0, void 0, void 0, function() {
    var cache2, _key, _data, _opts, options, populateCache, revalidate, rollbackOnError, customOptimisticData, _a2, key, keyInfo, _b, MUTATION, data, error, beforeMutationTs, hasCustomOptimisticData, rollbackData, optimisticData, res;
    return __generator(this, function(_c) {
      switch (_c.label) {
        case 0:
          cache2 = args[0], _key = args[1], _data = args[2], _opts = args[3];
          options = typeof _opts === "boolean" ? { revalidate: _opts } : _opts || {};
          populateCache = isUndefined(options.populateCache) ? true : options.populateCache;
          revalidate = options.revalidate !== false;
          rollbackOnError = options.rollbackOnError !== false;
          customOptimisticData = options.optimisticData;
          _a2 = serialize(_key), key = _a2[0], keyInfo = _a2[2];
          if (!key)
            return [2];
          _b = SWRGlobalState.get(cache2), MUTATION = _b[2];
          if (args.length < 3) {
            return [2, broadcastState(cache2, key, cache2.get(key), UNDEFINED, UNDEFINED, revalidate, true)];
          }
          data = _data;
          beforeMutationTs = getTimestamp();
          MUTATION[key] = [beforeMutationTs, 0];
          hasCustomOptimisticData = !isUndefined(customOptimisticData);
          rollbackData = cache2.get(key);
          if (hasCustomOptimisticData) {
            optimisticData = isFunction(customOptimisticData) ? customOptimisticData(rollbackData) : customOptimisticData;
            cache2.set(key, optimisticData);
            broadcastState(cache2, key, optimisticData);
          }
          if (isFunction(data)) {
            try {
              data = data(cache2.get(key));
            } catch (err) {
              error = err;
            }
          }
          if (!(data && isFunction(data.then)))
            return [3, 2];
          return [
            4,
            data.catch(function(err) {
              error = err;
            })
          ];
        case 1:
          data = _c.sent();
          if (beforeMutationTs !== MUTATION[key][0]) {
            if (error)
              throw error;
            return [2, data];
          } else if (error && hasCustomOptimisticData && rollbackOnError) {
            populateCache = true;
            data = rollbackData;
            cache2.set(key, rollbackData);
          }
          _c.label = 2;
        case 2:
          if (populateCache) {
            if (!error) {
              if (isFunction(populateCache)) {
                data = populateCache(data, rollbackData);
              }
              cache2.set(key, data);
            }
            cache2.set(keyInfo, mergeObjects(cache2.get(keyInfo), { error }));
          }
          MUTATION[key][1] = getTimestamp();
          return [
            4,
            broadcastState(cache2, key, data, error, UNDEFINED, revalidate, !!populateCache)
          ];
        case 3:
          res = _c.sent();
          if (error)
            throw error;
          return [2, populateCache ? res : data];
      }
    });
  });
};
var revalidateAllKeys = function(revalidators, type) {
  for (var key in revalidators) {
    if (revalidators[key][0])
      revalidators[key][0](type);
  }
};
var initCache = function(provider, options) {
  if (!SWRGlobalState.has(provider)) {
    var opts = mergeObjects(defaultConfigOptions, options);
    var EVENT_REVALIDATORS = {};
    var mutate2 = internalMutate.bind(UNDEFINED, provider);
    var unmount = noop;
    SWRGlobalState.set(provider, [EVENT_REVALIDATORS, {}, {}, {}, mutate2]);
    if (!IS_SERVER) {
      var releaseFocus_1 = opts.initFocus(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, FOCUS_EVENT)));
      var releaseReconnect_1 = opts.initReconnect(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, RECONNECT_EVENT)));
      unmount = function() {
        releaseFocus_1 && releaseFocus_1();
        releaseReconnect_1 && releaseReconnect_1();
        SWRGlobalState.delete(provider);
      };
    }
    return [provider, mutate2, unmount];
  }
  return [provider, SWRGlobalState.get(provider)[4]];
};
var onErrorRetry = function(_, __, config, revalidate, opts) {
  var maxRetryCount = config.errorRetryCount;
  var currentRetryCount = opts.retryCount;
  var timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
  if (!isUndefined(maxRetryCount) && currentRetryCount > maxRetryCount) {
    return;
  }
  setTimeout(revalidate, timeout, opts);
};
var _a = initCache(new Map());
var cache = _a[0];
var mutate = _a[1];
var defaultConfig = mergeObjects({
  onLoadingSlow: noop,
  onSuccess: noop,
  onError: noop,
  onErrorRetry,
  onDiscarded: noop,
  revalidateOnFocus: true,
  revalidateOnReconnect: true,
  revalidateIfStale: true,
  shouldRetryOnError: true,
  errorRetryInterval: slowConnection ? 1e4 : 5e3,
  focusThrottleInterval: 5 * 1e3,
  dedupingInterval: 2 * 1e3,
  loadingTimeout: slowConnection ? 5e3 : 3e3,
  compare: function(currentData, newData) {
    return stableHash(currentData) == stableHash(newData);
  },
  isPaused: function() {
    return false;
  },
  cache,
  mutate,
  fallback: {}
}, preset);
var mergeConfigs = function(a, b) {
  var v = mergeObjects(a, b);
  if (b) {
    var u1 = a.use, f1 = a.fallback;
    var u2 = b.use, f2 = b.fallback;
    if (u1 && u2) {
      v.use = u1.concat(u2);
    }
    if (f1 && f2) {
      v.fallback = mergeObjects(f1, f2);
    }
  }
  return v;
};
var SWRConfigContext = createContext2({});
var SWRConfig$1 = function(props) {
  var value = props.value;
  var extendedConfig = mergeConfigs(useContext2(SWRConfigContext), value);
  var provider = value && value.provider;
  var cacheContext = useState(function() {
    return provider ? initCache(provider(extendedConfig.cache || cache), value) : UNDEFINED;
  })[0];
  if (cacheContext) {
    extendedConfig.cache = cacheContext[0];
    extendedConfig.mutate = cacheContext[1];
  }
  useIsomorphicLayoutEffect(function() {
    return cacheContext ? cacheContext[2] : UNDEFINED;
  }, []);
  return createElement(SWRConfigContext.Provider, mergeObjects(props, {
    value: extendedConfig
  }));
};
var useStateWithDeps = function(state, unmountedRef) {
  var rerender = useState({})[1];
  var stateRef = useRef(state);
  var stateDependenciesRef = useRef({
    data: false,
    error: false,
    isValidating: false
  });
  var setState = useCallback(function(payload) {
    var shouldRerender = false;
    var currentState = stateRef.current;
    for (var _ in payload) {
      var k = _;
      if (currentState[k] !== payload[k]) {
        currentState[k] = payload[k];
        if (stateDependenciesRef.current[k]) {
          shouldRerender = true;
        }
      }
    }
    if (shouldRerender && !unmountedRef.current) {
      rerender({});
    }
  }, []);
  useIsomorphicLayoutEffect(function() {
    stateRef.current = state;
  });
  return [stateRef, stateDependenciesRef.current, setState];
};
var normalize = function(args) {
  return isFunction(args[1]) ? [args[0], args[1], args[2] || {}] : [args[0], null, (args[1] === null ? args[2] : args[1]) || {}];
};
var useSWRConfig = function() {
  return mergeObjects(defaultConfig, useContext2(SWRConfigContext));
};
var withArgs = function(hook) {
  return function useSWRArgs() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var fallbackConfig = useSWRConfig();
    var _a2 = normalize(args), key = _a2[0], fn = _a2[1], _config = _a2[2];
    var config = mergeConfigs(fallbackConfig, _config);
    var next = hook;
    var use = config.use;
    if (use) {
      for (var i = use.length; i-- > 0; ) {
        next = use[i](next);
      }
    }
    return next(key, fn || config.fetcher, config);
  };
};
var subscribeCallback = function(key, callbacks, callback) {
  var keyedRevalidators = callbacks[key] || (callbacks[key] = []);
  keyedRevalidators.push(callback);
  return function() {
    var index = keyedRevalidators.indexOf(callback);
    if (index >= 0) {
      keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
      keyedRevalidators.pop();
    }
  };
};
var WITH_DEDUPE = { dedupe: true };
var useSWRHandler = function(_key, fetcher2, config) {
  var cache2 = config.cache, compare = config.compare, fallbackData = config.fallbackData, suspense = config.suspense, revalidateOnMount = config.revalidateOnMount, refreshInterval = config.refreshInterval, refreshWhenHidden = config.refreshWhenHidden, refreshWhenOffline = config.refreshWhenOffline;
  var _a2 = SWRGlobalState.get(cache2), EVENT_REVALIDATORS = _a2[0], STATE_UPDATERS = _a2[1], MUTATION = _a2[2], FETCH = _a2[3];
  var _b = serialize(_key), key = _b[0], fnArgs = _b[1], keyInfo = _b[2];
  var initialMountedRef = useRef(false);
  var unmountedRef = useRef(false);
  var keyRef = useRef(key);
  var fetcherRef = useRef(fetcher2);
  var configRef = useRef(config);
  var getConfig = function() {
    return configRef.current;
  };
  var isActive = function() {
    return getConfig().isVisible() && getConfig().isOnline();
  };
  var patchFetchInfo = function(info2) {
    return cache2.set(keyInfo, mergeObjects(cache2.get(keyInfo), info2));
  };
  var cached = cache2.get(key);
  var fallback = isUndefined(fallbackData) ? config.fallback[key] : fallbackData;
  var data = isUndefined(cached) ? fallback : cached;
  var info = cache2.get(keyInfo) || {};
  var error = info.error;
  var isInitialMount = !initialMountedRef.current;
  var shouldRevalidate = function() {
    if (isInitialMount && !isUndefined(revalidateOnMount))
      return revalidateOnMount;
    if (getConfig().isPaused())
      return false;
    if (suspense)
      return isUndefined(data) ? false : config.revalidateIfStale;
    return isUndefined(data) || config.revalidateIfStale;
  };
  var resolveValidating = function() {
    if (!key || !fetcher2)
      return false;
    if (info.isValidating)
      return true;
    return isInitialMount && shouldRevalidate();
  };
  var isValidating = resolveValidating();
  var _c = useStateWithDeps({
    data,
    error,
    isValidating
  }, unmountedRef), stateRef = _c[0], stateDependencies = _c[1], setState = _c[2];
  var revalidate = useCallback(function(revalidateOpts) {
    return __awaiter(void 0, void 0, void 0, function() {
      var currentFetcher, newData, startAt, loading, opts, shouldStartNewRequest, isCurrentKeyMounted, cleanupState, newState, finishRequestAndUpdateState, mutationInfo, err_1;
      var _a3;
      return __generator(this, function(_b2) {
        switch (_b2.label) {
          case 0:
            currentFetcher = fetcherRef.current;
            if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) {
              return [2, false];
            }
            loading = true;
            opts = revalidateOpts || {};
            shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
            isCurrentKeyMounted = function() {
              return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            };
            cleanupState = function() {
              var requestInfo = FETCH[key];
              if (requestInfo && requestInfo[1] === startAt) {
                delete FETCH[key];
              }
            };
            newState = { isValidating: false };
            finishRequestAndUpdateState = function() {
              patchFetchInfo({ isValidating: false });
              if (isCurrentKeyMounted()) {
                setState(newState);
              }
            };
            patchFetchInfo({
              isValidating: true
            });
            setState({ isValidating: true });
            _b2.label = 1;
          case 1:
            _b2.trys.push([1, 3, , 4]);
            if (shouldStartNewRequest) {
              broadcastState(cache2, key, stateRef.current.data, stateRef.current.error, true);
              if (config.loadingTimeout && !cache2.get(key)) {
                setTimeout(function() {
                  if (loading && isCurrentKeyMounted()) {
                    getConfig().onLoadingSlow(key, config);
                  }
                }, config.loadingTimeout);
              }
              FETCH[key] = [currentFetcher.apply(void 0, fnArgs), getTimestamp()];
            }
            _a3 = FETCH[key], newData = _a3[0], startAt = _a3[1];
            return [4, newData];
          case 2:
            newData = _b2.sent();
            if (shouldStartNewRequest) {
              setTimeout(cleanupState, config.dedupingInterval);
            }
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
              if (shouldStartNewRequest) {
                if (isCurrentKeyMounted()) {
                  getConfig().onDiscarded(key);
                }
              }
              return [2, false];
            }
            patchFetchInfo({
              error: UNDEFINED
            });
            newState.error = UNDEFINED;
            mutationInfo = MUTATION[key];
            if (!isUndefined(mutationInfo) && (startAt <= mutationInfo[0] || startAt <= mutationInfo[1] || mutationInfo[1] === 0)) {
              finishRequestAndUpdateState();
              if (shouldStartNewRequest) {
                if (isCurrentKeyMounted()) {
                  getConfig().onDiscarded(key);
                }
              }
              return [2, false];
            }
            if (!compare(stateRef.current.data, newData)) {
              newState.data = newData;
            } else {
              newState.data = stateRef.current.data;
            }
            if (!compare(cache2.get(key), newData)) {
              cache2.set(key, newData);
            }
            if (shouldStartNewRequest) {
              if (isCurrentKeyMounted()) {
                getConfig().onSuccess(newData, key, config);
              }
            }
            return [3, 4];
          case 3:
            err_1 = _b2.sent();
            cleanupState();
            if (!getConfig().isPaused()) {
              patchFetchInfo({ error: err_1 });
              newState.error = err_1;
              if (shouldStartNewRequest && isCurrentKeyMounted()) {
                getConfig().onError(err_1, key, config);
                if (typeof config.shouldRetryOnError === "boolean" && config.shouldRetryOnError || isFunction(config.shouldRetryOnError) && config.shouldRetryOnError(err_1)) {
                  if (isActive()) {
                    getConfig().onErrorRetry(err_1, key, config, revalidate, {
                      retryCount: (opts.retryCount || 0) + 1,
                      dedupe: true
                    });
                  }
                }
              }
            }
            return [3, 4];
          case 4:
            loading = false;
            finishRequestAndUpdateState();
            if (isCurrentKeyMounted() && shouldStartNewRequest) {
              broadcastState(cache2, key, newState.data, newState.error, false);
            }
            return [2, true];
        }
      });
    });
  }, [key]);
  var boundMutate = useCallback(internalMutate.bind(UNDEFINED, cache2, function() {
    return keyRef.current;
  }), []);
  useIsomorphicLayoutEffect(function() {
    fetcherRef.current = fetcher2;
    configRef.current = config;
  });
  useIsomorphicLayoutEffect(function() {
    if (!key)
      return;
    var keyChanged = key !== keyRef.current;
    var softRevalidate = revalidate.bind(UNDEFINED, WITH_DEDUPE);
    var onStateUpdate = function(updatedData, updatedError, updatedIsValidating) {
      setState(mergeObjects({
        error: updatedError,
        isValidating: updatedIsValidating
      }, compare(stateRef.current.data, updatedData) ? UNDEFINED : {
        data: updatedData
      }));
    };
    var nextFocusRevalidatedAt = 0;
    var onRevalidate = function(type) {
      if (type == FOCUS_EVENT) {
        var now = Date.now();
        if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
          nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
          softRevalidate();
        }
      } else if (type == RECONNECT_EVENT) {
        if (getConfig().revalidateOnReconnect && isActive()) {
          softRevalidate();
        }
      } else if (type == MUTATE_EVENT) {
        return revalidate();
      }
      return;
    };
    var unsubUpdate = subscribeCallback(key, STATE_UPDATERS, onStateUpdate);
    var unsubEvents = subscribeCallback(key, EVENT_REVALIDATORS, onRevalidate);
    unmountedRef.current = false;
    keyRef.current = key;
    initialMountedRef.current = true;
    if (keyChanged) {
      setState({
        data,
        error,
        isValidating
      });
    }
    if (shouldRevalidate()) {
      if (isUndefined(data) || IS_SERVER) {
        softRevalidate();
      } else {
        rAF(softRevalidate);
      }
    }
    return function() {
      unmountedRef.current = true;
      unsubUpdate();
      unsubEvents();
    };
  }, [key, revalidate]);
  useIsomorphicLayoutEffect(function() {
    var timer;
    function next() {
      var interval = isFunction(refreshInterval) ? refreshInterval(data) : refreshInterval;
      if (interval && timer !== -1) {
        timer = setTimeout(execute, interval);
      }
    }
    function execute() {
      if (!stateRef.current.error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) {
        revalidate(WITH_DEDUPE).then(next);
      } else {
        next();
      }
    }
    next();
    return function() {
      if (timer) {
        clearTimeout(timer);
        timer = -1;
      }
    };
  }, [refreshInterval, refreshWhenHidden, refreshWhenOffline, revalidate]);
  useDebugValue(data);
  if (suspense && isUndefined(data) && key) {
    fetcherRef.current = fetcher2;
    configRef.current = config;
    unmountedRef.current = false;
    throw isUndefined(error) ? revalidate(WITH_DEDUPE) : error;
  }
  return {
    mutate: boundMutate,
    get data() {
      stateDependencies.data = true;
      return data;
    },
    get error() {
      stateDependencies.error = true;
      return error;
    },
    get isValidating() {
      stateDependencies.isValidating = true;
      return isValidating;
    }
  };
};
var SWRConfig = OBJECT.defineProperty(SWRConfig$1, "default", {
  value: defaultConfig
});
var useSWR = withArgs(useSWRHandler);

// src/hooks/useFetch/index.js
function useFetch(url, token) {
  const { data, error } = useSWR(url ? [url, token] : null, fetcher);
  return {
    data,
    error,
    isLoading: !error && !data
  };
}

// src/fluxos/fechar-vaga/steps/step1/step1.style.js
import styled4 from "@emotion/styled";
var BtnWrapper = styled4.div`
  display: flex;
  flex-direction: column;
  padding: 40px 16px;

  button {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
var StyledIcon = styled4.div`
  background: ${(props) => props.success ? "#D1FADF" : "#FEF0C7"};
  border: 8px solid ${(props) => props.success ? "#ECFDF3" : "#FFFAEB"};
  border-radius: 100%;

  margin-top: 24px;
  margin-bottom: 8px;

  box-icon {
    width: 28px;
    height: 28px;
    position: absolute;
    top: 10px;
    left: 10px;
  }

  width: 48px;
  height: 48px;
  position: relative;
`;
var TextWrapper = styled4.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  span {
    margin-bottom: 8px;
  }
  .info-text {
    color: #373737;
  }
`;

// src/fluxos/fechar-vaga/steps/step1/step1.component.js
var Step1 = () => {
  const {
    setModalContent,
    vagaId,
    env,
    token,
    onClose,
    showToast,
    setIsModalOpen
  } = useStepsContext();
  const { CLOSE_PROCESS, VACANCY_DATA } = useUrls(vagaId, env);
  const [loading, setLoading] = useState2(true);
  const [openPositions, setOpenPositions] = useState2();
  const [closedPositions, setClosedPositions] = useState2();
  const [shouldShowFeedbackButton, setShouldShowFeedbackButton] = useState2(false);
  const intl = useIntl();
  const [permiteFeedback, setPermiteFeedback] = useState2(false);
  useEffect2(() => {
    setLoading(true);
  }, []);
  const closeProcess = async () => {
    setLoading(true);
    const body = closedPositions === 0 ? { fechamento_com_candidatos_internos: false } : { fechamento_com_candidatos_internos: true };
    try {
      const response = await fetcher(CLOSE_PROCESS, token, "POST", body);
      if (response?.error) {
        showToast("error", intl);
        setLoading(false);
      } else {
        setLoading(false);
        onClose(true);
        setIsModalOpen(false);
      }
    } catch (error2) {
      setLoading(false);
      console.error(error2);
      showToast("error", intl);
    }
  };
  const { data, error } = useFetch(VACANCY_DATA, token);
  useEffect2(() => {
    if (data && !error) {
      setOpenPositions(data?.posicoes?.abertas);
      setClosedPositions(data?.posicoes?.fechadas);
      setShouldShowFeedbackButton(data.total_candidatos - data.posicoes?.fechadas > 0 && !data.situacoes.includes("feedback-enviado"));
      setLoading(false);
      setPermiteFeedback(data.permite_feedback);
    }
  }, [data, error]);
  return /* @__PURE__ */ React6.createElement(Wrapper, null, openPositions === 0 ? /* @__PURE__ */ React6.createElement(React6.Fragment, null, /* @__PURE__ */ React6.createElement(StyledIcon, {
    success: true
  }, /* @__PURE__ */ React6.createElement("box-icon", {
    name: "check-circle",
    color: "#039855"
  })), /* @__PURE__ */ React6.createElement(TextWrapper, null, /* @__PURE__ */ React6.createElement(Text2, {
    size: "lg",
    weight: 400
  }, /* @__PURE__ */ React6.createElement(FormattedMessage3, {
    id: "step1.confirmar-fechamento",
    defaultMessage: "Deseja mesmo fechar essa vaga?"
  })), /* @__PURE__ */ React6.createElement(Text2, {
    size: "sm",
    className: "info-text",
    style: { maxWidth: "560px" }
  }, /* @__PURE__ */ React6.createElement(FormattedMessage3, {
    id: "step1.info-fechar-vaga",
    defaultMessage: "Esse processo seletivo n\xE3o receber\xE1 mais novas candidaturas.{br}Voc\xEA ainda poder\xE1 acessar as informa\xE7\xF5es dos candidatos no painel da vaga a qualquer momento.{br}{br}Para visualizar os aprovados, acesse a sess\xE3o de Relat\xF3rios desse processo seletivo.",
    values: { br: /* @__PURE__ */ React6.createElement("br", null) }
  }))), /* @__PURE__ */ React6.createElement(Footer, {
    center: true,
    fluxo: "fechar-vaga",
    idAux: "btn_nao_informar_aprovados",
    idSuccess: "btn_informar_aprovados",
    labelAux: /* @__PURE__ */ React6.createElement(FormattedMessage3, {
      id: "btn.fechar-vaga-cancelar",
      defaultMessage: "Cancelar"
    }),
    labelFeedback: shouldShowFeedbackButton ? /* @__PURE__ */ React6.createElement(FormattedMessage3, {
      id: "btn.enviar-feedback",
      defaultMessage: "Enviar feedback"
    }) : null,
    nextStep: {
      fluxo: "enviar-feedback",
      step: "step1",
      origin: "fechar-vaga"
    },
    labelSuccess: /* @__PURE__ */ React6.createElement(FormattedMessage3, {
      id: "btn.fechar-vaga",
      defaultMessage: "Fechar vaga"
    }),
    stepToback: { fluxo: "marcar-aprovados", step: "step2" },
    functionSuccess: closeProcess,
    functionAux: () => setIsModalOpen(false),
    permiteFeedback,
    exibirMsgErroFeedback: () => {
      showToast("infoVagaNaoPermiteFeedback", intl);
    }
  })) : /* @__PURE__ */ React6.createElement(React6.Fragment, null, /* @__PURE__ */ React6.createElement(StyledIcon, {
    warning: true
  }, /* @__PURE__ */ React6.createElement("box-icon", {
    name: "error",
    color: "#DC6803"
  })), /* @__PURE__ */ React6.createElement(TextWrapper, null, /* @__PURE__ */ React6.createElement(Text2, {
    size: "lg",
    weight: 400
  }, /* @__PURE__ */ React6.createElement(FormattedMessage3, {
    id: "step1.aviso-posicoes",
    defaultMessage: "Voc\xEA ainda tem posi\xE7\xF5es em aberto!"
  })), /* @__PURE__ */ React6.createElement(Text2, {
    className: "info-text"
  }, /* @__PURE__ */ React6.createElement(FormattedMessage3, {
    id: "step1.confirmar-fechar-vaga",
    defaultMessage: "Deseja realmente fechar a vaga?"
  }))), /* @__PURE__ */ React6.createElement(Footer, {
    center: true,
    idAux: "btn_fechar_vaga",
    idFeedback: "btn_feedback",
    idSuccess: "btn_informar_aprovados",
    labelAux: /* @__PURE__ */ React6.createElement(FormattedMessage3, {
      id: "btn.fechar-vaga",
      defaultMessage: "Fechar vaga"
    }),
    labelFeedback: shouldShowFeedbackButton ? /* @__PURE__ */ React6.createElement(FormattedMessage3, {
      id: "btn.enviar-feedback",
      defaultMessage: "Enviar feedback"
    }) : null,
    nextStep: {
      fluxo: "enviar-feedback",
      step: "step1",
      origin: "fechar-vaga"
    },
    labelSuccess: /* @__PURE__ */ React6.createElement(FormattedMessage3, {
      id: "btn.marcar-aprovados",
      defaultMessage: "Marcar Aprovados"
    }),
    functionSuccess: () => {
      setModalContent({
        fluxo: "marcar-aprovados",
        step: "step1",
        origin: "fechar-vaga"
      });
    },
    functionAux: closeProcess,
    permiteFeedback,
    exibirMsgErroFeedback: () => {
      showToast("infoVagaNaoPermiteFeedback", intl);
    }
  })), loading && /* @__PURE__ */ React6.createElement(Loader, {
    opaque: true,
    id: "loader.mensagem-loading-generica",
    defaultMessage: "Aguarde, estamos carregando o conte\xFAdo"
  }));
};

// src/fluxos/enviar-feedback/steps/step1.component.js
import React9, { useState as useState3, useRef as useRef2, useEffect as useEffect3 } from "react";
import { Text as Text3 } from "@vagastec/ensemble-core";
import { defineMessage, FormattedMessage as FormattedMessage4, useIntl as useIntl2 } from "react-intl";

// src/rich-editor/rich-editor.component.js
var import_quill = __toModule(require_quill());
import React7 from "react";

// src/rich-editor/rich-editor.style.js
import styled5 from "@emotion/styled";
var Container = styled5.div`
  font-family: "Open Sans", sans-serif;

  button {
    margin: 0 2px;
  }

  .ql-clipboard {
    height: 1px;
    left: -100000px;
    overflow-y: hidden;
    position: absolute;
    top: 50%;
  }

  .ql-clipboard p {
    margin: 0;
    padding: 0;
  }

  .ql-toolbar {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
  }

  .ql-container {
    height: 200px;
  }

  .ql-editor {
    font: inherit;
    font-family: inherit;
    font-size: 14px;
    line-height: 1.6em;
    outline: none;
    overflow: auto;
    padding: 16px;
    position: absolute;
    width: 100%;
    white-space: pre-wrap;
  }

  .ql-editor :first-of-type {
    margin-top: 0;
  }

  .ql-editor :last-of-type {
    margin-bottom: 0;
  }

  .ql-editor img {
    max-width: 100%;
  }

  .ql-active {
    border-radius: 2px;
  }

  .ql-snow.ql-toolbar button.ql-active .ql-stroke {
    stroke: rgb(247, 144, 42);
  }

  .ql-snow.ql-toolbar button:hover .ql-stroke,
  .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,
  .ql-snow.ql-toolbar button.ql-active .ql-stroke,
  .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke {
    stroke: rgb(247, 144, 42);
  }

  .ql-toolbar.ql-snow .ql-picker-label:hover,
  .ql-snow.ql-toolbar .ql-picker-item:hover,
  .ql-snow.ql-toolbar .ql-picker-label.ql-active {
    color: rgb(247, 144, 42);
  }

  .ql-toolbar.ql-snow {
    border: 1px solid #ededed;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }

  .ql-container.ql-snow {
    border: 1px solid #ededed;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    height: 284px;
  }

  .ql-custom .ql-picker-item:before {
    content: attr(data-label);
  }
  .ql-custom .ql-picker-label:before {
    content: attr(data-content);
    min-width: 98px;
  }

  .ql-tooltip,
  .ql-editing,
  .ql-flip {
    left: 260px !important;
    top: 60px !important;
  }
`;
var RichEditorWrapper = styled5.div`
  font-family: "Open Sans", sans-serif;
  position: relative;
  margin-top: 8px;
  width: 100%;
`;
var Divisor = styled5.div`
  display: inline-block;
  content: "";
  width: 1px;
  height: 24px;
  background-color: #ededed;
  margin: 0 4px;
`;

// src/rich-editor/rich-editor.component.js
var RichEditor = React7.forwardRef(({
  initialValue,
  onChange = Function,
  variables = {},
  textLevels = {},
  testId,
  feedback
}, ref) => {
  const toolbarRef = React7.useRef();
  const quillRef = React7.useRef();
  const [hasFocus, setHasFocus] = React7.useState(false);
  React7.useEffect(() => {
    quillRef.current = new import_quill.default(ref.current, {
      theme: "snow",
      modules: {
        toolbar: {
          container: toolbarRef.current,
          handlers: {
            custom: variablesChange
          }
        }
      }
    });
    function variablesChange(value) {
      quillRef.current.focus();
      const range = quillRef.current.getSelection();
      quillRef.current.insertText(range.index, value);
      onChange(ref.current.firstChild.innerHTML);
    }
    let labelVariable = document.querySelector(".ql-custom span");
    labelVariable.dataset.content = variables.defaultOption;
    const quill = quillRef.current;
    delete quill.getModule("keyboard").bindings["9"];
    const editor = ref.current.firstChild;
    editor.setAttribute("data-testid", testId);
    quill.on("selection-change", () => {
      setHasFocus(quill.hasFocus());
    });
    const updateState = (delta, oldDelta, source) => {
      if (source !== "user")
        return;
      onChange(ref.current.firstChild.innerHTML);
    };
    quill.on("text-change", updateState);
    return () => {
      quill.off("text-change", updateState);
    };
  }, []);
  React7.useEffect(() => {
    if (initialValue === ref.current.firstChild.innerHTML)
      return;
    if (initialValue === void 0)
      initialValue = feedback;
    quillRef.current.setContents([]);
    quillRef.current.clipboard.dangerouslyPasteHTML(0, initialValue);
  }, [initialValue]);
  return /* @__PURE__ */ React7.createElement(RichEditorWrapper, null, /* @__PURE__ */ React7.createElement(Container, {
    className: "ql-container"
  }, /* @__PURE__ */ React7.createElement("div", {
    ref: toolbarRef
  }, /* @__PURE__ */ React7.createElement("select", {
    className: "ql-header",
    defaultValue: "false",
    hidden: hasFocus
  }, /* @__PURE__ */ React7.createElement("option", {
    value: "false"
  }, textLevels.normal), /* @__PURE__ */ React7.createElement("option", {
    value: "1"
  }, textLevels.heading1), /* @__PURE__ */ React7.createElement("option", {
    value: "2"
  }, textLevels.heading2)), /* @__PURE__ */ React7.createElement(Divisor, null), /* @__PURE__ */ React7.createElement("button", {
    type: "button",
    className: "ql-bold"
  }), /* @__PURE__ */ React7.createElement("button", {
    type: "button",
    className: "ql-italic"
  }), /* @__PURE__ */ React7.createElement(Divisor, null), /* @__PURE__ */ React7.createElement("button", {
    type: "button",
    className: "ql-list",
    value: "ordered"
  }), /* @__PURE__ */ React7.createElement("button", {
    type: "button",
    className: "ql-list",
    value: "bullet"
  }), /* @__PURE__ */ React7.createElement(Divisor, null), /* @__PURE__ */ React7.createElement("button", {
    type: "button",
    className: "ql-link"
  }), /* @__PURE__ */ React7.createElement(Divisor, null), variables.options.length && /* @__PURE__ */ React7.createElement("select", {
    className: "ql-custom"
  }, variables.options.map((variable) => /* @__PURE__ */ React7.createElement("option", {
    key: variable,
    value: variable
  }, variable)))), /* @__PURE__ */ React7.createElement("div", {
    ref
  })));
});
RichEditor.displayName = "RichEditor";

// src/select/select-input.component.js
import React8 from "react";

// src/select/select-input.style.js
import styled6 from "@emotion/styled";
var Select = styled6.select`
  appearance: none;
  background: url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.9987 5.33333L9.66536 0H0.332031L4.9987 5.33333Z' fill='%23373737'/%3E%3C/svg%3E%0A")
    no-repeat;
  background-position: center right 0.5rem;
  border: 1px solid #ededed;
  border-radius: 6px;
  cursor: ${(props) => props.disabled ? "not-allowed" : "auto"};
  font-size: 14px;
  padding: 8px;
  width: 100%;
`;

// src/select/select-input.component.js
var SelectInput = ({ children, ...props }) => {
  return /* @__PURE__ */ React8.createElement(Select, {
    ...props
  }, children);
};

// src/fluxos/enviar-feedback/steps/step1.style.js
import styled7 from "@emotion/styled";
var FeedbackWrapper = styled7.div`
  width: 646px;
`;
var TextWrapper2 = styled7.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 24px;

  h2:first-of-type {
    margin-bottom: 16px;
  }

  span:first-of-type {
    margin-bottom: 8px;
    text-align: center;
  }
`;
var SelectWrapper = styled7.div`
  display: inline-block;
  width: 100%;

  select {
    margin-top: 8px;
  }
`;

// src/fluxos/marcar-aprovados/steps/step1/step1.style.js
import styled8 from "@emotion/styled";
var SearchWrapper = styled8.div`
  text-align: center;

  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 24px;
  width: 502px;

  span {
    &:not(:last-of-type) {
      margin-bottom: 14px;
    }
  }

  .info-text {
    color: #373737;
  }

  [data-icon="svg-icon-loader"] {
    margin-top: 44px;
  }
`;
var Search = styled8.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 8px;
  position: relative;
  width: 100%;

  [data-icon="box-icon"] {
    position: absolute;
    right: 16px;
    top: 8px;
  }

  input {
    background-color: #fff;
    border: 1px solid #edeced;
    border-radius: 5px;
    font-size: 16px;
    padding: 4px 16px;
    height: 30px;
    width: 100%;
  }

  input:disabled {
    background: #f9fafb;
    cursor: not-allowed;
  }
`;
var CandidatesList = styled8.ul`
  text-align: left;
  max-height: 200px;
  margin: 0px;
  margin-top: 32px;
  padding: 0px;
  overflow-y: auto;
  width: 100%;

  li:first-of-type {
    margin-top: 8px;
  }
`;
var CandidatesListItem = styled8.li`
  align-items: center;
  background-color: #f9fafb;
  border-radius: 4px;
  color: #797979;
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
  padding: 8px;

  div {
    align-items: center;
    display: inherit;

    label {
      margin-left: 8px;
    }
  }

  button {
    display: flex;
    background: none;
    border: none;
    cursor: pointer;
  }
`;
var FilteredList = styled8.ul`
  background: white;
  color: black;
  cursor: pointer;
  list-style: none;
  margin: 0;
  margin-top: 8px;
  border-radius: 6px;
  max-height: 88px;
  overflow-y: auto;
  padding: 0;
  width: 100%;
  box-shadow: 0px 1px 3px rgba(55, 55, 55, 0.2);

  li {
    padding-top: 10px;
    text-align: initial;
    height: 32px;

    label {
      cursor: pointer;
      margin-left: 16px;
    }

    &:after {
      content: "";
      display: inline-block;
      height: 1px;
      width: 100%;
    }

    &:hover {
      background-color: #f2f2f2;
      color: #f7902a;
    }
  }
`;
var ErrorWrapper = styled8.div`
  display: inline-flex;
  align-self: flex-start;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 8px;
  margin-top: 28px;
`;
var Alert = styled8.div`
  align-items: start;
  background-color: ${(props) => props.backgroundColor ?? "#fffafa"};
  border: 1px solid ${(props) => props.borderColor ?? "#fda29b"};
  border-radius: 8px;
  color: ${(props) => props.textColor ?? "#d92d20"};
  display: flex;
  flex-direction: column;
  font-size: 14px;
  padding: 16px;
  text-align: left;

  div {
    display: flex;
    align-items: center;
  }

  span {
    margin-left: 32px;
  }

  [data-icon] {
    height: 24;
    margin-bottom: 0;
    margin-right: 8px;
    width: 24;
  }
`;

// src/fluxos/enviar-feedback/steps/step1.component.js
var Step12 = ({ origin }) => {
  const {
    setStepsVariations,
    stepsVariations,
    userPermissions,
    vagaId,
    toasts,
    showToast,
    token,
    env,
    setIsModalOpen,
    onClose,
    vacancyData
  } = useStepsContext();
  const [defaultMessages, setDefaultMessages] = useState3([]);
  const [disableSelect, setDisableSelect] = useState3(true);
  const intl = useIntl2();
  const emailMessageRef = useRef2();
  const { EMAIL_TEMPLATE, FEEDBACK, CLOSE_PROCESS } = useUrls(vagaId, env);
  const { data, error } = useFetch(EMAIL_TEMPLATE, token);
  const [loading, setLoading] = useState3(false);
  const [closedPositions, setClosedPositions] = useState3();
  const [candidatesCounter, setCandidatesCounter] = useState3(0);
  const [placeholder, setPlaceholder] = useState3(intl.formatMessage(defineMessage({
    id: "step1.mensagens-padrao",
    defaultMessage: "Mensagens padr\xE3o"
  })));
  const [permiteFeedback, setPermiteFeedback] = useState3(false);
  useEffect3(() => {
    if (vacancyData && !vacancyData.error) {
      setClosedPositions(vacancyData?.posicoes?.fechadas);
      setCandidatesCounter(vacancyData?.total_candidatos - vacancyData?.posicoes?.fechadas);
      setPermiteFeedback(vacancyData.permite_feedback);
    }
  }, [vacancyData]);
  const closeProcess = async () => {
    setLoading(true);
    const body = closedPositions === 0 ? { fechamento_com_candidatos_internos: false } : { fechamento_com_candidatos_internos: true };
    try {
      const response = await fetcher(CLOSE_PROCESS, token, "POST", body);
      if (response?.error) {
        showToast("error", intl);
        setLoading(false);
      } else {
        setLoading(false);
        onClose(true);
        setIsModalOpen(false);
      }
    } catch (error2) {
      setLoading(false);
      console.error(error2);
      showToast("error", intl);
    }
  };
  const feedback = intl.formatMessage(defineMessage({
    id: "step1.feedback",
    defaultMessage: "<p>Ol\xE1 <strong>{candidato_nome}</strong></p> <p>Agradecemos sua participa\xE7\xE3o no processo seletivo.<br />Ap\xF3s uma avalia\xE7\xE3o cuidadosa, neste processo, <strong>n\xE3o foi poss\xEDvel aproveitar seu perfil</strong>, mas n\xE3o desanime!</p><p>Agora voc\xEA faz parte do nosso banco de talentos e podemos considerar sua experi\xEAncia em futuras oportunidades.<br />Mantenha seu curr\xEDculo atualizado para aumentar suas chances!</p><p><strong>Desejamos sucesso na sua carreira!</strong></p><br /><p>Atenciosamente,</p>"
  }), {
    p: (...chunks) => `<p>${chunks.join("")}</p>`,
    strong: (...chunks) => `<strong>${chunks.join("")}</strong>`,
    br: /* @__PURE__ */ React9.createElement("br", null),
    candidato_nome: "{{candidato_nome}}"
  });
  const [message, setMessage] = useState3(feedback);
  const variables = {
    defaultOption: intl.formatMessage(defineMessage({
      id: "step1.variaveis",
      defaultMessage: "Vari\xE1veis"
    })),
    options: vagaId ? [
      "{{candidato_nome}}",
      "{{vaga_codigo}}",
      "{{vaga_cargo}}",
      "{{vaga_link}}"
    ] : ["{{candidato_nome}}"]
  };
  const textLevels = {
    normal: intl.formatMessage(defineMessage({
      id: "editor.texto-normal",
      defaultMessage: "Normal"
    })),
    heading1: intl.formatMessage(defineMessage({
      id: "editor.titulo1",
      defaultMessage: "T\xEDtulo 1"
    })),
    heading2: intl.formatMessage(defineMessage({
      id: "editor.titulo2",
      defaultMessage: "T\xEDtulo 2"
    }))
  };
  const sendMessage = async (action) => {
    setStepsVariations({
      ...stepsVariations,
      step2: action
    });
    if (action === "send") {
      try {
        if (message === "<p></p>" || message === "<p><br></p>") {
          emailMessageRef.current.firstChild.focus();
          if (toasts.length === 0) {
            showToast("message", intl);
          }
          return;
        }
        setLoading(true);
        const response = await fetcher(FEEDBACK, token, "POST", {
          mensagem: message ? message : feedback
        });
        if (response?.id) {
          if (origin === "fechar-vaga") {
            closeProcess();
          }
          if (origin === "marcar-aprovados" || origin === "posicoes-fechadas") {
            onClose();
            setLoading(false);
            setIsModalOpen(false);
          }
        }
        if (response?.error) {
          if (toasts.length === 0) {
            setLoading(false);
            showToast("error", intl);
          }
          return;
        }
      } catch (error2) {
        console.error(error2);
        showToast("error", intl);
      }
    }
  };
  useEffect3(() => {
    if (data?.mensagens_padrao.length === 0 && userPermissions?.dir_mensagem_padrao === 2) {
      setPlaceholder(intl.formatMessage(defineMessage({
        id: "step1.mensagens-padrao-sem-mensagem",
        defaultMessage: "N\xE3o h\xE1 mensagens padr\xE3o em sua empresa"
      })));
    }
    if (data?.mensagens_padrao.length === 0 && userPermissions?.dir_mensagem_padrao === 1) {
      setPlaceholder(intl.formatMessage(defineMessage({
        id: "step1.mensagens-padrao-sem-mensagem-divisao",
        defaultMessage: "N\xE3o h\xE1 mensagens padr\xE3o em sua divis\xE3o"
      })));
    }
    if (data?.mensagens_padrao.length > 0 && userPermissions?.dir_mensagem_padrao > 0) {
      setDefaultMessages(data?.mensagens_padrao);
      setDisableSelect(!disableSelect);
    }
    if (data?.mensagens_padrao.length > 0 && userPermissions?.dir_mensagem_padrao === 0) {
      setPlaceholder(intl.formatMessage(defineMessage({
        id: "step1.mensagens-padrao-aviso",
        defaultMessage: "Voc\xEA n\xE3o possui permiss\xE3o para visualizar as mensagens padr\xE3o"
      })));
    }
    if (error) {
      console.error(error);
      setPlaceholder(intl.formatMessage(defineMessage({
        id: "step1.mensagens-padrao-erro",
        defaultMessage: "N\xE3o foi poss\xEDvel carregar as mensagens padr\xE3o"
      })));
    }
  }, [data, error, userPermissions]);
  return /* @__PURE__ */ React9.createElement(React9.Fragment, null, /* @__PURE__ */ React9.createElement(Wrapper, null, /* @__PURE__ */ React9.createElement(FeedbackWrapper, null, /* @__PURE__ */ React9.createElement(TextWrapper2, null, /* @__PURE__ */ React9.createElement(Text3, {
    size: "lg",
    weight: 400,
    as: "h2"
  }, /* @__PURE__ */ React9.createElement(FormattedMessage4, {
    id: "step1.envie-mensagem",
    defaultMessage: "Feedback de elimina\xE7\xE3o"
  })), /* @__PURE__ */ React9.createElement(Text3, {
    size: "sm",
    weight: 400,
    fontColor: "#373737"
  }, origin === "fechar-vaga" ? /* @__PURE__ */ React9.createElement(FormattedMessage4, {
    id: "step1.mensagem-reprovados-fechar",
    defaultMessage: "Envie uma mensagem para os <b>candidatos n\xE3o selecionados</b>, avisando sobre o encerramento do processo seletivo",
    values: {
      b: (chunks) => /* @__PURE__ */ React9.createElement("strong", null, chunks),
      origin
    }
  }) : /* @__PURE__ */ React9.createElement(FormattedMessage4, {
    id: "step1.mensagem-reprovados",
    defaultMessage: "Envie uma mensagem para os <b>candidatos n\xE3o selecionados</b>",
    values: {
      b: (chunks) => /* @__PURE__ */ React9.createElement("strong", null, chunks),
      origin
    }
  }))), /* @__PURE__ */ React9.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: "32px"
    }
  }, /* @__PURE__ */ React9.createElement(Alert, {
    backgroundColor: "#FCFCFD",
    borderColor: "#D0D5DD",
    textColor: "#373737"
  }, /* @__PURE__ */ React9.createElement("div", {
    style: { gap: "3px", width: "fit-content" }
  }, /* @__PURE__ */ React9.createElement("box-icon", {
    name: "info-circle",
    color: "#475467",
    "data-icon": "svg-icon-atention"
  }), /* @__PURE__ */ React9.createElement(FormattedMessage4, {
    id: "step1.aviso-feedback",
    defaultMessage: "Esta mensagem ser\xE1 enviada para \n                <b>{candidatesCounter} candidatos n\xE3o selecionados.</b>",
    values: {
      b: (chunks) => /* @__PURE__ */ React9.createElement("strong", null, chunks),
      candidatesCounter
    }
  })))), /* @__PURE__ */ React9.createElement(SelectWrapper, null, /* @__PURE__ */ React9.createElement(Text3, {
    size: "sm",
    weight: 400,
    fontColor: "#373737"
  }, /* @__PURE__ */ React9.createElement(FormattedMessage4, {
    id: "step1.selecione-mensagem",
    defaultMessage: "Escolha uma mensagem"
  })), /* @__PURE__ */ React9.createElement(SelectInput, {
    "aria-required": "false",
    disabled: disableSelect,
    "data-testid": "select_mensagem_padrao",
    onChange: (e) => {
      setMessage(defaultMessages.find((v) => v.id === Number(e.target.value))?.conteudo);
    }
  }, [
    { id: 0, identificacao: placeholder, conteudo: message },
    ...defaultMessages
  ].map((item) => /* @__PURE__ */ React9.createElement("option", {
    key: item.id,
    value: item.id
  }, item.identificacao)))), /* @__PURE__ */ React9.createElement(RichEditor, {
    "data-testid": "rich_text_editor",
    initialValue: message,
    onChange: setMessage,
    textLevels,
    ref: emailMessageRef,
    variables,
    feedback,
    testId: "rich_text_editor"
  }), loading && /* @__PURE__ */ React9.createElement(Loader, null)), /* @__PURE__ */ React9.createElement(Footer, {
    center: true,
    fluxo: "fechar-vaga",
    idAux: "btn_cancelar_feedback",
    idSuccess: origin === "fechar-vaga" ? "btn_enviar_feedback_e_fechar" : "btn_enviar_feedback",
    labelSuccess: origin === "fechar-vaga" ? /* @__PURE__ */ React9.createElement(FormattedMessage4, {
      id: "btn.enviar-feedback-e-fechar",
      defaultMessage: "Enviar e fechar vaga"
    }) : /* @__PURE__ */ React9.createElement(FormattedMessage4, {
      id: "btn.enviar-feedback",
      defaultMessage: "Enviar feedback"
    }),
    labelAux: /* @__PURE__ */ React9.createElement(FormattedMessage4, {
      id: "btn.cancelar",
      defaultMessage: "Cancelar"
    }),
    functionSuccess: () => sendMessage("send"),
    functionAux: () => setIsModalOpen(false),
    permiteFeedback,
    exibirMsgErroFeedback: () => {
      showToast("infoVagaNaoPermiteFeedback", intl);
    }
  })));
};

// src/fluxos/marcar-aprovados/steps/step1/step1.component.js
import React11, { useState as useState5, createRef, useEffect as useEffect5 } from "react";
import { FormattedMessage as FormattedMessage5, useIntl as useIntl3, defineMessage as defineMessage3 } from "react-intl";

// src/fluxos/counter-label/counter-label.component.js
import React10, { forwardRef } from "react";

// src/fluxos/counter-label/counter-label.style.js
import styled9 from "@emotion/styled";
var CounterLabelWrapper = styled9.div`
  align-items: center;
  border-radius: 9999px;
  display: flex;
  font-family: sans-serif;
  font-size: 12px;
  height: auto;
  justify-content: start;
  max-width: fit-content;
  min-width: auto;
  padding: 4px;
  padding-right: 8px;

  span {
    align-items: center;
    background-color: #fff;
    border-radius: 9999px;
    box-sizing: border-box;
    display: flex;
    height: auto;
    padding: 2px;
  }

  p {
    margin: 0;
    margin-left: 8px;
  }
`;

// src/fluxos/counter-label/counter-label.component.js
var CounterLabel = forwardRef((props, ref) => {
  const { i18nOf, partial = 0, text, total = 10, ...rest } = props;
  const handleColorComponent = () => {
    if (!total && !partial) {
      return {
        backgroundColor: "rgb(249 250 251)",
        textColor: "rgb(55 65 81)"
      };
    }
    if (+partial >= +total) {
      return {
        backgroundColor: "rgb(236 253 243)",
        textColor: "rgb(2 122 72)"
      };
    }
    if (+partial < +total) {
      return {
        backgroundColor: "rgb(255 250 235)",
        textColor: "rgb(181 71 8)"
      };
    }
    return;
  };
  return /* @__PURE__ */ React10.createElement(CounterLabelWrapper, {
    "aria-label": ` ${partial}  ${i18nOf}  ${total} ${text}`,
    style: { background: handleColorComponent().backgroundColor },
    ...rest
  }, /* @__PURE__ */ React10.createElement("span", {
    ref,
    style: { color: handleColorComponent().textColor }
  }, partial ? `${partial} ` : " - ", i18nOf, " ", total ? total : " - "), /* @__PURE__ */ React10.createElement("p", {
    style: { color: handleColorComponent().textColor }
  }, text));
});
CounterLabel.displayName = "CounterLabel";

// src/fluxos/marcar-aprovados/steps/step1/step1.component.js
import "@vagastec/ensemble-core/dist/index.css";
import { Text as Text4 } from "@vagastec/ensemble-core";

// src/utils/helpers.js
import { useEffect as useEffect4, useState as useState4 } from "react";
import { defineMessage as defineMessage2 } from "react-intl";
function getCookie(key) {
  let cookie = document.cookie?.split("; ")?.find((v) => v.startsWith(key))?.split("=")[1];
  return cookie;
}
function setCookie(key, value, expirationDays = 1, domain) {
  const date = new Date();
  date.setTime(date.getTime() + expirationDays * 24 * 60 * 60 * 1e3);
  const expires = "expires=" + date.toUTCString();
  return document.cookie = `${key}=${value};${expires};path=/;domain=${domain};SameSite=Lax`;
}
var getWarnings = (type, onDismiss, intl) => {
  const timer = 5e3;
  const Messages = {
    message: {
      title: intl.formatMessage(defineMessage2({
        id: "toast.titulo-escreva-mensagem",
        defaultMessage: "Escreva uma mensagem"
      })),
      variant: "warning",
      body: intl.formatMessage(defineMessage2({
        id: "toast.texto-escreva-mensagem",
        defaultMessage: "O campo de mensagem n\xE3o pode estar vazio"
      })),
      timer,
      onDismiss
    },
    error: {
      title: intl.formatMessage(defineMessage2({
        id: "toast.titulo-erro",
        defaultMessage: "Ocorreu um erro inesperado"
      })),
      variant: "error",
      body: intl.formatMessage(defineMessage2({
        id: "toast.texto-erro",
        defaultMessage: "N\xE3o foi poss\xEDvel completar sua solicita\xE7\xE3o"
      })),
      timer,
      onDismiss
    },
    infoVagaNaoPermiteFeedback: {
      title: intl.formatMessage(defineMessage2({
        id: "toast.titulo-feedback",
        defaultMessage: "Erro!"
      })),
      variant: "error",
      body: intl.formatMessage(defineMessage2({
        id: "toast.texto-feedback",
        defaultMessage: "N\xE3o \xE9 permitido enviar feedback para vagas criadas h\xE1 mais de 6 meses."
      })),
      timer,
      onDismiss
    }
  };
  return Messages[type] ?? Messages["warning"];
};
function useDebouncer(value, delay = 1e3) {
  const [debouncedValue, setDebouncedValue] = useState4(value);
  useEffect4(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return debouncedValue;
}

// src/fluxos/marcar-aprovados/steps/step1/step1.component.js
var Step13 = ({ origin }) => {
  const {
    setModalContent,
    vagaId,
    token,
    env,
    setInformApproved,
    showToast,
    toasts,
    onAddApproved,
    vacancyData
  } = useStepsContext();
  const [active, setActive] = useState5(0);
  const [filtered, setFiltered] = useState5([]);
  const [isShow, setIsShow] = useState5(false);
  const [text, setText] = useState5("");
  const [list, setList] = useState5([]);
  const [openPositions, setOpenPositions] = useState5(null);
  const [permiteFeedback, setPermiteFeedback] = useState5(false);
  const inputRef = createRef();
  const debouncedText = useDebouncer(text);
  const { PROFESSIONALS, INFORM_APPROVED, APPROVED_LIST } = useUrls(vagaId, env);
  const approvedList = useFetch(APPROVED_LIST, token);
  useEffect5(() => {
    setOpenPositions(vacancyData?.posicoes?.total);
    setPermiteFeedback(vacancyData?.permite_feedback);
  }, [vacancyData]);
  useEffect5(() => {
    if (approvedList.data?.lista_aprovados) {
      const candidate = approvedList.data.lista_aprovados.map((n) => ({
        nome: n.nome,
        candidato_id: n.id
      }));
      setList(candidate);
    }
  }, [approvedList?.data]);
  useEffect5(() => {
    inputRef.current.focus();
  }, []);
  useEffect5(() => {
    onSuggest(debouncedText);
  }, [debouncedText]);
  const intl = useIntl3();
  const sendApproved = async (informApproved) => {
    if (informApproved) {
      setInformApproved(true);
      if (list.length) {
        let body = {
          contratados: []
        };
        list.forEach((l) => {
          body.contratados.push({ id: vagaId, candidato_id: l.candidato_id });
        });
        if (body.contratados.length) {
          try {
            const response = await fetcher(INFORM_APPROVED, token, "POST", body);
            if (response?.error) {
              showToast("error", intl);
            } else {
              onAddApproved(list.length);
              setModalContent({
                fluxo: "marcar-aprovados",
                step: "step2",
                origin: origin === "fechar-vaga" ? origin : openPositions === list.length || origin ? "posicoes-fechadas" : void 0
              });
            }
          } catch (err) {
            console.error(err);
            if (!toasts.length)
              showToast("error", intl);
          }
        }
      }
    }
  };
  const onSuggest = (text2) => {
    if (text2) {
      const url = `${PROFESSIONALS}=${text2}`;
      fetcher(url, token).then((res) => {
        const suggestions = res?.candidatos.reduce((acc, v) => {
          if (!isCandidateSelected(v.id, list)) {
            acc.push({ nome: v.nome, candidato_id: v.id });
          }
          return acc;
        }, []);
        setFiltered(suggestions);
        setActive(0);
      }).finally(() => setIsShow(true));
    } else {
      setFiltered([]);
    }
  };
  const isCandidateSelected = (id, candidateList) => {
    if (!candidateList.length)
      return false;
    if (candidateList.some((c) => c.candidato_id === id))
      return true;
    return false;
  };
  const updateList = (candidate) => {
    if (candidate !== void 0 && text !== "") {
      setList([...list, candidate]);
      setFiltered([]);
      setText("");
    }
  };
  const onKeyDown = (e) => {
    if (e.keyCode === 13) {
      setActive(0);
      setIsShow(false);
      updateList(filtered[active]);
      inputRef.current.focus();
    } else if (e.keyCode === 38) {
      return active === 0 ? null : setActive(active - 1);
    } else if (e.keyCode === 40) {
      return active - 1 === filtered.length ? null : setActive(active + 1);
    }
  };
  const onChoose = (suggestion) => {
    setActive(0);
    setFiltered([]);
    setIsShow(false);
    updateList(suggestion);
    inputRef.current.focus();
  };
  function onDelete(candidate) {
    const newList = list.filter((item) => item !== candidate);
    setList(newList);
  }
  const plural = defineMessage3({
    id: "step2.candidato-aprovado",
    defaultMessage: "{openPositions, plural, =0 {Quais s\xE3o os aprovados} one {Quais s\xE3o os aprovados} other {Quem \xE9 o aprovado}}?"
  });
  const renderCandidate = () => {
    if (isShow && text) {
      if (filtered.length) {
        return /* @__PURE__ */ React11.createElement(FilteredList, null, filtered.map((suggestion, index) => {
          return /* @__PURE__ */ React11.createElement("li", {
            key: suggestion + index,
            onClick: () => onChoose(suggestion),
            tabIndex: 0,
            onKeyDown
          }, /* @__PURE__ */ React11.createElement("label", {
            "aria-label": suggestion.nome
          }, suggestion.nome));
        }));
      } else {
        return /* @__PURE__ */ React11.createElement(FilteredList, null, /* @__PURE__ */ React11.createElement("li", null, /* @__PURE__ */ React11.createElement("label", {
          "aria-label": "Nenhum candidato encontrado"
        }, /* @__PURE__ */ React11.createElement(FormattedMessage5, {
          id: "step2.nenhum-candidato",
          defaultMessage: "Nenhum candidato encontrado"
        }))));
      }
    }
    return /* @__PURE__ */ React11.createElement(React11.Fragment, null);
  };
  return /* @__PURE__ */ React11.createElement(Wrapper, null, /* @__PURE__ */ React11.createElement(SearchWrapper, null, /* @__PURE__ */ React11.createElement(Text4, {
    size: "md",
    weight: 400,
    style: { marginBottom: "8px" }
  }, /* @__PURE__ */ React11.createElement(FormattedMessage5, {
    values: { openPositions },
    ...plural
  })), /* @__PURE__ */ React11.createElement(Text4, {
    className: "info-text",
    size: "sm",
    weight: 400,
    style: { marginBottom: "32px", color: "#373737" }
  }, /* @__PURE__ */ React11.createElement(FormattedMessage5, {
    id: "step2.aprovados-info",
    defaultMessage: "Procure os candidatos que foram aprovados nesse processo seletivo"
  })), /* @__PURE__ */ React11.createElement("div", {
    style: { marginBottom: "8px" }
  }, /* @__PURE__ */ React11.createElement(CounterLabel, {
    i18nOf: intl.formatMessage(defineMessage3({
      id: "step1.aprovados-de",
      defaultMessage: "de"
    })),
    total: openPositions,
    partial: list.length,
    text: intl.formatMessage(defineMessage3({
      id: "step1.aprovados-candidatos-aprovados",
      defaultMessage: "candidatos aprovados"
    }), { approved: list.length })
  })), /* @__PURE__ */ React11.createElement(Text4, {
    size: "sm",
    className: "info-text",
    weight: 400,
    style: { alignSelf: "start" }
  }, /* @__PURE__ */ React11.createElement(FormattedMessage5, {
    id: "step2.procurar",
    defaultMessage: "Busque pelo nome do candidato"
  })), /* @__PURE__ */ React11.createElement(Search, null, /* @__PURE__ */ React11.createElement("input", {
    disabled: list.length >= openPositions || approvedList?.error,
    "data-testid": "input_buscar_candidato",
    type: "text",
    onChange: (e) => setText(e.target.value),
    onKeyDown,
    value: text,
    ref: inputRef,
    "aria-labelledby": "Busque pelo candidato aprovado",
    placeholder: intl.formatMessage(defineMessage3({
      id: "step1.aprovados-placeholder",
      defaultMessage: "Digite o nome"
    }))
  }), /* @__PURE__ */ React11.createElement("box-icon", {
    name: "search",
    "data-icon": "box-icon",
    color: "#98A2B3"
  }), renderCandidate()), approvedList?.isLoading && /* @__PURE__ */ React11.createElement("box-icon", {
    name: "loader-alt",
    animation: "spin",
    color: "#E04F16",
    size: "md",
    "data-icon": "svg-icon-loader"
  }), list.length > 0 ? /* @__PURE__ */ React11.createElement(React11.Fragment, null, list.length >= openPositions && /* @__PURE__ */ React11.createElement(Alert, {
    borderColor: "#6CE9A6",
    textColor: "#027A48",
    backgroundColor: "#F6FEF9",
    style: {
      marginTop: "8px",
      width: "100%",
      boxSizing: "border-box"
    }
  }, /* @__PURE__ */ React11.createElement("div", null, /* @__PURE__ */ React11.createElement("box-icon", {
    name: "check-circle",
    color: "#039855",
    "data-icon": "svg-icon-check"
  }), /* @__PURE__ */ React11.createElement(FormattedMessage5, {
    id: "step1.lista-aprovados-fechado",
    defaultMessage: "Voc\xEA fechou todas as posi\xE7\xF5es"
  }))), /* @__PURE__ */ React11.createElement(CandidatesList, null, /* @__PURE__ */ React11.createElement(Text4, {
    size: "14px",
    weight: 400
  }, /* @__PURE__ */ React11.createElement(FormattedMessage5, {
    id: "step1.lista-aprovados",
    defaultMessage: "Lista de aprovados"
  })), list.map((item, index) => /* @__PURE__ */ React11.createElement(CandidatesListItem, {
    tabIndex: 0,
    key: item + index,
    "data-testid": "lista_item_candidato"
  }, /* @__PURE__ */ React11.createElement("div", null, /* @__PURE__ */ React11.createElement("box-icon", {
    name: "user-circle",
    color: "#101828"
  }), /* @__PURE__ */ React11.createElement("label", {
    "aria-label": item.nome
  }, item.nome)), /* @__PURE__ */ React11.createElement("button", {
    onClick: () => onDelete(item),
    "aria-label": "Fechar"
  }, /* @__PURE__ */ React11.createElement("box-icon", {
    name: "x",
    color: "#98A2B3"
  })))))) : approvedList?.error || approvedList?.data?.error ? /* @__PURE__ */ React11.createElement(React11.Fragment, null, /* @__PURE__ */ React11.createElement(ErrorWrapper, null, /* @__PURE__ */ React11.createElement(Text4, {
    size: "14px",
    weight: 400
  }, /* @__PURE__ */ React11.createElement(FormattedMessage5, {
    id: "step1.lista-aprovados",
    defaultMessage: "Lista de aprovados"
  }))), /* @__PURE__ */ React11.createElement(Alert, null, /* @__PURE__ */ React11.createElement("div", null, /* @__PURE__ */ React11.createElement("box-icon", {
    name: "error-circle",
    color: "#D92D20",
    "data-icon": "svg-icon-atention"
  }), /* @__PURE__ */ React11.createElement(FormattedMessage5, {
    id: "step1.lista-aprovados-erro",
    defaultMessage: "<b> Erro na aplica\xE7\xE3o! </b>",
    values: {
      b: (chunks) => /* @__PURE__ */ React11.createElement("strong", null, chunks)
    }
  })), /* @__PURE__ */ React11.createElement("span", null, /* @__PURE__ */ React11.createElement(FormattedMessage5, {
    id: "step1.lista-aprovados-erro-infos",
    defaultMessage: "N\xE3o foi poss\xEDvel carregar a informa\xE7\xE3o. Por favor, tente\n                  novamente. Se o erro persistir, entre em contato com a nossa\n                  equipe de suporte."
  })))) : /* @__PURE__ */ React11.createElement(React11.Fragment, null)), /* @__PURE__ */ React11.createElement(Footer, {
    style: { marginTop: "40px" },
    fluxo: "marcar-aprovados",
    idSuccess: "btn_confirmar_aprovados",
    labelSuccess: /* @__PURE__ */ React11.createElement(FormattedMessage5, {
      id: "btn.confirmar-aprovados",
      defaultMessage: "Confirmar aprovados"
    }),
    disabledSuccess: !list.length,
    hasBackButton: origin,
    stepToback: { fluxo: "fechar-vaga", step: "step1" },
    functionSuccess: () => sendApproved(true),
    permiteFeedback,
    exibirMsgErroFeedback: () => {
      showToast("infoVagaNaoPermiteFeedback", intl);
    }
  }));
};

// src/fluxos/marcar-aprovados/steps/step2/step2.component.js
import React13, { useEffect as useEffect6, useState as useState6 } from "react";
import { FormattedMessage as FormattedMessage6 } from "react-intl";
import "@vagastec/ensemble-core/dist/index.css";
import { Text as Text5 } from "@vagastec/ensemble-core";

// src/images/claps-svg.js
import React12 from "react";
function Claps(props) {
  return /* @__PURE__ */ React12.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "claps",
    viewBox: "0 0 404 176",
    width: "404",
    height: "176",
    ...props
  }, /* @__PURE__ */ React12.createElement("g", null, /* @__PURE__ */ React12.createElement("path", {
    d: "M118.579 58.338C117.879 53.5779 115.906 49.0944 112.866 45.36C113.813 39.501 116.212 22.302 115.139 2.23649C114.613 -10.9792 112.179 -24.0499 107.911 -36.5715C102.64 -51.219 94.6234 -62.811 84.0815 -71.001C82.0977 -72.4906 79.607 -73.1431 77.1459 -72.8179C74.6848 -72.4927 72.4501 -71.2158 70.923 -69.2623C69.396 -67.3088 68.6988 -64.8348 68.9816 -62.3733C69.2644 -59.9117 70.5045 -57.6594 72.4349 -56.1015C80.073 -50.148 85.9752 -41.4855 90.0152 -30.366C93.6965 -19.6602 95.7912 -8.47512 96.233 2.83499C97.1799 19.908 95.2862 35.028 94.3709 41.1075L93.1399 42.3675C87.6137 48.3696 83.7327 55.6931 81.8721 63.63C81.6512 64.9215 81.7774 67.221 81.588 67.914L75.6859 89.46C75.4606 90.2413 75.5406 91.0788 75.9096 91.8037C76.2786 92.5285 76.9092 93.0868 77.6743 93.366C78.0821 93.5063 78.5143 93.5616 78.9443 93.5287C79.3744 93.4958 79.7931 93.3752 80.1746 93.1745C80.5561 92.9738 80.8924 92.6971 81.1627 92.3617C81.4329 92.0262 81.6314 91.639 81.7459 91.224L87.1115 71.7255L87.9637 72.1665L80.3887 99.6975C80.1634 100.479 80.2434 101.316 80.6124 102.041C80.9814 102.766 81.612 103.324 82.3771 103.603C82.7849 103.744 83.2171 103.799 83.6471 103.766C84.0772 103.733 84.4959 103.613 84.8774 103.412C85.259 103.211 85.5952 102.935 85.8655 102.599C86.1357 102.264 86.3342 101.877 86.4487 101.462L93.6765 75.1275L94.5287 75.5685L86.4171 105.052C86.1919 105.834 86.2718 106.671 86.6408 107.396C87.0098 108.121 87.6404 108.679 88.4055 108.958C88.8133 109.099 89.2455 109.154 89.6756 109.121C90.1056 109.088 90.5243 108.968 90.9059 108.767C91.2874 108.566 91.6237 108.29 91.8939 107.954C92.1641 107.619 92.3626 107.232 92.4771 106.817L100.241 78.498C100.526 78.624 100.81 78.7815 101.125 78.876L94.2762 103.792C94.0509 104.574 94.1309 105.411 94.4999 106.136C94.8689 106.861 95.4995 107.419 96.2646 107.698C96.6724 107.839 97.1046 107.894 97.5346 107.861C97.9647 107.828 98.3834 107.708 98.7649 107.507C99.1465 107.306 99.4827 107.03 99.753 106.694C100.023 106.359 100.222 105.972 100.336 105.557L107.28 80.2935C107.501 79.4745 107.943 78.75 108.542 78.183C110.362 76.0992 111.612 73.5821 112.172 70.875C112.267 70.5285 112.393 70.245 112.519 70.0245L111.951 82.719C111.93 83.1312 111.991 83.5435 112.131 83.9319C112.27 84.3204 112.486 84.6774 112.765 84.9821C113.044 85.2868 113.38 85.5333 113.755 85.7071C114.13 85.881 114.536 85.9789 114.95 85.995C116.686 86.0895 118.169 84.735 118.232 83.0025L119.021 65.6145C119.368 64.134 119.305 61.866 118.579 58.338V58.338Z",
    fill: "#F7BA9A"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M92.8242 40.257L114.665 43.6275C115.216 41.1337 115.617 38.6091 115.865 36.0675L93.9605 33.138C93.6133 36.351 93.203 38.808 92.8242 40.257V40.257Z",
    fill: "#ECF0F1"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M117.443 -0.598518C116.149 -15.4035 113.182 -28.665 108.669 -40.005C102.672 -55.0305 93.8977 -66.78 82.5984 -75.0015C80.9009 -76.2264 78.9265 -77.014 76.8507 -77.2943C74.7749 -77.5745 72.6619 -77.3388 70.6993 -76.608C67.9674 -75.6048 65.6734 -73.6792 64.2149 -71.165C62.7564 -68.6508 62.2254 -65.7065 62.714 -62.8425C63.2384 -59.5421 65.0549 -56.5848 67.764 -54.621C75.1181 -49.2975 80.9571 -41.2965 85.1549 -30.87C89.076 -20.5712 91.4787 -9.75906 92.2881 1.22848C93.4243 13.7655 92.9193 25.4205 92.3196 32.949L93.9609 33.1695L115.865 36.099L117.349 36.288C118.075 27.7515 118.737 14.1435 117.443 -0.598518V-0.598518Z",
    fill: "#343844"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M121.105 84.5145L99.5476 69.5835C98.8594 69.1082 98.3138 68.4548 97.9695 67.6935C97.1804 65.961 95.4445 64.0395 92.2883 61.8345C92.0042 61.6455 91.7833 61.425 91.5939 61.2045L103.398 65.961C103.787 66.1466 104.209 66.2509 104.64 66.2674C105.07 66.2839 105.499 66.2123 105.901 66.057C106.303 65.9017 106.668 65.666 106.975 65.3643C107.282 65.0627 107.524 64.7016 107.686 64.3032C107.848 63.9048 107.926 63.4775 107.916 63.0477C107.907 62.6179 107.809 62.1947 107.629 61.8041C107.449 61.4134 107.191 61.0637 106.87 60.7764C106.55 60.4891 106.174 60.2703 105.765 60.1335L89.5739 53.5815C87.3847 52.4898 85.0062 51.8269 82.567 51.6285C78.2436 50.8073 73.7866 51.0233 69.5633 52.2585C60.3735 43.2601 52.0761 33.3968 44.7867 22.806C33.7083 6.55199 21.683 -17.4195 27.3958 -39.249C28.0278 -41.6759 27.6679 -44.254 26.3953 -46.4161C25.1227 -48.5782 23.0416 -50.1472 20.6098 -50.778C19.4058 -51.0903 18.1518 -51.1629 16.9196 -50.9916C15.6875 -50.8202 14.5012 -50.4084 13.4285 -49.7795C11.2621 -48.5094 9.68996 -46.4324 9.05796 -44.0055C5.68077 -31.0905 6.37514 -16.9785 11.1411 -2.07901C15.4018 10.558 21.4492 22.5228 29.1001 33.453C40.7783 50.5575 53.4664 63.126 57.5695 67.0005C57.8851 68.0085 58.3586 69.111 59.0214 70.2765C62.8331 77.4796 68.4564 83.5695 75.3392 87.948C76.4754 88.578 78.7164 89.2395 79.2845 89.649L97.6539 102.375C99.0426 103.32 100.968 103.131 102.01 101.808C102.282 101.471 102.481 101.081 102.596 100.663C102.711 100.246 102.738 99.8087 102.675 99.3801C102.613 98.9514 102.463 98.5402 102.235 98.172C102.006 97.8039 101.704 97.4868 101.347 97.2405L84.7133 85.7115L85.4076 85.05L108.89 101.335C110.279 102.28 112.204 102.091 113.246 100.768C113.518 100.431 113.718 100.042 113.832 99.6238C113.947 99.2061 113.974 98.7692 113.912 98.3406C113.85 97.9119 113.699 97.5007 113.471 97.1325C113.242 96.7644 112.94 96.4473 112.583 96.201L90.1104 80.6085L90.8048 79.947L115.96 97.3665C117.349 98.3115 119.274 98.1225 120.316 96.7995C120.588 96.4622 120.788 96.0726 120.902 95.6548C121.017 95.2371 121.044 94.8002 120.982 94.3716C120.92 93.9429 120.769 93.5317 120.541 93.1635C120.312 92.7954 120.01 92.4783 119.653 92.232L95.4761 75.474L96.1389 74.781L117.38 89.523C118.769 90.468 120.695 90.279 121.736 88.956C122.935 87.633 122.588 85.554 121.105 84.5145V84.5145Z",
    fill: "#FFD1AE"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M71.1099 50.9355C69.8474 49.8015 67.5749 47.88 64.7343 45.234L49.5527 61.2675C52.8668 64.323 55.4549 66.5595 56.8437 67.8195L71.1099 50.9355V50.9355Z",
    fill: "#ECF0F1"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M65.3975 44.541C58.1975 37.4416 51.56 29.7957 45.5447 21.672C25.1868 -6.14251 23.9875 -25.6725 26.5756 -37.2015C27.308 -40.4639 26.712 -43.883 24.9185 -46.7067C24.0304 -48.1049 22.8751 -49.3148 21.5186 -50.2674C20.162 -51.22 18.6307 -51.8965 17.0122 -52.2585C13.7433 -52.9895 10.3174 -52.3946 7.48806 -50.6047C4.65872 -48.8147 2.65773 -45.9764 1.92528 -42.714C-1.13628 -29.106 0.0946531 -14.427 5.58653 0.881991C9.72122 12.474 16.3178 24.4755 25.1868 36.54C32.1143 45.8808 39.7653 54.6647 48.0697 62.811L49.5847 61.2045L64.7662 45.2025L65.3975 44.541V44.541Z",
    fill: "#343844"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M253.384 -52.416C253.1 -67.977 249.249 -81.522 241.895 -92.673C241.215 -93.7158 240.335 -94.6138 239.305 -95.3151C238.276 -96.0165 237.117 -96.5073 235.896 -96.7592C234.675 -97.011 233.416 -97.019 232.193 -96.7827C230.969 -96.5463 229.804 -96.0702 228.765 -95.382C226.67 -94.006 225.208 -91.8568 224.699 -89.406C224.19 -86.9552 224.676 -84.403 226.051 -82.3095C231.353 -74.2455 234.194 -64.134 234.415 -52.29C234.636 -42.273 232.995 -31.0275 229.617 -18.837C226.136 -6.51865 221.442 5.42558 215.604 16.821C212.383 18.5276 209.329 20.5314 206.482 22.806C202.576 26.0468 199.21 29.8849 196.508 34.1775C195.877 35.343 195.246 37.548 194.867 38.1465L182.337 56.6685C181.39 58.0545 181.611 59.976 182.968 61.0155C183.309 61.2789 183.701 61.4698 184.118 61.5764C184.536 61.6829 184.972 61.7029 185.398 61.635C185.823 61.5671 186.231 61.4128 186.595 61.1816C186.959 60.9505 187.271 60.6474 187.513 60.291L198.844 43.533L199.507 44.226L183.505 67.8825C182.558 69.2685 182.779 71.19 184.136 72.2295C184.477 72.4929 184.868 72.6838 185.286 72.7904C185.704 72.8969 186.139 72.9169 186.565 72.849C186.991 72.7811 187.399 72.6268 187.763 72.3956C188.126 72.1645 188.439 71.8614 188.681 71.505L203.989 48.8565L204.651 49.5495L187.513 74.8755C186.566 76.2615 186.787 78.183 188.144 79.2225C188.485 79.4859 188.877 79.6768 189.295 79.7834C189.713 79.8899 190.148 79.9099 190.574 79.842C191 79.7741 191.407 79.6198 191.771 79.3886C192.135 79.1575 192.447 78.8543 192.689 78.498L209.165 54.18L209.859 54.8415L195.372 76.167C194.425 77.553 194.646 79.4745 196.003 80.514C196.344 80.7774 196.736 80.9683 197.154 81.0749C197.572 81.1814 198.007 81.2014 198.433 81.1335C198.859 81.0656 199.266 80.9113 199.63 80.6801C199.994 80.449 200.306 80.1459 200.548 79.7895L215.256 58.086C215.73 57.393 216.361 56.826 217.119 56.4795C219.517 55.096 221.508 53.1082 222.895 50.715C223.084 50.4315 223.305 50.211 223.494 50.022L218.855 61.866C218.702 62.2526 218.627 62.6656 218.635 63.0812C218.642 63.4967 218.733 63.9066 218.9 64.2873C219.067 64.6679 219.308 65.0118 219.609 65.2991C219.91 65.5863 220.265 65.8113 220.654 65.961C221.041 66.1136 221.455 66.1881 221.871 66.1804C222.288 66.1726 222.698 66.0827 223.08 65.9158C223.461 65.7489 223.806 65.5083 224.094 65.2079C224.381 64.9075 224.607 64.5532 224.757 64.1655L231.101 47.943C232.17 45.7434 232.803 43.358 232.963 40.9185C233.468 37.1385 233.91 31.941 231.732 26.8065C234.541 21.546 242.305 6.01648 247.766 -13.3245C251.524 -26.0151 253.416 -39.1828 253.384 -52.416V-52.416Z",
    fill: "#E0A78D"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M213.615 17.1675L232.837 28.035C233.563 26.6805 234.762 24.318 236.277 21.231L216.803 10.773C215.446 13.671 214.31 15.876 213.615 17.1675Z",
    fill: "#ECF0F1"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M256.541 -52.479C256.257 -68.6385 252.217 -82.7505 244.515 -94.4055C243.612 -95.7924 242.442 -96.9867 241.073 -97.9192C239.704 -98.8517 238.163 -99.5038 236.539 -99.8378C234.916 -100.172 233.242 -100.181 231.616 -99.8649C229.989 -99.5489 228.441 -98.9138 227.061 -97.9965C224.279 -96.1472 222.341 -93.277 221.667 -90.0094C220.993 -86.7418 221.639 -83.3408 223.463 -80.5455C228.45 -72.9855 231.101 -63.441 231.322 -52.1955C231.512 -42.4935 229.933 -31.5315 226.651 -19.656C223.753 -9.45986 220.005 0.476314 215.446 10.0485L216.835 10.8045L236.309 21.2625L237.698 22.0185C241.422 14.2695 246.851 1.7955 250.859 -12.474C254.659 -25.4696 256.572 -38.9416 256.541 -52.479V-52.479Z",
    fill: "#343844"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M226.967 66.4965L211.343 45.423C210.836 44.7558 210.529 43.9582 210.459 43.1235C210.27 41.2335 209.228 38.8395 206.956 35.7525C206.735 35.469 206.609 35.217 206.483 34.9335L216.109 43.218C216.741 43.7648 217.565 44.0388 218.4 43.9797C219.234 43.9207 220.011 43.5334 220.559 42.903C221.107 42.2721 221.382 41.4499 221.323 40.6171C221.264 39.7842 220.875 39.0089 220.244 38.4615L207.019 27.09C205.297 25.3593 203.262 23.9698 201.022 22.995C197.187 20.8306 192.894 19.6002 188.492 19.404C182.687 7.93858 177.995 -4.05451 174.478 -16.4115C169.207 -35.3745 165.546 -61.929 177.95 -80.766C178.882 -82.1913 179.412 -83.8415 179.482 -85.5423C179.552 -87.243 179.161 -88.9311 178.35 -90.4283C177.538 -91.9254 176.337 -93.1761 174.872 -94.048C173.407 -94.92 171.733 -95.3809 170.028 -95.382C166.935 -95.382 163.936 -93.87 162.106 -91.1295C154.752 -79.9785 150.901 -66.402 150.617 -50.715C150.396 -38.7135 152.29 -25.4835 156.203 -11.34C160.198 2.79701 165.612 16.4955 172.363 29.547C172.363 30.618 172.458 31.7835 172.679 33.1065C174.022 41.1443 177.389 48.71 182.463 55.0935C183.347 56.07 185.241 57.393 185.651 57.96L198.971 75.915C199.981 77.2695 201.874 77.679 203.263 76.7655C203.628 76.5316 203.94 76.2254 204.181 75.8659C204.421 75.5063 204.585 75.1012 204.662 74.6757C204.739 74.2501 204.728 73.8134 204.628 73.3925C204.529 72.9717 204.343 72.5758 204.084 72.2295L192.027 55.9755L192.911 55.566L209.923 78.498C210.933 79.8525 212.827 80.262 214.215 79.3485C214.58 79.1146 214.892 78.8084 215.133 78.4489C215.373 78.0893 215.537 77.6842 215.614 77.2586C215.691 76.8331 215.68 76.3963 215.58 75.9755C215.481 75.5547 215.295 75.1588 215.036 74.8125L198.844 52.92L199.728 52.5105L217.94 77.0805C218.95 78.435 220.843 78.8445 222.232 77.931C222.597 77.6971 222.909 77.3909 223.15 77.0314C223.39 76.6718 223.554 76.2667 223.631 75.8411C223.708 75.4156 223.697 74.9788 223.597 74.558C223.498 74.1372 223.312 73.7413 223.053 73.395L205.536 49.8015L206.388 49.3605L221.79 70.119C222.8 71.4735 224.694 71.883 226.083 70.9695C227.661 70.0245 228.04 67.9455 226.967 66.4965V66.4965Z",
    fill: "#F7BA9A"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M191.048 19.152C190.259 17.6715 188.87 15.0885 187.166 11.6865L167.281 21.3255C169.27 25.2945 170.879 28.2555 171.732 29.8935L191.048 19.152V19.152Z",
    fill: "#ECF0F1"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M188.302 11.151C184.097 1.9679 180.594 -7.51971 177.823 -17.2305C168.607 -50.4315 174.383 -69.1425 180.885 -79.002C182.661 -81.7923 183.267 -85.1673 182.572 -88.3993C181.878 -91.6314 179.939 -94.4617 177.173 -96.28C174.407 -98.0983 171.035 -98.759 167.786 -98.1196C164.536 -97.4802 161.669 -95.592 159.801 -92.862C152.131 -81.207 148.091 -67.0635 147.776 -50.778C147.555 -38.493 149.48 -24.948 153.489 -10.4895C156.656 0.697651 160.698 11.6196 165.577 22.176L167.281 21.357L187.166 11.718L188.302 11.151V11.151Z",
    fill: "#343844"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M374.394 -57.015C373.479 -59.1202 371.828 -60.8214 369.749 -61.8009C367.67 -62.7805 365.304 -62.9716 363.094 -62.3385L361.958 -61.929C360.815 -61.4357 359.781 -60.7223 358.915 -59.8296C358.049 -58.937 357.368 -57.8826 356.911 -56.7269C356.453 -55.5712 356.229 -54.3368 356.25 -53.0944C356.271 -51.852 356.538 -50.626 357.034 -49.4865C360.885 -40.635 361.927 -30.2085 360.127 -18.4905C358.612 -8.56801 355.077 2.23649 349.68 13.6395C344.098 25.1623 337.418 36.1223 329.733 46.368C329.196 46.5255 328.628 46.683 328.06 46.9035C320.345 49.5584 313.436 54.1336 307.986 60.1965C307.166 61.236 306.187 63.315 305.682 63.819L290.153 79.9155C288.986 81.1125 288.891 83.0655 290.027 84.294C290.318 84.6128 290.671 84.8686 291.065 85.0456C291.459 85.2225 291.886 85.3169 292.318 85.3228C292.75 85.3287 293.178 85.246 293.577 85.0799C293.976 84.9138 294.336 84.6677 294.635 84.357L308.681 69.804L309.217 70.5915L289.396 91.161C288.228 92.358 288.133 94.311 289.27 95.5395C289.561 95.8583 289.914 96.1141 290.308 96.291C290.702 96.468 291.128 96.5624 291.56 96.5683C291.992 96.5742 292.421 96.4915 292.819 96.3254C293.218 96.1593 293.578 95.9132 293.878 95.6025L312.847 75.915L313.383 76.7025L292.142 98.721C290.974 99.918 290.879 101.871 292.016 103.099C292.307 103.418 292.66 103.674 293.054 103.851C293.448 104.028 293.874 104.122 294.306 104.128C294.738 104.134 295.167 104.052 295.565 103.885C295.964 103.719 296.324 103.473 296.624 103.163L317.013 81.9945L317.581 82.7505L299.654 101.367C298.486 102.564 298.391 104.517 299.527 105.746C299.818 106.064 300.172 106.32 300.566 106.497C300.96 106.674 301.386 106.768 301.818 106.774C302.25 106.78 302.678 106.698 303.077 106.531C303.476 106.365 303.836 106.119 304.136 105.808L322.347 86.9085C322.915 86.31 323.673 85.869 324.462 85.6485C327.066 84.6967 329.374 83.078 331.153 80.955C331.406 80.703 331.627 80.514 331.879 80.3565L325.282 91.224C324.853 91.9387 324.725 92.7941 324.926 93.603C325.127 94.4118 325.641 95.1082 326.356 95.5395C327.072 95.9681 327.929 96.0961 328.739 95.8954C329.55 95.6947 330.247 95.1816 330.68 94.4685L339.707 79.569C340.685 78.435 341.695 76.419 342.768 72.954C344.436 68.4441 344.85 63.5679 343.968 58.842C352.755 47.3784 360.348 35.0507 366.629 22.05C372.493 10.1979 376.607 -2.43849 378.844 -15.4665C381.211 -30.7755 379.728 -44.793 374.394 -57.015Z",
    fill: "#5A443B"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M328.533 44.226L345.577 58.275C347.06 56.3744 348.502 54.442 349.901 52.479L332.542 38.808C330.806 41.2335 329.417 43.092 328.533 44.226V44.226Z",
    fill: "#ECF0F1"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M377.802 -60.291C377.156 -61.82 376.212 -63.2055 375.024 -64.3666C373.836 -65.5277 372.428 -66.4412 370.883 -67.0539C369.338 -67.6667 367.686 -67.9664 366.024 -67.9356C364.361 -67.9048 362.722 -67.5441 361.2 -66.8745C359.677 -66.2277 358.298 -65.2846 357.144 -64.1002C355.989 -62.9158 355.083 -61.5138 354.478 -59.976C353.215 -56.8575 353.278 -53.424 354.604 -50.337C358.202 -42.021 359.117 -32.1615 357.381 -21.0735C355.488 -10.2248 352.021 0.290946 347.092 10.143C342.446 19.6699 337.031 28.8035 330.9 37.4535L332.542 38.745L349.901 52.416L350.753 53.0775C357.966 43.0711 364.312 32.4698 369.722 21.3885C375.754 9.27049 380.006 -3.65107 382.347 -16.9785C384.872 -32.886 383.326 -47.502 377.802 -60.291V-60.291Z",
    fill: "#343844"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M327.84 72.5445L320.959 56.5425C320.171 54.2241 318.95 52.0757 317.361 50.211C314.55 46.0349 310.595 42.7543 305.967 40.761C301.958 39.249 291.322 33.579 287.503 46.9035C285.13 54.7039 284.826 62.9851 286.619 70.938C286.998 72.198 288.102 74.214 288.229 74.9385L292.3 96.894C292.616 98.532 294.131 99.7605 295.804 99.5715C296.235 99.5228 296.652 99.3856 297.028 99.1687C297.404 98.9518 297.731 98.6597 297.989 98.3108C298.247 97.9619 298.43 97.5637 298.526 97.141C298.622 96.7184 298.63 96.2804 298.55 95.8545L294.857 75.978L295.835 76.0095L301.043 104.076C301.359 105.714 302.874 106.943 304.546 106.754C304.978 106.705 305.395 106.568 305.771 106.351C306.147 106.134 306.474 105.842 306.732 105.493C306.99 105.144 307.172 104.746 307.269 104.323C307.365 103.9 307.373 103.462 307.292 103.037L302.305 76.167L303.284 76.1985L308.839 106.25C309.155 107.888 310.67 109.116 312.342 108.927C312.774 108.878 313.191 108.741 313.567 108.524C313.943 108.307 314.27 108.015 314.528 107.666C314.785 107.317 314.968 106.919 315.065 106.497C315.161 106.074 315.169 105.636 315.088 105.21L309.754 76.3245L310.701 76.293L315.404 101.682C315.72 103.32 317.235 104.549 318.907 104.36C319.339 104.311 319.756 104.174 320.132 103.957C320.508 103.74 320.835 103.448 321.093 103.099C321.35 102.75 321.533 102.352 321.63 101.929C321.726 101.506 321.734 101.068 321.653 100.643L316.887 74.8755C316.73 74.0565 316.793 73.206 317.077 72.4185C317.74 70.623 317.866 68.04 317.171 64.26C317.108 63.9135 317.077 63.5985 317.108 63.3465L322.127 75.033C322.454 75.8012 323.073 76.4085 323.848 76.7215C324.623 77.0345 325.491 77.0277 326.261 76.7025C327.776 76.0095 328.534 74.151 327.84 72.5445V72.5445Z",
    fill: "#785B4E"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M337.466 -70.686C339.54 -70.6854 341.557 -70.0049 343.207 -68.7491C344.856 -67.4932 346.046 -65.7316 346.595 -63.7349C347.143 -61.7382 347.02 -59.617 346.243 -57.6973C345.466 -55.7775 344.079 -54.1655 342.295 -53.109C322.947 -41.6745 314.552 -16.2225 310.953 3.11849C308.423 16.9226 307.365 30.9554 307.797 44.982C307.931 47.4883 307.062 49.945 305.381 51.8118C303.7 53.6785 301.345 54.8023 298.833 54.936C296.322 55.0697 293.861 54.2022 291.99 52.5245C290.12 50.8468 288.994 48.4963 288.86 45.99C288.333 30.6044 289.466 15.207 292.237 0.0629919C294.493 -13.1398 298.627 -25.9533 304.515 -37.989C311.648 -52.0065 321.117 -62.559 332.637 -69.363C334.101 -70.2228 335.767 -70.6794 337.466 -70.686V-70.686Z",
    fill: "#785B4E"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M287.155 41.265L309.249 41.139C309.281 39.564 309.312 36.855 309.438 33.3585L287.376 32.256C287.218 36.351 287.218 39.501 287.155 41.265Z",
    fill: "#ECF0F1"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M353.31 -66.1815C352.534 -67.6442 351.476 -68.9399 350.197 -69.9944C348.918 -71.0489 347.444 -71.8417 345.858 -72.3273C344.273 -72.8129 342.606 -72.9819 340.955 -72.8245C339.304 -72.6672 337.7 -72.1867 336.235 -71.4105C323.894 -64.89 313.51 -54.432 305.398 -40.32C298.792 -28.3862 293.925 -15.5733 290.943 -2.268C287.818 10.962 286.398 23.499 285.767 32.1615L287.345 32.256L309.407 33.3585L310.985 33.453C311.553 25.9245 312.784 15.057 315.53 3.5595C323.484 -29.9565 337.592 -43.5645 348.039 -49.077C351.003 -50.6556 353.221 -53.3401 354.208 -56.5447C355.196 -59.7493 354.873 -63.2136 353.31 -66.1815V-66.1815Z",
    fill: "#343844"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M40.4318 71.316L29.1955 64.323L27.3018 69.363L40.4318 71.316ZM103.273 164.146L118.675 159.831L115.614 154.35L103.273 164.146ZM78.0227 144.648L85.5346 133.78L80.5477 131.67L78.0227 144.648ZM128.775 40.572C128.775 40.572 140.327 23.6565 140.58 24.255L143.199 31.9095L128.775 40.572ZM65.3346 103.761C65.3346 103.761 55.4871 114.124 55.3924 113.683L54.4455 108.139L65.3346 103.761ZM121.295 113.715L124.451 127.89L129.88 125.464L121.295 113.715ZM132.089 68.1975L145.914 72.387L146.482 66.528L132.089 68.1975Z",
    fill: "#FCF2D7"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M103.588 146.506C102.957 147.63 102.388 148.786 101.884 149.971L105.514 147.956L107.944 149.971C107.755 148.995 107.692 147.892 107.692 146.758L108.954 146.066C109.775 145.593 110.658 145.152 111.574 145.058C110.28 145.089 108.986 145.026 107.692 144.931L107.849 140.584C106.713 141.833 105.678 143.171 104.756 144.585C103.746 144.428 102.736 144.238 101.726 143.986C101.032 143.829 100.274 143.64 99.6431 143.955C101 144.743 102.326 145.593 103.588 146.506V146.506ZM142 51.786C141.337 52.983 140.706 54.2115 140.201 55.4715L144.083 53.3295C144.967 54.0225 145.851 54.747 146.671 55.4715C146.492 54.3356 146.397 53.1879 146.387 52.038L147.744 51.282C148.628 50.778 149.543 50.3055 150.553 50.211C149.165 50.2425 147.776 50.1795 146.387 50.085L146.545 45.4545C145.327 46.7806 144.219 48.2027 143.231 49.707C142.158 49.5495 141.053 49.329 140.012 49.077C139.286 48.888 138.465 48.699 137.771 49.0455C139.223 49.896 140.643 50.8095 142 51.786V51.786ZM31.7206 99.5085C31.1841 100.453 30.7106 101.43 30.2688 102.438L33.3619 100.737C34.0562 101.272 34.7506 101.84 35.4134 102.438C35.2556 101.588 35.1925 100.674 35.1925 99.729L36.2656 99.1305C36.96 98.7525 37.6859 98.343 38.5066 98.28C37.4019 98.3115 36.2972 98.28 35.1925 98.1855L35.3188 94.5C34.3646 95.5585 33.4891 96.685 32.6991 97.8705C31.8469 97.7445 30.9947 97.5555 30.1425 97.3665C29.5428 97.2405 28.9116 97.083 28.375 97.335C29.5322 97.993 30.6493 98.7188 31.7206 99.5085V99.5085ZM144.115 139.198L139.443 138.096C140.264 139.135 141.053 140.206 141.811 141.309C141.147 141.972 140.515 142.665 139.917 143.388C140.895 143.231 141.905 143.105 142.884 142.916C143.768 144.302 144.62 145.719 145.409 147.199C145.788 145.498 146.293 143.829 146.924 142.223L152.289 141.151L147.871 140.112C148.711 138.382 149.715 136.737 150.869 135.198C148.445 136.217 146.172 137.563 144.115 139.198V139.198Z",
    fill: "#F0C419"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M205.567 107.604L203.42 121.558L209.165 121.275L205.567 107.604ZM228.26 93.0825L238.802 104.296L242.463 99.162L228.26 93.0825ZM176.371 80.577L160.18 82.278L162.168 88.6095L176.371 80.577ZM191.395 101.65L187.323 110.029L181.768 109.021L191.395 101.65ZM237.729 65.4255L250.922 56.826L258.087 63.0945L237.729 65.4255Z",
    fill: "#FCF2D7"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M272.29 88.9875L258.181 85.932L258.118 91.8225L272.29 88.9875ZM303.884 121.527L302.905 136.458L308.965 135.608L303.884 121.527ZM286.398 115.763L278.981 129.371L269.828 127.26L286.398 115.763ZM276.961 48.1005C276.961 48.1005 261.464 42.336 261.906 42.0525L267.398 38.556L276.961 48.1005V48.1005ZM332.7 108.864C332.7 108.864 351.291 110.376 350.912 110.817C349.295 112.647 347.675 114.474 346.051 116.298L332.7 108.864V108.864ZM324.336 157.185L320.233 144.932L315.657 147.546L324.336 157.185Z",
    fill: "#FCF2D7"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M254.267 131.261L249.943 130.221C250.701 131.197 251.427 132.174 252.121 133.182C251.521 133.78 250.922 134.442 250.354 135.103L253.1 134.694C253.92 135.985 254.709 137.309 255.435 138.663C255.782 137.088 256.256 135.544 256.856 134.032C258.528 133.717 260.17 133.402 261.811 133.024L257.708 132.048C258.486 130.451 259.416 128.932 260.485 127.512C258.256 128.483 256.166 129.743 254.267 131.261V131.261ZM334.089 121.968C333.395 123.196 332.795 124.456 332.227 125.748L336.204 123.543C337.119 124.236 338.003 124.992 338.855 125.748C338.666 124.677 338.571 123.48 338.571 122.251L339.96 121.495C340.875 120.991 341.79 120.487 342.832 120.393C341.411 120.424 339.991 120.361 338.571 120.267L338.729 115.542C337.498 116.896 336.361 118.345 335.351 119.889C334.247 119.7 333.142 119.511 332.037 119.227C331.28 119.038 330.459 118.849 329.765 119.196C331.248 120.015 332.7 120.96 334.089 121.968V121.968ZM375.215 66.3075C374.521 67.536 373.889 68.796 373.353 70.119L377.361 67.914L380.044 70.119C379.849 68.9532 379.754 67.7729 379.76 66.591L381.149 65.8035C382.03 65.2397 383.019 64.8643 384.052 64.701C382.632 64.7325 381.18 64.6695 379.76 64.575L379.918 59.8185C378.655 61.173 377.519 62.6535 376.509 64.197C375.404 64.008 374.268 63.7875 373.195 63.5355C372.437 63.3465 371.617 63.1575 370.891 63.504C372.374 64.3545 373.795 65.2995 375.215 66.3075V66.3075Z",
    fill: "#F0C419"
  })));
}

// src/fluxos/marcar-aprovados/steps/step2/step2.style.js
import styled10 from "@emotion/styled";
var TextWrapper3 = styled10.div`
  text-align: center;
  max-width: 560px;
  .info-text {
    color: #373737;
  }
`;
var Spacing = styled10.div`
  margin: 4px 0;
`;
var StyledIcon2 = styled10.span`
  margin-top: 24px;
  margin-bottom: 8px;
`;

// src/fluxos/marcar-aprovados/steps/step2/step2.component.js
var Step2 = ({ origin }) => {
  const { setModalContent, setIsModalOpen, env, vacancyData } = useStepsContext();
  const { vagaId } = useStepsContext();
  const [shouldShowFeedbackButton, setShouldShowFeedbackButton] = useState6(false);
  useEffect6(() => {
    setShouldShowFeedbackButton(vacancyData?.total_candidatos - vacancyData?.posicoes.fechadas > 0 && !vacancyData?.situacoes.includes("feedback-enviado"));
  }, [vacancyData]);
  const linkRelatorio = /* @__PURE__ */ React13.createElement("a", {
    href: `${env !== "production" ? `https://qa-epartner-relatorios.ad.vagastec.com.br` : `https://epartner-relatorios.vagas.com.br`}/dashboards/4/jobs/${vagaId}
    `
  }, /* @__PURE__ */ React13.createElement(FormattedMessage6, {
    id: "step2.redirect-relatorio-link",
    defaultMessage: "clique aqui"
  }));
  return /* @__PURE__ */ React13.createElement(Wrapper, null, origin === "fechar-vaga" ? /* @__PURE__ */ React13.createElement(React13.Fragment, null, /* @__PURE__ */ React13.createElement(StyledIcon, {
    success: true
  }, /* @__PURE__ */ React13.createElement("box-icon", {
    name: "check-circle",
    color: "#039855"
  })), /* @__PURE__ */ React13.createElement(TextWrapper3, null, /* @__PURE__ */ React13.createElement(Text5, {
    size: "lg",
    weight: 400
  }, /* @__PURE__ */ React13.createElement(FormattedMessage6, {
    id: "step2.vaga-fechada-candidatos-aprovados",
    defaultMessage: "Candidatos aprovados com sucesso, {br} deseja fechar a vaga?",
    values: { br: /* @__PURE__ */ React13.createElement("br", null) }
  })), /* @__PURE__ */ React13.createElement(Spacing, null), /* @__PURE__ */ React13.createElement(Text5, {
    size: "sm",
    weight: 400,
    className: "info-text"
  }, /* @__PURE__ */ React13.createElement(FormattedMessage6, {
    id: "step2.candidatos-aprovados-info",
    defaultMessage: "Voc\xEA ainda poder\xE1 acessar as informa\xE7\xF5es dos candidatos no painel da vaga {link} a qualquer momento.{br}\n                Para visualizar os aprovados, acesse a sess\xE3o de Relat\xF3rios desse processo seletivo.",
    values: {
      br: /* @__PURE__ */ React13.createElement("br", null),
      link: linkRelatorio
    }
  })), /* @__PURE__ */ React13.createElement(Spacing, null))) : /* @__PURE__ */ React13.createElement(React13.Fragment, null, /* @__PURE__ */ React13.createElement(Claps, null), /* @__PURE__ */ React13.createElement(TextWrapper3, null, /* @__PURE__ */ React13.createElement(Text5, {
    size: "lg",
    weight: 400
  }, /* @__PURE__ */ React13.createElement(FormattedMessage6, {
    id: "step2.candidatos-aprovados",
    defaultMessage: "Candidatos aprovados com sucesso"
  })), /* @__PURE__ */ React13.createElement(Spacing, null), /* @__PURE__ */ React13.createElement(Text5, {
    size: "sm",
    weight: 400,
    className: "info-text"
  }, /* @__PURE__ */ React13.createElement(FormattedMessage6, {
    id: "step2.candidatos-aprovados-info",
    defaultMessage: "Voc\xEA ainda poder\xE1 acessar as informa\xE7\xF5es dos candidatos no painel da vaga {link} a qualquer momento.{br}\n            Para visualizar os aprovados, acesse a sess\xE3o de Relat\xF3rios desse processo seletivo.",
    values: {
      br: /* @__PURE__ */ React13.createElement("br", null),
      link: linkRelatorio
    }
  })), /* @__PURE__ */ React13.createElement(Spacing, null))), /* @__PURE__ */ React13.createElement(Footer, {
    center: true,
    fluxo: "marcar-aprovados",
    idAux: "btn_feedback",
    idSuccess: origin === "fechar-vaga" ? "btn_fechar_vaga" : "btn_fechar",
    labelAux: origin && shouldShowFeedbackButton ? /* @__PURE__ */ React13.createElement(FormattedMessage6, {
      id: "btn.nao-informar-aprovados",
      defaultMessage: "Enviar feedback"
    }) : null,
    labelSuccess: origin === "fechar-vaga" ? /* @__PURE__ */ React13.createElement(FormattedMessage6, {
      id: "btn.informar-aprovados",
      defaultMessage: "Fechar vaga"
    }) : /* @__PURE__ */ React13.createElement(FormattedMessage6, {
      id: "btn.fechar",
      defaultMessage: "Fechar"
    }),
    stepToback: {
      fluxo: "marcar-aprovados",
      step: "step1",
      origin
    },
    hasBackButton: true,
    functionSuccess: () => origin === "fechar-vaga" ? setModalContent({
      fluxo: "fechar-vaga",
      step: "step1",
      origin: "fechar-vaga"
    }) : setIsModalOpen(false),
    functionAux: () => setModalContent({
      fluxo: "enviar-feedback",
      step: "step1",
      origin
    })
  }));
};

// src/hooks/auth/auth.hook.js
import { useState as useState7 } from "react";
var useAuth = (nodeToken, domainCookie) => {
  const [token, setToken] = useState7(getCookie(nodeToken));
  const body = {
    companyId: 12702,
    userId: 245088,
    name: "Teste01",
    clientId: "frontend"
  };
  async function fakeLogin() {
    if (false) {
      const response = await fetcher("/login", token, "POST", body);
      if (response)
        saveToken(response);
    }
  }
  function saveToken(data) {
    setCookie(nodeToken, data.token, data.expires_in, domainCookie);
    setToken(data.token);
  }
  return {
    fakeLogin,
    token
  };
};

// src/locales/locale-context.js
import React14 from "react";
var LocaleContext = React14.createContext();

// src/close-selection-process.js
var CustomModal = styled11(Modal)`
  padding: 0;
  max-height: 90vh;

  header {
    margin: 0;
    padding: 24px;

    h2 {
      max-width: 52ch;
    }
  }
`;
function CloseSelectionProcess({
  vagaId = "2431133",
  env = "development",
  position = "Balonista",
  currentLocale = "pt-BR",
  setIsModalOpen = () => {
  },
  nodeToken = "access%5Ftoken",
  domainCookie = "localhost",
  onClose = () => {
  },
  fluxo = "fechar-vaga",
  step = "step1",
  onAddApproved = () => null
} = {}) {
  const token = getCookie(nodeToken);
  const { fakeLogin } = useAuth(nodeToken, domainCookie);
  const [stepsVariations, setStepsVariations] = useState8({
    step3: null,
    step2: null
  });
  const { PERMISSIONS, VACANCY_DATA } = useUrls(vagaId, env);
  const { data, error } = useFetch(PERMISSIONS, token);
  const vacancy = useFetch(VACANCY_DATA, token);
  const [userPermissions, setUserPermissions] = useState8({});
  const [informApproved, setInformApproved] = useState8(false);
  const [toasts, addToast, removeToast] = useToaster();
  const [vacancyData, setVacancyData] = useState8();
  const showToast = (type, intl) => {
    addToast(getWarnings(type, (id) => removeToast(id), intl));
  };
  useEffect7(() => {
    fakeLogin();
  }, []);
  const compile = (msgs) => {
    const results = {};
    for (const [id, msg] of Object.entries(msgs)) {
      results[id] = msg.string;
    }
    return results;
  };
  const messages = {
    en: compile(en_US_default),
    es: compile(es_ES_default)
  };
  useEffect7(() => {
    if (data) {
      setUserPermissions(data?.funcionario?.permissoes);
    }
    if (error) {
      console.error(error);
    }
  }, [data, error]);
  useEffect7(() => {
    if (vacancy.data && !vacancy.data.error) {
      setVacancyData(vacancy.data);
    }
  }, [vacancy]);
  const getModal = (state, action) => {
    switch (action.fluxo) {
      case "marcar-aprovados":
        switch (action.step) {
          case "step1":
            return /* @__PURE__ */ React15.createElement(Step13, {
              origin: action.origin
            });
          case "step2":
            return /* @__PURE__ */ React15.createElement(Step2, {
              origin: action.origin
            });
          default:
            throw new Error("STEP INV\xC1LIDO");
        }
      case "fechar-vaga":
        switch (action.step) {
          case "step1":
            return /* @__PURE__ */ React15.createElement(Step1, {
              origin: action.origin
            });
          default:
            throw new Error("STEP INV\xC1LIDO");
        }
      case "enviar-feedback":
        switch (action.step) {
          case "step1":
            return /* @__PURE__ */ React15.createElement(Step12, {
              origin: action.origin
            });
          default:
            throw new Error("STEP INV\xC1LIDO");
        }
      default:
        throw new Error("FLUXO INV\xC1LIDO");
    }
  };
  const [modalContent, setModalContent] = useReducer(getModal);
  useEffect7(() => {
    setModalContent({ fluxo, step });
  }, []);
  const stepsProps = {
    stepsVariations,
    setStepsVariations,
    modalContent,
    setModalContent,
    setIsModalOpen,
    userPermissions,
    vagaId,
    toasts,
    showToast,
    informApproved,
    setInformApproved,
    token,
    onClose,
    env,
    onAddApproved,
    vacancyData
  };
  return /* @__PURE__ */ React15.createElement(IntlProvider, {
    messages: messages[currentLocale],
    locale: currentLocale,
    defaultLocale: "pt-BR"
  }, /* @__PURE__ */ React15.createElement(LocaleContext.Provider, {
    value: currentLocale
  }, /* @__PURE__ */ React15.createElement(StepsProvider, {
    ...stepsProps
  }, /* @__PURE__ */ React15.createElement(CustomModal, {
    className: "modal2",
    title: `${position} - v${vagaId}`,
    onClose: () => setIsModalOpen(false)
  }, modalContent), /* @__PURE__ */ React15.createElement(Toaster, {
    toasts
  }))));
}
export {
  CloseSelectionProcess
};
/*!
 * Quill Editor v1.3.7
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
